// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { ApnProfilesCreateEntityData, ApnProfilesCreateEntityErrors, ApnProfilesCreateEntityResponses, ApnProfilesDeleteEntityData, ApnProfilesDeleteEntityErrors, ApnProfilesDeleteEntityResponses, ApnProfilesGetEntityData, ApnProfilesGetEntityErrors, ApnProfilesGetEntityPageData, ApnProfilesGetEntityPageErrors, ApnProfilesGetEntityPageResponses, ApnProfilesGetEntityResponses, ApnProfilesIsValueUsedData, ApnProfilesIsValueUsedErrors, ApnProfilesIsValueUsedResponses, ApnProfilesListProfilesData, ApnProfilesListProfilesErrors, ApnProfilesListProfilesResponses, ApnProfilesUpdateEntityData, ApnProfilesUpdateEntityErrors, ApnProfilesUpdateEntityResponses, AppMessagesCreateEntityData, AppMessagesCreateEntityErrors, AppMessagesCreateEntityResponses, AppMessagesDeleteEntityData, AppMessagesDeleteEntityErrors, AppMessagesDeleteEntityResponses, AppMessagesGetEntityData, AppMessagesGetEntityErrors, AppMessagesGetEntityPageData, AppMessagesGetEntityPageErrors, AppMessagesGetEntityPageResponses, AppMessagesGetEntityResponses, AppMessagesNotifyImmediatelyData, AppMessagesNotifyImmediatelyErrors, AppMessagesNotifyImmediatelyResponses, AppMessagesUpdateEntityData, AppMessagesUpdateEntityErrors, AppMessagesUpdateEntityResponses, AppNotificationsNotifyCustomerData, AppNotificationsNotifyCustomerErrors, AppNotificationsNotifyCustomerResponses, AppNotificationsNotifyUserData, AppNotificationsNotifyUserErrors, AppNotificationsNotifyUserResponses, AuthorizeAuthorizeApiData, AuthorizeAuthorizeApiErrors, AuthorizeAuthorizeApiResponses, AuthorizeAuthorizeApiV2Data, AuthorizeAuthorizeApiV2Errors, AuthorizeAuthorizeApiV2Responses, AuthorizeAuthorizeDeviceData, AuthorizeAuthorizeDeviceErrors, AuthorizeAuthorizeDeviceFromApiV2Data, AuthorizeAuthorizeDeviceFromApiV2Errors, AuthorizeAuthorizeDeviceFromApiV2Responses, AuthorizeAuthorizeDeviceResponses, AuthorizeAuthorizeDeviceV2Data, AuthorizeAuthorizeDeviceV2Errors, AuthorizeAuthorizeDeviceV2Responses, AuthorizeAuthorizeRefreshTokenV2Data, AuthorizeAuthorizeRefreshTokenV2Errors, AuthorizeAuthorizeRefreshTokenV2Responses, AuthorizeAuthorizeServiceData, AuthorizeAuthorizeServiceDeviceV2Data, AuthorizeAuthorizeServiceDeviceV2Errors, AuthorizeAuthorizeServiceDeviceV2Responses, AuthorizeAuthorizeServiceErrors, AuthorizeAuthorizeServiceResponses, AuthorizeCheckContractV2Data, AuthorizeCheckContractV2Errors, AuthorizeCheckContractV2Responses, AuthorizeFinalizeTotpV2Data, AuthorizeFinalizeTotpV2Responses, AuthorizeLinkAppleCredentialsV2Data, AuthorizeLinkAppleCredentialsV2Errors, AuthorizeLinkCredentialsV2Data, AuthorizeLinkCredentialsV2Errors, AuthorizeLinkCredentialsV2Responses, AuthorizeLinkGoogleCredentialsV2Data, AuthorizeLinkGoogleCredentialsV2Errors, AuthorizeLoginAppleV2Data, AuthorizeLoginAppleV2Errors, AuthorizeLoginCookieData, AuthorizeLoginCookieErrors, AuthorizeLoginCookieResponses, AuthorizeLoginCookieV2Data, AuthorizeLoginCookieV2Errors, AuthorizeLoginCookieV2Responses, AuthorizeLoginCookieVerifyData, AuthorizeLoginCookieVerifyErrors, AuthorizeLoginCookieVerifyResponses, AuthorizeLoginCookieVerifyV2Data, AuthorizeLoginCookieVerifyV2Errors, AuthorizeLoginCookieVerifyV2Responses, AuthorizeLoginGoogleV2Data, AuthorizeLoginGoogleV2Errors, AuthorizeLogoutData, AuthorizeLogoutPostData, AuthorizeLogoutPostResponses, AuthorizeLogoutPostV2Data, AuthorizeLogoutPostV2Responses, AuthorizeLogoutResponses, AuthorizeLogoutV2Data, AuthorizeLogoutV2Responses, AuthorizeRefreshTokenData, AuthorizeRefreshTokenErrors, AuthorizeRefreshTokenResponses, AuthorizeRegisterDeviceV2Data, AuthorizeRegisterDeviceV2Errors, AuthorizeRegisterDeviceV2Responses, AuthorizeRegisterServiceRunnerV2Data, AuthorizeRegisterServiceRunnerV2Errors, AuthorizeRegisterServiceRunnerV2Responses, AuthorizeReRegisterUserV2Data, AuthorizeReRegisterUserV2Errors, AuthorizeReRegisterUserV2Responses, AuthorizeSetupTotpV2Data, AuthorizeSetupTotpV2Responses, AuthorizeUnlinkCredentialsV2Data, AuthorizeUnlinkCredentialsV2Errors, AuthorizeUnlinkCredentialsV2Responses, AuthorizeUnregisterDeviceData, AuthorizeUnregisterDeviceErrors, AuthorizeUnregisterDeviceResponses, AuthorizeVerifyLoginWithTotpBackupCodeV2Data, AuthorizeVerifyLoginWithTotpBackupCodeV2Responses, AuthorizeVerifyLoginWithTotpV2Data, AuthorizeVerifyLoginWithTotpV2Responses, BatteryTypesListContainerLockTypesData, BatteryTypesListContainerLockTypesErrors, BatteryTypesListContainerLockTypesResponses, BillingExportBillingItemsData, BillingExportBillingItemsResponses, BillingExportKeyGenerationsData, BillingExportKeyGenerationsResponses, BillingExportOpeningsByContractData, BillingExportOpeningsByContractResponses, BillingExportOpeningsByNfcCardData, BillingExportOpeningsByNfcCardResponses, BillingGetBillingItemsDataData, BillingGetBillingItemsDataErrors, BillingGetBillingItemsDataResponses, BillingGetBillingReportData, BillingGetBillingReportErrors, BillingGetBillingReportResponses, BillingGetOpeningsByCardData, BillingGetOpeningsByCardErrors, BillingGetOpeningsByCardResponses, BillingGetOpeningsByContractData, BillingGetOpeningsByContractErrors, BillingGetOpeningsByContractResponses, ContainerAccessGroupsCreateEntityData, ContainerAccessGroupsCreateEntityErrors, ContainerAccessGroupsCreateEntityResponses, ContainerAccessGroupsDeleteEntityData, ContainerAccessGroupsDeleteEntityErrors, ContainerAccessGroupsDeleteEntityResponses, ContainerAccessGroupsGetEntityData, ContainerAccessGroupsGetEntityErrors, ContainerAccessGroupsGetEntityPageData, ContainerAccessGroupsGetEntityPageErrors, ContainerAccessGroupsGetEntityPageResponses, ContainerAccessGroupsGetEntityResponses, ContainerAccessGroupsIsValueUsedData, ContainerAccessGroupsIsValueUsedErrors, ContainerAccessGroupsIsValueUsedResponses, ContainerAccessGroupsListEntitiesData, ContainerAccessGroupsListEntitiesErrors, ContainerAccessGroupsListEntitiesResponses, ContainerAccessGroupsUpdateEntityData, ContainerAccessGroupsUpdateEntityErrors, ContainerAccessGroupsUpdateEntityResponses, ContainerAddressesCreateContainerIslandsData, ContainerAddressesCreateContainerIslandsErrors, ContainerAddressesCreateContainerIslandsResponses, ContainerAddressesCreateEntityData, ContainerAddressesCreateEntityErrors, ContainerAddressesCreateEntityResponses, ContainerAddressesDeleteEntityData, ContainerAddressesDeleteEntityErrors, ContainerAddressesDeleteEntityResponses, ContainerAddressesGetEntityData, ContainerAddressesGetEntityErrors, ContainerAddressesGetEntityPageData, ContainerAddressesGetEntityPageErrors, ContainerAddressesGetEntityPageResponses, ContainerAddressesGetEntityResponses, ContainerAddressesIsValueUsedData, ContainerAddressesIsValueUsedErrors, ContainerAddressesIsValueUsedResponses, ContainerAddressesListAvailableContainersData, ContainerAddressesListAvailableContainersErrors, ContainerAddressesListAvailableContainersResponses, ContainerAddressesListContainersData, ContainerAddressesListContainersErrors, ContainerAddressesListContainersResponses, ContainerAddressesListEntitiesData, ContainerAddressesListEntitiesErrors, ContainerAddressesListEntitiesResponses, ContainerAddressesUpdateContainersGroupData, ContainerAddressesUpdateContainersGroupErrors, ContainerAddressesUpdateContainersGroupResponses, ContainerAddressesUpdateEntityData, ContainerAddressesUpdateEntityErrors, ContainerAddressesUpdateEntityResponses, ContainerConfigurationTemplatesCreateEntityV2Data, ContainerConfigurationTemplatesCreateEntityV2Errors, ContainerConfigurationTemplatesCreateEntityV2Responses, ContainerConfigurationTemplatesDeleteEntityV2Data, ContainerConfigurationTemplatesDeleteEntityV2Errors, ContainerConfigurationTemplatesDeleteEntityV2Responses, ContainerConfigurationTemplatesGetEntityPageV2Data, ContainerConfigurationTemplatesGetEntityPageV2Responses, ContainerConfigurationTemplatesGetEntityV2Data, ContainerConfigurationTemplatesGetEntityV2Errors, ContainerConfigurationTemplatesGetEntityV2Responses, ContainerConfigurationTemplatesIsValueUsedV2Data, ContainerConfigurationTemplatesIsValueUsedV2Errors, ContainerConfigurationTemplatesIsValueUsedV2Responses, ContainerConfigurationTemplatesUpdateEntityV2Data, ContainerConfigurationTemplatesUpdateEntityV2Errors, ContainerConfigurationTemplatesUpdateEntityV2Responses, ContainerEmptyingsCreateAutomaticRecordData, ContainerEmptyingsCreateAutomaticRecordResponses, ContainerEmptyingsCreateManualRecordData, ContainerEmptyingsCreateManualRecordResponses, ContainerEmptyingsExportListData, ContainerEmptyingsExportListErrors, ContainerEmptyingsExportListResponses, ContainerEmptyingsGetEntityPageData, ContainerEmptyingsGetEntityPageErrors, ContainerEmptyingsGetEntityPageResponses, ContainerLockTypeAliasesGetCustomerAliasesData, ContainerLockTypeAliasesGetCustomerAliasesErrors, ContainerLockTypeAliasesGetCustomerAliasesResponses, ContainerLockTypeAliasesGetEntityPageData, ContainerLockTypeAliasesGetEntityPageErrors, ContainerLockTypeAliasesGetEntityPageResponses, ContainerLockTypeAliasesUpdateAliasesData, ContainerLockTypeAliasesUpdateAliasesErrors, ContainerLockTypeAliasesUpdateAliasesResponses, ContainerLockTypesListContainerLockTypesData, ContainerLockTypesListContainerLockTypesErrors, ContainerLockTypesListContainerLockTypesResponses, ContainerLockTypesListContainerLockTypesWithAliasesData, ContainerLockTypesListContainerLockTypesWithAliasesErrors, ContainerLockTypesListContainerLockTypesWithAliasesResponses, ContainersActivateEntityData, ContainersActivateEntityErrors, ContainersActivateEntityResponses, ContainersAddEntriesData, ContainersAddEntriesErrors, ContainersAddEntriesResponses, ContainersCreateEntityData, ContainersCreateEntityErrors, ContainersCreateEntityResponses, ContainersCreateEntityV2Data, ContainersCreateEntityV2Errors, ContainersCreateEntityV2Responses, ContainersDeleteEntityData, ContainersDeleteEntityErrors, ContainersDeleteEntityResponses, ContainersExportConfigurationHistoryData, ContainersExportConfigurationHistoryResponses, ContainersExportFillLevelHistoryData, ContainersExportFillLevelHistoryResponses, ContainersExportListData, ContainersExportListErrors, ContainersExportListResponses, ContainersExportListV2Data, ContainersExportListV2Responses, ContainersExportMultipleFillLevelHistoryData, ContainersExportMultipleFillLevelHistoryResponses, ContainersGetContainerConfigurationHistoryData, ContainersGetContainerConfigurationHistoryResponses, ContainersGetContainerFillHistoryData, ContainersGetContainerFillHistoryErrors, ContainersGetContainerFillHistoryResponses, ContainersGetContainerInsertCounterHistoryData, ContainersGetContainerInsertCounterHistoryResponses, ContainersGetContainerLocationData, ContainersGetContainerLocationErrors, ContainersGetContainerLocationResponses, ContainersGetContainerLogData, ContainersGetContainerLogResponses, ContainersGetContainerMapData, ContainersGetContainerMapErrors, ContainersGetContainerMapResponses, ContainersGetContainerMapV2Data, ContainersGetContainerMapV2Errors, ContainersGetContainerMapV2Responses, ContainersGetContainerMapV3Data, ContainersGetContainerMapV3Errors, ContainersGetContainerMapV3Responses, ContainersGetEntityData, ContainersGetEntityErrors, ContainersGetEntityPageData, ContainersGetEntityPageErrors, ContainersGetEntityPageResponses, ContainersGetEntityPageV2Data, ContainersGetEntityPageV2Responses, ContainersGetEntityResponses, ContainersGetInfoEntityPageData, ContainersGetInfoEntityPageResponses, ContainersGetInfoEntityPageV2Data, ContainersGetInfoEntityPageV2Responses, ContainersGetLegacyAccessListData, ContainersGetLegacyAccessListErrors, ContainersGetLegacyAccessListResponses, ContainersGetLocationHistoryPageData, ContainersGetLocationHistoryPageErrors, ContainersGetLocationHistoryPageResponses, ContainersGetPageContainerConfigurationHistoryData, ContainersGetPageContainerConfigurationHistoryErrors, ContainersGetPageContainerConfigurationHistoryResponses, ContainersHasContainerLocationData, ContainersHasContainerLocationErrors, ContainersHasContainerLocationResponses, ContainersListEntitiesData, ContainersListEntitiesErrors, ContainersListEntitiesResponses, ContainersReceiveEmptyingDetectionLogsData, ContainersReceiveEmptyingDetectionLogsErrors, ContainersReceiveEmptyingDetectionLogsResponses, ContainersReceiveLogsData, ContainersReceiveLogsErrors, ContainersReceiveLogsResponses, ContainersReceiveStatusData, ContainersReceiveStatusErrors, ContainersReceiveStatusOnlyTelemetryData, ContainersReceiveStatusOnlyTelemetryErrors, ContainersReceiveStatusOnlyTelemetryResponses, ContainersReceiveStatusResponses, ContainersReceiveTransactionsData, ContainersReceiveTransactionsErrors, ContainersReceiveTransactionsResponses, ContainersUpdateEntityData, ContainersUpdateEntityErrors, ContainersUpdateEntityResponses, ContainersUpdateEntityV2Data, ContainersUpdateEntityV2Errors, ContainersUpdateEntityV2Responses, ContainerTransactionConflictsExportListData, ContainerTransactionConflictsExportListErrors, ContainerTransactionConflictsExportListResponses, ContainerTransactionConflictsGetEntityPageData, ContainerTransactionConflictsGetEntityPageErrors, ContainerTransactionConflictsGetEntityPageResponses, ContainerTransactionsConfirmData, ContainerTransactionsConfirmErrors, ContainerTransactionsConfirmResponses, ContainerTransactionsExportListData, ContainerTransactionsExportListErrors, ContainerTransactionsExportListResponses, ContainerTransactionsGetEntityPageData, ContainerTransactionsGetEntityPageErrors, ContainerTransactionsGetEntityPageResponses, ContainerTransactionsReceiveTransactionsData, ContainerTransactionsReceiveTransactionsErrors, ContainerTransactionsReceiveTransactionsResponses, ContainerTypeCreateEntityData, ContainerTypeCreateEntityErrors, ContainerTypeCreateEntityResponses, ContainerTypeDeleteEntityData, ContainerTypeDeleteEntityErrors, ContainerTypeDeleteEntityResponses, ContainerTypeGetEntityData, ContainerTypeGetEntityErrors, ContainerTypeGetEntityPageData, ContainerTypeGetEntityPageResponses, ContainerTypeGetEntityResponses, ContainerTypeGetListData, ContainerTypeGetListResponses, ContainerTypeUpdateEntityData, ContainerTypeUpdateEntityErrors, ContainerTypeUpdateEntityResponses, ContractsActivateEntityData, ContractsActivateEntityErrors, ContractsActivateEntityResponses, ContractsBrandingData, ContractsBrandingErrors, ContractsBrandingResponses, ContractsCreateEntityData, ContractsCreateEntityErrors, ContractsCreateEntityResponses, ContractsDeleteEntityData, ContractsDeleteEntityErrors, ContractsDeleteEntityResponses, ContractsExportListData, ContractsExportListErrors, ContractsExportListResponses, ContractsGetEntityData, ContractsGetEntityErrors, ContractsGetEntityPageData, ContractsGetEntityPageErrors, ContractsGetEntityPageResponses, ContractsGetEntityResponses, ContractsIsValueUsedData, ContractsIsValueUsedErrors, ContractsIsValueUsedResponses, ContractsListAvailableUsersData, ContractsListAvailableUsersErrors, ContractsListAvailableUsersResponses, ContractsListDevicesData, ContractsListDevicesErrors, ContractsListDevicesResponses, ContractsListEntitiesData, ContractsListEntitiesErrors, ContractsListEntitiesResponses, ContractsListUsersData, ContractsListUsersErrors, ContractsListUsersResponses, ContractsUpdateEntityData, ContractsUpdateEntityErrors, ContractsUpdateEntityResponses, ContractsUpdateUsersData, ContractsUpdateUsersErrors, ContractsUpdateUsersResponses, CustomerEulasCreateEntityData, CustomerEulasCreateEntityErrors, CustomerEulasCreateEntityResponses, CustomerEulasGetEntityData, CustomerEulasGetEntityErrors, CustomerEulasGetEntityPageData, CustomerEulasGetEntityPageResponses, CustomerEulasGetEntityResponses, CustomerEulasGetEulaTextData, CustomerEulasGetEulaTextErrors, CustomerEulasGetEulaTextResponses, CustomerEulasIsValueUsedData, CustomerEulasIsValueUsedErrors, CustomerEulasIsValueUsedResponses, CustomerEulasUpdateEntityData, CustomerEulasUpdateEntityErrors, CustomerEulasUpdateEntityResponses, CustomersActivateCigNumberV2Data, CustomersActivateCigNumberV2Errors, CustomersActivateCigNumberV2Responses, CustomersActivateEntityData, CustomersActivateEntityErrors, CustomersActivateEntityResponses, CustomersActivateEntityV2Data, CustomersActivateEntityV2Errors, CustomersActivateEntityV2Responses, CustomersBrandingData, CustomersBrandingErrors, CustomersBrandingResponses, CustomersChangeContainersCustomerData, CustomersChangeContainersCustomerErrors, CustomersChangeContainersCustomerResponses, CustomersCreateCigNumberV2Data, CustomersCreateCigNumberV2Errors, CustomersCreateCigNumberV2Responses, CustomersCreateEntityData, CustomersCreateEntityErrors, CustomersCreateEntityResponses, CustomersCreateEntityV2Data, CustomersCreateEntityV2Errors, CustomersCreateEntityV2Responses, CustomersDeactivateCigNumberV2Data, CustomersDeactivateCigNumberV2Errors, CustomersDeactivateCigNumberV2Responses, CustomersDeleteEntityData, CustomersDeleteEntityErrors, CustomersDeleteEntityResponses, CustomersDeleteEntityV2Data, CustomersDeleteEntityV2Errors, CustomersDeleteEntityV2Responses, CustomersExportListData, CustomersExportListErrors, CustomersExportListResponses, CustomersExportListV2Data, CustomersExportListV2Responses, CustomersFeratelImportLargeListData, CustomersFeratelImportLargeListResponses, CustomersFtpExportTransactionsData, CustomersFtpExportTransactionsResponses, CustomersFtpImportLargeListData, CustomersFtpImportLargeListResponses, CustomersFtpImportLegacyListData, CustomersFtpImportLegacyListResponses, CustomersGetChangeContainersCustomerTemplateData, CustomersGetChangeContainersCustomerTemplateErrors, CustomersGetChangeContainersCustomerTemplateResponses, CustomersGetChatBotKeyData, CustomersGetChatBotKeyErrors, CustomersGetChatBotKeyResponses, CustomersGetCigNumberV2Data, CustomersGetCigNumberV2Errors, CustomersGetCigNumberV2Responses, CustomersGetCustomerFeaturesData, CustomersGetCustomerFeaturesErrors, CustomersGetCustomerFeaturesResponses, CustomersGetCustomerFtpData, CustomersGetCustomerFtpErrors, CustomersGetCustomerFtpResponses, CustomersGetCustomerNotificationSettingsPageData, CustomersGetCustomerNotificationSettingsPageErrors, CustomersGetCustomerNotificationSettingsPageResponses, CustomersGetCustomersFeaturesData, CustomersGetCustomersFeaturesErrors, CustomersGetCustomersFeaturesResponses, CustomersGetCustomerWebHookData, CustomersGetCustomerWebHookErrors, CustomersGetCustomerWebHookResponses, CustomersGetEntityData, CustomersGetEntityErrors, CustomersGetEntityPageData, CustomersGetEntityPageErrors, CustomersGetEntityPageResponses, CustomersGetEntityPageV2Data, CustomersGetEntityPageV2Responses, CustomersGetEntityResponses, CustomersGetEntityV2Data, CustomersGetEntityV2Errors, CustomersGetEntityV2Responses, CustomersGetImportTemplateContainerAddressesData, CustomersGetImportTemplateContainerAddressesErrors, CustomersGetImportTemplateContainerAddressesResponses, CustomersGetImportTemplateContainersData, CustomersGetImportTemplateContainersErrors, CustomersGetImportTemplateContainersResponses, CustomersGetImportTemplateContractContainersData, CustomersGetImportTemplateContractContainersErrors, CustomersGetImportTemplateContractContainersResponses, CustomersGetImportTemplateContractsData, CustomersGetImportTemplateContractsErrors, CustomersGetImportTemplateContractsResponses, CustomersGetImportTemplateFillLevelSensorsData, CustomersGetImportTemplateFillLevelSensorsErrors, CustomersGetImportTemplateFillLevelSensorsResponses, CustomersGetImportTemplateLocationTrackersV2Data, CustomersGetImportTemplateLocationTrackersV2Errors, CustomersGetImportTemplateLocationTrackersV2Responses, CustomersGetImportTemplateNfcCardsContractsData, CustomersGetImportTemplateNfcCardsContractsErrors, CustomersGetImportTemplateNfcCardsContractsResponses, CustomersGetImportTemplateNfcCardsData, CustomersGetImportTemplateNfcCardsErrors, CustomersGetImportTemplateNfcCardsForCustomerData, CustomersGetImportTemplateNfcCardsForCustomerErrors, CustomersGetImportTemplateNfcCardsForCustomerResponses, CustomersGetImportTemplateNfcCardsForCustomerV2Data, CustomersGetImportTemplateNfcCardsForCustomerV2Errors, CustomersGetImportTemplateNfcCardsForCustomerV2Responses, CustomersGetImportTemplateNfcCardsResponses, CustomersGetImportTemplateNfcCardsV2Data, CustomersGetImportTemplateNfcCardsV2Errors, CustomersGetImportTemplateNfcCardsV2Responses, CustomersGetImportTemplateRegionCodesData, CustomersGetImportTemplateRegionCodesErrors, CustomersGetImportTemplateRegionCodesResponses, CustomersGetImportTemplateServiceTasksData, CustomersGetImportTemplateServiceTasksErrors, CustomersGetImportTemplateServiceTasksResponses, CustomersGetImportTemplateSlocFillLevelSensorsV2Data, CustomersGetImportTemplateSlocFillLevelSensorsV2Errors, CustomersGetImportTemplateSlocFillLevelSensorsV2Responses, CustomersGetNfcCardsCustomFieldsV2Data, CustomersGetNfcCardsCustomFieldsV2Responses, CustomersGetServiceTaskCloseOutRulesV2Data, CustomersGetServiceTaskCloseOutRulesV2Responses, CustomersGetTreeV2Data, CustomersGetTreeV2Responses, CustomersImportContainerAddressesData, CustomersImportContainerAddressesErrors, CustomersImportContainerAddressesResponses, CustomersImportContainersData, CustomersImportContainersErrors, CustomersImportContainersResponses, CustomersImportContractContainersData, CustomersImportContractContainersErrors, CustomersImportContractContainersResponses, CustomersImportContractsData, CustomersImportContractsErrors, CustomersImportContractsResponses, CustomersImportFillLevelSensorsData, CustomersImportFillLevelSensorsErrors, CustomersImportFillLevelSensorsResponses, CustomersImportFillLevelSensorsV2Data, CustomersImportFillLevelSensorsV2Errors, CustomersImportFillLevelSensorsV2Responses, CustomersImportLocationTrackersV2Data, CustomersImportLocationTrackersV2Errors, CustomersImportLocationTrackersV2Responses, CustomersImportNfcCardsContractsData, CustomersImportNfcCardsContractsErrors, CustomersImportNfcCardsContractsResponses, CustomersImportNfcCardsData, CustomersImportNfcCardsErrors, CustomersImportNfcCardsJsonV2Data, CustomersImportNfcCardsJsonV2Errors, CustomersImportNfcCardsJsonV2Responses, CustomersImportNfcCardsResponses, CustomersImportNfcCardsV2Data, CustomersImportNfcCardsV2Errors, CustomersImportNfcCardsV2Responses, CustomersImportProAlphaNumbersV2Data, CustomersImportProAlphaNumbersV2Errors, CustomersImportProAlphaNumbersV2Responses, CustomersImportRegionCodesData, CustomersImportRegionCodesErrors, CustomersImportRegionCodesResponses, CustomersImportServiceTasksData, CustomersImportServiceTasksErrors, CustomersImportServiceTasksResponses, CustomersIsValueUsedData, CustomersIsValueUsedErrors, CustomersIsValueUsedResponses, CustomersIsValueUsedV2Data, CustomersIsValueUsedV2Errors, CustomersIsValueUsedV2Responses, CustomersListCigNumbersV2Data, CustomersListCigNumbersV2Errors, CustomersListCigNumbersV2Responses, CustomersListDepartmentsData, CustomersListDepartmentsResponses, CustomersListDepartmentsV2Data, CustomersListDepartmentsV2Responses, CustomersListEntitiesData, CustomersListEntitiesErrors, CustomersListEntitiesResponses, CustomersListEntitiesV2Data, CustomersListEntitiesV2Errors, CustomersListEntitiesV2Responses, CustomersSetCustomerFeaturesData, CustomersSetCustomerFeaturesErrors, CustomersSetCustomerFeaturesResponses, CustomersSetCustomerFtpData, CustomersSetCustomerFtpErrors, CustomersSetCustomerFtpPutData, CustomersSetCustomerFtpPutErrors, CustomersSetCustomerFtpPutResponses, CustomersSetCustomerFtpResponses, CustomersSetCustomerWebHookData, CustomersSetCustomerWebHookErrors, CustomersSetCustomerWebHookResponses, CustomersSetCustomerWebHooksPutData, CustomersSetCustomerWebHooksPutErrors, CustomersSetCustomerWebHooksPutResponses, CustomersSetLogoData, CustomersSetLogoErrors, CustomersSetLogoResponses, CustomersSetNfcCardsCustomFieldsV2Data, CustomersSetNfcCardsCustomFieldsV2Responses, CustomersSetServiceTaskCloseOutRulesV2Data, CustomersSetServiceTaskCloseOutRulesV2Responses, CustomersTestFtpConnectionData, CustomersTestFtpConnectionErrors, CustomersTestFtpConnectionResponses, CustomersUpdateCigNumberV2Data, CustomersUpdateCigNumberV2Errors, CustomersUpdateCigNumberV2Responses, CustomersUpdateEntityData, CustomersUpdateEntityErrors, CustomersUpdateEntityResponses, CustomersUpdateEntityV2Data, CustomersUpdateEntityV2Errors, CustomersUpdateEntityV2Responses, CustomersUpdateParentData, CustomersUpdateParentErrors, CustomersUpdateParentResponses, CustomersUpdateParentV2Data, CustomersUpdateParentV2Errors, CustomersUpdateParentV2Responses, CustomersValidateContainerAddressesImportData, CustomersValidateContainerAddressesImportErrors, CustomersValidateContainerAddressesImportResponses, CustomersValidateContainersChangeCustomerImportData, CustomersValidateContainersChangeCustomerImportErrors, CustomersValidateContainersChangeCustomerImportResponses, CustomersValidateContainersImportData, CustomersValidateContainersImportErrors, CustomersValidateContainersImportResponses, CustomersValidateContractContainersImportData, CustomersValidateContractContainersImportErrors, CustomersValidateContractContainersImportResponses, CustomersValidateContractsImportData, CustomersValidateContractsImportErrors, CustomersValidateContractsImportResponses, CustomersValidateImportFillLevelSensorsData, CustomersValidateImportFillLevelSensorsErrors, CustomersValidateImportFillLevelSensorsResponses, CustomersValidateImportFillLevelSensorsV2Data, CustomersValidateImportFillLevelSensorsV2Errors, CustomersValidateImportFillLevelSensorsV2Responses, CustomersValidateImportLocationTrackersV2Data, CustomersValidateImportLocationTrackersV2Errors, CustomersValidateImportLocationTrackersV2Responses, CustomersValidateImportNfcCardsContractsData, CustomersValidateImportNfcCardsContractsErrors, CustomersValidateImportNfcCardsContractsResponses, CustomersValidateImportNfcCardsData, CustomersValidateImportNfcCardsErrors, CustomersValidateImportNfcCardsResponses, CustomersValidateImportNfcCardsV2Data, CustomersValidateImportNfcCardsV2Errors, CustomersValidateImportNfcCardsV2Responses, CustomersValidateImportRegionCodesData, CustomersValidateImportRegionCodesErrors, CustomersValidateImportRegionCodesResponses, CustomersValidateImportServiceTasksData, CustomersValidateImportServiceTasksErrors, CustomersValidateImportServiceTasksResponses, CustomersValidateProAlphaNumbersV2Data, CustomersValidateProAlphaNumbersV2Responses, DashboardExportFillLevelHistoryData, DashboardExportFillLevelHistoryResponses, DashboardGetContainersDataData, DashboardGetContainersDataErrors, DashboardGetContainersDataResponses, DashboardGetDashboardIssueDataData, DashboardGetDashboardIssueDataErrors, DashboardGetDashboardIssueDataResponses, DashboardGetMissingTransactionsDataData, DashboardGetMissingTransactionsDataErrors, DashboardGetMissingTransactionsDataResponses, DashboardGetTransactionsDataData, DashboardGetTransactionsDataErrors, DashboardGetTransactionsDataResponses, DashboardGetTransactionsTotalData, DashboardGetTransactionsTotalErrors, DashboardGetTransactionsTotalResponses, DataServicesGetCalculatedContainerIslandsData, DataServicesGetCalculatedContainerIslandsErrors, DataServicesGetCalculatedContainerIslandsResponses, DevicesGetDevicesPageData, DevicesGetDevicesPageErrors, DevicesGetDevicesPageResponses, DigiGatewayHardwareCommisionData, DigiGatewayHardwareCommisionErrors, DigiGatewayHardwareCommisionResponses, DigiGatewayHardwareGetDigiGatewayConfigurationData, DigiGatewayHardwareGetDigiGatewayConfigurationErrors, DigiGatewayHardwareGetDigiGatewayConfigurationResponses, DigiGatewayHardwareGetDigiGatewayTaskContextData, DigiGatewayHardwareGetDigiGatewayTaskContextErrors, DigiGatewayHardwareGetDigiGatewayTaskContextResponses, DigiGatewayHardwareGetDigiGatewayTasksData, DigiGatewayHardwareGetDigiGatewayTasksErrors, DigiGatewayHardwareGetDigiGatewayTasksResponses, DigiGatewayHardwareReceiveDiscoveryReportData, DigiGatewayHardwareReceiveDiscoveryReportErrors, DigiGatewayHardwareReceiveDiscoveryReportResponses, DigiGatewayHardwareResolveDigiGatewayTaskData, DigiGatewayHardwareResolveDigiGatewayTaskErrors, DigiGatewayHardwareResolveDigiGatewayTaskResponses, DigiGatewaysCreateDigiGatewayTaskData, DigiGatewaysCreateDigiGatewayTaskErrors, DigiGatewaysCreateDigiGatewayTaskResponses, DigiGatewaysGetDigiGatewayData, DigiGatewaysGetDigiGatewayErrors, DigiGatewaysGetDigiGatewayResponses, DigiGatewaysGetDigiGatewaysPageData, DigiGatewaysGetDigiGatewaysPageErrors, DigiGatewaysGetDigiGatewaysPageResponses, DigiGatewaysGetDigiGatewayTaskData, DigiGatewaysGetDigiGatewayTaskErrors, DigiGatewaysGetDigiGatewayTaskResponses, DigiGatewaysGetDigiGatewayTasksPageData, DigiGatewaysGetDigiGatewayTasksPageErrors, DigiGatewaysGetDigiGatewayTasksPageResponses, DigiGatewaysUpdateEntityData, DigiGatewaysUpdateEntityErrors, DigiGatewaysUpdateEntityResponses, EmptyingDetectionLogsExportEmptyingDetectionLogData, EmptyingDetectionLogsExportEmptyingDetectionLogResponses, EmptyingDetectionLogsGetEmptyingDetectionLogsData, EmptyingDetectionLogsGetEmptyingDetectionLogsResponses, EmptyingDetectionsCloneEntityData, EmptyingDetectionsCloneEntityResponses, EmptyingDetectionsCreateEntityData, EmptyingDetectionsCreateEntityErrors, EmptyingDetectionsCreateEntityResponses, EmptyingDetectionsDeleteEntityData, EmptyingDetectionsDeleteEntityErrors, EmptyingDetectionsDeleteEntityResponses, EmptyingDetectionsExportEntitiesData, EmptyingDetectionsExportEntitiesResponses, EmptyingDetectionsGetEntityData, EmptyingDetectionsGetEntityErrors, EmptyingDetectionsGetEntityPageData, EmptyingDetectionsGetEntityPageErrors, EmptyingDetectionsGetEntityPageResponses, EmptyingDetectionsGetEntityResponses, EmptyingDetectionsIsValueUsedData, EmptyingDetectionsIsValueUsedErrors, EmptyingDetectionsIsValueUsedResponses, EmptyingDetectionsListAvailableContainersData, EmptyingDetectionsListAvailableContainersErrors, EmptyingDetectionsListAvailableContainersResponses, EmptyingDetectionsListContainersData, EmptyingDetectionsListContainersErrors, EmptyingDetectionsListContainersResponses, EmptyingDetectionsListEntitiesData, EmptyingDetectionsListEntitiesErrors, EmptyingDetectionsListEntitiesResponses, EmptyingDetectionsUpdateContainersData, EmptyingDetectionsUpdateContainersErrors, EmptyingDetectionsUpdateContainersResponses, EmptyingDetectionsUpdateEntityData, EmptyingDetectionsUpdateEntityErrors, EmptyingDetectionsUpdateEntityResponses, EndTestGetEndTestPageData, EndTestGetEndTestPageErrors, EndTestGetEndTestPageResponses, FilesLoadFileData, FilesLoadFileErrors, FilesLoadFileResponses, FillLevelSensorConfigurationGroupsCreateEntityData, FillLevelSensorConfigurationGroupsCreateEntityErrors, FillLevelSensorConfigurationGroupsCreateEntityResponses, FillLevelSensorConfigurationGroupsDeleteEntityData, FillLevelSensorConfigurationGroupsDeleteEntityErrors, FillLevelSensorConfigurationGroupsDeleteEntityResponses, FillLevelSensorConfigurationGroupsGetEntityData, FillLevelSensorConfigurationGroupsGetEntityErrors, FillLevelSensorConfigurationGroupsGetEntityPageData, FillLevelSensorConfigurationGroupsGetEntityPageResponses, FillLevelSensorConfigurationGroupsGetEntityResponses, FillLevelSensorConfigurationGroupsIsValueUsedData, FillLevelSensorConfigurationGroupsIsValueUsedErrors, FillLevelSensorConfigurationGroupsIsValueUsedResponses, FillLevelSensorConfigurationGroupsListAvailableContainersData, FillLevelSensorConfigurationGroupsListAvailableContainersErrors, FillLevelSensorConfigurationGroupsListAvailableContainersResponses, FillLevelSensorConfigurationGroupsListContainersData, FillLevelSensorConfigurationGroupsListContainersErrors, FillLevelSensorConfigurationGroupsListContainersResponses, FillLevelSensorConfigurationGroupsListEntitiesData, FillLevelSensorConfigurationGroupsListEntitiesErrors, FillLevelSensorConfigurationGroupsListEntitiesResponses, FillLevelSensorConfigurationGroupsUpdateContainersGroupData, FillLevelSensorConfigurationGroupsUpdateContainersGroupErrors, FillLevelSensorConfigurationGroupsUpdateContainersGroupResponses, FillLevelSensorConfigurationGroupsUpdateEntityData, FillLevelSensorConfigurationGroupsUpdateEntityErrors, FillLevelSensorConfigurationGroupsUpdateEntityResponses, FillLevelSensorsActivateFillLevelSensorData, FillLevelSensorsActivateFillLevelSensorErrors, FillLevelSensorsActivateFillLevelSensorResponses, FillLevelSensorsCreateEntityData, FillLevelSensorsCreateEntityErrors, FillLevelSensorsCreateEntityResponses, FillLevelSensorsDeleteFillLevelSensorData, FillLevelSensorsDeleteFillLevelSensorErrors, FillLevelSensorsDeleteFillLevelSensorResponses, FillLevelSensorsExportListData, FillLevelSensorsExportListErrors, FillLevelSensorsExportListResponses, FillLevelSensorsGetConfigurationData, FillLevelSensorsGetConfigurationResponses, FillLevelSensorsGetContainersPageData, FillLevelSensorsGetContainersPageResponses, FillLevelSensorsGetEntityData, FillLevelSensorsGetEntityErrors, FillLevelSensorsGetEntityPageData, FillLevelSensorsGetEntityPageErrors, FillLevelSensorsGetEntityPageResponses, FillLevelSensorsGetEntityResponses, FillLevelSensorsIsValueUsedData, FillLevelSensorsIsValueUsedErrors, FillLevelSensorsIsValueUsedResponses, FillLevelSensorsListEntitiesData, FillLevelSensorsListEntitiesErrors, FillLevelSensorsListEntitiesResponses, FillLevelSensorsUpdateConfigurationData, FillLevelSensorsUpdateConfigurationErrors, FillLevelSensorsUpdateConfigurationResponses, FillLevelSensorsUpdateEntityData, FillLevelSensorsUpdateEntityErrors, FillLevelSensorsUpdateEntityResponses, FillLevelSensorTypesListFillLevelSensorTypesData, FillLevelSensorTypesListFillLevelSensorTypesErrors, FillLevelSensorTypesListFillLevelSensorTypesResponses, FirmwareActivateEntityData, FirmwareActivateEntityErrors, FirmwareActivateEntityResponses, FirmwareAssignUpdateData, FirmwareAssignUpdateErrors, FirmwareAssignUpdateResponses, FirmwareAssignUpdateViaCsvData, FirmwareAssignUpdateViaCsvErrors, FirmwareAssignUpdateViaCsvResponses, FirmwareDeleteEntityData, FirmwareDeleteEntityErrors, FirmwareDeleteEntityResponses, FirmwareGetEntityData, FirmwareGetEntityErrors, FirmwareGetEntityPageData, FirmwareGetEntityPageErrors, FirmwareGetEntityPageResponses, FirmwareGetEntityResponses, FirmwareListEntitiesData, FirmwareListEntitiesErrors, FirmwareListEntitiesResponses, FirmwareListUpdateableUnitsData, FirmwareListUpdateableUnitsErrors, FirmwareListUpdateableUnitsResponses, FirmwareUpdateEntityData, FirmwareUpdateEntityErrors, FirmwareUpdateEntityResponses, FirmwareUploadFirmwareData, FirmwareUploadFirmwareErrors, FirmwareUploadFirmwareResponses, FirmwareValidateUpdateData, FirmwareValidateUpdateErrors, FirmwareValidateUpdateResponses, FirmwareValidateUpdateViaCsvData, FirmwareValidateUpdateViaCsvErrors, FirmwareValidateUpdateViaCsvResponses, FractionConfigurationGroupsCreateEntityData, FractionConfigurationGroupsCreateEntityErrors, FractionConfigurationGroupsCreateEntityResponses, FractionConfigurationGroupsDeleteEntityData, FractionConfigurationGroupsDeleteEntityErrors, FractionConfigurationGroupsDeleteEntityResponses, FractionConfigurationGroupsGetEntityData, FractionConfigurationGroupsGetEntityErrors, FractionConfigurationGroupsGetEntityPageData, FractionConfigurationGroupsGetEntityPageErrors, FractionConfigurationGroupsGetEntityPageResponses, FractionConfigurationGroupsGetEntityResponses, FractionConfigurationGroupsIsValueUsedData, FractionConfigurationGroupsIsValueUsedErrors, FractionConfigurationGroupsIsValueUsedResponses, FractionConfigurationGroupsListAvailableContainersData, FractionConfigurationGroupsListAvailableContainersErrors, FractionConfigurationGroupsListAvailableContainersResponses, FractionConfigurationGroupsListContainersData, FractionConfigurationGroupsListContainersErrors, FractionConfigurationGroupsListContainersResponses, FractionConfigurationGroupsListEntitiesData, FractionConfigurationGroupsListEntitiesErrors, FractionConfigurationGroupsListEntitiesResponses, FractionConfigurationGroupsUpdateContainersGroupData, FractionConfigurationGroupsUpdateContainersGroupErrors, FractionConfigurationGroupsUpdateContainersGroupResponses, FractionConfigurationGroupsUpdateEntityData, FractionConfigurationGroupsUpdateEntityErrors, FractionConfigurationGroupsUpdateEntityResponses, FractionsCreateEntityV2Data, FractionsCreateEntityV2Errors, FractionsCreateEntityV2Responses, FractionsDeleteEntityV2Data, FractionsDeleteEntityV2Errors, FractionsDeleteEntityV2Responses, FractionsGetEntityPageV2Data, FractionsGetEntityPageV2Errors, FractionsGetEntityPageV2Responses, FractionsGetEntityV2Data, FractionsGetEntityV2Errors, FractionsGetEntityV2Responses, FractionsIsValueUsedV2Data, FractionsIsValueUsedV2Errors, FractionsIsValueUsedV2Responses, FractionsListAvailableContainersV2Data, FractionsListAvailableContainersV2Errors, FractionsListAvailableContainersV2Responses, FractionsListContainersV2Data, FractionsListContainersV2Errors, FractionsListContainersV2Responses, FractionsListEntitiesV2Data, FractionsListEntitiesV2Errors, FractionsListEntitiesV2Responses, FractionsUpdateContainersGroupV2Data, FractionsUpdateContainersGroupV2Errors, FractionsUpdateContainersGroupV2Responses, FractionsUpdateEntityV2Data, FractionsUpdateEntityV2Errors, FractionsUpdateEntityV2Responses, FreeAccessGetContainerFreeAccessTokenForHardwareUnitV2Data, FreeAccessGetContainerFreeAccessTokenForHardwareUnitV2Errors, FreeAccessGetContainerFreeAccessTokenForHardwareUnitV2Responses, GeozonesCreateEntityData, GeozonesCreateEntityErrors, GeozonesCreateEntityResponses, GeozonesDeleteEntityData, GeozonesDeleteEntityErrors, GeozonesDeleteEntityResponses, GeozonesGetEntityData, GeozonesGetEntityErrors, GeozonesGetEntityPageData, GeozonesGetEntityPageResponses, GeozonesGetEntityResponses, GeozonesIsValueUsedData, GeozonesIsValueUsedErrors, GeozonesIsValueUsedResponses, GeozonesListAvailableContainersData, GeozonesListAvailableContainersErrors, GeozonesListAvailableContainersResponses, GeozonesListContainersData, GeozonesListContainersErrors, GeozonesListContainersLastLocationData, GeozonesListContainersLastLocationErrors, GeozonesListContainersLastLocationResponses, GeozonesListContainersResponses, GeozonesUpdateContainersGroupData, GeozonesUpdateContainersGroupErrors, GeozonesUpdateContainersGroupResponses, GeozonesUpdateEntityData, GeozonesUpdateEntityErrors, GeozonesUpdateEntityResponses, HardwareCommandsCreateEntityData, HardwareCommandsCreateEntityErrors, HardwareCommandsCreateEntityResponses, HardwareCommandsGetEntityData, HardwareCommandsGetEntityErrors, HardwareCommandsGetEntityPageData, HardwareCommandsGetEntityPageErrors, HardwareCommandsGetEntityPageResponses, HardwareCommandsGetEntityResponses, HardwareUnitConfigurationChecksCheckSnapshotData, HardwareUnitConfigurationChecksCheckSnapshotErrors, HardwareUnitConfigurationChecksCheckSnapshotResponses, HardwareUnitConfigurationChecksGetConfigurationSnapshotData, HardwareUnitConfigurationChecksGetConfigurationSnapshotErrors, HardwareUnitConfigurationChecksGetConfigurationSnapshotResponses, HardwareUnitLogMessagesGetListOfModulesData, HardwareUnitLogMessagesGetListOfModulesResponses, HardwareUnitLogMessagesGetMessagesPageData, HardwareUnitLogMessagesGetMessagesPageResponses, HardwareUnitLogMessagesImportLogMessagesData, HardwareUnitLogMessagesImportLogMessagesErrors, HardwareUnitLogMessagesImportLogMessagesResponses, HardwareUnitLogMessagesValidateHardwareUnitLogImportData, HardwareUnitLogMessagesValidateHardwareUnitLogImportErrors, HardwareUnitLogMessagesValidateHardwareUnitLogImportResponses, HardwareUnitsAddEntriesData, HardwareUnitsAddEntriesErrors, HardwareUnitsAddEntriesResponses, HardwareUnitsAddLegacyAccessListEntriesData, HardwareUnitsAddLegacyAccessListEntriesErrors, HardwareUnitsAddLegacyAccessListEntriesResponses, HardwareUnitsBulkUpdateData, HardwareUnitsBulkUpdateResponses, HardwareUnitsCreateHardwareConfigurationData, HardwareUnitsCreateHardwareConfigurationErrors, HardwareUnitsCreateHardwareConfigurationResponses, HardwareUnitsExportData, HardwareUnitsExportMultiTelemetryHistoryData, HardwareUnitsExportMultiTelemetryHistoryResponses, HardwareUnitsExportResponses, HardwareUnitsExportTelemetryHistoryData, HardwareUnitsExportTelemetryHistoryResponses, HardwareUnitsGetContainerIdData, HardwareUnitsGetContainerIdErrors, HardwareUnitsGetContainerIdResponses, HardwareUnitsGetEndTestResultsData, HardwareUnitsGetEndTestResultsErrors, HardwareUnitsGetEndTestResultsResponses, HardwareUnitsGetEntityData, HardwareUnitsGetEntityErrors, HardwareUnitsGetEntityPageData, HardwareUnitsGetEntityPageErrors, HardwareUnitsGetEntityPageResponses, HardwareUnitsGetEntityResponses, HardwareUnitsGetFirmwareHistoryData, HardwareUnitsGetFirmwareHistoryErrors, HardwareUnitsGetFirmwareHistoryResponses, HardwareUnitsGetFirmwareInfoData, HardwareUnitsGetFirmwareInfoErrors, HardwareUnitsGetFirmwareInfoResponses, HardwareUnitsGetHardwareConfigurationData, HardwareUnitsGetHardwareConfigurationErrors, HardwareUnitsGetHardwareConfigurationResponses, HardwareUnitsGetLargeListData, HardwareUnitsGetLargeListResponses, HardwareUnitsGetLegacyAccessListData, HardwareUnitsGetLegacyAccessListErrors, HardwareUnitsGetLegacyAccessListResponses, HardwareUnitsGetLogData, HardwareUnitsGetLogResponses, HardwareUnitsGetTelemetryHistoryData, HardwareUnitsGetTelemetryHistoryErrors, HardwareUnitsGetTelemetryHistoryResponses, HardwareUnitsIsAvailableData, HardwareUnitsIsAvailableErrors, HardwareUnitsIsAvailableResponses, HardwareUnitsListHardwareModulesData, HardwareUnitsListHardwareModulesErrors, HardwareUnitsListHardwareModulesResponses, HardwareUnitsListHardwareUnitsData, HardwareUnitsListHardwareUnitsErrors, HardwareUnitsListHardwareUnitsForServiceUserData, HardwareUnitsListHardwareUnitsForServiceUserErrors, HardwareUnitsListHardwareUnitsForServiceUserResponses, HardwareUnitsListHardwareUnitsResponses, HardwareUnitsListPagedHardwareUnitsData, HardwareUnitsListPagedHardwareUnitsErrors, HardwareUnitsListPagedHardwareUnitsResponses, HardwareUnitsUpdateEntityData, HardwareUnitsUpdateEntityErrors, HardwareUnitsUpdateEntityResponses, HardwareUnitsValidateBulkUpdateData, HardwareUnitsValidateBulkUpdateResponses, ImagesShowImageData, ImagesShowImageErrors, ImagesShowImageResponses, ImagesUploadImageData, ImagesUploadImageErrors, ImagesUploadImageResponses, IntervalConfigurationGroupsCreateEntityData, IntervalConfigurationGroupsCreateEntityErrors, IntervalConfigurationGroupsCreateEntityResponses, IntervalConfigurationGroupsDeleteEntityData, IntervalConfigurationGroupsDeleteEntityErrors, IntervalConfigurationGroupsDeleteEntityResponses, IntervalConfigurationGroupsGetEntityData, IntervalConfigurationGroupsGetEntityErrors, IntervalConfigurationGroupsGetEntityPageData, IntervalConfigurationGroupsGetEntityPageErrors, IntervalConfigurationGroupsGetEntityPageResponses, IntervalConfigurationGroupsGetEntityResponses, IntervalConfigurationGroupsIsValueUsedData, IntervalConfigurationGroupsIsValueUsedErrors, IntervalConfigurationGroupsIsValueUsedResponses, IntervalConfigurationGroupsListAvailableContainersData, IntervalConfigurationGroupsListAvailableContainersErrors, IntervalConfigurationGroupsListAvailableContainersResponses, IntervalConfigurationGroupsListContainersData, IntervalConfigurationGroupsListContainersErrors, IntervalConfigurationGroupsListContainersResponses, IntervalConfigurationGroupsListEntitiesData, IntervalConfigurationGroupsListEntitiesErrors, IntervalConfigurationGroupsListEntitiesResponses, IntervalConfigurationGroupsUpdateContainersGroupData, IntervalConfigurationGroupsUpdateContainersGroupErrors, IntervalConfigurationGroupsUpdateContainersGroupResponses, IntervalConfigurationGroupsUpdateEntityData, IntervalConfigurationGroupsUpdateEntityErrors, IntervalConfigurationGroupsUpdateEntityResponses, IssuesCreateIssueData, IssuesCreateIssueErrors, IssuesCreateIssueResponses, IssuesExportListData, IssuesExportListErrors, IssuesExportListResponses, IssuesFixIssueData, IssuesFixIssueErrors, IssuesFixIssueResponses, IssuesGetIssueData, IssuesGetIssueErrors, IssuesGetIssueResponses, IssuesGetIssuesPageData, IssuesGetIssuesPageErrors, IssuesGetIssuesPageResponses, IssuesListIssueTypesData, IssuesListIssueTypesResponses, IssuesRejectIssueData, IssuesRejectIssueErrors, IssuesRejectIssueResponses, IssuesReopenIssueData, IssuesReopenIssueErrors, IssuesReopenIssueResponses, IssuesStartIssueData, IssuesStartIssueErrors, IssuesStartIssueResponses, LanguagesListLanguagesData, LanguagesListLanguagesResponses, LargeListsActivateEntityData, LargeListsActivateEntityErrors, LargeListsActivateEntityResponses, LargeListsAddEntriesData, LargeListsAddEntriesErrors, LargeListsAddEntriesResponses, LargeListsBulkAssignLargeListData, LargeListsBulkAssignLargeListErrors, LargeListsBulkAssignLargeListResponses, LargeListsCreateEntityData, LargeListsCreateEntityErrors, LargeListsCreateEntityResponses, LargeListsDeleteEntityData, LargeListsDeleteEntityErrors, LargeListsDeleteEntityResponses, LargeListsGetEntityData, LargeListsGetEntityErrors, LargeListsGetEntityPageData, LargeListsGetEntityPageErrors, LargeListsGetEntityPageResponses, LargeListsGetEntityResponses, LargeListsGetEntriesPageData, LargeListsGetEntriesPageResponses, LargeListsGetImportTemplateContractContainersData, LargeListsGetImportTemplateContractContainersErrors, LargeListsGetImportTemplateContractContainersResponses, LargeListsIsValueUsedData, LargeListsIsValueUsedErrors, LargeListsIsValueUsedResponses, LargeListsListAvailableContainersData, LargeListsListAvailableContainersErrors, LargeListsListAvailableContainersResponses, LargeListsListContainersData, LargeListsListContainersErrors, LargeListsListContainersResponses, LargeListsListEntitiesData, LargeListsListEntitiesErrors, LargeListsListEntitiesResponses, LargeListsUpdateContainersData, LargeListsUpdateContainersErrors, LargeListsUpdateContainersResponses, LargeListsUpdateEntityData, LargeListsUpdateEntityErrors, LargeListsUpdateEntityResponses, LegalGetLegalDocumentData, LegalGetLegalDocumentErrors, LegalGetLegalDocumentResponses, LegalGetLegalDocumentWithCultureData, LegalGetLegalDocumentWithCultureErrors, LegalGetLegalDocumentWithCultureResponses, LiftingSystemsCreateEntityData, LiftingSystemsCreateEntityErrors, LiftingSystemsCreateEntityResponses, LiftingSystemsDeleteEntityData, LiftingSystemsDeleteEntityErrors, LiftingSystemsDeleteEntityResponses, LiftingSystemsGetEntityData, LiftingSystemsGetEntityErrors, LiftingSystemsGetEntityPageData, LiftingSystemsGetEntityPageErrors, LiftingSystemsGetEntityPageResponses, LiftingSystemsGetEntityResponses, LiftingSystemsListEntitiesData, LiftingSystemsListEntitiesErrors, LiftingSystemsListEntitiesResponses, LiftingSystemsUpdateEntityData, LiftingSystemsUpdateEntityErrors, LiftingSystemsUpdateEntityResponses, LocationTrackersActivateEntityData, LocationTrackersActivateEntityErrors, LocationTrackersActivateEntityResponses, LocationTrackersCreateEntityData, LocationTrackersCreateEntityErrors, LocationTrackersCreateEntityResponses, LocationTrackersDeleteEntityData, LocationTrackersDeleteEntityErrors, LocationTrackersDeleteEntityResponses, LocationTrackersGetEntityData, LocationTrackersGetEntityErrors, LocationTrackersGetEntityPageData, LocationTrackersGetEntityPageResponses, LocationTrackersGetEntityResponses, LocationTrackersIsValueUsedData, LocationTrackersIsValueUsedErrors, LocationTrackersIsValueUsedResponses, LocationTrackersListEntitiesData, LocationTrackersListEntitiesErrors, LocationTrackersListEntitiesResponses, LocationTrackersUpdateEntityData, LocationTrackersUpdateEntityErrors, LocationTrackersUpdateEntityResponses, LocationTrackerTypesListLocationTrackerTypesData, LocationTrackerTypesListLocationTrackerTypesErrors, LocationTrackerTypesListLocationTrackerTypesResponses, MaterialsCreateEntityData, MaterialsCreateEntityErrors, MaterialsCreateEntityResponses, MaterialsDeleteEntityData, MaterialsDeleteEntityErrors, MaterialsDeleteEntityResponses, MaterialsGetEntityData, MaterialsGetEntityErrors, MaterialsGetEntityPageData, MaterialsGetEntityPageErrors, MaterialsGetEntityPageResponses, MaterialsGetEntityResponses, MaterialsIsValueUsedData, MaterialsIsValueUsedErrors, MaterialsIsValueUsedResponses, MaterialsListMaterialsData, MaterialsListMaterialsResponses, MaterialsUpdateEntityData, MaterialsUpdateEntityErrors, MaterialsUpdateEntityResponses, MeAddContractV2Data, MeAddContractV2Responses, MeGetAllContainersDataV2V2Data, MeGetAllContainersDataV2V2Responses, MeGetContainerBlockingIntervalsData, MeGetContainerBlockingIntervalsErrors, MeGetContainerBlockingIntervalsResponses, MeGetContainerBlockingIntervalsV2Data, MeGetContainerBlockingIntervalsV2Errors, MeGetContainerBlockingIntervalsV2Responses, MeGetContainerDataV2V2Data, MeGetContainerDataV2V2Errors, MeGetContainerDataV2V2Responses, MeGetContainerMapData, MeGetContainerMapErrors, MeGetContainerMapResponses, MeGetContainerMapV2Data, MeGetContainerMapV2Errors, MeGetContainerMapV2Responses, MeGetContainersData, MeGetContainersResponses, MeGetContainersV2Data, MeGetContainersV2Responses, MeGetFeaturesData, MeGetFeaturesResponses, MeGetFeaturesV2Data, MeGetFeaturesV2Responses, MeGetMessagesData, MeGetMessagesResponses, MeGetMessagesV2Data, MeGetMessagesV2Responses, MeGetTransactionsDailyCountReportData, MeGetTransactionsDailyCountReportErrors, MeGetTransactionsDailyCountReportResponses, MeGetTransactionsDailyCountReportV2Data, MeGetTransactionsDailyCountReportV2Errors, MeGetTransactionsDailyCountReportV2Responses, MeGetTransactionsData, MeGetTransactionsErrors, MeGetTransactionsResponses, MeGetTransactionsV2Data, MeGetTransactionsV2Errors, MeGetTransactionsV2Responses, MeGetUserProfileData, MeGetUserProfileResponses, MeGetUserProfileV2Data, MeGetUserProfileV2Responses, MeGetUserTransactionFractionData, MeGetUserTransactionFractionErrors, MeGetUserTransactionFractionResponses, MeGetUserTransactionFractionV2Data, MeGetUserTransactionFractionV2Errors, MeGetUserTransactionFractionV2Responses, MeGetUserTransactionTotalsByFractionData, MeGetUserTransactionTotalsByFractionDetailedData, MeGetUserTransactionTotalsByFractionDetailedErrors, MeGetUserTransactionTotalsByFractionDetailedResponses, MeGetUserTransactionTotalsByFractionDetailedV2Data, MeGetUserTransactionTotalsByFractionDetailedV2Errors, MeGetUserTransactionTotalsByFractionDetailedV2Responses, MeGetUserTransactionTotalsByFractionErrors, MeGetUserTransactionTotalsByFractionResponses, MeGetUserTransactionTotalsByFractionV2Data, MeGetUserTransactionTotalsByFractionV2Errors, MeGetUserTransactionTotalsByFractionV2Responses, MeGetUserTransactionTotalsBySourceData, MeGetUserTransactionTotalsBySourceErrors, MeGetUserTransactionTotalsBySourceResponses, MeGetUserTransactionTotalsBySourceV2Data, MeGetUserTransactionTotalsBySourceV2Errors, MeGetUserTransactionTotalsBySourceV2Responses, MeGetUserTransactionTotalsData, MeGetUserTransactionTotalsDetailedData, MeGetUserTransactionTotalsDetailedErrors, MeGetUserTransactionTotalsDetailedResponses, MeGetUserTransactionTotalsDetailedV2Data, MeGetUserTransactionTotalsDetailedV2Errors, MeGetUserTransactionTotalsDetailedV2Responses, MeGetUserTransactionTotalsErrors, MeGetUserTransactionTotalsResponses, MeGetUserTransactionTotalsV2Data, MeGetUserTransactionTotalsV2Errors, MeGetUserTransactionTotalsV2Responses, MeUpdateUserContractV2Data, MeUpdateUserContractV2Responses, MeUpdateUserDeviceV2Data, MeUpdateUserDeviceV2Responses, MifareDataReadFrameCreateEntityData, MifareDataReadFrameCreateEntityErrors, MifareDataReadFrameCreateEntityResponses, MifareDataReadFrameDeleteEntityData, MifareDataReadFrameDeleteEntityErrors, MifareDataReadFrameDeleteEntityResponses, MifareDataReadFrameGetEntityData, MifareDataReadFrameGetEntityErrors, MifareDataReadFrameGetEntityPageData, MifareDataReadFrameGetEntityPageErrors, MifareDataReadFrameGetEntityPageResponses, MifareDataReadFrameGetEntityResponses, MifareDataReadFrameIsValueUsedData, MifareDataReadFrameIsValueUsedErrors, MifareDataReadFrameIsValueUsedResponses, MifareDataReadFrameListEntitiesData, MifareDataReadFrameListEntitiesErrors, MifareDataReadFrameListEntitiesResponses, MifareDataReadFrameUpdateEntityData, MifareDataReadFrameUpdateEntityErrors, MifareDataReadFrameUpdateEntityResponses, NfcCardBlacklistsAddCardData, NfcCardBlacklistsAddCardErrors, NfcCardBlacklistsAddCardResponses, NfcCardBlacklistsCreateEntityData, NfcCardBlacklistsCreateEntityErrors, NfcCardBlacklistsCreateEntityResponses, NfcCardBlacklistsDeleteEntityData, NfcCardBlacklistsDeleteEntityErrors, NfcCardBlacklistsDeleteEntityResponses, NfcCardBlacklistsGetEntityData, NfcCardBlacklistsGetEntityErrors, NfcCardBlacklistsGetEntityPageData, NfcCardBlacklistsGetEntityPageErrors, NfcCardBlacklistsGetEntityPageResponses, NfcCardBlacklistsGetEntityResponses, NfcCardBlacklistsIsValueUsedData, NfcCardBlacklistsIsValueUsedErrors, NfcCardBlacklistsIsValueUsedResponses, NfcCardBlacklistsListEntitiesData, NfcCardBlacklistsListEntitiesErrors, NfcCardBlacklistsListEntitiesResponses, NfcCardBlacklistsRemoveCardData, NfcCardBlacklistsRemoveCardErrors, NfcCardBlacklistsRemoveCardResponses, NfcCardBlacklistsUpdateEntityData, NfcCardBlacklistsUpdateEntityErrors, NfcCardBlacklistsUpdateEntityResponses, NfcCardConfigurationGroupsCreateEntityData, NfcCardConfigurationGroupsCreateEntityErrors, NfcCardConfigurationGroupsCreateEntityResponses, NfcCardConfigurationGroupsDeleteEntityData, NfcCardConfigurationGroupsDeleteEntityErrors, NfcCardConfigurationGroupsDeleteEntityResponses, NfcCardConfigurationGroupsGetEntityData, NfcCardConfigurationGroupsGetEntityErrors, NfcCardConfigurationGroupsGetEntityPageData, NfcCardConfigurationGroupsGetEntityPageErrors, NfcCardConfigurationGroupsGetEntityPageResponses, NfcCardConfigurationGroupsGetEntityResponses, NfcCardConfigurationGroupsIsValueUsedData, NfcCardConfigurationGroupsIsValueUsedErrors, NfcCardConfigurationGroupsIsValueUsedResponses, NfcCardConfigurationGroupsListAvailableContainersData, NfcCardConfigurationGroupsListAvailableContainersErrors, NfcCardConfigurationGroupsListAvailableContainersResponses, NfcCardConfigurationGroupsListContainersData, NfcCardConfigurationGroupsListContainersErrors, NfcCardConfigurationGroupsListContainersResponses, NfcCardConfigurationGroupsListEligibleData, NfcCardConfigurationGroupsListEligibleResponses, NfcCardConfigurationGroupsListEntitiesData, NfcCardConfigurationGroupsListEntitiesErrors, NfcCardConfigurationGroupsListEntitiesResponses, NfcCardConfigurationGroupsUpdateContainersGroupData, NfcCardConfigurationGroupsUpdateContainersGroupErrors, NfcCardConfigurationGroupsUpdateContainersGroupResponses, NfcCardConfigurationGroupsUpdateEntityData, NfcCardConfigurationGroupsUpdateEntityErrors, NfcCardConfigurationGroupsUpdateEntityResponses, NfcCardsActivateEntityData, NfcCardsActivateEntityErrors, NfcCardsActivateEntityResponses, NfcCardsCreateEntityData, NfcCardsCreateEntityErrors, NfcCardsCreateEntityResponses, NfcCardsExportListData, NfcCardsExportListErrors, NfcCardsExportListResponses, NfcCardsGenerateBleKeysData, NfcCardsGenerateBleKeysErrors, NfcCardsGenerateBleKeysResponses, NfcCardsGetBlacklistOptionsData, NfcCardsGetBlacklistOptionsErrors, NfcCardsGetBlacklistOptionsResponses, NfcCardsGetEntityData, NfcCardsGetEntityErrors, NfcCardsGetEntityPageData, NfcCardsGetEntityPageErrors, NfcCardsGetEntityPageResponses, NfcCardsGetEntityResponses, NfcCardsIsValueUsedData, NfcCardsIsValueUsedErrors, NfcCardsIsValueUsedResponses, NfcCardsListCardAuthenticationTypesData, NfcCardsListCardAuthenticationTypesResponses, NfcCardsListCardReaderTypesData, NfcCardsListCardReaderTypesResponses, NfcCardsListCardTypesData, NfcCardsListCardTypesResponses, NfcCardsListEntitiesData, NfcCardsListEntitiesErrors, NfcCardsListEntitiesResponses, NfcCardsUpdateEntityData, NfcCardsUpdateEntityErrors, NfcCardsUpdateEntityResponses, NotificationSettingsCreateNotificationSettingData, NotificationSettingsCreateNotificationSettingErrors, NotificationSettingsCreateNotificationSettingResponses, NotificationSettingsDeleteNotificationSettingData, NotificationSettingsDeleteNotificationSettingErrors, NotificationSettingsDeleteNotificationSettingResponses, NotificationSettingsGetNotificationSettingData, NotificationSettingsGetNotificationSettingErrors, NotificationSettingsGetNotificationSettingResponses, NotificationSettingsUpdateNotificationSettingData, NotificationSettingsUpdateNotificationSettingErrors, NotificationSettingsUpdateNotificationSettingResponses, PermissionGroupsCreateEntityData, PermissionGroupsCreateEntityErrors, PermissionGroupsCreateEntityResponses, PermissionGroupsDeleteEntityData, PermissionGroupsDeleteEntityErrors, PermissionGroupsDeleteEntityResponses, PermissionGroupsGetEffectiveRolesByGroupIdsData, PermissionGroupsGetEffectiveRolesByGroupIdsResponses, PermissionGroupsGetEntityData, PermissionGroupsGetEntityErrors, PermissionGroupsGetEntityPageData, PermissionGroupsGetEntityPageErrors, PermissionGroupsGetEntityPageResponses, PermissionGroupsGetEntityResponses, PermissionGroupsIsValueUsedData, PermissionGroupsIsValueUsedErrors, PermissionGroupsIsValueUsedResponses, PermissionGroupsListEntitiesData, PermissionGroupsListEntitiesErrors, PermissionGroupsListEntitiesResponses, PermissionGroupsUpdateEntityData, PermissionGroupsUpdateEntityErrors, PermissionGroupsUpdateEntityResponses, ProductsCreateEntityData, ProductsCreateEntityErrors, ProductsCreateEntityResponses, ProductsDeleteEntityData, ProductsDeleteEntityErrors, ProductsDeleteEntityResponses, ProductsGetByPartNumberData, ProductsGetByPartNumberResponses, ProductsGetEntityData, ProductsGetEntityErrors, ProductsGetEntityPageData, ProductsGetEntityPageErrors, ProductsGetEntityPageResponses, ProductsGetEntityResponses, ProductsIsValueUsedData, ProductsIsValueUsedErrors, ProductsIsValueUsedResponses, ProductsListEntitiesData, ProductsListEntitiesErrors, ProductsListEntitiesResponses, ProductsUpdateEntityData, ProductsUpdateEntityErrors, ProductsUpdateEntityResponses, RegionCodesConfigurationGroupsCreateEntityData, RegionCodesConfigurationGroupsCreateEntityErrors, RegionCodesConfigurationGroupsCreateEntityResponses, RegionCodesConfigurationGroupsDeleteEntityData, RegionCodesConfigurationGroupsDeleteEntityErrors, RegionCodesConfigurationGroupsDeleteEntityResponses, RegionCodesConfigurationGroupsGetEntityData, RegionCodesConfigurationGroupsGetEntityErrors, RegionCodesConfigurationGroupsGetEntityPageData, RegionCodesConfigurationGroupsGetEntityPageErrors, RegionCodesConfigurationGroupsGetEntityPageResponses, RegionCodesConfigurationGroupsGetEntityResponses, RegionCodesConfigurationGroupsIsValueUsedData, RegionCodesConfigurationGroupsIsValueUsedErrors, RegionCodesConfigurationGroupsIsValueUsedResponses, RegionCodesConfigurationGroupsListAvailableContainersData, RegionCodesConfigurationGroupsListAvailableContainersErrors, RegionCodesConfigurationGroupsListAvailableContainersResponses, RegionCodesConfigurationGroupsListContainersData, RegionCodesConfigurationGroupsListContainersErrors, RegionCodesConfigurationGroupsListContainersResponses, RegionCodesConfigurationGroupsListEntitiesData, RegionCodesConfigurationGroupsListEntitiesErrors, RegionCodesConfigurationGroupsListEntitiesResponses, RegionCodesConfigurationGroupsUpdateContainersGroupData, RegionCodesConfigurationGroupsUpdateContainersGroupErrors, RegionCodesConfigurationGroupsUpdateContainersGroupResponses, RegionCodesConfigurationGroupsUpdateEntityData, RegionCodesConfigurationGroupsUpdateEntityErrors, RegionCodesConfigurationGroupsUpdateEntityResponses, RegionCodesCreateEntityData, RegionCodesCreateEntityErrors, RegionCodesCreateEntityResponses, RegionCodesDeleteEntityData, RegionCodesDeleteEntityErrors, RegionCodesDeleteEntityResponses, RegionCodesExportListData, RegionCodesExportListErrors, RegionCodesExportListResponses, RegionCodesGetEntityData, RegionCodesGetEntityErrors, RegionCodesGetEntityPageData, RegionCodesGetEntityPageErrors, RegionCodesGetEntityPageResponses, RegionCodesGetEntityResponses, RegionCodesIsValueUsedData, RegionCodesIsValueUsedErrors, RegionCodesIsValueUsedResponses, RegionCodesListEntitiesData, RegionCodesListEntitiesErrors, RegionCodesListEntitiesResponses, RegionCodesUpdateEntityData, RegionCodesUpdateEntityErrors, RegionCodesUpdateEntityResponses, ReportsCreateTaskListReportData, ReportsCreateTaskListReportErrors, ReportsCreateTaskListReportResponses, ReportsDeleteReportData, ReportsDeleteReportErrors, ReportsDeleteReportResponses, ReportsExportLastCommunicationFlsReportData, ReportsExportLastCommunicationFlsReportErrors, ReportsExportLastCommunicationFlsReportResponses, ReportsExportLastCommunicationLocationTrackerReportData, ReportsExportLastCommunicationLocationTrackerReportErrors, ReportsExportLastCommunicationLocationTrackerReportResponses, ReportsExportLastCommunicationReportData, ReportsExportLastCommunicationReportErrors, ReportsExportLastCommunicationReportResponses, ReportsExportListData, ReportsExportListErrors, ReportsExportListResponses, ReportsGetBatteryLifeReportData, ReportsGetBatteryLifeReportErrors, ReportsGetBatteryLifeReportResponses, ReportsGetIssueReportsDailyCountReportData, ReportsGetIssueReportsDailyCountReportErrors, ReportsGetIssueReportsDailyCountReportResponses, ReportsGetLastCommunicationFlsReportData, ReportsGetLastCommunicationFlsReportErrors, ReportsGetLastCommunicationFlsReportResponses, ReportsGetLastCommunicationLocationTrackerData, ReportsGetLastCommunicationLocationTrackerErrors, ReportsGetLastCommunicationLocationTrackerResponses, ReportsGetLastCommunicationReportData, ReportsGetLastCommunicationReportErrors, ReportsGetLastCommunicationReportResponses, ReportsGetPagedBatteryLifeReportData, ReportsGetPagedBatteryLifeReportErrors, ReportsGetPagedBatteryLifeReportResponses, ReportsGetReportConfigurationData, ReportsGetReportConfigurationResponses, ReportsGetReportsPageData, ReportsGetReportsPageErrors, ReportsGetReportsPageResponses, ReportsGetTransactionsDailyCountReportData, ReportsGetTransactionsDailyCountReportErrors, ReportsGetTransactionsDailyCountReportResponses, ReportsRunTaskListReportData, ReportsRunTaskListReportErrors, ReportsRunTaskListReportResponses, ReportsUpdateTaskListReportData, ReportsUpdateTaskListReportErrors, ReportsUpdateTaskListReportResponses, RolesGetAllData, RolesGetAllResponses, ServerInfoGetConfigData, ServerInfoGetConfigResponses, ServerInfoGetExportSettingsData, ServerInfoGetExportSettingsResponses, ServiceAppEventsCreateEntityData, ServiceAppEventsCreateEntityErrors, ServiceAppEventsCreateEntityResponses, ServiceAppEventsExportServiceAppEventsData, ServiceAppEventsExportServiceAppEventsResponses, ServiceAppEventsGetEntityData, ServiceAppEventsGetEntityErrors, ServiceAppEventsGetEntityPageData, ServiceAppEventsGetEntityPageErrors, ServiceAppEventsGetEntityPageResponses, ServiceAppEventsGetEntityResponses, ServiceCallsBulkServiceCallConfirmationData, ServiceCallsBulkServiceCallConfirmationErrors, ServiceCallsBulkServiceCallConfirmationResponses, ServiceCallsConfirmServiceCallData, ServiceCallsConfirmServiceCallErrors, ServiceCallsConfirmServiceCallResponses, ServiceCallsExportServiceCallsData, ServiceCallsExportServiceCallsResponses, ServiceCallsGetServiceCallsPageData, ServiceCallsGetServiceCallsPageErrors, ServiceCallsGetServiceCallsPageResponses, ServiceCallsListServiceCallsData, ServiceCallsListServiceCallsResponses, ServiceCallsValidateBulkServiceCallConfirmationData, ServiceCallsValidateBulkServiceCallConfirmationErrors, ServiceCallsValidateBulkServiceCallConfirmationResponses, ServiceDashboardGetDashboardDataData, ServiceDashboardGetDashboardDataErrors, ServiceDashboardGetDashboardDataResponses, ServiceTaskCancelServiceTaskData, ServiceTaskCancelServiceTaskErrors, ServiceTaskCancelServiceTaskResponses, ServiceTaskCategoriesCreateEntityData, ServiceTaskCategoriesCreateEntityErrors, ServiceTaskCategoriesCreateEntityResponses, ServiceTaskCategoriesDeleteEntityData, ServiceTaskCategoriesDeleteEntityErrors, ServiceTaskCategoriesDeleteEntityResponses, ServiceTaskCategoriesGetEntityData, ServiceTaskCategoriesGetEntityErrors, ServiceTaskCategoriesGetEntityPageData, ServiceTaskCategoriesGetEntityPageErrors, ServiceTaskCategoriesGetEntityPageResponses, ServiceTaskCategoriesGetEntityResponses, ServiceTaskCategoriesIsValueUsedData, ServiceTaskCategoriesIsValueUsedErrors, ServiceTaskCategoriesIsValueUsedResponses, ServiceTaskCategoriesListCategoriesData, ServiceTaskCategoriesListCategoriesResponses, ServiceTaskCategoriesUpdateEntityData, ServiceTaskCategoriesUpdateEntityErrors, ServiceTaskCategoriesUpdateEntityResponses, ServiceTaskCausesCreateEntityData, ServiceTaskCausesCreateEntityErrors, ServiceTaskCausesCreateEntityResponses, ServiceTaskCausesDeleteEntityData, ServiceTaskCausesDeleteEntityErrors, ServiceTaskCausesDeleteEntityResponses, ServiceTaskCausesGetEntityData, ServiceTaskCausesGetEntityErrors, ServiceTaskCausesGetEntityPageData, ServiceTaskCausesGetEntityPageErrors, ServiceTaskCausesGetEntityPageResponses, ServiceTaskCausesGetEntityResponses, ServiceTaskCausesIsValueUsedData, ServiceTaskCausesIsValueUsedErrors, ServiceTaskCausesIsValueUsedResponses, ServiceTaskCausesListCausesData, ServiceTaskCausesListCausesResponses, ServiceTaskCausesUpdateEntityData, ServiceTaskCausesUpdateEntityErrors, ServiceTaskCausesUpdateEntityResponses, ServiceTaskCreateServiceTaskData, ServiceTaskCreateServiceTaskErrors, ServiceTaskCreateServiceTaskResponses, ServiceTaskExportListData, ServiceTaskExportListErrors, ServiceTaskExportListResponses, ServiceTaskFixServiceTaskData, ServiceTaskFixServiceTaskErrors, ServiceTaskFixServiceTaskResponses, ServiceTaskGetServiceTaskData, ServiceTaskGetServiceTaskErrors, ServiceTaskGetServiceTaskListData, ServiceTaskGetServiceTaskListResponses, ServiceTaskGetServiceTaskLogsPageData, ServiceTaskGetServiceTaskLogsPageErrors, ServiceTaskGetServiceTaskLogsPageResponses, ServiceTaskGetServiceTaskPageData, ServiceTaskGetServiceTaskPageErrors, ServiceTaskGetServiceTaskPageResponses, ServiceTaskGetServiceTaskResponses, ServiceTaskHasActiveServiceTaskData, ServiceTaskHasActiveServiceTaskErrors, ServiceTaskHasActiveServiceTaskResponses, ServiceTaskRejectServiceTaskData, ServiceTaskRejectServiceTaskErrors, ServiceTaskRejectServiceTaskResponses, ServiceTaskReopenServiceTaskData, ServiceTaskReopenServiceTaskErrors, ServiceTaskReopenServiceTaskResponses, ServiceTaskSolutionsCreateEntityData, ServiceTaskSolutionsCreateEntityErrors, ServiceTaskSolutionsCreateEntityResponses, ServiceTaskSolutionsDeleteEntityData, ServiceTaskSolutionsDeleteEntityErrors, ServiceTaskSolutionsDeleteEntityResponses, ServiceTaskSolutionsGetEntityData, ServiceTaskSolutionsGetEntityErrors, ServiceTaskSolutionsGetEntityPageData, ServiceTaskSolutionsGetEntityPageErrors, ServiceTaskSolutionsGetEntityPageResponses, ServiceTaskSolutionsGetEntityResponses, ServiceTaskSolutionsIsValueUsedData, ServiceTaskSolutionsIsValueUsedErrors, ServiceTaskSolutionsIsValueUsedResponses, ServiceTaskSolutionsListSolutionsData, ServiceTaskSolutionsListSolutionsResponses, ServiceTaskSolutionsUpdateEntityData, ServiceTaskSolutionsUpdateEntityErrors, ServiceTaskSolutionsUpdateEntityResponses, ServiceTaskStartServiceTaskData, ServiceTaskStartServiceTaskErrors, ServiceTaskStartServiceTaskResponses, ServiceTaskUpdateServiceTaskData, ServiceTaskUpdateServiceTaskErrors, ServiceTaskUpdateServiceTaskResponses, ServiceTaskUploadImageData, ServiceTaskUploadImageErrors, ServiceTaskUploadImageResponses, SimCardsGetTerminateTemplateData, SimCardsGetTerminateTemplateErrors, SimCardsGetTerminateTemplateResponses, SimCardsTerminateSimCardsData, SimCardsTerminateSimCardsErrors, SimCardsTerminateSimCardsResponses, SimCardsValidatSimCardsForTerminationData, SimCardsValidatSimCardsForTerminationErrors, SimCardsValidatSimCardsForTerminationResponses, SlocGetSlocConfigurationStateData, SlocGetSlocConfigurationStateErrors, SlocGetSlocConfigurationStateResponses, SlocGetSlocCustomerNameData, SlocGetSlocCustomerNameErrors, SlocGetSlocCustomerNameResponses, SlocGetSlocEmptyingOptionsData, SlocGetSlocEmptyingOptionsErrors, SlocGetSlocEmptyingOptionsResponses, SlocGetSlocGroupsByApiKeyData, SlocGetSlocGroupsByApiKeyErrors, SlocGetSlocGroupsByApiKeyResponses, SlocGetSlocGroupsData, SlocGetSlocGroupsErrors, SlocGetSlocGroupsResponses, SlocGetSlocProfilesData, SlocGetSlocProfilesErrors, SlocGetSlocProfilesResponses, SlocHasValidSlocApiKeyData, SlocHasValidSlocApiKeyResponses, SlocReceiveSlocDataData, SlocReceiveSlocDataResponses, SlocSetSlocConfigurationData, SlocSetSlocConfigurationErrors, SlocSetSlocConfigurationResponses, SocialServiceActionsGetEntityData, SocialServiceActionsGetEntityErrors, SocialServiceActionsGetEntityPageData, SocialServiceActionsGetEntityPageErrors, SocialServiceActionsGetEntityPageResponses, SocialServiceActionsGetEntityResponses, SocialServiceActionsListCategoriesData, SocialServiceActionsListCategoriesResponses, SocialServiceActionsUpdateEntityData, SocialServiceActionsUpdateEntityErrors, SocialServiceActionsUpdateEntityResponses, SocialServiceActivateRunnerPrivilegesData, SocialServiceActivateRunnerPrivilegesErrors, SocialServiceActivateRunnerPrivilegesResponses, SocialServiceDeactivateRunnerPrivilegesData, SocialServiceDeactivateRunnerPrivilegesErrors, SocialServiceDeactivateRunnerPrivilegesResponses, SocialServiceGetRunnerNotificationSettingsData, SocialServiceGetRunnerNotificationSettingsErrors, SocialServiceGetRunnerNotificationSettingsResponses, SocialServiceGetTransactionsData, SocialServiceGetTransactionsErrors, SocialServiceGetTransactionsResponses, SocialServiceNotificationsNotifyRunnersData, SocialServiceNotificationsNotifyRunnersErrors, SocialServiceNotificationsNotifyRunnersResponses, SocialServiceReportsRunnerLocationData, SocialServiceReportsRunnerLocationErrors, SocialServiceReportsRunnerLocationResponses, SocialServiceRunnersBanRunnerData, SocialServiceRunnersBanRunnerErrors, SocialServiceRunnersBanRunnerResponses, SocialServiceRunnersGetEntityPageData, SocialServiceRunnersGetEntityPageErrors, SocialServiceRunnersGetEntityPageResponses, SocialServiceRunnersGetRunnerTransactionsData, SocialServiceRunnersGetRunnerTransactionsErrors, SocialServiceRunnersGetRunnerTransactionsResponses, SocialServiceRunnersListUsersData, SocialServiceRunnersListUsersResponses, SocialServiceRunnersRedeemRunnerCreditsData, SocialServiceRunnersRedeemRunnerCreditsErrors, SocialServiceRunnersRedeemRunnerCreditsResponses, SocialServiceRunnersUnbanBanRunnerData, SocialServiceRunnersUnbanBanRunnerErrors, SocialServiceRunnersUnbanBanRunnerResponses, SocialServiceTaskAddExtraTimeToSocialServiceTaskData, SocialServiceTaskAddExtraTimeToSocialServiceTaskErrors, SocialServiceTaskAddExtraTimeToSocialServiceTaskResponses, SocialServiceTaskAddImagesData, SocialServiceTaskAddImagesErrors, SocialServiceTaskAddImagesResponses, SocialServiceTaskAssignSocialServiceTaskData, SocialServiceTaskAssignSocialServiceTaskErrors, SocialServiceTaskAssignSocialServiceTaskResponses, SocialServiceTaskFailSocialServiceTaskData, SocialServiceTaskFailSocialServiceTaskErrors, SocialServiceTaskFailSocialServiceTaskResponses, SocialServiceTaskFinishSocialServiceTaskData, SocialServiceTaskFinishSocialServiceTaskErrors, SocialServiceTaskFinishSocialServiceTaskResponses, SocialServiceTaskGetEntityPageData, SocialServiceTaskGetEntityPageErrors, SocialServiceTaskGetEntityPageResponses, SocialServiceTaskGetSocialServiceTaskData, SocialServiceTaskGetSocialServiceTaskErrors, SocialServiceTaskGetSocialServiceTaskResponses, SocialServiceTaskListOfAssignedSocialServiceTasksToCurrentUserData, SocialServiceTaskListOfAssignedSocialServiceTasksToCurrentUserErrors, SocialServiceTaskListOfAssignedSocialServiceTasksToCurrentUserResponses, SocialServiceTaskRejectSocialServiceTaskData, SocialServiceTaskRejectSocialServiceTaskErrors, SocialServiceTaskRejectSocialServiceTaskResponses, SocialServiceTaskReportIssueSocialServiceTaskData, SocialServiceTaskReportIssueSocialServiceTaskErrors, SocialServiceTaskReportIssueSocialServiceTaskResponses, SocialServiceTaskSocialServiceTasksMapData, SocialServiceTaskSocialServiceTasksMapErrors, SocialServiceTaskSocialServiceTasksMapResponses, SocialServiceTaskStartSocialServiceTaskData, SocialServiceTaskStartSocialServiceTaskErrors, SocialServiceTaskStartSocialServiceTaskResponses, SocialServiceUpdateRunnerNotificationSettingsData, SocialServiceUpdateRunnerNotificationSettingsErrors, SocialServiceUpdateRunnerNotificationSettingsResponses, SupersetDashboardsCreateEntityData, SupersetDashboardsCreateEntityErrors, SupersetDashboardsCreateEntityResponses, SupersetDashboardsDeleteEntityData, SupersetDashboardsDeleteEntityErrors, SupersetDashboardsDeleteEntityResponses, SupersetDashboardsGetEntityData, SupersetDashboardsGetEntityErrors, SupersetDashboardsGetEntityPageData, SupersetDashboardsGetEntityPageErrors, SupersetDashboardsGetEntityPageResponses, SupersetDashboardsGetEntityResponses, SupersetDashboardsGetGuestTokenData, SupersetDashboardsGetGuestTokenErrors, SupersetDashboardsGetGuestTokenResponses, SupersetDashboardsIsValueUsedData, SupersetDashboardsIsValueUsedErrors, SupersetDashboardsIsValueUsedResponses, SupersetDashboardsListEntitiesData, SupersetDashboardsListEntitiesErrors, SupersetDashboardsListEntitiesResponses, SupersetDashboardsUpdateEntityData, SupersetDashboardsUpdateEntityErrors, SupersetDashboardsUpdateEntityResponses, SystemOperationsLogExportListData, SystemOperationsLogExportListErrors, SystemOperationsLogExportListResponses, SystemOperationsLogGetEntityPageData, SystemOperationsLogGetEntityPageErrors, SystemOperationsLogGetEntityPageResponses, SystemOperationsLogGetIssueData, SystemOperationsLogGetIssueErrors, SystemOperationsLogGetIssueResponses, TechniciansGetEntityPageData, TechniciansGetEntityPageErrors, TechniciansGetEntityPageResponses, TechniciansListUsersData, TechniciansListUsersResponses, TruckBodiesCreateEntityData, TruckBodiesCreateEntityErrors, TruckBodiesCreateEntityResponses, TruckBodiesDeleteEntityData, TruckBodiesDeleteEntityErrors, TruckBodiesDeleteEntityResponses, TruckBodiesGetEntityData, TruckBodiesGetEntityErrors, TruckBodiesGetEntityPageData, TruckBodiesGetEntityPageErrors, TruckBodiesGetEntityPageResponses, TruckBodiesGetEntityResponses, TruckBodiesListEntitiesData, TruckBodiesListEntitiesErrors, TruckBodiesListEntitiesResponses, TruckBodiesUpdateEntityData, TruckBodiesUpdateEntityErrors, TruckBodiesUpdateEntityResponses, TruckDepotsCreateEntityData, TruckDepotsCreateEntityErrors, TruckDepotsCreateEntityResponses, TruckDepotsDeleteEntityData, TruckDepotsDeleteEntityErrors, TruckDepotsDeleteEntityResponses, TruckDepotsGetAssignedTrucksData, TruckDepotsGetAssignedTrucksErrors, TruckDepotsGetAssignedTrucksResponses, TruckDepotsGetEntityData, TruckDepotsGetEntityErrors, TruckDepotsGetEntityPageData, TruckDepotsGetEntityPageResponses, TruckDepotsGetEntityResponses, TruckDepotsListAvailableTrucksData, TruckDepotsListAvailableTrucksErrors, TruckDepotsListAvailableTrucksResponses, TruckDepotsListEntitiesData, TruckDepotsListEntitiesErrors, TruckDepotsListEntitiesResponses, TruckDepotsUpdateContainersGroupData, TruckDepotsUpdateContainersGroupErrors, TruckDepotsUpdateContainersGroupResponses, TruckDepotsUpdateEntityData, TruckDepotsUpdateEntityErrors, TruckDepotsUpdateEntityResponses, TrucksCreateEntityData, TrucksCreateEntityErrors, TrucksCreateEntityResponses, TrucksDeleteEntityData, TrucksDeleteEntityErrors, TrucksDeleteEntityResponses, TrucksGetEntityData, TrucksGetEntityErrors, TrucksGetEntityPageData, TrucksGetEntityPageErrors, TrucksGetEntityPageResponses, TrucksGetEntityResponses, TrucksListEntitiesData, TrucksListEntitiesErrors, TrucksListEntitiesResponses, TrucksUpdateEntityData, TrucksUpdateEntityErrors, TrucksUpdateEntityResponses, TruckTypesCreateEntityData, TruckTypesCreateEntityErrors, TruckTypesCreateEntityResponses, TruckTypesDeleteEntityData, TruckTypesDeleteEntityErrors, TruckTypesDeleteEntityResponses, TruckTypesGetEntityData, TruckTypesGetEntityErrors, TruckTypesGetEntityPageData, TruckTypesGetEntityPageErrors, TruckTypesGetEntityPageResponses, TruckTypesGetEntityResponses, TruckTypesListEntitiesData, TruckTypesListEntitiesErrors, TruckTypesListEntitiesResponses, TruckTypesUpdateEntityData, TruckTypesUpdateEntityErrors, TruckTypesUpdateEntityResponses, UserNotificationSettingsCreateProfileNotificationSettingData, UserNotificationSettingsCreateProfileNotificationSettingErrors, UserNotificationSettingsCreateProfileNotificationSettingResponses, UserNotificationSettingsDeleteNotificationSettingData, UserNotificationSettingsDeleteNotificationSettingErrors, UserNotificationSettingsDeleteNotificationSettingResponses, UserNotificationSettingsGetProfileNotificationSettingData, UserNotificationSettingsGetProfileNotificationSettingErrors, UserNotificationSettingsGetProfileNotificationSettingResponses, UserNotificationSettingsGetUserNotificationSettingsPageData, UserNotificationSettingsGetUserNotificationSettingsPageErrors, UserNotificationSettingsGetUserNotificationSettingsPageResponses, UserNotificationSettingsUpdateProfileNotificationSettingData, UserNotificationSettingsUpdateProfileNotificationSettingErrors, UserNotificationSettingsUpdateProfileNotificationSettingResponses, UsersActivateUserData, UsersActivateUserErrors, UsersActivateUserResponses, UsersBanForAppCustomerData, UsersBanForAppCustomerErrors, UsersBanForAppCustomerResponses, UsersChangeOwnPasswordData, UsersChangeOwnPasswordErrors, UsersChangeOwnPasswordResponses, UsersChangePasswordData, UsersChangePasswordErrors, UsersChangePasswordResponses, UsersCreateEntityData, UsersCreateEntityErrors, UsersCreateEntityResponses, UsersDeleteEntityData, UsersDeleteEntityErrors, UsersDeleteEntityResponses, UsersExportListData, UsersExportListErrors, UsersExportListResponses, UsersFinishPasswordResetData, UsersFinishPasswordResetErrors, UsersFinishPasswordResetResponses, UsersGetEntityData, UsersGetEntityErrors, UsersGetEntityPageData, UsersGetEntityPageErrors, UsersGetEntityPageResponses, UsersGetEntityResponses, UsersGetMyFavouritesData, UsersGetMyFavouritesResponses, UsersGetMyPreferencesData, UsersGetMyPreferencesResponses, UsersGetProfileData, UsersGetProfileErrors, UsersGetProfileResponses, UsersInitPasswordResetData, UsersInitPasswordResetErrors, UsersInitPasswordResetResponses, UsersIsValueUsedData, UsersIsValueUsedErrors, UsersIsValueUsedResponses, UsersListUsersData, UsersListUsersResponses, UsersResetTotpSettingsData, UsersResetTotpSettingsErrors, UsersResetTotpSettingsResponses, UsersSetFavouritesData, UsersSetFavouritesResponses, UsersSetPreferencesData, UsersSetPreferencesResponses, UsersUnbanForAppCustomerData, UsersUnbanForAppCustomerErrors, UsersUnbanForAppCustomerResponses, UsersUnregisterDeviceData, UsersUnregisterDeviceResponses, UsersUnregisterOwnDeviceData, UsersUnregisterOwnDeviceResponses, UsersUpdateEntityData, UsersUpdateEntityErrors, UsersUpdateEntityResponses, UsersUpdateProfileData, UsersUpdateProfileErrors, UsersUpdateProfileResponses, UsersValidatePasswordData, UsersValidatePasswordErrors, UsersValidatePasswordResponses, UsersVerifyPasswordResetData, UsersVerifyPasswordResetErrors, UsersVerifyPasswordResetResponses, UserWizardCreateUserWizardData, UserWizardCreateUserWizardErrors, UserWizardCreateUserWizardResponses, UserWizardDeleteUserWizardData, UserWizardDeleteUserWizardErrors, UserWizardDeleteUserWizardResponses, UserWizardGetUserWizardData, UserWizardGetUserWizardErrors, UserWizardGetUserWizardPageData, UserWizardGetUserWizardPageErrors, UserWizardGetUserWizardPageResponses, UserWizardGetUserWizardResponses, UserWizardUpdateUserWizardData, UserWizardUpdateUserWizardErrors, UserWizardUpdateUserWizardResponses, WasteCategoriesListContainerLockTypesData, WasteCategoriesListContainerLockTypesErrors, WasteCategoriesListContainerLockTypesResponses, WasteYardsCreateEntityData, WasteYardsCreateEntityErrors, WasteYardsCreateEntityResponses, WasteYardsDeleteEntityData, WasteYardsDeleteEntityErrors, WasteYardsDeleteEntityResponses, WasteYardsGetEntityData, WasteYardsGetEntityErrors, WasteYardsGetEntityPageData, WasteYardsGetEntityPageResponses, WasteYardsGetEntityResponses, WasteYardsListEntitiesData, WasteYardsListEntitiesErrors, WasteYardsListEntitiesResponses, WasteYardsUpdateEntityData, WasteYardsUpdateEntityErrors, WasteYardsUpdateEntityResponses, WellKnownGetDocumentData, WellKnownGetDocumentErrors, WellKnownGetDocumentResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Gets page of APN profiles for administration
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const apnProfilesGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<ApnProfilesGetEntityPageData, ThrowOnError>): RequestResult<ApnProfilesGetEntityPageResponses, ApnProfilesGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<ApnProfilesGetEntityPageResponses, ApnProfilesGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/apn-profiles', ...options });

/**
 * Creates new APN profile
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const apnProfilesCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<ApnProfilesCreateEntityData, ThrowOnError>): RequestResult<ApnProfilesCreateEntityResponses, ApnProfilesCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<ApnProfilesCreateEntityResponses, ApnProfilesCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/apn-profiles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Lists APN profiles available for configuration of the ACU
 *
 * Without `customerId` only global profiles are returned. With `customerId` global profiles
 * and the profiles of that customer are returned; the customer must be accessible to the user, otherwise 403 is returned.<p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const apnProfilesListProfiles = <ThrowOnError extends boolean = false>(options?: Options<ApnProfilesListProfilesData, ThrowOnError>): RequestResult<ApnProfilesListProfilesResponses, ApnProfilesListProfilesErrors, ThrowOnError> => (options?.client ?? client).get<ApnProfilesListProfilesResponses, ApnProfilesListProfilesErrors, ThrowOnError>({ url: '/api/v1/apn-profiles/list', ...options });

/**
 * Deletes APN profile
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const apnProfilesDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<ApnProfilesDeleteEntityData, ThrowOnError>): RequestResult<ApnProfilesDeleteEntityResponses, ApnProfilesDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<ApnProfilesDeleteEntityResponses, ApnProfilesDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/apn-profiles/{id}', ...options });

/**
 * Gets APN profile detail
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const apnProfilesGetEntity = <ThrowOnError extends boolean = false>(options: Options<ApnProfilesGetEntityData, ThrowOnError>): RequestResult<ApnProfilesGetEntityResponses, ApnProfilesGetEntityErrors, ThrowOnError> => (options.client ?? client).get<ApnProfilesGetEntityResponses, ApnProfilesGetEntityErrors, ThrowOnError>({ url: '/api/v1/apn-profiles/{id}', ...options });

/**
 * Updates APN profile
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const apnProfilesUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<ApnProfilesUpdateEntityData, ThrowOnError>): RequestResult<ApnProfilesUpdateEntityResponses, ApnProfilesUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<ApnProfilesUpdateEntityResponses, ApnProfilesUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/apn-profiles/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Checks whether value of given field is already used by another APN profile
 *
 * Supported field is `name`. Scope may contain `customerId`, without it the global profiles are checked.<p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const apnProfilesIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<ApnProfilesIsValueUsedData, ThrowOnError>): RequestResult<ApnProfilesIsValueUsedResponses, ApnProfilesIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<ApnProfilesIsValueUsedResponses, ApnProfilesIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/apn-profiles/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of App Messages
 *
 * <p><strong>Required Roles</strong>: <code>APP_MESSAGE_VIEW</code> or <code>APP_MESSAGE_ADMIN</code></p>
 */
export const appMessagesGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<AppMessagesGetEntityPageData, ThrowOnError>): RequestResult<AppMessagesGetEntityPageResponses, AppMessagesGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<AppMessagesGetEntityPageResponses, AppMessagesGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/app-messages', ...options });

/**
 * Creates new App Message
 *
 * <p><strong>Required Roles</strong>: <code>APP_MESSAGE_ADMIN</code></p>
 */
export const appMessagesCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<AppMessagesCreateEntityData, ThrowOnError>): RequestResult<AppMessagesCreateEntityResponses, AppMessagesCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<AppMessagesCreateEntityResponses, AppMessagesCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/app-messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Deletes App Message
 *
 * <p><strong>Required Roles</strong>: <code>APP_MESSAGE_ADMIN</code></p>
 */
export const appMessagesDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<AppMessagesDeleteEntityData, ThrowOnError>): RequestResult<AppMessagesDeleteEntityResponses, AppMessagesDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<AppMessagesDeleteEntityResponses, AppMessagesDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/app-messages/{id}', ...options });

/**
 * Gets App Message
 *
 * <p><strong>Required Roles</strong>: <code>APP_MESSAGE_VIEW</code> or <code>APP_MESSAGE_ADMIN</code></p>
 */
export const appMessagesGetEntity = <ThrowOnError extends boolean = false>(options: Options<AppMessagesGetEntityData, ThrowOnError>): RequestResult<AppMessagesGetEntityResponses, AppMessagesGetEntityErrors, ThrowOnError> => (options.client ?? client).get<AppMessagesGetEntityResponses, AppMessagesGetEntityErrors, ThrowOnError>({ url: '/api/v1/app-messages/{id}', ...options });

/**
 * Updates App Message
 *
 * <p><strong>Required Roles</strong>: <code>APP_MESSAGE_ADMIN</code></p>
 */
export const appMessagesUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<AppMessagesUpdateEntityData, ThrowOnError>): RequestResult<AppMessagesUpdateEntityResponses, AppMessagesUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<AppMessagesUpdateEntityResponses, AppMessagesUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/app-messages/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Triggers immediate notification for given App Messages
 *
 * This endpoint triggers notification for given App Messages.
 * Process of notification is processed in background, so it may take some time to complete the notification.<p><strong>Required Roles</strong>: <code>APP_MESSAGE_ADMIN</code></p>
 */
export const appMessagesNotifyImmediately = <ThrowOnError extends boolean = false>(options?: Options<AppMessagesNotifyImmediatelyData, ThrowOnError>): RequestResult<AppMessagesNotifyImmediatelyResponses, AppMessagesNotifyImmediatelyErrors, ThrowOnError> => (options?.client ?? client).post<AppMessagesNotifyImmediatelyResponses, AppMessagesNotifyImmediatelyErrors, ThrowOnError>({
    url: '/api/v1/app-messages/notify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Posts message to all devices belonging to given customer
 *
 * <p><strong>Required Roles</strong>: <ul><li><code>CUSTOMER_ADMIN</code></li><li><code>APP_MESSAGE_ADMIN</code></li></ul></p>
 */
export const appNotificationsNotifyCustomer = <ThrowOnError extends boolean = false>(options: Options<AppNotificationsNotifyCustomerData, ThrowOnError>): RequestResult<AppNotificationsNotifyCustomerResponses, AppNotificationsNotifyCustomerErrors, ThrowOnError> => (options.client ?? client).post<AppNotificationsNotifyCustomerResponses, AppNotificationsNotifyCustomerErrors, ThrowOnError>({
    url: '/api/v1/app-notifications/customer/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Posts message to all devices belonging to given user
 *
 * <p><strong>Required Roles</strong>: <ul><li><code>USER_ADMIN</code></li><li><code>APP_MESSAGE_ADMIN</code></li></ul></p>
 */
export const appNotificationsNotifyUser = <ThrowOnError extends boolean = false>(options: Options<AppNotificationsNotifyUserData, ThrowOnError>): RequestResult<AppNotificationsNotifyUserResponses, AppNotificationsNotifyUserErrors, ThrowOnError> => (options.client ?? client).post<AppNotificationsNotifyUserResponses, AppNotificationsNotifyUserErrors, ThrowOnError>({
    url: '/api/v1/app-notifications/user/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authenticates device user using user name and password
 *
 * <b>Deprecated</b>: Please use the `POST /api/v2/authorize` endpoint instead
 *
 * This is intended for the applications where the JWT token can be securely used (e.g. Android app).
 *
 * In case the device specified in request is not registered to contract
 * and user has exactly one contract, the device will be auto-registered
 *
 * @deprecated
 */
export const authorizeAuthorizeDevice = <ThrowOnError extends boolean = false>(options: Options<AuthorizeAuthorizeDeviceData, ThrowOnError>): RequestResult<AuthorizeAuthorizeDeviceResponses, AuthorizeAuthorizeDeviceErrors, ThrowOnError> => (options.client ?? client).post<AuthorizeAuthorizeDeviceResponses, AuthorizeAuthorizeDeviceErrors, ThrowOnError>({
    url: '/api/v1/authorize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unregisters current device of current user.
 * Device and User are identified by the Authorize header (JWT token)
 *
 * This is intended for the applications where the JWT token can be securely used (e.g. Android app).
 * Device will be marked as deleted, removed from all contracts
 * and all refresh tokens associated with the device will be invalidated.<p><strong>Required Roles</strong>: <code>APP_USER</code></p>
 */
export const authorizeUnregisterDevice = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeUnregisterDeviceData, ThrowOnError>): RequestResult<AuthorizeUnregisterDeviceResponses, AuthorizeUnregisterDeviceErrors, ThrowOnError> => (options?.client ?? client).delete<AuthorizeUnregisterDeviceResponses, AuthorizeUnregisterDeviceErrors, ThrowOnError>({ url: '/api/v1/authorize/device', ...options });

/**
 * Authenticates user using user name and password
 *
 * <b>Deprecated</b>: Please use the `POST /api/v2/authorize/api` endpoint instead
 *
 * This is intended for the applications where the JWT token can be securely used
 * (e.g. server apps) but not for mobile applications.
 *
 * @deprecated
 */
export const authorizeAuthorizeApi = <ThrowOnError extends boolean = false>(options: Options<AuthorizeAuthorizeApiData, ThrowOnError>): RequestResult<AuthorizeAuthorizeApiResponses, AuthorizeAuthorizeApiErrors, ThrowOnError> => (options.client ?? client).post<AuthorizeAuthorizeApiResponses, AuthorizeAuthorizeApiErrors, ThrowOnError>({
    url: '/api/v1/authorize/api',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authenticates service app using user name and password
 *
 * This is intended for the service application.
 * Authorizes only users with APP_SERVICE_USER role
 */
export const authorizeAuthorizeService = <ThrowOnError extends boolean = false>(options: Options<AuthorizeAuthorizeServiceData, ThrowOnError>): RequestResult<AuthorizeAuthorizeServiceResponses, AuthorizeAuthorizeServiceErrors, ThrowOnError> => (options.client ?? client).post<AuthorizeAuthorizeServiceResponses, AuthorizeAuthorizeServiceErrors, ThrowOnError>({
    url: '/api/v1/authorize/service-app',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refreshes authentication token using the refresh token
 *
 * This is intended for the applications where the JWT token can be securely used (e.g. Android app).
 */
export const authorizeRefreshToken = <ThrowOnError extends boolean = false>(options: Options<AuthorizeRefreshTokenData, ThrowOnError>): RequestResult<AuthorizeRefreshTokenResponses, AuthorizeRefreshTokenErrors, ThrowOnError> => (options.client ?? client).post<AuthorizeRefreshTokenResponses, AuthorizeRefreshTokenErrors, ThrowOnError>({
    url: '/api/v1/authorize/refresh-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verifies whether the caller is already authorized
 *
 * This is intended for the applications using cookies
 */
export const authorizeLoginCookieVerify = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeLoginCookieVerifyData, ThrowOnError>): RequestResult<AuthorizeLoginCookieVerifyResponses, AuthorizeLoginCookieVerifyErrors, ThrowOnError> => (options?.client ?? client).get<AuthorizeLoginCookieVerifyResponses, AuthorizeLoginCookieVerifyErrors, ThrowOnError>({ url: '/api/v1/authorize/login', ...options });

/**
 * Authenticates user using the user name and password
 * and sets the authentication cookie.
 *
 * This is intended for the applications where the JWT token
 * cannot be securely used (e.g. SPA web application)
 */
export const authorizeLoginCookie = <ThrowOnError extends boolean = false>(options: Options<AuthorizeLoginCookieData, ThrowOnError>): RequestResult<AuthorizeLoginCookieResponses, AuthorizeLoginCookieErrors, ThrowOnError> => (options.client ?? client).post<AuthorizeLoginCookieResponses, AuthorizeLoginCookieErrors, ThrowOnError>({
    url: '/api/v1/authorize/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Logs out the user, clears any authorization cookies and revokes refresh token
 */
export const authorizeLogout = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeLogoutData, ThrowOnError>): RequestResult<AuthorizeLogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AuthorizeLogoutResponses, unknown, ThrowOnError>({ url: '/api/v1/authorize/logout', ...options });

/**
 * Logs out the user, clears any authorization cookies and revokes refresh token
 */
export const authorizeLogoutPost = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeLogoutPostData, ThrowOnError>): RequestResult<AuthorizeLogoutPostResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AuthorizeLogoutPostResponses, unknown, ThrowOnError>({ url: '/api/v1/authorize/logout', ...options });

/**
 * Checks for validity of contract
 */
export const authorizeCheckContractV2 = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeCheckContractV2Data, ThrowOnError>): RequestResult<AuthorizeCheckContractV2Responses, AuthorizeCheckContractV2Errors, ThrowOnError> => (options?.client ?? client).post<AuthorizeCheckContractV2Responses, AuthorizeCheckContractV2Errors, ThrowOnError>({
    url: '/api/v2/authorize/contract/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Registers new device and user using contract, user name and new password
 *
 * This is intended for the applications where the JWT token can be securely used (e.g. Android app).
 */
export const authorizeRegisterDeviceV2 = <ThrowOnError extends boolean = false>(options: Options<AuthorizeRegisterDeviceV2Data, ThrowOnError>): RequestResult<AuthorizeRegisterDeviceV2Responses, AuthorizeRegisterDeviceV2Errors, ThrowOnError> => (options.client ?? client).post<AuthorizeRegisterDeviceV2Responses, AuthorizeRegisterDeviceV2Errors, ThrowOnError>({
    url: '/api/v2/authorize/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Registers new device and user as social service runner
 *
 * This is intended for the service applications where the JWT token can be securely used (e.g. Android app).
 */
export const authorizeRegisterServiceRunnerV2 = <ThrowOnError extends boolean = false>(options: Options<AuthorizeRegisterServiceRunnerV2Data, ThrowOnError>): RequestResult<AuthorizeRegisterServiceRunnerV2Responses, AuthorizeRegisterServiceRunnerV2Errors, ThrowOnError> => (options.client ?? client).post<AuthorizeRegisterServiceRunnerV2Responses, AuthorizeRegisterServiceRunnerV2Errors, ThrowOnError>({
    url: '/api/v2/authorize/register-social-service',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authenticates device user using user name and password
 *
 * This is intended for the applications where the JWT token can be securely used (e.g. Android app).
 *
 * In case the device specified in request is not registered to contract
 * it will get registered to all possible contracts. It will not register to contracts that already
 * reached the Max Devices limit.
 */
export const authorizeAuthorizeDeviceV2 = <ThrowOnError extends boolean = false>(options: Options<AuthorizeAuthorizeDeviceV2Data, ThrowOnError>): RequestResult<AuthorizeAuthorizeDeviceV2Responses, AuthorizeAuthorizeDeviceV2Errors, ThrowOnError> => (options.client ?? client).post<AuthorizeAuthorizeDeviceV2Responses, AuthorizeAuthorizeDeviceV2Errors, ThrowOnError>({
    url: '/api/v2/authorize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authorizes device whos user was already authenticated in the system.
 *
 * This is intended for the external applications where the JWT token can be securely used (e.g. Android app).
 *
 * In case the device specified in request is not registered to contract
 * it will get registered to all possible contracts. It will not register to contracts that already
 * reached the Max Devices limit.
 */
export const authorizeAuthorizeDeviceFromApiV2 = <ThrowOnError extends boolean = false>(options: Options<AuthorizeAuthorizeDeviceFromApiV2Data, ThrowOnError>): RequestResult<AuthorizeAuthorizeDeviceFromApiV2Responses, AuthorizeAuthorizeDeviceFromApiV2Errors, ThrowOnError> => (options.client ?? client).post<AuthorizeAuthorizeDeviceFromApiV2Responses, AuthorizeAuthorizeDeviceFromApiV2Errors, ThrowOnError>({
    url: '/api/v2/authorize/link-device',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authenticates service device user using user name and password
 *
 * This is intended for the service applications where the JWT token can be securely used (e.g. Android app).
 */
export const authorizeAuthorizeServiceDeviceV2 = <ThrowOnError extends boolean = false>(options: Options<AuthorizeAuthorizeServiceDeviceV2Data, ThrowOnError>): RequestResult<AuthorizeAuthorizeServiceDeviceV2Responses, AuthorizeAuthorizeServiceDeviceV2Errors, ThrowOnError> => (options.client ?? client).post<AuthorizeAuthorizeServiceDeviceV2Responses, AuthorizeAuthorizeServiceDeviceV2Errors, ThrowOnError>({
    url: '/api/v2/authorize/service-app',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authenticates server to server call using user name and password
 *
 * This is intended for server to server authentication.
 */
export const authorizeAuthorizeApiV2 = <ThrowOnError extends boolean = false>(options: Options<AuthorizeAuthorizeApiV2Data, ThrowOnError>): RequestResult<AuthorizeAuthorizeApiV2Responses, AuthorizeAuthorizeApiV2Errors, ThrowOnError> => (options.client ?? client).post<AuthorizeAuthorizeApiV2Responses, AuthorizeAuthorizeApiV2Errors, ThrowOnError>({
    url: '/api/v2/authorize/api',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authenticates using refresh token
 *
 * This is intended for the applications where the JWT token can be securely used (e.g. Android app).
 */
export const authorizeAuthorizeRefreshTokenV2 = <ThrowOnError extends boolean = false>(options: Options<AuthorizeAuthorizeRefreshTokenV2Data, ThrowOnError>): RequestResult<AuthorizeAuthorizeRefreshTokenV2Responses, AuthorizeAuthorizeRefreshTokenV2Errors, ThrowOnError> => (options.client ?? client).post<AuthorizeAuthorizeRefreshTokenV2Responses, AuthorizeAuthorizeRefreshTokenV2Errors, ThrowOnError>({
    url: '/api/v2/authorize/refresh-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Re-registers existing anonymous user as full user with email and password
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code></p>
 */
export const authorizeReRegisterUserV2 = <ThrowOnError extends boolean = false>(options: Options<AuthorizeReRegisterUserV2Data, ThrowOnError>): RequestResult<AuthorizeReRegisterUserV2Responses, AuthorizeReRegisterUserV2Errors, ThrowOnError> => (options.client ?? client).post<AuthorizeReRegisterUserV2Responses, AuthorizeReRegisterUserV2Errors, ThrowOnError>({
    url: '/api/v2/authorize/reregister',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Links new credentials to current user
 */
export const authorizeLinkCredentialsV2 = <ThrowOnError extends boolean = false>(options: Options<AuthorizeLinkCredentialsV2Data, ThrowOnError>): RequestResult<AuthorizeLinkCredentialsV2Responses, AuthorizeLinkCredentialsV2Errors, ThrowOnError> => (options.client ?? client).post<AuthorizeLinkCredentialsV2Responses, AuthorizeLinkCredentialsV2Errors, ThrowOnError>({
    url: '/api/v2/authorize/link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unlinks external credentials to current user
 */
export const authorizeUnlinkCredentialsV2 = <ThrowOnError extends boolean = false>(options: Options<AuthorizeUnlinkCredentialsV2Data, ThrowOnError>): RequestResult<AuthorizeUnlinkCredentialsV2Responses, AuthorizeUnlinkCredentialsV2Errors, ThrowOnError> => (options.client ?? client).post<AuthorizeUnlinkCredentialsV2Responses, AuthorizeUnlinkCredentialsV2Errors, ThrowOnError>({
    url: '/api/v2/authorize/unlink',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * This is Google authentiaction callback.
 * Authenticates user using the google token
 *
 * This is intended for the applications where the JWT token
 * cannot be securely used (e.g. SPA web application)
 */
export const authorizeLoginGoogleV2 = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeLoginGoogleV2Data, ThrowOnError>): RequestResult<unknown, AuthorizeLoginGoogleV2Errors, ThrowOnError> => (options?.client ?? client).post<unknown, AuthorizeLoginGoogleV2Errors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v2/authorize/google',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * This is Apple authentiaction callback.
 * Authenticates user using the apple token
 *
 * This is intended for the applications where the JWT token
 * cannot be securely used (e.g. SPA web application)
 */
export const authorizeLoginAppleV2 = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeLoginAppleV2Data, ThrowOnError>): RequestResult<unknown, AuthorizeLoginAppleV2Errors, ThrowOnError> => (options?.client ?? client).post<unknown, AuthorizeLoginAppleV2Errors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v2/authorize/apple',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Links new Google credentials to current user.
 * This is callback endpoint for Google OAuth and is expected to be called by Google
 */
export const authorizeLinkGoogleCredentialsV2 = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeLinkGoogleCredentialsV2Data, ThrowOnError>): RequestResult<unknown, AuthorizeLinkGoogleCredentialsV2Errors, ThrowOnError> => (options?.client ?? client).post<unknown, AuthorizeLinkGoogleCredentialsV2Errors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v2/authorize/google/link',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Links new Apple credentials to current user.
 * This is callback endpoint for Apple OAuth and is expected to be called by Apple
 */
export const authorizeLinkAppleCredentialsV2 = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeLinkAppleCredentialsV2Data, ThrowOnError>): RequestResult<unknown, AuthorizeLinkAppleCredentialsV2Errors, ThrowOnError> => (options?.client ?? client).post<unknown, AuthorizeLinkAppleCredentialsV2Errors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v2/authorize/apple/link',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Verifies whether the caller is already authorized
 *
 * This is intended for the applications using cookies
 */
export const authorizeLoginCookieVerifyV2 = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeLoginCookieVerifyV2Data, ThrowOnError>): RequestResult<AuthorizeLoginCookieVerifyV2Responses, AuthorizeLoginCookieVerifyV2Errors, ThrowOnError> => (options?.client ?? client).get<AuthorizeLoginCookieVerifyV2Responses, AuthorizeLoginCookieVerifyV2Errors, ThrowOnError>({ url: '/api/v2/authorize/login', ...options });

/**
 * Authenticates user using the user name and password
 * and sets the authentication cookie.
 *
 * This is intended for the applications where the JWT token
 * cannot be securely used (e.g. SPA web application)
 */
export const authorizeLoginCookieV2 = <ThrowOnError extends boolean = false>(options: Options<AuthorizeLoginCookieV2Data, ThrowOnError>): RequestResult<AuthorizeLoginCookieV2Responses, AuthorizeLoginCookieV2Errors, ThrowOnError> => (options.client ?? client).post<AuthorizeLoginCookieV2Responses, AuthorizeLoginCookieV2Errors, ThrowOnError>({
    url: '/api/v2/authorize/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Logs out the user, clears any authorization cookies and revokes refresh token
 */
export const authorizeLogoutV2 = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeLogoutV2Data, ThrowOnError>): RequestResult<AuthorizeLogoutV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<AuthorizeLogoutV2Responses, unknown, ThrowOnError>({ url: '/api/v2/authorize/logout', ...options });

/**
 * Logs out the user, clears any authorization cookies and revokes refresh token
 */
export const authorizeLogoutPostV2 = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeLogoutPostV2Data, ThrowOnError>): RequestResult<AuthorizeLogoutPostV2Responses, unknown, ThrowOnError> => (options?.client ?? client).post<AuthorizeLogoutPostV2Responses, unknown, ThrowOnError>({ url: '/api/v2/authorize/logout', ...options });

/**
 * Setups TOTP for logged-in user
 */
export const authorizeSetupTotpV2 = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeSetupTotpV2Data, ThrowOnError>): RequestResult<AuthorizeSetupTotpV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<AuthorizeSetupTotpV2Responses, unknown, ThrowOnError>({ url: '/api/v2/authorize/totp/setup', ...options });

/**
 * Finalizes TOTP setup for logged-in user
 */
export const authorizeFinalizeTotpV2 = <ThrowOnError extends boolean = false>(options: Options<AuthorizeFinalizeTotpV2Data, ThrowOnError>): RequestResult<AuthorizeFinalizeTotpV2Responses, unknown, ThrowOnError> => (options.client ?? client).post<AuthorizeFinalizeTotpV2Responses, unknown, ThrowOnError>({
    url: '/api/v2/authorize/totp/finalize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verifies login with TOTP
 */
export const authorizeVerifyLoginWithTotpV2 = <ThrowOnError extends boolean = false>(options: Options<AuthorizeVerifyLoginWithTotpV2Data, ThrowOnError>): RequestResult<AuthorizeVerifyLoginWithTotpV2Responses, unknown, ThrowOnError> => (options.client ?? client).post<AuthorizeVerifyLoginWithTotpV2Responses, unknown, ThrowOnError>({
    url: '/api/v2/authorize/login/totp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verifies login with TOTP backup code
 */
export const authorizeVerifyLoginWithTotpBackupCodeV2 = <ThrowOnError extends boolean = false>(options: Options<AuthorizeVerifyLoginWithTotpBackupCodeV2Data, ThrowOnError>): RequestResult<AuthorizeVerifyLoginWithTotpBackupCodeV2Responses, unknown, ThrowOnError> => (options.client ?? client).post<AuthorizeVerifyLoginWithTotpBackupCodeV2Responses, unknown, ThrowOnError>({
    url: '/api/v2/authorize/login/totp-backup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets list of battery types
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>ENDTEST_RUN</code></p>
 */
export const batteryTypesListContainerLockTypes = <ThrowOnError extends boolean = false>(options?: Options<BatteryTypesListContainerLockTypesData, ThrowOnError>): RequestResult<BatteryTypesListContainerLockTypesResponses, BatteryTypesListContainerLockTypesErrors, ThrowOnError> => (options?.client ?? client).get<BatteryTypesListContainerLockTypesResponses, BatteryTypesListContainerLockTypesErrors, ThrowOnError>({ url: '/api/v1/battery-types', ...options });

/**
 * Get billing report in tree format.
 * Every node of tree has own billing data statistic and
 * summarized children data statistic.
 *
 * <p><strong>Required Roles</strong>: <code>BILLING_VIEW</code> or <code>BILLING_ADMIN</code></p>
 */
export const billingGetBillingReport = <ThrowOnError extends boolean = false>(options?: Options<BillingGetBillingReportData, ThrowOnError>): RequestResult<BillingGetBillingReportResponses, BillingGetBillingReportErrors, ThrowOnError> => (options?.client ?? client).get<BillingGetBillingReportResponses, BillingGetBillingReportErrors, ThrowOnError>({ url: '/api/v1/billing', ...options });

/**
 * Get billing report for card openings
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const billingGetOpeningsByCard = <ThrowOnError extends boolean = false>(options: Options<BillingGetOpeningsByCardData, ThrowOnError>): RequestResult<BillingGetOpeningsByCardResponses, BillingGetOpeningsByCardErrors, ThrowOnError> => (options.client ?? client).get<BillingGetOpeningsByCardResponses, BillingGetOpeningsByCardErrors, ThrowOnError>({ url: '/api/v1/billing/{customerId}/card-openings', ...options });

/**
 * Get billing report for contract openings
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const billingGetOpeningsByContract = <ThrowOnError extends boolean = false>(options: Options<BillingGetOpeningsByContractData, ThrowOnError>): RequestResult<BillingGetOpeningsByContractResponses, BillingGetOpeningsByContractErrors, ThrowOnError> => (options.client ?? client).get<BillingGetOpeningsByContractResponses, BillingGetOpeningsByContractErrors, ThrowOnError>({ url: '/api/v1/billing/{customerId}/contract-openings', ...options });

/**
 * Get billing report items
 *
 * <p><strong>Required Roles</strong>: <code>BILLING_VIEW</code> or <code>BILLING_ADMIN</code></p>
 */
export const billingGetBillingItemsData = <ThrowOnError extends boolean = false>(options?: Options<BillingGetBillingItemsDataData, ThrowOnError>): RequestResult<BillingGetBillingItemsDataResponses, BillingGetBillingItemsDataErrors, ThrowOnError> => (options?.client ?? client).get<BillingGetBillingItemsDataResponses, BillingGetBillingItemsDataErrors, ThrowOnError>({ url: '/api/v1/billing/items', ...options });

/**
 * Export billing report
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>BILLING_VIEW</code> or <code>BILLING_ADMIN</code></p>
 */
export const billingExportBillingItems = <ThrowOnError extends boolean = false>(options: Options<BillingExportBillingItemsData, ThrowOnError>): RequestResult<BillingExportBillingItemsResponses, unknown, ThrowOnError> => (options.client ?? client).get<BillingExportBillingItemsResponses, unknown, ThrowOnError>({ url: '/api/v1/billing/items/export.{format}', ...options });

/**
 * Export opening by card report items
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const billingExportOpeningsByNfcCard = <ThrowOnError extends boolean = false>(options: Options<BillingExportOpeningsByNfcCardData, ThrowOnError>): RequestResult<BillingExportOpeningsByNfcCardResponses, unknown, ThrowOnError> => (options.client ?? client).get<BillingExportOpeningsByNfcCardResponses, unknown, ThrowOnError>({ url: '/api/v1/billing/{customerId}/card-openings/export.{format}', ...options });

/**
 * Export opening by contract report items
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const billingExportOpeningsByContract = <ThrowOnError extends boolean = false>(options: Options<BillingExportOpeningsByContractData, ThrowOnError>): RequestResult<BillingExportOpeningsByContractResponses, unknown, ThrowOnError> => (options.client ?? client).get<BillingExportOpeningsByContractResponses, unknown, ThrowOnError>({ url: '/api/v1/billing/{customerId}/contract-openings/export.{format}', ...options });

/**
 * Export BLE key generations of the customer and all of its descendants
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const billingExportKeyGenerations = <ThrowOnError extends boolean = false>(options: Options<BillingExportKeyGenerationsData, ThrowOnError>): RequestResult<BillingExportKeyGenerationsResponses, unknown, ThrowOnError> => (options.client ?? client).get<BillingExportKeyGenerationsResponses, unknown, ThrowOnError>({ url: '/api/v1/billing/{customerId}/key-generations/export.{format}', ...options });

/**
 * Gets page of container access groups
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_VIEW</code> or <code>LARGE_LIST_ADMIN</code></p>
 */
export const containerAccessGroupsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<ContainerAccessGroupsGetEntityPageData, ThrowOnError>): RequestResult<ContainerAccessGroupsGetEntityPageResponses, ContainerAccessGroupsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<ContainerAccessGroupsGetEntityPageResponses, ContainerAccessGroupsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/container-access-groups', ...options });

/**
 * Creates new container access group
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const containerAccessGroupsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<ContainerAccessGroupsCreateEntityData, ThrowOnError>): RequestResult<ContainerAccessGroupsCreateEntityResponses, ContainerAccessGroupsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<ContainerAccessGroupsCreateEntityResponses, ContainerAccessGroupsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/container-access-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of container access groups
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_VIEW</code> or <code>LARGE_LIST_ADMIN</code></p>
 */
export const containerAccessGroupsListEntities = <ThrowOnError extends boolean = false>(options?: Options<ContainerAccessGroupsListEntitiesData, ThrowOnError>): RequestResult<ContainerAccessGroupsListEntitiesResponses, ContainerAccessGroupsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<ContainerAccessGroupsListEntitiesResponses, ContainerAccessGroupsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/container-access-groups/list', ...options });

/**
 * Deletes container access group
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const containerAccessGroupsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<ContainerAccessGroupsDeleteEntityData, ThrowOnError>): RequestResult<ContainerAccessGroupsDeleteEntityResponses, ContainerAccessGroupsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<ContainerAccessGroupsDeleteEntityResponses, ContainerAccessGroupsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/container-access-groups/{id}', ...options });

/**
 * Gets container access group
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_VIEW</code> or <code>LARGE_LIST_ADMIN</code></p>
 */
export const containerAccessGroupsGetEntity = <ThrowOnError extends boolean = false>(options: Options<ContainerAccessGroupsGetEntityData, ThrowOnError>): RequestResult<ContainerAccessGroupsGetEntityResponses, ContainerAccessGroupsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<ContainerAccessGroupsGetEntityResponses, ContainerAccessGroupsGetEntityErrors, ThrowOnError>({ url: '/api/v1/container-access-groups/{id}', ...options });

/**
 * Updates container access group
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const containerAccessGroupsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<ContainerAccessGroupsUpdateEntityData, ThrowOnError>): RequestResult<ContainerAccessGroupsUpdateEntityResponses, ContainerAccessGroupsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<ContainerAccessGroupsUpdateEntityResponses, ContainerAccessGroupsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/container-access-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const containerAccessGroupsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<ContainerAccessGroupsIsValueUsedData, ThrowOnError>): RequestResult<ContainerAccessGroupsIsValueUsedResponses, ContainerAccessGroupsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<ContainerAccessGroupsIsValueUsedResponses, ContainerAccessGroupsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/container-access-groups/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of container addresses
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerAddressesGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<ContainerAddressesGetEntityPageData, ThrowOnError>): RequestResult<ContainerAddressesGetEntityPageResponses, ContainerAddressesGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<ContainerAddressesGetEntityPageResponses, ContainerAddressesGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/container-addresses', ...options });

/**
 * Creates new container address
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerAddressesCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<ContainerAddressesCreateEntityData, ThrowOnError>): RequestResult<ContainerAddressesCreateEntityResponses, ContainerAddressesCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<ContainerAddressesCreateEntityResponses, ContainerAddressesCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/container-addresses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of container addresses
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerAddressesListEntities = <ThrowOnError extends boolean = false>(options?: Options<ContainerAddressesListEntitiesData, ThrowOnError>): RequestResult<ContainerAddressesListEntitiesResponses, ContainerAddressesListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<ContainerAddressesListEntitiesResponses, ContainerAddressesListEntitiesErrors, ThrowOnError>({ url: '/api/v1/container-addresses/list', ...options });

/**
 * Deletes container address
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerAddressesDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<ContainerAddressesDeleteEntityData, ThrowOnError>): RequestResult<ContainerAddressesDeleteEntityResponses, ContainerAddressesDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<ContainerAddressesDeleteEntityResponses, ContainerAddressesDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/container-addresses/{id}', ...options });

/**
 * Gets container address
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerAddressesGetEntity = <ThrowOnError extends boolean = false>(options: Options<ContainerAddressesGetEntityData, ThrowOnError>): RequestResult<ContainerAddressesGetEntityResponses, ContainerAddressesGetEntityErrors, ThrowOnError> => (options.client ?? client).get<ContainerAddressesGetEntityResponses, ContainerAddressesGetEntityErrors, ThrowOnError>({ url: '/api/v1/container-addresses/{id}', ...options });

/**
 * Updates container address
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerAddressesUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<ContainerAddressesUpdateEntityData, ThrowOnError>): RequestResult<ContainerAddressesUpdateEntityResponses, ContainerAddressesUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<ContainerAddressesUpdateEntityResponses, ContainerAddressesUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/container-addresses/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create container addresses (islands) and assign containers to them
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerAddressesCreateContainerIslands = <ThrowOnError extends boolean = false>(options: Options<ContainerAddressesCreateContainerIslandsData, ThrowOnError>): RequestResult<ContainerAddressesCreateContainerIslandsResponses, ContainerAddressesCreateContainerIslandsErrors, ThrowOnError> => (options.client ?? client).post<ContainerAddressesCreateContainerIslandsResponses, ContainerAddressesCreateContainerIslandsErrors, ThrowOnError>({
    url: '/api/v1/container-addresses/islands',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update address assigned containers
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerAddressesUpdateContainersGroup = <ThrowOnError extends boolean = false>(options: Options<ContainerAddressesUpdateContainersGroupData, ThrowOnError>): RequestResult<ContainerAddressesUpdateContainersGroupResponses, ContainerAddressesUpdateContainersGroupErrors, ThrowOnError> => (options.client ?? client).put<ContainerAddressesUpdateContainersGroupResponses, ContainerAddressesUpdateContainersGroupErrors, ThrowOnError>({
    url: '/api/v1/container-addresses/{id}/containers/partial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists active containers not assigned to this address,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const containerAddressesListAvailableContainers = <ThrowOnError extends boolean = false>(options: Options<ContainerAddressesListAvailableContainersData, ThrowOnError>): RequestResult<ContainerAddressesListAvailableContainersResponses, ContainerAddressesListAvailableContainersErrors, ThrowOnError> => (options.client ?? client).get<ContainerAddressesListAvailableContainersResponses, ContainerAddressesListAvailableContainersErrors, ThrowOnError>({ url: '/api/v1/container-addresses/{id}/containers/available', ...options });

/**
 * Lists active containers assigned to this address,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerAddressesListContainers = <ThrowOnError extends boolean = false>(options: Options<ContainerAddressesListContainersData, ThrowOnError>): RequestResult<ContainerAddressesListContainersResponses, ContainerAddressesListContainersErrors, ThrowOnError> => (options.client ?? client).get<ContainerAddressesListContainersResponses, ContainerAddressesListContainersErrors, ThrowOnError>({ url: '/api/v1/container-addresses/{id}/containers', ...options });

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerAddressesIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<ContainerAddressesIsValueUsedData, ThrowOnError>): RequestResult<ContainerAddressesIsValueUsedResponses, ContainerAddressesIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<ContainerAddressesIsValueUsedResponses, ContainerAddressesIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/container-addresses/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of container configuration templates
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerConfigurationTemplatesGetEntityPageV2 = <ThrowOnError extends boolean = false>(options?: Options<ContainerConfigurationTemplatesGetEntityPageV2Data, ThrowOnError>): RequestResult<ContainerConfigurationTemplatesGetEntityPageV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<ContainerConfigurationTemplatesGetEntityPageV2Responses, unknown, ThrowOnError>({ url: '/api/v2/container-configuration-templates', ...options });

/**
 * Creates new Container configuration template
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerConfigurationTemplatesCreateEntityV2 = <ThrowOnError extends boolean = false>(options?: Options<ContainerConfigurationTemplatesCreateEntityV2Data, ThrowOnError>): RequestResult<ContainerConfigurationTemplatesCreateEntityV2Responses, ContainerConfigurationTemplatesCreateEntityV2Errors, ThrowOnError> => (options?.client ?? client).post<ContainerConfigurationTemplatesCreateEntityV2Responses, ContainerConfigurationTemplatesCreateEntityV2Errors, ThrowOnError>({
    url: '/api/v2/container-configuration-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Deletes Container configuration template
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerConfigurationTemplatesDeleteEntityV2 = <ThrowOnError extends boolean = false>(options: Options<ContainerConfigurationTemplatesDeleteEntityV2Data, ThrowOnError>): RequestResult<ContainerConfigurationTemplatesDeleteEntityV2Responses, ContainerConfigurationTemplatesDeleteEntityV2Errors, ThrowOnError> => (options.client ?? client).delete<ContainerConfigurationTemplatesDeleteEntityV2Responses, ContainerConfigurationTemplatesDeleteEntityV2Errors, ThrowOnError>({ url: '/api/v2/container-configuration-templates/{id}', ...options });

/**
 * Gets Container configuration template
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerConfigurationTemplatesGetEntityV2 = <ThrowOnError extends boolean = false>(options: Options<ContainerConfigurationTemplatesGetEntityV2Data, ThrowOnError>): RequestResult<ContainerConfigurationTemplatesGetEntityV2Responses, ContainerConfigurationTemplatesGetEntityV2Errors, ThrowOnError> => (options.client ?? client).get<ContainerConfigurationTemplatesGetEntityV2Responses, ContainerConfigurationTemplatesGetEntityV2Errors, ThrowOnError>({ url: '/api/v2/container-configuration-templates/{id}', ...options });

/**
 * Updates Container configuration template
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerConfigurationTemplatesUpdateEntityV2 = <ThrowOnError extends boolean = false>(options: Options<ContainerConfigurationTemplatesUpdateEntityV2Data, ThrowOnError>): RequestResult<ContainerConfigurationTemplatesUpdateEntityV2Responses, ContainerConfigurationTemplatesUpdateEntityV2Errors, ThrowOnError> => (options.client ?? client).put<ContainerConfigurationTemplatesUpdateEntityV2Responses, ContainerConfigurationTemplatesUpdateEntityV2Errors, ThrowOnError>({
    url: '/api/v2/container-configuration-templates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerConfigurationTemplatesIsValueUsedV2 = <ThrowOnError extends boolean = false>(options?: Options<ContainerConfigurationTemplatesIsValueUsedV2Data, ThrowOnError>): RequestResult<ContainerConfigurationTemplatesIsValueUsedV2Responses, ContainerConfigurationTemplatesIsValueUsedV2Errors, ThrowOnError> => (options?.client ?? client).post<ContainerConfigurationTemplatesIsValueUsedV2Responses, ContainerConfigurationTemplatesIsValueUsedV2Errors, ThrowOnError>({
    url: '/api/v2/container-configuration-templates/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of container emptying records
 *
 * <p><strong>Required Roles</strong>: <code>AUTO_READOUT_VIEW</code></p>
 */
export const containerEmptyingsGetEntityPage = <ThrowOnError extends boolean = false>(options: Options<ContainerEmptyingsGetEntityPageData, ThrowOnError>): RequestResult<ContainerEmptyingsGetEntityPageResponses, ContainerEmptyingsGetEntityPageErrors, ThrowOnError> => (options.client ?? client).get<ContainerEmptyingsGetEntityPageResponses, ContainerEmptyingsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/container-emptyings', ...options });

/**
 * Creates new manual container emptying record
 *
 * <p><strong>Required Roles</strong>: <code>AUTO_READOUT_RUN</code></p>
 */
export const containerEmptyingsCreateManualRecord = <ThrowOnError extends boolean = false>(options: Options<ContainerEmptyingsCreateManualRecordData, ThrowOnError>): RequestResult<ContainerEmptyingsCreateManualRecordResponses, unknown, ThrowOnError> => (options.client ?? client).post<ContainerEmptyingsCreateManualRecordResponses, unknown, ThrowOnError>({
    url: '/api/v1/container-emptyings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creates new automatic container emptying record
 *
 * <p><strong>Required Roles</strong>: <code>AUTO_READOUT_RUN</code></p>
 */
export const containerEmptyingsCreateAutomaticRecord = <ThrowOnError extends boolean = false>(options: Options<ContainerEmptyingsCreateAutomaticRecordData, ThrowOnError>): RequestResult<ContainerEmptyingsCreateAutomaticRecordResponses, unknown, ThrowOnError> => (options.client ?? client).post<ContainerEmptyingsCreateAutomaticRecordResponses, unknown, ThrowOnError>({
    url: '/api/v1/container-emptyings/auto',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exports container emptying records.
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>AUTO_READOUT_VIEW</code></p>
 */
export const containerEmptyingsExportList = <ThrowOnError extends boolean = false>(options: Options<ContainerEmptyingsExportListData, ThrowOnError>): RequestResult<ContainerEmptyingsExportListResponses, ContainerEmptyingsExportListErrors, ThrowOnError> => (options.client ?? client).get<ContainerEmptyingsExportListResponses, ContainerEmptyingsExportListErrors, ThrowOnError>({ url: '/api/v1/container-emptyings/export.{format}', ...options });

/**
 * Gets page of which customers has any container lock type aliases
 *
 * <p><strong>Required Roles</strong>: <code>LOCK_TYPE_ALIAS_VIEW</code> or <code>LOCK_TYPE_ALIAS_ADMIN</code></p>
 */
export const containerLockTypeAliasesGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<ContainerLockTypeAliasesGetEntityPageData, ThrowOnError>): RequestResult<ContainerLockTypeAliasesGetEntityPageResponses, ContainerLockTypeAliasesGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<ContainerLockTypeAliasesGetEntityPageResponses, ContainerLockTypeAliasesGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/container-lock-type-aliases', ...options });

/**
 * Gets list of container lock type aliases for a customer
 *
 * <p><strong>Required Roles</strong>: <code>LOCK_TYPE_ALIAS_VIEW</code> or <code>LOCK_TYPE_ALIAS_ADMIN</code></p>
 */
export const containerLockTypeAliasesGetCustomerAliases = <ThrowOnError extends boolean = false>(options: Options<ContainerLockTypeAliasesGetCustomerAliasesData, ThrowOnError>): RequestResult<ContainerLockTypeAliasesGetCustomerAliasesResponses, ContainerLockTypeAliasesGetCustomerAliasesErrors, ThrowOnError> => (options.client ?? client).get<ContainerLockTypeAliasesGetCustomerAliasesResponses, ContainerLockTypeAliasesGetCustomerAliasesErrors, ThrowOnError>({ url: '/api/v1/container-lock-type-aliases/{customerId}', ...options });

/**
 * Updates container lock type aliases
 *
 * <p><strong>Required Roles</strong>: <code>LOCK_TYPE_ALIAS_ADMIN</code></p>
 */
export const containerLockTypeAliasesUpdateAliases = <ThrowOnError extends boolean = false>(options: Options<ContainerLockTypeAliasesUpdateAliasesData, ThrowOnError>): RequestResult<ContainerLockTypeAliasesUpdateAliasesResponses, ContainerLockTypeAliasesUpdateAliasesErrors, ThrowOnError> => (options.client ?? client).put<ContainerLockTypeAliasesUpdateAliasesResponses, ContainerLockTypeAliasesUpdateAliasesErrors, ThrowOnError>({
    url: '/api/v1/container-lock-type-aliases/{customerId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets list of container lock types
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>ENDTEST_RUN</code></p>
 */
export const containerLockTypesListContainerLockTypes = <ThrowOnError extends boolean = false>(options?: Options<ContainerLockTypesListContainerLockTypesData, ThrowOnError>): RequestResult<ContainerLockTypesListContainerLockTypesResponses, ContainerLockTypesListContainerLockTypesErrors, ThrowOnError> => (options?.client ?? client).get<ContainerLockTypesListContainerLockTypesResponses, ContainerLockTypesListContainerLockTypesErrors, ThrowOnError>({ url: '/api/v1/container-lock-types', ...options });

/**
 * Gets list of container lock types with aliases
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>ENDTEST_RUN</code></p>
 */
export const containerLockTypesListContainerLockTypesWithAliases = <ThrowOnError extends boolean = false>(options: Options<ContainerLockTypesListContainerLockTypesWithAliasesData, ThrowOnError>): RequestResult<ContainerLockTypesListContainerLockTypesWithAliasesResponses, ContainerLockTypesListContainerLockTypesWithAliasesErrors, ThrowOnError> => (options.client ?? client).get<ContainerLockTypesListContainerLockTypesWithAliasesResponses, ContainerLockTypesListContainerLockTypesWithAliasesErrors, ThrowOnError>({ url: '/api/v1/container-lock-types/{customerId}', ...options });

/**
 * Gets page of containers
 *
 * <b>Deprecated</b>: Please use the `GET /api/v2/containers` instead.
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 *
 * @deprecated
 */
export const containersGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<ContainersGetEntityPageData, ThrowOnError>): RequestResult<ContainersGetEntityPageResponses, ContainersGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<ContainersGetEntityPageResponses, ContainersGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/containers', ...options });

/**
 * Creates new container
 *
 * <b>Deprecated</b>: Please use the `POST /api/v2/containers` endpoint instead.
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 *
 * @deprecated
 */
export const containersCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<ContainersCreateEntityData, ThrowOnError>): RequestResult<ContainersCreateEntityResponses, ContainersCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<ContainersCreateEntityResponses, ContainersCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/containers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of containers with basic information
 *
 * <b>Deprecated</b>: Please use the `GET /api/v2/containers/list-paged` instead.
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 *
 * @deprecated
 */
export const containersGetInfoEntityPage = <ThrowOnError extends boolean = false>(options?: Options<ContainersGetInfoEntityPageData, ThrowOnError>): RequestResult<ContainersGetInfoEntityPageResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ContainersGetInfoEntityPageResponses, unknown, ThrowOnError>({ url: '/api/v1/containers/list-paged', ...options });

/**
 * Gets list of containers
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersListEntities = <ThrowOnError extends boolean = false>(options?: Options<ContainersListEntitiesData, ThrowOnError>): RequestResult<ContainersListEntitiesResponses, ContainersListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<ContainersListEntitiesResponses, ContainersListEntitiesErrors, ThrowOnError>({ url: '/api/v1/containers/list', ...options });

/**
 * Deletes container
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<ContainersDeleteEntityData, ThrowOnError>): RequestResult<ContainersDeleteEntityResponses, ContainersDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<ContainersDeleteEntityResponses, ContainersDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/containers/{id}', ...options });

/**
 * Gets container
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersGetEntity = <ThrowOnError extends boolean = false>(options: Options<ContainersGetEntityData, ThrowOnError>): RequestResult<ContainersGetEntityResponses, ContainersGetEntityErrors, ThrowOnError> => (options.client ?? client).get<ContainersGetEntityResponses, ContainersGetEntityErrors, ThrowOnError>({ url: '/api/v1/containers/{id}', ...options });

/**
 * Updates container.
 *
 * <b>Deprecated</b>: Please use the `PUT /api/v2/containers` instead
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 *
 * @deprecated
 */
export const containersUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<ContainersUpdateEntityData, ThrowOnError>): RequestResult<ContainersUpdateEntityResponses, ContainersUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<ContainersUpdateEntityResponses, ContainersUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/containers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activates Container
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersActivateEntity = <ThrowOnError extends boolean = false>(options: Options<ContainersActivateEntityData, ThrowOnError>): RequestResult<ContainersActivateEntityResponses, ContainersActivateEntityErrors, ThrowOnError> => (options.client ?? client).put<ContainersActivateEntityResponses, ContainersActivateEntityErrors, ThrowOnError>({ url: '/api/v1/containers/{id}/activate', ...options });

/**
 * Gets container location
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersGetContainerLocation = <ThrowOnError extends boolean = false>(options: Options<ContainersGetContainerLocationData, ThrowOnError>): RequestResult<ContainersGetContainerLocationResponses, ContainersGetContainerLocationErrors, ThrowOnError> => (options.client ?? client).get<ContainersGetContainerLocationResponses, ContainersGetContainerLocationErrors, ThrowOnError>({ url: '/api/v1/containers/{id}/location', ...options });

/**
 * Gets whether the container has a location
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersHasContainerLocation = <ThrowOnError extends boolean = false>(options: Options<ContainersHasContainerLocationData, ThrowOnError>): RequestResult<ContainersHasContainerLocationResponses, ContainersHasContainerLocationErrors, ThrowOnError> => (options.client ?? client).get<ContainersHasContainerLocationResponses, ContainersHasContainerLocationErrors, ThrowOnError>({ url: '/api/v1/containers/{id}/has-location', ...options });

/**
 * Shows known container locations
 *
 * <b>Deprecated</b>: Please use the `GET /api/v2/containers/map` instead
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 *
 * @deprecated
 */
export const containersGetContainerMap = <ThrowOnError extends boolean = false>(options?: Options<ContainersGetContainerMapData, ThrowOnError>): RequestResult<ContainersGetContainerMapResponses, ContainersGetContainerMapErrors, ThrowOnError> => (options?.client ?? client).get<ContainersGetContainerMapResponses, ContainersGetContainerMapErrors, ThrowOnError>({ url: '/api/v1/containers/map', ...options });

/**
 * Gets logs for the container
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersGetContainerLog = <ThrowOnError extends boolean = false>(options: Options<ContainersGetContainerLogData, ThrowOnError>): RequestResult<ContainersGetContainerLogResponses, unknown, ThrowOnError> => (options.client ?? client).get<ContainersGetContainerLogResponses, unknown, ThrowOnError>({ url: '/api/v1/containers/{containerId}/log', ...options });

/**
 * Gets configuration history for the container
 *
 * <b>Deprecated</b>: Please use the `GET /api/v1/containers/config-history-page` endpoint for better performance
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 *
 * @deprecated
 */
export const containersGetContainerConfigurationHistory = <ThrowOnError extends boolean = false>(options: Options<ContainersGetContainerConfigurationHistoryData, ThrowOnError>): RequestResult<ContainersGetContainerConfigurationHistoryResponses, unknown, ThrowOnError> => (options.client ?? client).get<ContainersGetContainerConfigurationHistoryResponses, unknown, ThrowOnError>({ url: '/api/v1/containers/{containerId}/config-history', ...options });

/**
 * Gets configuration history for the container
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersGetPageContainerConfigurationHistory = <ThrowOnError extends boolean = false>(options: Options<ContainersGetPageContainerConfigurationHistoryData, ThrowOnError>): RequestResult<ContainersGetPageContainerConfigurationHistoryResponses, ContainersGetPageContainerConfigurationHistoryErrors, ThrowOnError> => (options.client ?? client).get<ContainersGetPageContainerConfigurationHistoryResponses, ContainersGetPageContainerConfigurationHistoryErrors, ThrowOnError>({ url: '/api/v1/containers/{containerId}/config-history-page', ...options });

/**
 * Exports configuration history for one container
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersExportConfigurationHistory = <ThrowOnError extends boolean = false>(options: Options<ContainersExportConfigurationHistoryData, ThrowOnError>): RequestResult<ContainersExportConfigurationHistoryResponses, unknown, ThrowOnError> => (options.client ?? client).get<ContainersExportConfigurationHistoryResponses, unknown, ThrowOnError>({ url: '/api/v1/containers/{containerId}/config-history/export.{format}', ...options });

/**
 * Gets fill level history for the container
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersGetContainerFillHistory = <ThrowOnError extends boolean = false>(options: Options<ContainersGetContainerFillHistoryData, ThrowOnError>): RequestResult<ContainersGetContainerFillHistoryResponses, ContainersGetContainerFillHistoryErrors, ThrowOnError> => (options.client ?? client).get<ContainersGetContainerFillHistoryResponses, ContainersGetContainerFillHistoryErrors, ThrowOnError>({ url: '/api/v1/containers/{containerId}/fill', ...options });

/**
 * Gets insert counter history for the container
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersGetContainerInsertCounterHistory = <ThrowOnError extends boolean = false>(options: Options<ContainersGetContainerInsertCounterHistoryData, ThrowOnError>): RequestResult<ContainersGetContainerInsertCounterHistoryResponses, unknown, ThrowOnError> => (options.client ?? client).get<ContainersGetContainerInsertCounterHistoryResponses, unknown, ThrowOnError>({ url: '/api/v1/containers/{containerId}/insert-counter', ...options });

/**
 * Exports containers.
 *
 * <b>Deprecated</b>: Please use the `GET /api/v2/containers/export` instead
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 *
 * @deprecated
 */
export const containersExportList = <ThrowOnError extends boolean = false>(options: Options<ContainersExportListData, ThrowOnError>): RequestResult<ContainersExportListResponses, ContainersExportListErrors, ThrowOnError> => (options.client ?? client).get<ContainersExportListResponses, ContainersExportListErrors, ThrowOnError>({ url: '/api/v1/containers/export.{format}', ...options });

/**
 * Exports fill level history for one container
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>FILL_SENSOR_VIEW</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const containersExportFillLevelHistory = <ThrowOnError extends boolean = false>(options: Options<ContainersExportFillLevelHistoryData, ThrowOnError>): RequestResult<ContainersExportFillLevelHistoryResponses, unknown, ThrowOnError> => (options.client ?? client).get<ContainersExportFillLevelHistoryResponses, unknown, ThrowOnError>({ url: '/api/v1/containers/{id}/fill-levels/export.{format}', ...options });

/**
 * Exports fill level history for multiple containers
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>FILL_SENSOR_VIEW</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const containersExportMultipleFillLevelHistory = <ThrowOnError extends boolean = false>(options: Options<ContainersExportMultipleFillLevelHistoryData, ThrowOnError>): RequestResult<ContainersExportMultipleFillLevelHistoryResponses, unknown, ThrowOnError> => (options.client ?? client).get<ContainersExportMultipleFillLevelHistoryResponses, unknown, ThrowOnError>({ url: '/api/v1/containers/fill-levels/export.{format}', ...options });

/**
 * Receives transactions from the container
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const containersReceiveTransactions = <ThrowOnError extends boolean = false>(options?: Options<ContainersReceiveTransactionsData, ThrowOnError>): RequestResult<ContainersReceiveTransactionsResponses, ContainersReceiveTransactionsErrors, ThrowOnError> => (options?.client ?? client).post<ContainersReceiveTransactionsResponses, ContainersReceiveTransactionsErrors, ThrowOnError>({
    url: '/api/v1/containers/transactions',
    ...options,
    headers: {
        'Content-Type': 'application/x-protobuf',
        ...options?.headers
    }
});

/**
 * Receives status (telemetry) from the container
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const containersReceiveStatus = <ThrowOnError extends boolean = false>(options?: Options<ContainersReceiveStatusData, ThrowOnError>): RequestResult<ContainersReceiveStatusResponses, ContainersReceiveStatusErrors, ThrowOnError> => (options?.client ?? client).post<ContainersReceiveStatusResponses, ContainersReceiveStatusErrors, ThrowOnError>({
    url: '/api/v1/containers/status',
    ...options,
    headers: {
        'Content-Type': 'application/x-protobuf',
        ...options?.headers
    }
});

/**
 * Receives status (telemetry) from the container
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const containersReceiveStatusOnlyTelemetry = <ThrowOnError extends boolean = false>(options?: Options<ContainersReceiveStatusOnlyTelemetryData, ThrowOnError>): RequestResult<ContainersReceiveStatusOnlyTelemetryResponses, ContainersReceiveStatusOnlyTelemetryErrors, ThrowOnError> => (options?.client ?? client).post<ContainersReceiveStatusOnlyTelemetryResponses, ContainersReceiveStatusOnlyTelemetryErrors, ThrowOnError>({
    url: '/api/v1/containers/short-status',
    ...options,
    headers: {
        'Content-Type': 'application/x-protobuf',
        ...options?.headers
    }
});

/**
 * Receives logs from the container
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>CONTAINER_ADMIN</code> or <code>PROXY</code> or <code>APP_API_KEY</code></p>
 */
export const containersReceiveLogs = <ThrowOnError extends boolean = false>(options?: Options<ContainersReceiveLogsData, ThrowOnError>): RequestResult<ContainersReceiveLogsResponses, ContainersReceiveLogsErrors, ThrowOnError> => (options?.client ?? client).post<ContainersReceiveLogsResponses, ContainersReceiveLogsErrors, ThrowOnError>({
    url: '/api/v1/containers/logs',
    ...options,
    headers: {
        'Content-Type': 'application/x-protobuf',
        ...options?.headers
    }
});

/**
 * Receives emptying detection logs from the container
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>CONTAINER_ADMIN</code> or <code>PROXY</code> or <code>APP_API_KEY</code></p>
 */
export const containersReceiveEmptyingDetectionLogs = <ThrowOnError extends boolean = false>(options?: Options<ContainersReceiveEmptyingDetectionLogsData, ThrowOnError>): RequestResult<ContainersReceiveEmptyingDetectionLogsResponses, ContainersReceiveEmptyingDetectionLogsErrors, ThrowOnError> => (options?.client ?? client).post<ContainersReceiveEmptyingDetectionLogsResponses, ContainersReceiveEmptyingDetectionLogsErrors, ThrowOnError>({
    url: '/api/v1/containers/emptying-detection-logs',
    ...options,
    headers: {
        'Content-Type': 'application/x-protobuf',
        ...options?.headers
    }
});

/**
 * Gets the legacy access list
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_VIEW</code> or <code>LARGE_LIST_ADMIN</code></p>
 */
export const containersGetLegacyAccessList = <ThrowOnError extends boolean = false>(options: Options<ContainersGetLegacyAccessListData, ThrowOnError>): RequestResult<ContainersGetLegacyAccessListResponses, ContainersGetLegacyAccessListErrors, ThrowOnError> => (options.client ?? client).get<ContainersGetLegacyAccessListResponses, ContainersGetLegacyAccessListErrors, ThrowOnError>({ url: '/api/v1/containers/{id}/legacy-access-list', ...options });

/**
 * Adds entries to the legacy access list.
 *
 * The access list is used for `eGate` type hardware units.
 * For the newer generation `AcUpgrade`, the Large List is used instead.<p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const containersAddEntries = <ThrowOnError extends boolean = false>(options: Options<ContainersAddEntriesData, ThrowOnError>): RequestResult<ContainersAddEntriesResponses, ContainersAddEntriesErrors, ThrowOnError> => (options.client ?? client).post<ContainersAddEntriesResponses, ContainersAddEntriesErrors, ThrowOnError>({
    url: '/api/v1/containers/{id}/legacy-access-list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets list of locations history for given container
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersGetLocationHistoryPage = <ThrowOnError extends boolean = false>(options: Options<ContainersGetLocationHistoryPageData, ThrowOnError>): RequestResult<ContainersGetLocationHistoryPageResponses, ContainersGetLocationHistoryPageErrors, ThrowOnError> => (options.client ?? client).get<ContainersGetLocationHistoryPageResponses, ContainersGetLocationHistoryPageErrors, ThrowOnError>({ url: '/api/v1/containers/{id}/location-history', ...options });

/**
 * Gets page of containers
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersGetEntityPageV2 = <ThrowOnError extends boolean = false>(options?: Options<ContainersGetEntityPageV2Data, ThrowOnError>): RequestResult<ContainersGetEntityPageV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<ContainersGetEntityPageV2Responses, unknown, ThrowOnError>({ url: '/api/v2/containers', ...options });

/**
 * Creates new container
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersCreateEntityV2 = <ThrowOnError extends boolean = false>(options?: Options<ContainersCreateEntityV2Data, ThrowOnError>): RequestResult<ContainersCreateEntityV2Responses, ContainersCreateEntityV2Errors, ThrowOnError> => (options?.client ?? client).post<ContainersCreateEntityV2Responses, ContainersCreateEntityV2Errors, ThrowOnError>({
    url: '/api/v2/containers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of containers with basic information
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersGetInfoEntityPageV2 = <ThrowOnError extends boolean = false>(options?: Options<ContainersGetInfoEntityPageV2Data, ThrowOnError>): RequestResult<ContainersGetInfoEntityPageV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<ContainersGetInfoEntityPageV2Responses, unknown, ThrowOnError>({ url: '/api/v2/containers/list-paged', ...options });

/**
 * Updates container
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersUpdateEntityV2 = <ThrowOnError extends boolean = false>(options: Options<ContainersUpdateEntityV2Data, ThrowOnError>): RequestResult<ContainersUpdateEntityV2Responses, ContainersUpdateEntityV2Errors, ThrowOnError> => (options.client ?? client).put<ContainersUpdateEntityV2Responses, ContainersUpdateEntityV2Errors, ThrowOnError>({
    url: '/api/v2/containers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Shows known container locations
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersGetContainerMapV2 = <ThrowOnError extends boolean = false>(options?: Options<ContainersGetContainerMapV2Data, ThrowOnError>): RequestResult<ContainersGetContainerMapV2Responses, ContainersGetContainerMapV2Errors, ThrowOnError> => (options?.client ?? client).get<ContainersGetContainerMapV2Responses, ContainersGetContainerMapV2Errors, ThrowOnError>({ url: '/api/v2/containers/map', ...options });

/**
 * Exports containers.
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersExportListV2 = <ThrowOnError extends boolean = false>(options: Options<ContainersExportListV2Data, ThrowOnError>): RequestResult<ContainersExportListV2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ContainersExportListV2Responses, unknown, ThrowOnError>({ url: '/api/v2/containers/export.{format}', ...options });

/**
 * Shows known container locations
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containersGetContainerMapV3 = <ThrowOnError extends boolean = false>(options?: Options<ContainersGetContainerMapV3Data, ThrowOnError>): RequestResult<ContainersGetContainerMapV3Responses, ContainersGetContainerMapV3Errors, ThrowOnError> => (options?.client ?? client).get<ContainersGetContainerMapV3Responses, ContainersGetContainerMapV3Errors, ThrowOnError>({ url: '/api/v3/containers/map', ...options });

/**
 * Gets paged list of container transactions
 *
 * <p><strong>Required Roles</strong>: <code>TRANSACTION_VIEW</code></p>
 */
export const containerTransactionConflictsGetEntityPage = <ThrowOnError extends boolean = false>(options: Options<ContainerTransactionConflictsGetEntityPageData, ThrowOnError>): RequestResult<ContainerTransactionConflictsGetEntityPageResponses, ContainerTransactionConflictsGetEntityPageErrors, ThrowOnError> => (options.client ?? client).get<ContainerTransactionConflictsGetEntityPageResponses, ContainerTransactionConflictsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/container-transaction-conflicts', ...options });

/**
 * Exports list of container transaction conflicts
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>TRANSACTION_VIEW</code></p>
 */
export const containerTransactionConflictsExportList = <ThrowOnError extends boolean = false>(options: Options<ContainerTransactionConflictsExportListData, ThrowOnError>): RequestResult<ContainerTransactionConflictsExportListResponses, ContainerTransactionConflictsExportListErrors, ThrowOnError> => (options.client ?? client).get<ContainerTransactionConflictsExportListResponses, ContainerTransactionConflictsExportListErrors, ThrowOnError>({ url: '/api/v1/container-transaction-conflicts/export.{format}', ...options });

/**
 * Gets paged list of container transactions
 *
 * If includeAddress is set to true, the report will contain additional column with the address of the container at the time of the transaction.
 * But this requires additional processing, so time of the report page generation will be longer.<p><strong>Required Roles</strong>: <code>TRANSACTION_VIEW</code></p>
 */
export const containerTransactionsGetEntityPage = <ThrowOnError extends boolean = false>(options: Options<ContainerTransactionsGetEntityPageData, ThrowOnError>): RequestResult<ContainerTransactionsGetEntityPageResponses, ContainerTransactionsGetEntityPageErrors, ThrowOnError> => (options.client ?? client).get<ContainerTransactionsGetEntityPageResponses, ContainerTransactionsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/container-transactions', ...options });

/**
 * Receives transactions from the container
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>CONTAINER_ADMIN</code> or <code>APP_API_KEY</code></p>
 */
export const containerTransactionsReceiveTransactions = <ThrowOnError extends boolean = false>(options?: Options<ContainerTransactionsReceiveTransactionsData, ThrowOnError>): RequestResult<ContainerTransactionsReceiveTransactionsResponses, ContainerTransactionsReceiveTransactionsErrors, ThrowOnError> => (options?.client ?? client).post<ContainerTransactionsReceiveTransactionsResponses, ContainerTransactionsReceiveTransactionsErrors, ThrowOnError>({
    url: '/api/v1/container-transactions',
    ...options,
    headers: {
        'Content-Type': 'application/x-protobuf',
        ...options?.headers
    }
});

/**
 * Exports list of container transactions.
 *
 * The supported *format*s are either JSON or CSV.
 *
 * If includeAddress is set to true, the export will contain additional column with the address of the container at the time of the transaction.
 * But this requires additional processing, so time of the export generation will be longer.<p><strong>Required Roles</strong>: <code>TRANSACTION_VIEW</code></p>
 */
export const containerTransactionsExportList = <ThrowOnError extends boolean = false>(options: Options<ContainerTransactionsExportListData, ThrowOnError>): RequestResult<ContainerTransactionsExportListResponses, ContainerTransactionsExportListErrors, ThrowOnError> => (options.client ?? client).get<ContainerTransactionsExportListResponses, ContainerTransactionsExportListErrors, ThrowOnError>({ url: '/api/v1/container-transactions/export.{format}', ...options });

/**
 * Marks the transaction and all transactions with lower TransactionId
 * and same Hardware Unit as confirmed.
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const containerTransactionsConfirm = <ThrowOnError extends boolean = false>(options: Options<ContainerTransactionsConfirmData, ThrowOnError>): RequestResult<ContainerTransactionsConfirmResponses, ContainerTransactionsConfirmErrors, ThrowOnError> => (options.client ?? client).put<ContainerTransactionsConfirmResponses, ContainerTransactionsConfirmErrors, ThrowOnError>({ url: '/api/v1/container-transactions/{transactionId}/confirm', ...options });

/**
 * Gets list of ContainerTypes
 *
 * <p><strong>Required Roles</strong>: <code>CONT_TYPE_VIEW</code> or <code>CONTAINER_VIEW</code></p>
 */
export const containerTypeGetList = <ThrowOnError extends boolean = false>(options?: Options<ContainerTypeGetListData, ThrowOnError>): RequestResult<ContainerTypeGetListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ContainerTypeGetListResponses, unknown, ThrowOnError>({ url: '/api/v1/container-type/list', ...options });

/**
 * Gets a page of ContainerTypes
 *
 * <p><strong>Required Roles</strong>: <code>CONT_TYPE_VIEW</code> or <code>CONT_TYPE_ADMIN</code></p>
 */
export const containerTypeGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<ContainerTypeGetEntityPageData, ThrowOnError>): RequestResult<ContainerTypeGetEntityPageResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ContainerTypeGetEntityPageResponses, unknown, ThrowOnError>({ url: '/api/v1/container-type', ...options });

/**
 * Creates a new ContainerType
 *
 * <p><strong>Required Roles</strong>: <code>CONT_TYPE_ADMIN</code></p>
 */
export const containerTypeCreateEntity = <ThrowOnError extends boolean = false>(options: Options<ContainerTypeCreateEntityData, ThrowOnError>): RequestResult<ContainerTypeCreateEntityResponses, ContainerTypeCreateEntityErrors, ThrowOnError> => (options.client ?? client).post<ContainerTypeCreateEntityResponses, ContainerTypeCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/container-type',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes a ContainerType
 *
 * <p><strong>Required Roles</strong>: <code>CONT_TYPE_ADMIN</code></p>
 */
export const containerTypeDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<ContainerTypeDeleteEntityData, ThrowOnError>): RequestResult<ContainerTypeDeleteEntityResponses, ContainerTypeDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<ContainerTypeDeleteEntityResponses, ContainerTypeDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/container-type/{id}', ...options });

/**
 * Gets a ContainerType by id
 *
 * <p><strong>Required Roles</strong>: <code>CONT_TYPE_VIEW</code> or <code>CONT_TYPE_ADMIN</code></p>
 */
export const containerTypeGetEntity = <ThrowOnError extends boolean = false>(options: Options<ContainerTypeGetEntityData, ThrowOnError>): RequestResult<ContainerTypeGetEntityResponses, ContainerTypeGetEntityErrors, ThrowOnError> => (options.client ?? client).get<ContainerTypeGetEntityResponses, ContainerTypeGetEntityErrors, ThrowOnError>({ url: '/api/v1/container-type/{id}', ...options });

/**
 * Updates a ContainerType
 *
 * <p><strong>Required Roles</strong>: <code>CONT_TYPE_ADMIN</code></p>
 */
export const containerTypeUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<ContainerTypeUpdateEntityData, ThrowOnError>): RequestResult<ContainerTypeUpdateEntityResponses, ContainerTypeUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<ContainerTypeUpdateEntityResponses, ContainerTypeUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/container-type/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets page of Contracts
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_VIEW</code> or <code>CONTRACT_ADMIN</code></p>
 */
export const contractsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<ContractsGetEntityPageData, ThrowOnError>): RequestResult<ContractsGetEntityPageResponses, ContractsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<ContractsGetEntityPageResponses, ContractsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/contracts', ...options });

/**
 * Creates new Contract
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const contractsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<ContractsCreateEntityData, ThrowOnError>): RequestResult<ContractsCreateEntityResponses, ContractsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<ContractsCreateEntityResponses, ContractsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/contracts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of containers
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_VIEW</code> or <code>CONTRACT_ADMIN</code></p>
 */
export const contractsListEntities = <ThrowOnError extends boolean = false>(options?: Options<ContractsListEntitiesData, ThrowOnError>): RequestResult<ContractsListEntitiesResponses, ContractsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<ContractsListEntitiesResponses, ContractsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/contracts/list', ...options });

/**
 * Deletes Contract
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const contractsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<ContractsDeleteEntityData, ThrowOnError>): RequestResult<ContractsDeleteEntityResponses, ContractsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<ContractsDeleteEntityResponses, ContractsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/contracts/{id}', ...options });

/**
 * Gets Contract
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_VIEW</code> or <code>CONTRACT_ADMIN</code></p>
 */
export const contractsGetEntity = <ThrowOnError extends boolean = false>(options: Options<ContractsGetEntityData, ThrowOnError>): RequestResult<ContractsGetEntityResponses, ContractsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<ContractsGetEntityResponses, ContractsGetEntityErrors, ThrowOnError>({ url: '/api/v1/contracts/{id}', ...options });

/**
 * Updates Contract
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const contractsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<ContractsUpdateEntityData, ThrowOnError>): RequestResult<ContractsUpdateEntityResponses, ContractsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<ContractsUpdateEntityResponses, ContractsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/contracts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activates Contract
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const contractsActivateEntity = <ThrowOnError extends boolean = false>(options: Options<ContractsActivateEntityData, ThrowOnError>): RequestResult<ContractsActivateEntityResponses, ContractsActivateEntityErrors, ThrowOnError> => (options.client ?? client).put<ContractsActivateEntityResponses, ContractsActivateEntityErrors, ThrowOnError>({ url: '/api/v1/contracts/{id}/activate', ...options });

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const contractsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<ContractsIsValueUsedData, ThrowOnError>): RequestResult<ContractsIsValueUsedResponses, ContractsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<ContractsIsValueUsedResponses, ContractsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/contracts/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Exports contracts.
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>CONTRACT_VIEW</code> or <code>CONTRACT_ADMIN</code></p>
 */
export const contractsExportList = <ThrowOnError extends boolean = false>(options: Options<ContractsExportListData, ThrowOnError>): RequestResult<ContractsExportListResponses, ContractsExportListErrors, ThrowOnError> => (options.client ?? client).get<ContractsExportListResponses, ContractsExportListErrors, ThrowOnError>({ url: '/api/v1/contracts/export.{format}', ...options });

/**
 * Gets Customer branding from Contract Id
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>CONTRACT_VIEW</code> or <code>CONTRACT_ADMIN</code></p>
 */
export const contractsBranding = <ThrowOnError extends boolean = false>(options: Options<ContractsBrandingData, ThrowOnError>): RequestResult<ContractsBrandingResponses, ContractsBrandingErrors, ThrowOnError> => (options.client ?? client).get<ContractsBrandingResponses, ContractsBrandingErrors, ThrowOnError>({ url: '/api/v1/contracts/{id}/branding', ...options });

/**
 * Lists active users not assigned to the contract,
 * ordered by user name
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const contractsListAvailableUsers = <ThrowOnError extends boolean = false>(options: Options<ContractsListAvailableUsersData, ThrowOnError>): RequestResult<ContractsListAvailableUsersResponses, ContractsListAvailableUsersErrors, ThrowOnError> => (options.client ?? client).get<ContractsListAvailableUsersResponses, ContractsListAvailableUsersErrors, ThrowOnError>({ url: '/api/v1/contracts/{contractId}/users/available', ...options });

/**
 * Lists users assigned to the contract
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_VIEW</code> or <code>CONTRACT_ADMIN</code></p>
 */
export const contractsListUsers = <ThrowOnError extends boolean = false>(options: Options<ContractsListUsersData, ThrowOnError>): RequestResult<ContractsListUsersResponses, ContractsListUsersErrors, ThrowOnError> => (options.client ?? client).get<ContractsListUsersResponses, ContractsListUsersErrors, ThrowOnError>({ url: '/api/v1/contracts/{contractId}/users', ...options });

/**
 * Updates given users for given contract
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const contractsUpdateUsers = <ThrowOnError extends boolean = false>(options: Options<ContractsUpdateUsersData, ThrowOnError>): RequestResult<ContractsUpdateUsersResponses, ContractsUpdateUsersErrors, ThrowOnError> => (options.client ?? client).put<ContractsUpdateUsersResponses, ContractsUpdateUsersErrors, ThrowOnError>({
    url: '/api/v1/contracts/{id}/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists devices assigned to the contract.
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_VIEW</code> or <code>CONTRACT_ADMIN</code></p>
 */
export const contractsListDevices = <ThrowOnError extends boolean = false>(options: Options<ContractsListDevicesData, ThrowOnError>): RequestResult<ContractsListDevicesResponses, ContractsListDevicesErrors, ThrowOnError> => (options.client ?? client).get<ContractsListDevicesResponses, ContractsListDevicesErrors, ThrowOnError>({ url: '/api/v1/contracts/{contractId}/devices', ...options });

/**
 * Gets page of Customer EULAs
 */
export const customerEulasGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<CustomerEulasGetEntityPageData, ThrowOnError>): RequestResult<CustomerEulasGetEntityPageResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CustomerEulasGetEntityPageResponses, unknown, ThrowOnError>({ url: '/api/v1/customer-eulas', ...options });

/**
 * Creates new Customer EULA
 *
 * <p><strong>Required Roles</strong>: <code>CUST_EULA_ADMIN</code></p>
 */
export const customerEulasCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<CustomerEulasCreateEntityData, ThrowOnError>): RequestResult<CustomerEulasCreateEntityResponses, CustomerEulasCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<CustomerEulasCreateEntityResponses, CustomerEulasCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/customer-eulas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets Customer EULA (for UI view)
 */
export const customerEulasGetEntity = <ThrowOnError extends boolean = false>(options: Options<CustomerEulasGetEntityData, ThrowOnError>): RequestResult<CustomerEulasGetEntityResponses, CustomerEulasGetEntityErrors, ThrowOnError> => (options.client ?? client).get<CustomerEulasGetEntityResponses, CustomerEulasGetEntityErrors, ThrowOnError>({ url: '/api/v1/customer-eulas/{id}', ...options });

/**
 * Updates Customer EULA
 *
 * <p><strong>Required Roles</strong>: <code>CUST_EULA_ADMIN</code></p>
 */
export const customerEulasUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<CustomerEulasUpdateEntityData, ThrowOnError>): RequestResult<CustomerEulasUpdateEntityResponses, CustomerEulasUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<CustomerEulasUpdateEntityResponses, CustomerEulasUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/customer-eulas/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets Customer EULA text
 */
export const customerEulasGetEulaText = <ThrowOnError extends boolean = false>(options: Options<CustomerEulasGetEulaTextData, ThrowOnError>): RequestResult<CustomerEulasGetEulaTextResponses, CustomerEulasGetEulaTextErrors, ThrowOnError> => (options.client ?? client).get<CustomerEulasGetEulaTextResponses, CustomerEulasGetEulaTextErrors, ThrowOnError>({ url: '/api/v1/customer-eulas/{id}/index.html', ...options });

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>CUST_EULA_ADMIN</code></p>
 */
export const customerEulasIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<CustomerEulasIsValueUsedData, ThrowOnError>): RequestResult<CustomerEulasIsValueUsedResponses, CustomerEulasIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<CustomerEulasIsValueUsedResponses, CustomerEulasIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/customer-eulas/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets paged view of customers
 *
 * <b>Deprecated</b>: Use <code>GET /api/v2/customers</code> instead
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 *
 * @deprecated
 */
export const customersGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetEntityPageData, ThrowOnError>): RequestResult<CustomersGetEntityPageResponses, CustomersGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<CustomersGetEntityPageResponses, CustomersGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/customers', ...options });

/**
 * Creates new Customer
 *
 * <b>Deprecated</b>: Use <code>POST /api/v2/customers</code> instead
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 *
 * @deprecated
 */
export const customersCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<CustomersCreateEntityData, ThrowOnError>): RequestResult<CustomersCreateEntityResponses, CustomersCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<CustomersCreateEntityResponses, CustomersCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/customers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of customers
 *
 * <b>Deprecated</b>: Use <code>GET /api/v2/customers/list</code> instead
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 *
 * @deprecated
 */
export const customersListEntities = <ThrowOnError extends boolean = false>(options?: Options<CustomersListEntitiesData, ThrowOnError>): RequestResult<CustomersListEntitiesResponses, CustomersListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<CustomersListEntitiesResponses, CustomersListEntitiesErrors, ThrowOnError>({ url: '/api/v1/customers/list', ...options });

/**
 * Deletes Customer.
 *
 * <b>Deprecated</b>: Use <code>DELETE /api/v2/customers/{id}</code> instead
 *
 * Calling user cannot delete his last accessible Customer.
 * Customer must not have any active children.<p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 *
 * @deprecated
 */
export const customersDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<CustomersDeleteEntityData, ThrowOnError>): RequestResult<CustomersDeleteEntityResponses, CustomersDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<CustomersDeleteEntityResponses, CustomersDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/customers/{id}', ...options });

/**
 * Gets specific Customer
 *
 * <b>Deprecated</b>: Use <code>GET /api/v2/customers/{id}</code> instead
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 *
 * @deprecated
 */
export const customersGetEntity = <ThrowOnError extends boolean = false>(options: Options<CustomersGetEntityData, ThrowOnError>): RequestResult<CustomersGetEntityResponses, CustomersGetEntityErrors, ThrowOnError> => (options.client ?? client).get<CustomersGetEntityResponses, CustomersGetEntityErrors, ThrowOnError>({ url: '/api/v1/customers/{id}', ...options });

/**
 * Updates Customer
 *
 * <b>Deprecated</b>: Use <code>PUT /api/v2/customers/{id}</code> instead
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 *
 * @deprecated
 */
export const customersUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<CustomersUpdateEntityData, ThrowOnError>): RequestResult<CustomersUpdateEntityResponses, CustomersUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<CustomersUpdateEntityResponses, CustomersUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creates new Customer
 *
 * <b>Deprecated</b>: Use <code>PUT /api/v2/customers/{id}/parent</code> instead
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 *
 * @deprecated
 */
export const customersUpdateParent = <ThrowOnError extends boolean = false>(options: Options<CustomersUpdateParentData, ThrowOnError>): RequestResult<CustomersUpdateParentResponses, CustomersUpdateParentErrors, ThrowOnError> => (options.client ?? client).put<CustomersUpdateParentResponses, CustomersUpdateParentErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/parent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activates previously deleted Customer.
 *
 * <b>Deprecated</b>: Use <code>PUT /api/v2/customers/{id}/activate</code> instead
 *
 * Calling user must have access to Customer's parent.
 * Parent must not be deleted.<p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 *
 * @deprecated
 */
export const customersActivateEntity = <ThrowOnError extends boolean = false>(options: Options<CustomersActivateEntityData, ThrowOnError>): RequestResult<CustomersActivateEntityResponses, CustomersActivateEntityErrors, ThrowOnError> => (options.client ?? client).put<CustomersActivateEntityResponses, CustomersActivateEntityErrors, ThrowOnError>({ url: '/api/v1/customers/{id}/activate', ...options });

/**
 * Check if value for given field is already used
 *
 * <b>Deprecated</b>: Use <code>POST /api/v2/customers/value-used</code> instead
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 *
 * @deprecated
 */
export const customersIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<CustomersIsValueUsedData, ThrowOnError>): RequestResult<CustomersIsValueUsedResponses, CustomersIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<CustomersIsValueUsedResponses, CustomersIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/customers/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Exports customers.
 *
 * <b>Deprecated</b>: Use <code>GET /api/v2/customers/export.{format}</code> instead
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 *
 * @deprecated
 */
export const customersExportList = <ThrowOnError extends boolean = false>(options: Options<CustomersExportListData, ThrowOnError>): RequestResult<CustomersExportListResponses, CustomersExportListErrors, ThrowOnError> => (options.client ?? client).get<CustomersExportListResponses, CustomersExportListErrors, ThrowOnError>({ url: '/api/v1/customers/export.{format}', ...options });

/**
 * Lists departments
 *
 * <b>Deprecated</b>: Use <code>GET /api/v2/customers/departments/list</code> instead
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 *
 * @deprecated
 */
export const customersListDepartments = <ThrowOnError extends boolean = false>(options?: Options<CustomersListDepartmentsData, ThrowOnError>): RequestResult<CustomersListDepartmentsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CustomersListDepartmentsResponses, unknown, ThrowOnError>({ url: '/api/v1/customers/departments/list', ...options });

/**
 * Validates import of  container addresses for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const customersValidateContainerAddressesImport = <ThrowOnError extends boolean = false>(options: Options<CustomersValidateContainerAddressesImportData, ThrowOnError>): RequestResult<CustomersValidateContainerAddressesImportResponses, CustomersValidateContainerAddressesImportErrors, ThrowOnError> => (options.client ?? client).post<CustomersValidateContainerAddressesImportResponses, CustomersValidateContainerAddressesImportErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/container-addresses/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validates import of  containers for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const customersValidateContainersImport = <ThrowOnError extends boolean = false>(options: Options<CustomersValidateContainersImportData, ThrowOnError>): RequestResult<CustomersValidateContainersImportResponses, CustomersValidateContainersImportErrors, ThrowOnError> => (options.client ?? client).post<CustomersValidateContainersImportResponses, CustomersValidateContainersImportErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/containers/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validates possibility of changing containers customer
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const customersValidateContainersChangeCustomerImport = <ThrowOnError extends boolean = false>(options: Options<CustomersValidateContainersChangeCustomerImportData, ThrowOnError>): RequestResult<CustomersValidateContainersChangeCustomerImportResponses, CustomersValidateContainersChangeCustomerImportErrors, ThrowOnError> => (options.client ?? client).post<CustomersValidateContainersChangeCustomerImportResponses, CustomersValidateContainersChangeCustomerImportErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/containers-customer/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Imports container addresses for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const customersImportContainerAddresses = <ThrowOnError extends boolean = false>(options: Options<CustomersImportContainerAddressesData, ThrowOnError>): RequestResult<CustomersImportContainerAddressesResponses, CustomersImportContainerAddressesErrors, ThrowOnError> => (options.client ?? client).post<CustomersImportContainerAddressesResponses, CustomersImportContainerAddressesErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/container-addresses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Imports containers for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const customersImportContainers = <ThrowOnError extends boolean = false>(options: Options<CustomersImportContainersData, ThrowOnError>): RequestResult<CustomersImportContainersResponses, CustomersImportContainersErrors, ThrowOnError> => (options.client ?? client).post<CustomersImportContainersResponses, CustomersImportContainersErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/containers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Changes customer for multiple of containers
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const customersChangeContainersCustomer = <ThrowOnError extends boolean = false>(options: Options<CustomersChangeContainersCustomerData, ThrowOnError>): RequestResult<CustomersChangeContainersCustomerResponses, CustomersChangeContainersCustomerErrors, ThrowOnError> => (options.client ?? client).post<CustomersChangeContainersCustomerResponses, CustomersChangeContainersCustomerErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/containers-customer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validates import of contracts for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersValidateContractsImport = <ThrowOnError extends boolean = false>(options: Options<CustomersValidateContractsImportData, ThrowOnError>): RequestResult<CustomersValidateContractsImportResponses, CustomersValidateContractsImportErrors, ThrowOnError> => (options.client ?? client).post<CustomersValidateContractsImportResponses, CustomersValidateContractsImportErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/contracts/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Imports contracts for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersImportContracts = <ThrowOnError extends boolean = false>(options: Options<CustomersImportContractsData, ThrowOnError>): RequestResult<CustomersImportContractsResponses, CustomersImportContractsErrors, ThrowOnError> => (options.client ?? client).post<CustomersImportContractsResponses, CustomersImportContractsErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/contracts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validates import of contract containers for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersValidateContractContainersImport = <ThrowOnError extends boolean = false>(options: Options<CustomersValidateContractContainersImportData, ThrowOnError>): RequestResult<CustomersValidateContractContainersImportResponses, CustomersValidateContractContainersImportErrors, ThrowOnError> => (options.client ?? client).post<CustomersValidateContractContainersImportResponses, CustomersValidateContractContainersImportErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/contract-containers/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Imports contract containers for given customer.
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersImportContractContainers = <ThrowOnError extends boolean = false>(options: Options<CustomersImportContractContainersData, ThrowOnError>): RequestResult<CustomersImportContractContainersResponses, CustomersImportContractContainersErrors, ThrowOnError> => (options.client ?? client).post<CustomersImportContractContainersResponses, CustomersImportContractContainersErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/contract-containers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Imports NFC cards for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersImportNfcCards = <ThrowOnError extends boolean = false>(options: Options<CustomersImportNfcCardsData, ThrowOnError>): RequestResult<CustomersImportNfcCardsResponses, CustomersImportNfcCardsErrors, ThrowOnError> => (options.client ?? client).post<CustomersImportNfcCardsResponses, CustomersImportNfcCardsErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/nfc-cards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Imports region codes for given customer
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const customersImportRegionCodes = <ThrowOnError extends boolean = false>(options: Options<CustomersImportRegionCodesData, ThrowOnError>): RequestResult<CustomersImportRegionCodesResponses, CustomersImportRegionCodesErrors, ThrowOnError> => (options.client ?? client).post<CustomersImportRegionCodesResponses, CustomersImportRegionCodesErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/region-codes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validates import of NFC cards for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersValidateImportNfcCards = <ThrowOnError extends boolean = false>(options: Options<CustomersValidateImportNfcCardsData, ThrowOnError>): RequestResult<CustomersValidateImportNfcCardsResponses, CustomersValidateImportNfcCardsErrors, ThrowOnError> => (options.client ?? client).post<CustomersValidateImportNfcCardsResponses, CustomersValidateImportNfcCardsErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/nfc-cards/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validates import of region codes for given customer
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const customersValidateImportRegionCodes = <ThrowOnError extends boolean = false>(options: Options<CustomersValidateImportRegionCodesData, ThrowOnError>): RequestResult<CustomersValidateImportRegionCodesResponses, CustomersValidateImportRegionCodesErrors, ThrowOnError> => (options.client ?? client).post<CustomersValidateImportRegionCodesResponses, CustomersValidateImportRegionCodesErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/region-codes/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Provides template CSV for container addresses import
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const customersGetImportTemplateContainerAddresses = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetImportTemplateContainerAddressesData, ThrowOnError>): RequestResult<CustomersGetImportTemplateContainerAddressesResponses, CustomersGetImportTemplateContainerAddressesErrors, ThrowOnError> => (options?.client ?? client).get<CustomersGetImportTemplateContainerAddressesResponses, CustomersGetImportTemplateContainerAddressesErrors, ThrowOnError>({ url: '/api/v1/customers/template/container-addresses.csv', ...options });

/**
 * Provides template CSV for containers import
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const customersGetImportTemplateContainers = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetImportTemplateContainersData, ThrowOnError>): RequestResult<CustomersGetImportTemplateContainersResponses, CustomersGetImportTemplateContainersErrors, ThrowOnError> => (options?.client ?? client).get<CustomersGetImportTemplateContainersResponses, CustomersGetImportTemplateContainersErrors, ThrowOnError>({ url: '/api/v1/customers/template/containers.csv', ...options });

/**
 * Provides template CSV for containers import
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const customersGetChangeContainersCustomerTemplate = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetChangeContainersCustomerTemplateData, ThrowOnError>): RequestResult<CustomersGetChangeContainersCustomerTemplateResponses, CustomersGetChangeContainersCustomerTemplateErrors, ThrowOnError> => (options?.client ?? client).get<CustomersGetChangeContainersCustomerTemplateResponses, CustomersGetChangeContainersCustomerTemplateErrors, ThrowOnError>({ url: '/api/v1/customers/template/containers-customer.csv', ...options });

/**
 * Provides template CSV for contracts import
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersGetImportTemplateContracts = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetImportTemplateContractsData, ThrowOnError>): RequestResult<CustomersGetImportTemplateContractsResponses, CustomersGetImportTemplateContractsErrors, ThrowOnError> => (options?.client ?? client).get<CustomersGetImportTemplateContractsResponses, CustomersGetImportTemplateContractsErrors, ThrowOnError>({ url: '/api/v1/customers/template/contracts.csv', ...options });

/**
 * Provides template CSV for containers to contract assignment import
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersGetImportTemplateContractContainers = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetImportTemplateContractContainersData, ThrowOnError>): RequestResult<CustomersGetImportTemplateContractContainersResponses, CustomersGetImportTemplateContractContainersErrors, ThrowOnError> => (options?.client ?? client).get<CustomersGetImportTemplateContractContainersResponses, CustomersGetImportTemplateContractContainersErrors, ThrowOnError>({ url: '/api/v1/customers/template/contract-containers.csv', ...options });

/**
 * Provides template CSV for NFC cards import
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersGetImportTemplateNfcCards = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetImportTemplateNfcCardsData, ThrowOnError>): RequestResult<CustomersGetImportTemplateNfcCardsResponses, CustomersGetImportTemplateNfcCardsErrors, ThrowOnError> => (options?.client ?? client).get<CustomersGetImportTemplateNfcCardsResponses, CustomersGetImportTemplateNfcCardsErrors, ThrowOnError>({ url: '/api/v1/customers/template/nfc-cards.csv', ...options });

/**
 * Provides template CSV for NFC cards import
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersGetImportTemplateNfcCardsForCustomer = <ThrowOnError extends boolean = false>(options: Options<CustomersGetImportTemplateNfcCardsForCustomerData, ThrowOnError>): RequestResult<CustomersGetImportTemplateNfcCardsForCustomerResponses, CustomersGetImportTemplateNfcCardsForCustomerErrors, ThrowOnError> => (options.client ?? client).get<CustomersGetImportTemplateNfcCardsForCustomerResponses, CustomersGetImportTemplateNfcCardsForCustomerErrors, ThrowOnError>({ url: '/api/v1/customers/{id}/template/nfc-cards.csv', ...options });

/**
 * Provides template CSV for region codes import
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const customersGetImportTemplateRegionCodes = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetImportTemplateRegionCodesData, ThrowOnError>): RequestResult<CustomersGetImportTemplateRegionCodesResponses, CustomersGetImportTemplateRegionCodesErrors, ThrowOnError> => (options?.client ?? client).get<CustomersGetImportTemplateRegionCodesResponses, CustomersGetImportTemplateRegionCodesErrors, ThrowOnError>({ url: '/api/v1/customers/template/region-codes.csv', ...options });

/**
 * Provides template CSV for fill level sensor import
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_ADMIN</code></p>
 */
export const customersGetImportTemplateFillLevelSensors = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetImportTemplateFillLevelSensorsData, ThrowOnError>): RequestResult<CustomersGetImportTemplateFillLevelSensorsResponses, CustomersGetImportTemplateFillLevelSensorsErrors, ThrowOnError> => (options?.client ?? client).get<CustomersGetImportTemplateFillLevelSensorsResponses, CustomersGetImportTemplateFillLevelSensorsErrors, ThrowOnError>({ url: '/api/v1/customers/template/fill-level-sensors.csv', ...options });

/**
 * Validates import of fill level sensors for given customer
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_ADMIN</code></p>
 */
export const customersValidateImportFillLevelSensors = <ThrowOnError extends boolean = false>(options: Options<CustomersValidateImportFillLevelSensorsData, ThrowOnError>): RequestResult<CustomersValidateImportFillLevelSensorsResponses, CustomersValidateImportFillLevelSensorsErrors, ThrowOnError> => (options.client ?? client).post<CustomersValidateImportFillLevelSensorsResponses, CustomersValidateImportFillLevelSensorsErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/fill-level-sensors/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Imports fill level sensors for given customer
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_ADMIN</code></p>
 */
export const customersImportFillLevelSensors = <ThrowOnError extends boolean = false>(options: Options<CustomersImportFillLevelSensorsData, ThrowOnError>): RequestResult<CustomersImportFillLevelSensorsResponses, CustomersImportFillLevelSensorsErrors, ThrowOnError> => (options.client ?? client).post<CustomersImportFillLevelSensorsResponses, CustomersImportFillLevelSensorsErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/fill-level-sensors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verifies service task import from CSV file
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_ADMIN</code></p>
 */
export const customersValidateImportServiceTasks = <ThrowOnError extends boolean = false>(options: Options<CustomersValidateImportServiceTasksData, ThrowOnError>): RequestResult<CustomersValidateImportServiceTasksResponses, CustomersValidateImportServiceTasksErrors, ThrowOnError> => (options.client ?? client).post<CustomersValidateImportServiceTasksResponses, CustomersValidateImportServiceTasksErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/service-tasks/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import service task from CSV file
 *
 * It is only for documentation purposes. Imported service task is marked as "Fixed"<p><strong>Required Roles</strong>: <code>SC_TASK_ADMIN</code></p>
 */
export const customersImportServiceTasks = <ThrowOnError extends boolean = false>(options: Options<CustomersImportServiceTasksData, ThrowOnError>): RequestResult<CustomersImportServiceTasksResponses, CustomersImportServiceTasksErrors, ThrowOnError> => (options.client ?? client).post<CustomersImportServiceTasksResponses, CustomersImportServiceTasksErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/service-tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Provides template CSV for service task import
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_ADMIN</code></p>
 */
export const customersGetImportTemplateServiceTasks = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetImportTemplateServiceTasksData, ThrowOnError>): RequestResult<CustomersGetImportTemplateServiceTasksResponses, CustomersGetImportTemplateServiceTasksErrors, ThrowOnError> => (options?.client ?? client).get<CustomersGetImportTemplateServiceTasksResponses, CustomersGetImportTemplateServiceTasksErrors, ThrowOnError>({ url: '/api/v1/customers/template/service-tasks.csv', ...options });

/**
 * Validates import of NFC cards to Contracts mapping for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersValidateImportNfcCardsContracts = <ThrowOnError extends boolean = false>(options: Options<CustomersValidateImportNfcCardsContractsData, ThrowOnError>): RequestResult<CustomersValidateImportNfcCardsContractsResponses, CustomersValidateImportNfcCardsContractsErrors, ThrowOnError> => (options.client ?? client).post<CustomersValidateImportNfcCardsContractsResponses, CustomersValidateImportNfcCardsContractsErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/nfc-cards-contracts/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Imports NFC cards to Contracts mapping for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersImportNfcCardsContracts = <ThrowOnError extends boolean = false>(options: Options<CustomersImportNfcCardsContractsData, ThrowOnError>): RequestResult<CustomersImportNfcCardsContractsResponses, CustomersImportNfcCardsContractsErrors, ThrowOnError> => (options.client ?? client).post<CustomersImportNfcCardsContractsResponses, CustomersImportNfcCardsContractsErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/nfc-cards-contracts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Provides template CSV for NFC cards to Contracts mapping import
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersGetImportTemplateNfcCardsContracts = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetImportTemplateNfcCardsContractsData, ThrowOnError>): RequestResult<CustomersGetImportTemplateNfcCardsContractsResponses, CustomersGetImportTemplateNfcCardsContractsErrors, ThrowOnError> => (options?.client ?? client).get<CustomersGetImportTemplateNfcCardsContractsResponses, CustomersGetImportTemplateNfcCardsContractsErrors, ThrowOnError>({ url: '/api/v1/customers/template/nfc-cards-contracts.csv', ...options });

/**
 * Sets the customer logo to uploaded PNG image.
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersSetLogo = <ThrowOnError extends boolean = false>(options: Options<CustomersSetLogoData, ThrowOnError>): RequestResult<CustomersSetLogoResponses, CustomersSetLogoErrors, ThrowOnError> => (options.client ?? client).post<CustomersSetLogoResponses, CustomersSetLogoErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v1/customers/{id}/logo',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Gets Customer branding
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>CONTRACT_VIEW</code> or <code>CONTRACT_ADMIN</code></p>
 */
export const customersBranding = <ThrowOnError extends boolean = false>(options: Options<CustomersBrandingData, ThrowOnError>): RequestResult<CustomersBrandingResponses, CustomersBrandingErrors, ThrowOnError> => (options.client ?? client).get<CustomersBrandingResponses, CustomersBrandingErrors, ThrowOnError>({ url: '/api/v1/customers/{id}/branding', ...options });

/**
 * Gets enabled and disabled features for all customers
 *
 * <p><strong>Required Roles</strong>: <code>FEATURE_VIEW</code> or <code>FEATURE_ADMIN</code></p>
 */
export const customersGetCustomersFeatures = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetCustomersFeaturesData, ThrowOnError>): RequestResult<CustomersGetCustomersFeaturesResponses, CustomersGetCustomersFeaturesErrors, ThrowOnError> => (options?.client ?? client).get<CustomersGetCustomersFeaturesResponses, CustomersGetCustomersFeaturesErrors, ThrowOnError>({ url: '/api/v1/customers/features', ...options });

/**
 * Gets enabled and disabled features of given customer
 *
 * <p><strong>Required Roles</strong>: <code>FEATURE_VIEW</code> or <code>FEATURE_ADMIN</code> or <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const customersGetCustomerFeatures = <ThrowOnError extends boolean = false>(options: Options<CustomersGetCustomerFeaturesData, ThrowOnError>): RequestResult<CustomersGetCustomerFeaturesResponses, CustomersGetCustomerFeaturesErrors, ThrowOnError> => (options.client ?? client).get<CustomersGetCustomerFeaturesResponses, CustomersGetCustomerFeaturesErrors, ThrowOnError>({ url: '/api/v1/customers/{id}/features', ...options });

/**
 * Sets features of given customer
 *
 * <p><strong>Required Roles</strong>: <code>FEATURE_ADMIN</code></p>
 */
export const customersSetCustomerFeatures = <ThrowOnError extends boolean = false>(options: Options<CustomersSetCustomerFeaturesData, ThrowOnError>): RequestResult<CustomersSetCustomerFeaturesResponses, CustomersSetCustomerFeaturesErrors, ThrowOnError> => (options.client ?? client).put<CustomersSetCustomerFeaturesResponses, CustomersSetCustomerFeaturesErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/features',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets the Mercury AI key for given customer
 */
export const customersGetChatBotKey = <ThrowOnError extends boolean = false>(options: Options<CustomersGetChatBotKeyData, ThrowOnError>): RequestResult<CustomersGetChatBotKeyResponses, CustomersGetChatBotKeyErrors, ThrowOnError> => (options.client ?? client).get<CustomersGetChatBotKeyResponses, CustomersGetChatBotKeyErrors, ThrowOnError>({ url: '/api/v1/customers/{id}/chat-bot/mercury-ai/key', ...options });

/**
 * Get page of notification settings for specific customer
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersGetCustomerNotificationSettingsPage = <ThrowOnError extends boolean = false>(options: Options<CustomersGetCustomerNotificationSettingsPageData, ThrowOnError>): RequestResult<CustomersGetCustomerNotificationSettingsPageResponses, CustomersGetCustomerNotificationSettingsPageErrors, ThrowOnError> => (options.client ?? client).get<CustomersGetCustomerNotificationSettingsPageResponses, CustomersGetCustomerNotificationSettingsPageErrors, ThrowOnError>({ url: '/api/v1/customers/{id}/notification-settings', ...options });

/**
 * Test FTP connectivity
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersTestFtpConnection = <ThrowOnError extends boolean = false>(options?: Options<CustomersTestFtpConnectionData, ThrowOnError>): RequestResult<CustomersTestFtpConnectionResponses, CustomersTestFtpConnectionErrors, ThrowOnError> => (options?.client ?? client).post<CustomersTestFtpConnectionResponses, CustomersTestFtpConnectionErrors, ThrowOnError>({
    url: '/api/v1/customers/ftp/test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets Customer FTP settings
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const customersGetCustomerFtp = <ThrowOnError extends boolean = false>(options: Options<CustomersGetCustomerFtpData, ThrowOnError>): RequestResult<CustomersGetCustomerFtpResponses, CustomersGetCustomerFtpErrors, ThrowOnError> => (options.client ?? client).get<CustomersGetCustomerFtpResponses, CustomersGetCustomerFtpErrors, ThrowOnError>({ url: '/api/v1/customers/{id}/ftp', ...options });

/**
 * Updates customer FTP settings
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersSetCustomerFtp = <ThrowOnError extends boolean = false>(options: Options<CustomersSetCustomerFtpData, ThrowOnError>): RequestResult<CustomersSetCustomerFtpResponses, CustomersSetCustomerFtpErrors, ThrowOnError> => (options.client ?? client).post<CustomersSetCustomerFtpResponses, CustomersSetCustomerFtpErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/ftp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates customer FTP settings
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersSetCustomerFtpPut = <ThrowOnError extends boolean = false>(options: Options<CustomersSetCustomerFtpPutData, ThrowOnError>): RequestResult<CustomersSetCustomerFtpPutResponses, CustomersSetCustomerFtpPutErrors, ThrowOnError> => (options.client ?? client).put<CustomersSetCustomerFtpPutResponses, CustomersSetCustomerFtpPutErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/ftp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger FTP Large List import for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CRON</code> or <code>CONTAINER_ADMIN</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const customersFtpImportLargeList = <ThrowOnError extends boolean = false>(options: Options<CustomersFtpImportLargeListData, ThrowOnError>): RequestResult<CustomersFtpImportLargeListResponses, unknown, ThrowOnError> => (options.client ?? client).post<CustomersFtpImportLargeListResponses, unknown, ThrowOnError>({ url: '/api/v1/customers/{id}/ftp/import-large-list', ...options });

/**
 * Trigger FTP Large List import for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CRON</code> or <code>CONTAINER_ADMIN</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const customersFtpImportLegacyList = <ThrowOnError extends boolean = false>(options: Options<CustomersFtpImportLegacyListData, ThrowOnError>): RequestResult<CustomersFtpImportLegacyListResponses, unknown, ThrowOnError> => (options.client ?? client).post<CustomersFtpImportLegacyListResponses, unknown, ThrowOnError>({ url: '/api/v1/customers/{id}/ftp/import-legacy-list', ...options });

/**
 * Trigger FTP Transactions export for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CRON</code> or <code>CONTAINER_ADMIN</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const customersFtpExportTransactions = <ThrowOnError extends boolean = false>(options: Options<CustomersFtpExportTransactionsData, ThrowOnError>): RequestResult<CustomersFtpExportTransactionsResponses, unknown, ThrowOnError> => (options.client ?? client).post<CustomersFtpExportTransactionsResponses, unknown, ThrowOnError>({ url: '/api/v1/customers/{id}/ftp/export-transactions', ...options });

/**
 * Trigger Feratel Large List import for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CRON</code> or <code>CONTAINER_ADMIN</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const customersFeratelImportLargeList = <ThrowOnError extends boolean = false>(options: Options<CustomersFeratelImportLargeListData, ThrowOnError>): RequestResult<CustomersFeratelImportLargeListResponses, unknown, ThrowOnError> => (options.client ?? client).post<CustomersFeratelImportLargeListResponses, unknown, ThrowOnError>({ url: '/api/v1/customers/{id}/feratel/import-large-list', ...options });

/**
 * Gets Customer web hooks settings
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const customersGetCustomerWebHook = <ThrowOnError extends boolean = false>(options: Options<CustomersGetCustomerWebHookData, ThrowOnError>): RequestResult<CustomersGetCustomerWebHookResponses, CustomersGetCustomerWebHookErrors, ThrowOnError> => (options.client ?? client).get<CustomersGetCustomerWebHookResponses, CustomersGetCustomerWebHookErrors, ThrowOnError>({ url: '/api/v1/customers/{id}/webhook', ...options });

/**
 * Updates customer webhook settings
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersSetCustomerWebHook = <ThrowOnError extends boolean = false>(options: Options<CustomersSetCustomerWebHookData, ThrowOnError>): RequestResult<CustomersSetCustomerWebHookResponses, CustomersSetCustomerWebHookErrors, ThrowOnError> => (options.client ?? client).post<CustomersSetCustomerWebHookResponses, CustomersSetCustomerWebHookErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/webhook',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates customer webhook settings
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersSetCustomerWebHooksPut = <ThrowOnError extends boolean = false>(options: Options<CustomersSetCustomerWebHooksPutData, ThrowOnError>): RequestResult<CustomersSetCustomerWebHooksPutResponses, CustomersSetCustomerWebHooksPutErrors, ThrowOnError> => (options.client ?? client).put<CustomersSetCustomerWebHooksPutResponses, CustomersSetCustomerWebHooksPutErrors, ThrowOnError>({
    url: '/api/v1/customers/{id}/webhook',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets CIG numbers of the customer
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code> or <code>SC_TASK_VIEW</code> or <code>SC_TASK_ADMIN</code> or <code>APP_SERVICE_USER</code></p>
 */
export const customersListCigNumbersV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersListCigNumbersV2Data, ThrowOnError>): RequestResult<CustomersListCigNumbersV2Responses, CustomersListCigNumbersV2Errors, ThrowOnError> => (options.client ?? client).get<CustomersListCigNumbersV2Responses, CustomersListCigNumbersV2Errors, ThrowOnError>({ url: '/api/v2/customers/{id}/cig-numbers', ...options });

/**
 * Creates new CIG number of the customer
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersCreateCigNumberV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersCreateCigNumberV2Data, ThrowOnError>): RequestResult<CustomersCreateCigNumberV2Responses, CustomersCreateCigNumberV2Errors, ThrowOnError> => (options.client ?? client).post<CustomersCreateCigNumberV2Responses, CustomersCreateCigNumberV2Errors, ThrowOnError>({
    url: '/api/v2/customers/{id}/cig-numbers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivates CIG number of the customer. Deactivated CIG number cannot be picked for new service tasks,
 * but stays readable on the service tasks already referencing it.
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersDeactivateCigNumberV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersDeactivateCigNumberV2Data, ThrowOnError>): RequestResult<CustomersDeactivateCigNumberV2Responses, CustomersDeactivateCigNumberV2Errors, ThrowOnError> => (options.client ?? client).delete<CustomersDeactivateCigNumberV2Responses, CustomersDeactivateCigNumberV2Errors, ThrowOnError>({ url: '/api/v2/customers/{id}/cig-numbers/{cigNumberId}', ...options });

/**
 * Gets single CIG number of the customer, active or not
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code> or <code>SC_TASK_VIEW</code> or <code>SC_TASK_ADMIN</code> or <code>APP_SERVICE_USER</code></p>
 */
export const customersGetCigNumberV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersGetCigNumberV2Data, ThrowOnError>): RequestResult<CustomersGetCigNumberV2Responses, CustomersGetCigNumberV2Errors, ThrowOnError> => (options.client ?? client).get<CustomersGetCigNumberV2Responses, CustomersGetCigNumberV2Errors, ThrowOnError>({ url: '/api/v2/customers/{id}/cig-numbers/{cigNumberId}', ...options });

/**
 * Updates CIG number of the customer
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersUpdateCigNumberV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersUpdateCigNumberV2Data, ThrowOnError>): RequestResult<CustomersUpdateCigNumberV2Responses, CustomersUpdateCigNumberV2Errors, ThrowOnError> => (options.client ?? client).put<CustomersUpdateCigNumberV2Responses, CustomersUpdateCigNumberV2Errors, ThrowOnError>({
    url: '/api/v2/customers/{id}/cig-numbers/{cigNumberId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activates previously deactivated CIG number of the customer
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersActivateCigNumberV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersActivateCigNumberV2Data, ThrowOnError>): RequestResult<CustomersActivateCigNumberV2Responses, CustomersActivateCigNumberV2Errors, ThrowOnError> => (options.client ?? client).put<CustomersActivateCigNumberV2Responses, CustomersActivateCigNumberV2Errors, ThrowOnError>({ url: '/api/v2/customers/{id}/cig-numbers/{cigNumberId}/activate', ...options });

/**
 * Gets paged view of customers
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const customersGetEntityPageV2 = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetEntityPageV2Data, ThrowOnError>): RequestResult<CustomersGetEntityPageV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<CustomersGetEntityPageV2Responses, unknown, ThrowOnError>({ url: '/api/v2/customers', ...options });

/**
 * Creates new Customer
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersCreateEntityV2 = <ThrowOnError extends boolean = false>(options?: Options<CustomersCreateEntityV2Data, ThrowOnError>): RequestResult<CustomersCreateEntityV2Responses, CustomersCreateEntityV2Errors, ThrowOnError> => (options?.client ?? client).post<CustomersCreateEntityV2Responses, CustomersCreateEntityV2Errors, ThrowOnError>({
    url: '/api/v2/customers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets accessible customers organized in parent-child tree
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const customersGetTreeV2 = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetTreeV2Data, ThrowOnError>): RequestResult<CustomersGetTreeV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<CustomersGetTreeV2Responses, unknown, ThrowOnError>({ url: '/api/v2/customers/tree', ...options });

/**
 * Gets list of customers
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const customersListEntitiesV2 = <ThrowOnError extends boolean = false>(options?: Options<CustomersListEntitiesV2Data, ThrowOnError>): RequestResult<CustomersListEntitiesV2Responses, CustomersListEntitiesV2Errors, ThrowOnError> => (options?.client ?? client).get<CustomersListEntitiesV2Responses, CustomersListEntitiesV2Errors, ThrowOnError>({ url: '/api/v2/customers/list', ...options });

/**
 * Deletes Customer.
 *
 * Calling user cannot delete his last accessible Customer.
 * Customer must not have any active children.<p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersDeleteEntityV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersDeleteEntityV2Data, ThrowOnError>): RequestResult<CustomersDeleteEntityV2Responses, CustomersDeleteEntityV2Errors, ThrowOnError> => (options.client ?? client).delete<CustomersDeleteEntityV2Responses, CustomersDeleteEntityV2Errors, ThrowOnError>({ url: '/api/v2/customers/{id}', ...options });

/**
 * Gets specific Customer
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const customersGetEntityV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersGetEntityV2Data, ThrowOnError>): RequestResult<CustomersGetEntityV2Responses, CustomersGetEntityV2Errors, ThrowOnError> => (options.client ?? client).get<CustomersGetEntityV2Responses, CustomersGetEntityV2Errors, ThrowOnError>({ url: '/api/v2/customers/{id}', ...options });

/**
 * Updates Customer
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersUpdateEntityV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersUpdateEntityV2Data, ThrowOnError>): RequestResult<CustomersUpdateEntityV2Responses, CustomersUpdateEntityV2Errors, ThrowOnError> => (options.client ?? client).put<CustomersUpdateEntityV2Responses, CustomersUpdateEntityV2Errors, ThrowOnError>({
    url: '/api/v2/customers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creates new Customer
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersUpdateParentV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersUpdateParentV2Data, ThrowOnError>): RequestResult<CustomersUpdateParentV2Responses, CustomersUpdateParentV2Errors, ThrowOnError> => (options.client ?? client).put<CustomersUpdateParentV2Responses, CustomersUpdateParentV2Errors, ThrowOnError>({
    url: '/api/v2/customers/{id}/parent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activates previously deleted Customer.
 *
 * Calling user must have access to Customer's parent.
 * Parent must not be deleted.<p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersActivateEntityV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersActivateEntityV2Data, ThrowOnError>): RequestResult<CustomersActivateEntityV2Responses, CustomersActivateEntityV2Errors, ThrowOnError> => (options.client ?? client).put<CustomersActivateEntityV2Responses, CustomersActivateEntityV2Errors, ThrowOnError>({ url: '/api/v2/customers/{id}/activate', ...options });

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersIsValueUsedV2 = <ThrowOnError extends boolean = false>(options?: Options<CustomersIsValueUsedV2Data, ThrowOnError>): RequestResult<CustomersIsValueUsedV2Responses, CustomersIsValueUsedV2Errors, ThrowOnError> => (options?.client ?? client).post<CustomersIsValueUsedV2Responses, CustomersIsValueUsedV2Errors, ThrowOnError>({
    url: '/api/v2/customers/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Exports customers.
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const customersExportListV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersExportListV2Data, ThrowOnError>): RequestResult<CustomersExportListV2Responses, unknown, ThrowOnError> => (options.client ?? client).get<CustomersExportListV2Responses, unknown, ThrowOnError>({ url: '/api/v2/customers/export.{format}', ...options });

/**
 * Lists departments
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersListDepartmentsV2 = <ThrowOnError extends boolean = false>(options?: Options<CustomersListDepartmentsV2Data, ThrowOnError>): RequestResult<CustomersListDepartmentsV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<CustomersListDepartmentsV2Responses, unknown, ThrowOnError>({ url: '/api/v2/customers/departments/list', ...options });

/**
 * Gets customer's custom NFC card fields
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const customersGetNfcCardsCustomFieldsV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersGetNfcCardsCustomFieldsV2Data, ThrowOnError>): RequestResult<CustomersGetNfcCardsCustomFieldsV2Responses, unknown, ThrowOnError> => (options.client ?? client).get<CustomersGetNfcCardsCustomFieldsV2Responses, unknown, ThrowOnError>({ url: '/api/v2/customers/{id}/custom-fields/nfc-cards', ...options });

/**
 * Sets customer's custom NFC card fields
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersSetNfcCardsCustomFieldsV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersSetNfcCardsCustomFieldsV2Data, ThrowOnError>): RequestResult<CustomersSetNfcCardsCustomFieldsV2Responses, unknown, ThrowOnError> => (options.client ?? client).post<CustomersSetNfcCardsCustomFieldsV2Responses, unknown, ThrowOnError>({
    url: '/api/v2/customers/{id}/custom-fields/nfc-cards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets customer's rules which fields are mandatory when closing out a service task.
 * Customer without own rules has all fields mandatory.
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code> or <code>SC_TASK_VIEW</code> or <code>SC_TASK_ADMIN</code> or <code>APP_SERVICE_USER</code></p>
 */
export const customersGetServiceTaskCloseOutRulesV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersGetServiceTaskCloseOutRulesV2Data, ThrowOnError>): RequestResult<CustomersGetServiceTaskCloseOutRulesV2Responses, unknown, ThrowOnError> => (options.client ?? client).get<CustomersGetServiceTaskCloseOutRulesV2Responses, unknown, ThrowOnError>({ url: '/api/v2/customers/{id}/service-task-close-out-rules', ...options });

/**
 * Sets customer's rules which fields are mandatory when closing out a service task
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const customersSetServiceTaskCloseOutRulesV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersSetServiceTaskCloseOutRulesV2Data, ThrowOnError>): RequestResult<CustomersSetServiceTaskCloseOutRulesV2Responses, unknown, ThrowOnError> => (options.client ?? client).put<CustomersSetServiceTaskCloseOutRulesV2Responses, unknown, ThrowOnError>({
    url: '/api/v2/customers/{id}/service-task-close-out-rules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Provides template CSV for NFC cards import
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersGetImportTemplateNfcCardsV2 = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetImportTemplateNfcCardsV2Data, ThrowOnError>): RequestResult<CustomersGetImportTemplateNfcCardsV2Responses, CustomersGetImportTemplateNfcCardsV2Errors, ThrowOnError> => (options?.client ?? client).get<CustomersGetImportTemplateNfcCardsV2Responses, CustomersGetImportTemplateNfcCardsV2Errors, ThrowOnError>({ url: '/api/v2/customers/template/nfc-cards.csv', ...options });

/**
 * Provides template CSV for NFC cards import
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersGetImportTemplateNfcCardsForCustomerV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersGetImportTemplateNfcCardsForCustomerV2Data, ThrowOnError>): RequestResult<CustomersGetImportTemplateNfcCardsForCustomerV2Responses, CustomersGetImportTemplateNfcCardsForCustomerV2Errors, ThrowOnError> => (options.client ?? client).get<CustomersGetImportTemplateNfcCardsForCustomerV2Responses, CustomersGetImportTemplateNfcCardsForCustomerV2Errors, ThrowOnError>({ url: '/api/v2/customers/{id}/template/nfc-cards.csv', ...options });

/**
 * Validates import of NFC cards for given customer
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersValidateImportNfcCardsV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersValidateImportNfcCardsV2Data, ThrowOnError>): RequestResult<CustomersValidateImportNfcCardsV2Responses, CustomersValidateImportNfcCardsV2Errors, ThrowOnError> => (options.client ?? client).post<CustomersValidateImportNfcCardsV2Responses, CustomersValidateImportNfcCardsV2Errors, ThrowOnError>({
    url: '/api/v2/customers/{id}/nfc-cards/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Imports NFC cards for given customer
 *
 * Note if providing data via JSON the custom captions will NOT be set - use  the
 * `/api/v2/customers/{id}/nfc-cards/json` endpoint instead to provide new captions via JSON<p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersImportNfcCardsV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersImportNfcCardsV2Data, ThrowOnError>): RequestResult<CustomersImportNfcCardsV2Responses, CustomersImportNfcCardsV2Errors, ThrowOnError> => (options.client ?? client).post<CustomersImportNfcCardsV2Responses, CustomersImportNfcCardsV2Errors, ThrowOnError>({
    url: '/api/v2/customers/{id}/nfc-cards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Imports NFC cards for given customer
 *
 * Unlike import via CSV, the new captions are set as received i.e.,
 * null values clear the existing captions.<p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const customersImportNfcCardsJsonV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersImportNfcCardsJsonV2Data, ThrowOnError>): RequestResult<CustomersImportNfcCardsJsonV2Responses, CustomersImportNfcCardsJsonV2Errors, ThrowOnError> => (options.client ?? client).post<CustomersImportNfcCardsJsonV2Responses, CustomersImportNfcCardsJsonV2Errors, ThrowOnError>({
    url: '/api/v2/customers/{id}/nfc-cards/json',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Imports ProAlpha numbers for customers
 *
 * <p><strong>Required Roles</strong>: <code>BILLING_ADMIN</code></p>
 */
export const customersImportProAlphaNumbersV2 = <ThrowOnError extends boolean = false>(options?: Options<CustomersImportProAlphaNumbersV2Data, ThrowOnError>): RequestResult<CustomersImportProAlphaNumbersV2Responses, CustomersImportProAlphaNumbersV2Errors, ThrowOnError> => (options?.client ?? client).post<CustomersImportProAlphaNumbersV2Responses, CustomersImportProAlphaNumbersV2Errors, ThrowOnError>({
    url: '/api/v2/customers/pro-alpha-numbers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Validates ProAlpha numbers for customers import
 *
 * <p><strong>Required Roles</strong>: <code>BILLING_ADMIN</code></p>
 */
export const customersValidateProAlphaNumbersV2 = <ThrowOnError extends boolean = false>(options?: Options<CustomersValidateProAlphaNumbersV2Data, ThrowOnError>): RequestResult<CustomersValidateProAlphaNumbersV2Responses, unknown, ThrowOnError> => (options?.client ?? client).post<CustomersValidateProAlphaNumbersV2Responses, unknown, ThrowOnError>({
    url: '/api/v2/customers/pro-alpha-numbers/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Validates import of Location Trackers for given customer
 *
 * <p><strong>Required Roles</strong>: <code>LOC_TRACK_ADMIN</code></p>
 */
export const customersValidateImportLocationTrackersV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersValidateImportLocationTrackersV2Data, ThrowOnError>): RequestResult<CustomersValidateImportLocationTrackersV2Responses, CustomersValidateImportLocationTrackersV2Errors, ThrowOnError> => (options.client ?? client).post<CustomersValidateImportLocationTrackersV2Responses, CustomersValidateImportLocationTrackersV2Errors, ThrowOnError>({
    url: '/api/v2/customers/{id}/location-trackers/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Imports Location Trackers for given customer
 *
 * <p><strong>Required Roles</strong>: <code>LOC_TRACK_ADMIN</code></p>
 */
export const customersImportLocationTrackersV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersImportLocationTrackersV2Data, ThrowOnError>): RequestResult<CustomersImportLocationTrackersV2Responses, CustomersImportLocationTrackersV2Errors, ThrowOnError> => (options.client ?? client).post<CustomersImportLocationTrackersV2Responses, CustomersImportLocationTrackersV2Errors, ThrowOnError>({
    url: '/api/v2/customers/{id}/location-trackers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Provides template CSV for Location Trackers import
 *
 * <p><strong>Required Roles</strong>: <code>LOC_TRACK_ADMIN</code></p>
 */
export const customersGetImportTemplateLocationTrackersV2 = <ThrowOnError extends boolean = false>(options?: Options<CustomersGetImportTemplateLocationTrackersV2Data, ThrowOnError>): RequestResult<CustomersGetImportTemplateLocationTrackersV2Responses, CustomersGetImportTemplateLocationTrackersV2Errors, ThrowOnError> => (options?.client ?? client).get<CustomersGetImportTemplateLocationTrackersV2Responses, CustomersGetImportTemplateLocationTrackersV2Errors, ThrowOnError>({ url: '/api/v2/customers/template/location-trackers.csv', ...options });

/**
 * Validates import of fill level sensors for given customer
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_ADMIN</code></p>
 */
export const customersImportFillLevelSensorsV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersImportFillLevelSensorsV2Data, ThrowOnError>): RequestResult<CustomersImportFillLevelSensorsV2Responses, CustomersImportFillLevelSensorsV2Errors, ThrowOnError> => (options.client ?? client).post<CustomersImportFillLevelSensorsV2Responses, CustomersImportFillLevelSensorsV2Errors, ThrowOnError>({
    url: '/api/v2/customers/{id}/sloc-fill-level-sensors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validates import of fill level sensors for given customer
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_ADMIN</code></p>
 */
export const customersValidateImportFillLevelSensorsV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersValidateImportFillLevelSensorsV2Data, ThrowOnError>): RequestResult<CustomersValidateImportFillLevelSensorsV2Responses, CustomersValidateImportFillLevelSensorsV2Errors, ThrowOnError> => (options.client ?? client).post<CustomersValidateImportFillLevelSensorsV2Responses, CustomersValidateImportFillLevelSensorsV2Errors, ThrowOnError>({
    url: '/api/v2/customers/{id}/sloc-fill-level-sensors/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Provides template CSV for SLOC fill level sensor import populated with all containers of the given customer
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_ADMIN</code></p>
 */
export const customersGetImportTemplateSlocFillLevelSensorsV2 = <ThrowOnError extends boolean = false>(options: Options<CustomersGetImportTemplateSlocFillLevelSensorsV2Data, ThrowOnError>): RequestResult<CustomersGetImportTemplateSlocFillLevelSensorsV2Responses, CustomersGetImportTemplateSlocFillLevelSensorsV2Errors, ThrowOnError> => (options.client ?? client).get<CustomersGetImportTemplateSlocFillLevelSensorsV2Responses, CustomersGetImportTemplateSlocFillLevelSensorsV2Errors, ThrowOnError>({ url: '/api/v2/customers/{id}/template/sloc-fill-level-sensors.csv', ...options });

/**
 * Gets issue data for Dashboard
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const dashboardGetDashboardIssueData = <ThrowOnError extends boolean = false>(options?: Options<DashboardGetDashboardIssueDataData, ThrowOnError>): RequestResult<DashboardGetDashboardIssueDataResponses, DashboardGetDashboardIssueDataErrors, ThrowOnError> => (options?.client ?? client).get<DashboardGetDashboardIssueDataResponses, DashboardGetDashboardIssueDataErrors, ThrowOnError>({ url: '/api/v1/dashboard/issue-reports', ...options });

/**
 * Gets container data for Dashboard
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const dashboardGetContainersData = <ThrowOnError extends boolean = false>(options?: Options<DashboardGetContainersDataData, ThrowOnError>): RequestResult<DashboardGetContainersDataResponses, DashboardGetContainersDataErrors, ThrowOnError> => (options?.client ?? client).get<DashboardGetContainersDataResponses, DashboardGetContainersDataErrors, ThrowOnError>({ url: '/api/v1/dashboard/containers', ...options });

/**
 * Gets transactions data for Dashboard
 *
 * <b>Deprecated</b>: For performance reasons, please use the `GET /api/v1/dashboard/transactions-total` instead
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 *
 * @deprecated
 */
export const dashboardGetTransactionsData = <ThrowOnError extends boolean = false>(options?: Options<DashboardGetTransactionsDataData, ThrowOnError>): RequestResult<DashboardGetTransactionsDataResponses, DashboardGetTransactionsDataErrors, ThrowOnError> => (options?.client ?? client).get<DashboardGetTransactionsDataResponses, DashboardGetTransactionsDataErrors, ThrowOnError>({ url: '/api/v1/dashboard/transactions', ...options });

/**
 * Gets missing transactions data for Dashboard
 *
 * <b>Deprecated</b>: For performance reasons, please use the `GET /api/v1/dashboard/transactions-total` instead
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 *
 * @deprecated
 */
export const dashboardGetMissingTransactionsData = <ThrowOnError extends boolean = false>(options?: Options<DashboardGetMissingTransactionsDataData, ThrowOnError>): RequestResult<DashboardGetMissingTransactionsDataResponses, DashboardGetMissingTransactionsDataErrors, ThrowOnError> => (options?.client ?? client).get<DashboardGetMissingTransactionsDataResponses, DashboardGetMissingTransactionsDataErrors, ThrowOnError>({ url: '/api/v1/dashboard/missing-transactions', ...options });

/**
 * Gets total transactions data for Dashboard
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const dashboardGetTransactionsTotal = <ThrowOnError extends boolean = false>(options?: Options<DashboardGetTransactionsTotalData, ThrowOnError>): RequestResult<DashboardGetTransactionsTotalResponses, DashboardGetTransactionsTotalErrors, ThrowOnError> => (options?.client ?? client).get<DashboardGetTransactionsTotalResponses, DashboardGetTransactionsTotalErrors, ThrowOnError>({ url: '/api/v1/dashboard/transactions-total', ...options });

/**
 * Exports missing transactions data for Dashboard
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const dashboardExportFillLevelHistory = <ThrowOnError extends boolean = false>(options: Options<DashboardExportFillLevelHistoryData, ThrowOnError>): RequestResult<DashboardExportFillLevelHistoryResponses, unknown, ThrowOnError> => (options.client ?? client).get<DashboardExportFillLevelHistoryResponses, unknown, ThrowOnError>({ url: '/api/v1/dashboard/missing-transactions/export.{format}', ...options });

/**
 * Gets possible container islands
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const dataServicesGetCalculatedContainerIslands = <ThrowOnError extends boolean = false>(options: Options<DataServicesGetCalculatedContainerIslandsData, ThrowOnError>): RequestResult<DataServicesGetCalculatedContainerIslandsResponses, DataServicesGetCalculatedContainerIslandsErrors, ThrowOnError> => (options.client ?? client).post<DataServicesGetCalculatedContainerIslandsResponses, DataServicesGetCalculatedContainerIslandsErrors, ThrowOnError>({
    url: '/api/v1/data-services/container-islands/calculate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets page of devices
 *
 * <p><strong>Required Roles</strong>: <code>USER_ADMIN</code> or <code>APP_USER</code></p>
 */
export const devicesGetDevicesPage = <ThrowOnError extends boolean = false>(options?: Options<DevicesGetDevicesPageData, ThrowOnError>): RequestResult<DevicesGetDevicesPageResponses, DevicesGetDevicesPageErrors, ThrowOnError> => (options?.client ?? client).get<DevicesGetDevicesPageResponses, DevicesGetDevicesPageErrors, ThrowOnError>({ url: '/api/v1/devices', ...options });

/**
 * Registers or refreshes a gateway record in Cockpit after first connection.
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const digiGatewayHardwareCommision = <ThrowOnError extends boolean = false>(options: Options<DigiGatewayHardwareCommisionData, ThrowOnError>): RequestResult<DigiGatewayHardwareCommisionResponses, DigiGatewayHardwareCommisionErrors, ThrowOnError> => (options.client ?? client).post<DigiGatewayHardwareCommisionResponses, DigiGatewayHardwareCommisionErrors, ThrowOnError>({
    url: '/api/v1/gw/{gatewayId}/commisioning',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Receive information from Digi Gateway about discovered devices
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const digiGatewayHardwareReceiveDiscoveryReport = <ThrowOnError extends boolean = false>(options: Options<DigiGatewayHardwareReceiveDiscoveryReportData, ThrowOnError>): RequestResult<DigiGatewayHardwareReceiveDiscoveryReportResponses, DigiGatewayHardwareReceiveDiscoveryReportErrors, ThrowOnError> => (options.client ?? client).post<DigiGatewayHardwareReceiveDiscoveryReportResponses, DigiGatewayHardwareReceiveDiscoveryReportErrors, ThrowOnError>({
    url: '/api/v1/gw/{gatewayId}/discovery-reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Receive information from Digi Gateway about discovered devices
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const digiGatewayHardwareGetDigiGatewayConfiguration = <ThrowOnError extends boolean = false>(options: Options<DigiGatewayHardwareGetDigiGatewayConfigurationData, ThrowOnError>): RequestResult<DigiGatewayHardwareGetDigiGatewayConfigurationResponses, DigiGatewayHardwareGetDigiGatewayConfigurationErrors, ThrowOnError> => (options.client ?? client).get<DigiGatewayHardwareGetDigiGatewayConfigurationResponses, DigiGatewayHardwareGetDigiGatewayConfigurationErrors, ThrowOnError>({ url: '/api/v1/gw/{gatewayId}/configuration', ...options });

/**
 * Get tasks for specific gateway
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const digiGatewayHardwareGetDigiGatewayTasks = <ThrowOnError extends boolean = false>(options: Options<DigiGatewayHardwareGetDigiGatewayTasksData, ThrowOnError>): RequestResult<DigiGatewayHardwareGetDigiGatewayTasksResponses, DigiGatewayHardwareGetDigiGatewayTasksErrors, ThrowOnError> => (options.client ?? client).get<DigiGatewayHardwareGetDigiGatewayTasksResponses, DigiGatewayHardwareGetDigiGatewayTasksErrors, ThrowOnError>({ url: '/api/v1/gw/{gatewayId}/tasks', ...options });

/**
 * Get detailed information about specific gateway task
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const digiGatewayHardwareGetDigiGatewayTaskContext = <ThrowOnError extends boolean = false>(options: Options<DigiGatewayHardwareGetDigiGatewayTaskContextData, ThrowOnError>): RequestResult<DigiGatewayHardwareGetDigiGatewayTaskContextResponses, DigiGatewayHardwareGetDigiGatewayTaskContextErrors, ThrowOnError> => (options.client ?? client).get<DigiGatewayHardwareGetDigiGatewayTaskContextResponses, DigiGatewayHardwareGetDigiGatewayTaskContextErrors, ThrowOnError>({ url: '/api/v1/gw/{gatewayId}/tasks/{taskId}/context', ...options });

/**
 * Send result of tasks for specific gateway
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const digiGatewayHardwareResolveDigiGatewayTask = <ThrowOnError extends boolean = false>(options: Options<DigiGatewayHardwareResolveDigiGatewayTaskData, ThrowOnError>): RequestResult<DigiGatewayHardwareResolveDigiGatewayTaskResponses, DigiGatewayHardwareResolveDigiGatewayTaskErrors, ThrowOnError> => (options.client ?? client).post<DigiGatewayHardwareResolveDigiGatewayTaskResponses, DigiGatewayHardwareResolveDigiGatewayTaskErrors, ThrowOnError>({
    url: '/api/v1/gw/{gatewayId}/tasks/{taskId}/resolution',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get page of Digi Gateways
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const digiGatewaysGetDigiGatewaysPage = <ThrowOnError extends boolean = false>(options?: Options<DigiGatewaysGetDigiGatewaysPageData, ThrowOnError>): RequestResult<DigiGatewaysGetDigiGatewaysPageResponses, DigiGatewaysGetDigiGatewaysPageErrors, ThrowOnError> => (options?.client ?? client).get<DigiGatewaysGetDigiGatewaysPageResponses, DigiGatewaysGetDigiGatewaysPageErrors, ThrowOnError>({ url: '/api/v1/digi-gateways', ...options });

/**
 * Get detailed information about one Digi Gateway
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const digiGatewaysGetDigiGateway = <ThrowOnError extends boolean = false>(options: Options<DigiGatewaysGetDigiGatewayData, ThrowOnError>): RequestResult<DigiGatewaysGetDigiGatewayResponses, DigiGatewaysGetDigiGatewayErrors, ThrowOnError> => (options.client ?? client).get<DigiGatewaysGetDigiGatewayResponses, DigiGatewaysGetDigiGatewayErrors, ThrowOnError>({ url: '/api/v1/digi-gateways/{id}', ...options });

/**
 * Updates Digi Gateway
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const digiGatewaysUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<DigiGatewaysUpdateEntityData, ThrowOnError>): RequestResult<DigiGatewaysUpdateEntityResponses, DigiGatewaysUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<DigiGatewaysUpdateEntityResponses, DigiGatewaysUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/digi-gateways/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get page of Digi Gateway Tasks
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const digiGatewaysGetDigiGatewayTasksPage = <ThrowOnError extends boolean = false>(options: Options<DigiGatewaysGetDigiGatewayTasksPageData, ThrowOnError>): RequestResult<DigiGatewaysGetDigiGatewayTasksPageResponses, DigiGatewaysGetDigiGatewayTasksPageErrors, ThrowOnError> => (options.client ?? client).get<DigiGatewaysGetDigiGatewayTasksPageResponses, DigiGatewaysGetDigiGatewayTasksPageErrors, ThrowOnError>({ url: '/api/v1/digi-gateways/{id}/tasks', ...options });

/**
 * Create new Digi Gateway task
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const digiGatewaysCreateDigiGatewayTask = <ThrowOnError extends boolean = false>(options: Options<DigiGatewaysCreateDigiGatewayTaskData, ThrowOnError>): RequestResult<DigiGatewaysCreateDigiGatewayTaskResponses, DigiGatewaysCreateDigiGatewayTaskErrors, ThrowOnError> => (options.client ?? client).post<DigiGatewaysCreateDigiGatewayTaskResponses, DigiGatewaysCreateDigiGatewayTaskErrors, ThrowOnError>({
    url: '/api/v1/digi-gateways/{id}/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get detailed information about one Digi Gateway tasks
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const digiGatewaysGetDigiGatewayTask = <ThrowOnError extends boolean = false>(options: Options<DigiGatewaysGetDigiGatewayTaskData, ThrowOnError>): RequestResult<DigiGatewaysGetDigiGatewayTaskResponses, DigiGatewaysGetDigiGatewayTaskErrors, ThrowOnError> => (options.client ?? client).get<DigiGatewaysGetDigiGatewayTaskResponses, DigiGatewaysGetDigiGatewayTaskErrors, ThrowOnError>({ url: '/api/v1/digi-gateways/{id}/tasks/{taskId}', ...options });

/**
 * Gets logs for the hardware unit
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const emptyingDetectionLogsGetEmptyingDetectionLogs = <ThrowOnError extends boolean = false>(options?: Options<EmptyingDetectionLogsGetEmptyingDetectionLogsData, ThrowOnError>): RequestResult<EmptyingDetectionLogsGetEmptyingDetectionLogsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<EmptyingDetectionLogsGetEmptyingDetectionLogsResponses, unknown, ThrowOnError>({ url: '/api/v1/emptying-detection-logs', ...options });

/**
 * Exports given emptying detection log
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const emptyingDetectionLogsExportEmptyingDetectionLog = <ThrowOnError extends boolean = false>(options: Options<EmptyingDetectionLogsExportEmptyingDetectionLogData, ThrowOnError>): RequestResult<EmptyingDetectionLogsExportEmptyingDetectionLogResponses, unknown, ThrowOnError> => (options.client ?? client).get<EmptyingDetectionLogsExportEmptyingDetectionLogResponses, unknown, ThrowOnError>({ url: '/api/v1/emptying-detection-logs/{id}/export.{format}', ...options });

/**
 * Gets page of emptying detection configurations
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code> or <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const emptyingDetectionsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<EmptyingDetectionsGetEntityPageData, ThrowOnError>): RequestResult<EmptyingDetectionsGetEntityPageResponses, EmptyingDetectionsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<EmptyingDetectionsGetEntityPageResponses, EmptyingDetectionsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/emptying-detections', ...options });

/**
 * Creates new emptying detection configuration
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const emptyingDetectionsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<EmptyingDetectionsCreateEntityData, ThrowOnError>): RequestResult<EmptyingDetectionsCreateEntityResponses, EmptyingDetectionsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<EmptyingDetectionsCreateEntityResponses, EmptyingDetectionsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/emptying-detections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of emptying detection configurations
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code> or <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const emptyingDetectionsListEntities = <ThrowOnError extends boolean = false>(options?: Options<EmptyingDetectionsListEntitiesData, ThrowOnError>): RequestResult<EmptyingDetectionsListEntitiesResponses, EmptyingDetectionsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<EmptyingDetectionsListEntitiesResponses, EmptyingDetectionsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/emptying-detections/list', ...options });

/**
 * Deletes emptying detection configuration
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const emptyingDetectionsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<EmptyingDetectionsDeleteEntityData, ThrowOnError>): RequestResult<EmptyingDetectionsDeleteEntityResponses, EmptyingDetectionsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<EmptyingDetectionsDeleteEntityResponses, EmptyingDetectionsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/emptying-detections/{id}', ...options });

/**
 * Gets emptying detection configuration
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code> or <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const emptyingDetectionsGetEntity = <ThrowOnError extends boolean = false>(options: Options<EmptyingDetectionsGetEntityData, ThrowOnError>): RequestResult<EmptyingDetectionsGetEntityResponses, EmptyingDetectionsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<EmptyingDetectionsGetEntityResponses, EmptyingDetectionsGetEntityErrors, ThrowOnError>({ url: '/api/v1/emptying-detections/{id}', ...options });

/**
 * Updates emptying detection configuration
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const emptyingDetectionsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<EmptyingDetectionsUpdateEntityData, ThrowOnError>): RequestResult<EmptyingDetectionsUpdateEntityResponses, EmptyingDetectionsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<EmptyingDetectionsUpdateEntityResponses, EmptyingDetectionsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/emptying-detections/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const emptyingDetectionsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<EmptyingDetectionsIsValueUsedData, ThrowOnError>): RequestResult<EmptyingDetectionsIsValueUsedResponses, EmptyingDetectionsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<EmptyingDetectionsIsValueUsedResponses, EmptyingDetectionsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/emptying-detections/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Creates new emptying detection configuration for existing one
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const emptyingDetectionsCloneEntity = <ThrowOnError extends boolean = false>(options: Options<EmptyingDetectionsCloneEntityData, ThrowOnError>): RequestResult<EmptyingDetectionsCloneEntityResponses, unknown, ThrowOnError> => (options.client ?? client).post<EmptyingDetectionsCloneEntityResponses, unknown, ThrowOnError>({
    url: '/api/v1/emptying-detections/{id}/clone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists containers not having the specified emptying detection assigned,
 * ordered by container name
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code> or <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const emptyingDetectionsListAvailableContainers = <ThrowOnError extends boolean = false>(options: Options<EmptyingDetectionsListAvailableContainersData, ThrowOnError>): RequestResult<EmptyingDetectionsListAvailableContainersResponses, EmptyingDetectionsListAvailableContainersErrors, ThrowOnError> => (options.client ?? client).get<EmptyingDetectionsListAvailableContainersResponses, EmptyingDetectionsListAvailableContainersErrors, ThrowOnError>({ url: '/api/v1/emptying-detections/{id}/containers/available', ...options });

/**
 * Lists containers assigned to the specified emptying detection,
 * ordered by container name
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code> or <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const emptyingDetectionsListContainers = <ThrowOnError extends boolean = false>(options: Options<EmptyingDetectionsListContainersData, ThrowOnError>): RequestResult<EmptyingDetectionsListContainersResponses, EmptyingDetectionsListContainersErrors, ThrowOnError> => (options.client ?? client).get<EmptyingDetectionsListContainersResponses, EmptyingDetectionsListContainersErrors, ThrowOnError>({ url: '/api/v1/emptying-detections/{id}/containers', ...options });

/**
 * Assigns or removes emptying detection from given containers
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code> or <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const emptyingDetectionsUpdateContainers = <ThrowOnError extends boolean = false>(options: Options<EmptyingDetectionsUpdateContainersData, ThrowOnError>): RequestResult<EmptyingDetectionsUpdateContainersResponses, EmptyingDetectionsUpdateContainersErrors, ThrowOnError> => (options.client ?? client).put<EmptyingDetectionsUpdateContainersResponses, EmptyingDetectionsUpdateContainersErrors, ThrowOnError>({
    url: '/api/v1/emptying-detections/{id}/containers/partial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exports emptying detection.
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code> or <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const emptyingDetectionsExportEntities = <ThrowOnError extends boolean = false>(options: Options<EmptyingDetectionsExportEntitiesData, ThrowOnError>): RequestResult<EmptyingDetectionsExportEntitiesResponses, unknown, ThrowOnError> => (options.client ?? client).get<EmptyingDetectionsExportEntitiesResponses, unknown, ThrowOnError>({ url: '/api/v1/emptying-detections/export.{format}', ...options });

/**
 * Gets end-test page
 *
 * <p><strong>Required Roles</strong>: <code>ENDTEST_VIEW</code> or <code>ENDTEST_RUN</code></p>
 */
export const endTestGetEndTestPage = <ThrowOnError extends boolean = false>(options?: Options<EndTestGetEndTestPageData, ThrowOnError>): RequestResult<EndTestGetEndTestPageResponses, EndTestGetEndTestPageErrors, ThrowOnError> => (options?.client ?? client).get<EndTestGetEndTestPageResponses, EndTestGetEndTestPageErrors, ThrowOnError>({ url: '/api/v1/end-test', ...options });

/**
 * Gets file
 *
 * <p><strong>Required Roles</strong>: </p>
 */
export const filesLoadFile = <ThrowOnError extends boolean = false>(options: Options<FilesLoadFileData, ThrowOnError>): RequestResult<FilesLoadFileResponses, FilesLoadFileErrors, ThrowOnError> => (options.client ?? client).get<FilesLoadFileResponses, FilesLoadFileErrors, ThrowOnError>({ url: '/api/v1/files/{id}', ...options });

/**
 * Gets paged list of FillLevelSensorConfigurationGroups
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>FILL_SENSOR_VIEW</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorConfigurationGroupsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<FillLevelSensorConfigurationGroupsGetEntityPageData, ThrowOnError>): RequestResult<FillLevelSensorConfigurationGroupsGetEntityPageResponses, unknown, ThrowOnError> => (options?.client ?? client).get<FillLevelSensorConfigurationGroupsGetEntityPageResponses, unknown, ThrowOnError>({ url: '/api/v1/fill-level-sensor-configuration-groups', ...options });

/**
 * Creates new FillLevelSensorConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorConfigurationGroupsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<FillLevelSensorConfigurationGroupsCreateEntityData, ThrowOnError>): RequestResult<FillLevelSensorConfigurationGroupsCreateEntityResponses, FillLevelSensorConfigurationGroupsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<FillLevelSensorConfigurationGroupsCreateEntityResponses, FillLevelSensorConfigurationGroupsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/fill-level-sensor-configuration-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of FillLevelSensorConfigurationGroups
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>FILL_SENSOR_VIEW</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorConfigurationGroupsListEntities = <ThrowOnError extends boolean = false>(options?: Options<FillLevelSensorConfigurationGroupsListEntitiesData, ThrowOnError>): RequestResult<FillLevelSensorConfigurationGroupsListEntitiesResponses, FillLevelSensorConfigurationGroupsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<FillLevelSensorConfigurationGroupsListEntitiesResponses, FillLevelSensorConfigurationGroupsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/fill-level-sensor-configuration-groups/list', ...options });

/**
 * Deletes FillLevelSensorConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorConfigurationGroupsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<FillLevelSensorConfigurationGroupsDeleteEntityData, ThrowOnError>): RequestResult<FillLevelSensorConfigurationGroupsDeleteEntityResponses, FillLevelSensorConfigurationGroupsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<FillLevelSensorConfigurationGroupsDeleteEntityResponses, FillLevelSensorConfigurationGroupsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/fill-level-sensor-configuration-groups/{id}', ...options });

/**
 * Gets FillLevelSensorConfigurationGroup by id
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>FILL_SENSOR_VIEW</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorConfigurationGroupsGetEntity = <ThrowOnError extends boolean = false>(options: Options<FillLevelSensorConfigurationGroupsGetEntityData, ThrowOnError>): RequestResult<FillLevelSensorConfigurationGroupsGetEntityResponses, FillLevelSensorConfigurationGroupsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<FillLevelSensorConfigurationGroupsGetEntityResponses, FillLevelSensorConfigurationGroupsGetEntityErrors, ThrowOnError>({ url: '/api/v1/fill-level-sensor-configuration-groups/{id}', ...options });

/**
 * Updates FillLevelSensorConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorConfigurationGroupsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<FillLevelSensorConfigurationGroupsUpdateEntityData, ThrowOnError>): RequestResult<FillLevelSensorConfigurationGroupsUpdateEntityResponses, FillLevelSensorConfigurationGroupsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<FillLevelSensorConfigurationGroupsUpdateEntityResponses, FillLevelSensorConfigurationGroupsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/fill-level-sensor-configuration-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update assigned containers to FillLevelSensor Configuration Group
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorConfigurationGroupsUpdateContainersGroup = <ThrowOnError extends boolean = false>(options: Options<FillLevelSensorConfigurationGroupsUpdateContainersGroupData, ThrowOnError>): RequestResult<FillLevelSensorConfigurationGroupsUpdateContainersGroupResponses, FillLevelSensorConfigurationGroupsUpdateContainersGroupErrors, ThrowOnError> => (options.client ?? client).put<FillLevelSensorConfigurationGroupsUpdateContainersGroupResponses, FillLevelSensorConfigurationGroupsUpdateContainersGroupErrors, ThrowOnError>({
    url: '/api/v1/fill-level-sensor-configuration-groups/{id}/containers/partial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists active containers not assigned to this FillLevelSensor Configuration Group,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorConfigurationGroupsListAvailableContainers = <ThrowOnError extends boolean = false>(options: Options<FillLevelSensorConfigurationGroupsListAvailableContainersData, ThrowOnError>): RequestResult<FillLevelSensorConfigurationGroupsListAvailableContainersResponses, FillLevelSensorConfigurationGroupsListAvailableContainersErrors, ThrowOnError> => (options.client ?? client).get<FillLevelSensorConfigurationGroupsListAvailableContainersResponses, FillLevelSensorConfigurationGroupsListAvailableContainersErrors, ThrowOnError>({ url: '/api/v1/fill-level-sensor-configuration-groups/{id}/containers/available', ...options });

/**
 * Lists active containers assigned to this FillLevelSensor Configuration Group,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorConfigurationGroupsListContainers = <ThrowOnError extends boolean = false>(options: Options<FillLevelSensorConfigurationGroupsListContainersData, ThrowOnError>): RequestResult<FillLevelSensorConfigurationGroupsListContainersResponses, FillLevelSensorConfigurationGroupsListContainersErrors, ThrowOnError> => (options.client ?? client).get<FillLevelSensorConfigurationGroupsListContainersResponses, FillLevelSensorConfigurationGroupsListContainersErrors, ThrowOnError>({ url: '/api/v1/fill-level-sensor-configuration-groups/{id}/containers', ...options });

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorConfigurationGroupsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<FillLevelSensorConfigurationGroupsIsValueUsedData, ThrowOnError>): RequestResult<FillLevelSensorConfigurationGroupsIsValueUsedResponses, FillLevelSensorConfigurationGroupsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<FillLevelSensorConfigurationGroupsIsValueUsedResponses, FillLevelSensorConfigurationGroupsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/fill-level-sensor-configuration-groups/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of fill level sensors
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_VIEW</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<FillLevelSensorsGetEntityPageData, ThrowOnError>): RequestResult<FillLevelSensorsGetEntityPageResponses, FillLevelSensorsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<FillLevelSensorsGetEntityPageResponses, FillLevelSensorsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/fill-level-sensors', ...options });

/**
 * Creates new fill level sensor
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<FillLevelSensorsCreateEntityData, ThrowOnError>): RequestResult<FillLevelSensorsCreateEntityResponses, FillLevelSensorsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<FillLevelSensorsCreateEntityResponses, FillLevelSensorsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/fill-level-sensors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of fill level sensors
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_VIEW</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorsListEntities = <ThrowOnError extends boolean = false>(options?: Options<FillLevelSensorsListEntitiesData, ThrowOnError>): RequestResult<FillLevelSensorsListEntitiesResponses, FillLevelSensorsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<FillLevelSensorsListEntitiesResponses, FillLevelSensorsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/fill-level-sensors/list', ...options });

/**
 * Soft-deletes fill level sensor
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorsDeleteFillLevelSensor = <ThrowOnError extends boolean = false>(options: Options<FillLevelSensorsDeleteFillLevelSensorData, ThrowOnError>): RequestResult<FillLevelSensorsDeleteFillLevelSensorResponses, FillLevelSensorsDeleteFillLevelSensorErrors, ThrowOnError> => (options.client ?? client).delete<FillLevelSensorsDeleteFillLevelSensorResponses, FillLevelSensorsDeleteFillLevelSensorErrors, ThrowOnError>({ url: '/api/v1/fill-level-sensors/{id}', ...options });

/**
 * Gets fill level sensor
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_VIEW</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorsGetEntity = <ThrowOnError extends boolean = false>(options: Options<FillLevelSensorsGetEntityData, ThrowOnError>): RequestResult<FillLevelSensorsGetEntityResponses, FillLevelSensorsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<FillLevelSensorsGetEntityResponses, FillLevelSensorsGetEntityErrors, ThrowOnError>({ url: '/api/v1/fill-level-sensors/{id}', ...options });

/**
 * Updates fill level sensor
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<FillLevelSensorsUpdateEntityData, ThrowOnError>): RequestResult<FillLevelSensorsUpdateEntityResponses, FillLevelSensorsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<FillLevelSensorsUpdateEntityResponses, FillLevelSensorsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/fill-level-sensors/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets fill level sensor configuration
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_VIEW</code> or <code>CONTAINER_VIEW</code></p>
 */
export const fillLevelSensorsGetConfiguration = <ThrowOnError extends boolean = false>(options: Options<FillLevelSensorsGetConfigurationData, ThrowOnError>): RequestResult<FillLevelSensorsGetConfigurationResponses, unknown, ThrowOnError> => (options.client ?? client).get<FillLevelSensorsGetConfigurationResponses, unknown, ThrowOnError>({ url: '/api/v1/fill-level-sensors/{id}/config', ...options });

/**
 * Updates fill level sensor configuration
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_ADMIN</code> or <code>CONTAINER_ADMIN</code></p>
 */
export const fillLevelSensorsUpdateConfiguration = <ThrowOnError extends boolean = false>(options: Options<FillLevelSensorsUpdateConfigurationData, ThrowOnError>): RequestResult<FillLevelSensorsUpdateConfigurationResponses, FillLevelSensorsUpdateConfigurationErrors, ThrowOnError> => (options.client ?? client).put<FillLevelSensorsUpdateConfigurationResponses, FillLevelSensorsUpdateConfigurationErrors, ThrowOnError>({
    url: '/api/v1/fill-level-sensors/{id}/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<FillLevelSensorsIsValueUsedData, ThrowOnError>): RequestResult<FillLevelSensorsIsValueUsedResponses, FillLevelSensorsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<FillLevelSensorsIsValueUsedResponses, FillLevelSensorsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/fill-level-sensors/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of containers for fill level view
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fillLevelSensorsGetContainersPage = <ThrowOnError extends boolean = false>(options?: Options<FillLevelSensorsGetContainersPageData, ThrowOnError>): RequestResult<FillLevelSensorsGetContainersPageResponses, unknown, ThrowOnError> => (options?.client ?? client).get<FillLevelSensorsGetContainersPageResponses, unknown, ThrowOnError>({ url: '/api/v1/fill-level-sensors/containers', ...options });

/**
 * Exports containers for fill level view.
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fillLevelSensorsExportList = <ThrowOnError extends boolean = false>(options: Options<FillLevelSensorsExportListData, ThrowOnError>): RequestResult<FillLevelSensorsExportListResponses, FillLevelSensorsExportListErrors, ThrowOnError> => (options.client ?? client).get<FillLevelSensorsExportListResponses, FillLevelSensorsExportListErrors, ThrowOnError>({ url: '/api/v1/fill-level-sensors/containers/export.{format}', ...options });

/**
 * Activates soft-deleted fill level sensor
 *
 * <p><strong>Required Roles</strong>: <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorsActivateFillLevelSensor = <ThrowOnError extends boolean = false>(options: Options<FillLevelSensorsActivateFillLevelSensorData, ThrowOnError>): RequestResult<FillLevelSensorsActivateFillLevelSensorResponses, FillLevelSensorsActivateFillLevelSensorErrors, ThrowOnError> => (options.client ?? client).put<FillLevelSensorsActivateFillLevelSensorResponses, FillLevelSensorsActivateFillLevelSensorErrors, ThrowOnError>({ url: '/api/v1/fill-level-sensors/{id}/activate', ...options });

/**
 * Gets list of fill level sensor types
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>FILL_SENSOR_VIEW</code> or <code>FILL_SENSOR_ADMIN</code></p>
 */
export const fillLevelSensorTypesListFillLevelSensorTypes = <ThrowOnError extends boolean = false>(options?: Options<FillLevelSensorTypesListFillLevelSensorTypesData, ThrowOnError>): RequestResult<FillLevelSensorTypesListFillLevelSensorTypesResponses, FillLevelSensorTypesListFillLevelSensorTypesErrors, ThrowOnError> => (options?.client ?? client).get<FillLevelSensorTypesListFillLevelSensorTypesResponses, FillLevelSensorTypesListFillLevelSensorTypesErrors, ThrowOnError>({ url: '/api/v1/fill-level-sensor-types/list', ...options });

/**
 * Gets page of firmware packages
 *
 * <p><strong>Required Roles</strong>: <code>FIRMWARE_VIEW</code> or <code>FIRMWARE_ADMIN</code></p>
 */
export const firmwareGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<FirmwareGetEntityPageData, ThrowOnError>): RequestResult<FirmwareGetEntityPageResponses, FirmwareGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<FirmwareGetEntityPageResponses, FirmwareGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/firmware', ...options });

/**
 * Uploads firmware package.
 * Expects zipped firmware zip packages
 *
 * <p><strong>Required Roles</strong>: <code>FIRMWARE_ADMIN</code></p>
 */
export const firmwareUploadFirmware = <ThrowOnError extends boolean = false>(options: Options<FirmwareUploadFirmwareData, ThrowOnError>): RequestResult<FirmwareUploadFirmwareResponses, FirmwareUploadFirmwareErrors, ThrowOnError> => (options.client ?? client).post<FirmwareUploadFirmwareResponses, FirmwareUploadFirmwareErrors, ThrowOnError>({
    bodySerializer: null,
    url: '/api/v1/firmware',
    ...options,
    headers: {
        'Content-Type': 'application/zip',
        ...options.headers
    }
});

/**
 * Gets list of firmware packages
 *
 * <p><strong>Required Roles</strong>: <code>FIRMWARE_VIEW</code> or <code>FIRMWARE_ADMIN</code></p>
 */
export const firmwareListEntities = <ThrowOnError extends boolean = false>(options?: Options<FirmwareListEntitiesData, ThrowOnError>): RequestResult<FirmwareListEntitiesResponses, FirmwareListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<FirmwareListEntitiesResponses, FirmwareListEntitiesErrors, ThrowOnError>({ url: '/api/v1/firmware/list', ...options });

/**
 * Marks firmware as deactivated
 *
 * It is recommended to set the status directly via the `POST` endpoint<p><strong>Required Roles</strong>: <code>FIRMWARE_ADMIN</code></p>
 */
export const firmwareDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<FirmwareDeleteEntityData, ThrowOnError>): RequestResult<FirmwareDeleteEntityResponses, FirmwareDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<FirmwareDeleteEntityResponses, FirmwareDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/firmware/{id}', ...options });

/**
 * Gets firmware package
 *
 * <p><strong>Required Roles</strong>: <code>FIRMWARE_VIEW</code> or <code>FIRMWARE_ADMIN</code></p>
 */
export const firmwareGetEntity = <ThrowOnError extends boolean = false>(options: Options<FirmwareGetEntityData, ThrowOnError>): RequestResult<FirmwareGetEntityResponses, FirmwareGetEntityErrors, ThrowOnError> => (options.client ?? client).get<FirmwareGetEntityResponses, FirmwareGetEntityErrors, ThrowOnError>({ url: '/api/v1/firmware/{id}', ...options });

/**
 * Updates firmware package
 *
 * <p><strong>Required Roles</strong>: <code>FIRMWARE_ADMIN</code></p>
 */
export const firmwareUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<FirmwareUpdateEntityData, ThrowOnError>): RequestResult<FirmwareUpdateEntityResponses, FirmwareUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<FirmwareUpdateEntityResponses, FirmwareUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/firmware/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activates previously deactivated firmware with a eGateDigi.Api.FirmwarePackageStatus set to eGateDigi.Api.FirmwarePackageStatus.Test.
 *
 * It is recommended to set the status directly via the `POST` endpoint<p><strong>Required Roles</strong>: <code>FIRMWARE_ADMIN</code></p>
 */
export const firmwareActivateEntity = <ThrowOnError extends boolean = false>(options: Options<FirmwareActivateEntityData, ThrowOnError>): RequestResult<FirmwareActivateEntityResponses, FirmwareActivateEntityErrors, ThrowOnError> => (options.client ?? client).put<FirmwareActivateEntityResponses, FirmwareActivateEntityErrors, ThrowOnError>({ url: '/api/v1/firmware/{id}/activate', ...options });

/**
 * Verifies firmware package can be assigned
 *
 * <p><strong>Required Roles</strong>: <code>FIRMWARE_ADMIN</code></p>
 */
export const firmwareValidateUpdate = <ThrowOnError extends boolean = false>(options: Options<FirmwareValidateUpdateData, ThrowOnError>): RequestResult<FirmwareValidateUpdateResponses, FirmwareValidateUpdateErrors, ThrowOnError> => (options.client ?? client).post<FirmwareValidateUpdateResponses, FirmwareValidateUpdateErrors, ThrowOnError>({
    url: '/api/v1/firmware/{id}/assign/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verifies firmware package can be assigned
 *
 * <p><strong>Required Roles</strong>: <code>FIRMWARE_ADMIN</code></p>
 */
export const firmwareValidateUpdateViaCsv = <ThrowOnError extends boolean = false>(options: Options<FirmwareValidateUpdateViaCsvData, ThrowOnError>): RequestResult<FirmwareValidateUpdateViaCsvResponses, FirmwareValidateUpdateViaCsvErrors, ThrowOnError> => (options.client ?? client).post<FirmwareValidateUpdateViaCsvResponses, FirmwareValidateUpdateViaCsvErrors, ThrowOnError>({
    url: '/api/v1/firmware/{id}/assign-csv/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates firmware package
 *
 * <p><strong>Required Roles</strong>: <code>FIRMWARE_ADMIN</code></p>
 */
export const firmwareAssignUpdate = <ThrowOnError extends boolean = false>(options: Options<FirmwareAssignUpdateData, ThrowOnError>): RequestResult<FirmwareAssignUpdateResponses, FirmwareAssignUpdateErrors, ThrowOnError> => (options.client ?? client).post<FirmwareAssignUpdateResponses, FirmwareAssignUpdateErrors, ThrowOnError>({
    url: '/api/v1/firmware/{id}/assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates firmware package
 *
 * <p><strong>Required Roles</strong>: <code>FIRMWARE_ADMIN</code></p>
 */
export const firmwareAssignUpdateViaCsv = <ThrowOnError extends boolean = false>(options: Options<FirmwareAssignUpdateViaCsvData, ThrowOnError>): RequestResult<FirmwareAssignUpdateViaCsvResponses, FirmwareAssignUpdateViaCsvErrors, ThrowOnError> => (options.client ?? client).post<FirmwareAssignUpdateViaCsvResponses, FirmwareAssignUpdateViaCsvErrors, ThrowOnError>({
    url: '/api/v1/firmware/{id}/assign-csv',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists all hardware units that can be updated by the firmware package with given Id
 *
 * <p><strong>Required Roles</strong>: <code>FIRMWARE_ADMIN</code></p>
 */
export const firmwareListUpdateableUnits = <ThrowOnError extends boolean = false>(options: Options<FirmwareListUpdateableUnitsData, ThrowOnError>): RequestResult<FirmwareListUpdateableUnitsResponses, FirmwareListUpdateableUnitsErrors, ThrowOnError> => (options.client ?? client).get<FirmwareListUpdateableUnitsResponses, FirmwareListUpdateableUnitsErrors, ThrowOnError>({ url: '/api/v1/firmware/{id}/hardware-units', ...options });

/**
 * Gets page of FractionConfigurationGroups
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionConfigurationGroupsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<FractionConfigurationGroupsGetEntityPageData, ThrowOnError>): RequestResult<FractionConfigurationGroupsGetEntityPageResponses, FractionConfigurationGroupsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<FractionConfigurationGroupsGetEntityPageResponses, FractionConfigurationGroupsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/fraction-configuration-groups', ...options });

/**
 * Creates new FractionConfigurationGroup
 *
 * <b>Deprecated</b>: Use <code>POST /api/v2/fractions</code> instead
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 *
 * @deprecated
 */
export const fractionConfigurationGroupsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<FractionConfigurationGroupsCreateEntityData, ThrowOnError>): RequestResult<FractionConfigurationGroupsCreateEntityResponses, FractionConfigurationGroupsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<FractionConfigurationGroupsCreateEntityResponses, FractionConfigurationGroupsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/fraction-configuration-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of FractionConfigurationGroups
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionConfigurationGroupsListEntities = <ThrowOnError extends boolean = false>(options?: Options<FractionConfigurationGroupsListEntitiesData, ThrowOnError>): RequestResult<FractionConfigurationGroupsListEntitiesResponses, FractionConfigurationGroupsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<FractionConfigurationGroupsListEntitiesResponses, FractionConfigurationGroupsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/fraction-configuration-groups/list', ...options });

/**
 * Delete FractionConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionConfigurationGroupsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<FractionConfigurationGroupsDeleteEntityData, ThrowOnError>): RequestResult<FractionConfigurationGroupsDeleteEntityResponses, FractionConfigurationGroupsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<FractionConfigurationGroupsDeleteEntityResponses, FractionConfigurationGroupsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/fraction-configuration-groups/{id}', ...options });

/**
 * Gets FractionConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionConfigurationGroupsGetEntity = <ThrowOnError extends boolean = false>(options: Options<FractionConfigurationGroupsGetEntityData, ThrowOnError>): RequestResult<FractionConfigurationGroupsGetEntityResponses, FractionConfigurationGroupsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<FractionConfigurationGroupsGetEntityResponses, FractionConfigurationGroupsGetEntityErrors, ThrowOnError>({ url: '/api/v1/fraction-configuration-groups/{id}', ...options });

/**
 * Updates FractionConfigurationGroup
 *
 * <b>Deprecated</b>: Use <code>PUT /api/v2/fractions</code> instead
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 *
 * @deprecated
 */
export const fractionConfigurationGroupsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<FractionConfigurationGroupsUpdateEntityData, ThrowOnError>): RequestResult<FractionConfigurationGroupsUpdateEntityResponses, FractionConfigurationGroupsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<FractionConfigurationGroupsUpdateEntityResponses, FractionConfigurationGroupsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/fraction-configuration-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update assigned containers to fraction group
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionConfigurationGroupsUpdateContainersGroup = <ThrowOnError extends boolean = false>(options: Options<FractionConfigurationGroupsUpdateContainersGroupData, ThrowOnError>): RequestResult<FractionConfigurationGroupsUpdateContainersGroupResponses, FractionConfigurationGroupsUpdateContainersGroupErrors, ThrowOnError> => (options.client ?? client).put<FractionConfigurationGroupsUpdateContainersGroupResponses, FractionConfigurationGroupsUpdateContainersGroupErrors, ThrowOnError>({
    url: '/api/v1/fraction-configuration-groups/{id}/containers/partial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists active containers not assigned to this fraction,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionConfigurationGroupsListAvailableContainers = <ThrowOnError extends boolean = false>(options: Options<FractionConfigurationGroupsListAvailableContainersData, ThrowOnError>): RequestResult<FractionConfigurationGroupsListAvailableContainersResponses, FractionConfigurationGroupsListAvailableContainersErrors, ThrowOnError> => (options.client ?? client).get<FractionConfigurationGroupsListAvailableContainersResponses, FractionConfigurationGroupsListAvailableContainersErrors, ThrowOnError>({ url: '/api/v1/fraction-configuration-groups/{id}/containers/available', ...options });

/**
 * Lists active containers assigned to this fraction,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionConfigurationGroupsListContainers = <ThrowOnError extends boolean = false>(options: Options<FractionConfigurationGroupsListContainersData, ThrowOnError>): RequestResult<FractionConfigurationGroupsListContainersResponses, FractionConfigurationGroupsListContainersErrors, ThrowOnError> => (options.client ?? client).get<FractionConfigurationGroupsListContainersResponses, FractionConfigurationGroupsListContainersErrors, ThrowOnError>({ url: '/api/v1/fraction-configuration-groups/{id}/containers', ...options });

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionConfigurationGroupsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<FractionConfigurationGroupsIsValueUsedData, ThrowOnError>): RequestResult<FractionConfigurationGroupsIsValueUsedResponses, FractionConfigurationGroupsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<FractionConfigurationGroupsIsValueUsedResponses, FractionConfigurationGroupsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/fraction-configuration-groups/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of FractionConfigurationGroups
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionsGetEntityPageV2 = <ThrowOnError extends boolean = false>(options?: Options<FractionsGetEntityPageV2Data, ThrowOnError>): RequestResult<FractionsGetEntityPageV2Responses, FractionsGetEntityPageV2Errors, ThrowOnError> => (options?.client ?? client).get<FractionsGetEntityPageV2Responses, FractionsGetEntityPageV2Errors, ThrowOnError>({ url: '/api/v2/fractions', ...options });

/**
 * Creates new FractionConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionsCreateEntityV2 = <ThrowOnError extends boolean = false>(options?: Options<FractionsCreateEntityV2Data, ThrowOnError>): RequestResult<FractionsCreateEntityV2Responses, FractionsCreateEntityV2Errors, ThrowOnError> => (options?.client ?? client).post<FractionsCreateEntityV2Responses, FractionsCreateEntityV2Errors, ThrowOnError>({
    url: '/api/v2/fractions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of FractionConfigurationGroups
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionsListEntitiesV2 = <ThrowOnError extends boolean = false>(options?: Options<FractionsListEntitiesV2Data, ThrowOnError>): RequestResult<FractionsListEntitiesV2Responses, FractionsListEntitiesV2Errors, ThrowOnError> => (options?.client ?? client).get<FractionsListEntitiesV2Responses, FractionsListEntitiesV2Errors, ThrowOnError>({ url: '/api/v2/fractions/list', ...options });

/**
 * Delete FractionConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionsDeleteEntityV2 = <ThrowOnError extends boolean = false>(options: Options<FractionsDeleteEntityV2Data, ThrowOnError>): RequestResult<FractionsDeleteEntityV2Responses, FractionsDeleteEntityV2Errors, ThrowOnError> => (options.client ?? client).delete<FractionsDeleteEntityV2Responses, FractionsDeleteEntityV2Errors, ThrowOnError>({ url: '/api/v2/fractions/{id}', ...options });

/**
 * Gets FractionConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionsGetEntityV2 = <ThrowOnError extends boolean = false>(options: Options<FractionsGetEntityV2Data, ThrowOnError>): RequestResult<FractionsGetEntityV2Responses, FractionsGetEntityV2Errors, ThrowOnError> => (options.client ?? client).get<FractionsGetEntityV2Responses, FractionsGetEntityV2Errors, ThrowOnError>({ url: '/api/v2/fractions/{id}', ...options });

/**
 * Updates FractionConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionsUpdateEntityV2 = <ThrowOnError extends boolean = false>(options: Options<FractionsUpdateEntityV2Data, ThrowOnError>): RequestResult<FractionsUpdateEntityV2Responses, FractionsUpdateEntityV2Errors, ThrowOnError> => (options.client ?? client).put<FractionsUpdateEntityV2Responses, FractionsUpdateEntityV2Errors, ThrowOnError>({
    url: '/api/v2/fractions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update assigned containers to fraction group
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionsUpdateContainersGroupV2 = <ThrowOnError extends boolean = false>(options: Options<FractionsUpdateContainersGroupV2Data, ThrowOnError>): RequestResult<FractionsUpdateContainersGroupV2Responses, FractionsUpdateContainersGroupV2Errors, ThrowOnError> => (options.client ?? client).put<FractionsUpdateContainersGroupV2Responses, FractionsUpdateContainersGroupV2Errors, ThrowOnError>({
    url: '/api/v2/fractions/{id}/containers/partial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists active containers not assigned to this fraction,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionsListAvailableContainersV2 = <ThrowOnError extends boolean = false>(options: Options<FractionsListAvailableContainersV2Data, ThrowOnError>): RequestResult<FractionsListAvailableContainersV2Responses, FractionsListAvailableContainersV2Errors, ThrowOnError> => (options.client ?? client).get<FractionsListAvailableContainersV2Responses, FractionsListAvailableContainersV2Errors, ThrowOnError>({ url: '/api/v2/fractions/{id}/containers/available', ...options });

/**
 * Lists active containers assigned to this fraction,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionsListContainersV2 = <ThrowOnError extends boolean = false>(options: Options<FractionsListContainersV2Data, ThrowOnError>): RequestResult<FractionsListContainersV2Responses, FractionsListContainersV2Errors, ThrowOnError> => (options.client ?? client).get<FractionsListContainersV2Responses, FractionsListContainersV2Errors, ThrowOnError>({ url: '/api/v2/fractions/{id}/containers', ...options });

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const fractionsIsValueUsedV2 = <ThrowOnError extends boolean = false>(options?: Options<FractionsIsValueUsedV2Data, ThrowOnError>): RequestResult<FractionsIsValueUsedV2Responses, FractionsIsValueUsedV2Errors, ThrowOnError> => (options?.client ?? client).post<FractionsIsValueUsedV2Responses, FractionsIsValueUsedV2Errors, ThrowOnError>({
    url: '/api/v2/fractions/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets container access data in emz.eGate.Protobuf.Api.V2.ContainerData protobuf message
 *
 * <p><strong>Required Roles</strong>: <code>APP_API_KEY</code></p>
 */
export const freeAccessGetContainerFreeAccessTokenForHardwareUnitV2 = <ThrowOnError extends boolean = false>(options: Options<FreeAccessGetContainerFreeAccessTokenForHardwareUnitV2Data, ThrowOnError>): RequestResult<FreeAccessGetContainerFreeAccessTokenForHardwareUnitV2Responses, FreeAccessGetContainerFreeAccessTokenForHardwareUnitV2Errors, ThrowOnError> => (options.client ?? client).get<FreeAccessGetContainerFreeAccessTokenForHardwareUnitV2Responses, FreeAccessGetContainerFreeAccessTokenForHardwareUnitV2Errors, ThrowOnError>({ url: '/api/v2/free-access/containers-hw/{hardwareUnitId}', ...options });

/**
 * Gets paged list of geozones
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const geozonesGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<GeozonesGetEntityPageData, ThrowOnError>): RequestResult<GeozonesGetEntityPageResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GeozonesGetEntityPageResponses, unknown, ThrowOnError>({ url: '/api/v1/geozones', ...options });

/**
 * Creates new geozone
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const geozonesCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<GeozonesCreateEntityData, ThrowOnError>): RequestResult<GeozonesCreateEntityResponses, GeozonesCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<GeozonesCreateEntityResponses, GeozonesCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/geozones',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Deletes geozone
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const geozonesDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<GeozonesDeleteEntityData, ThrowOnError>): RequestResult<GeozonesDeleteEntityResponses, GeozonesDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<GeozonesDeleteEntityResponses, GeozonesDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/geozones/{id}', ...options });

/**
 * Gets geozone by id
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const geozonesGetEntity = <ThrowOnError extends boolean = false>(options: Options<GeozonesGetEntityData, ThrowOnError>): RequestResult<GeozonesGetEntityResponses, GeozonesGetEntityErrors, ThrowOnError> => (options.client ?? client).get<GeozonesGetEntityResponses, GeozonesGetEntityErrors, ThrowOnError>({ url: '/api/v1/geozones/{id}', ...options });

/**
 * Updates geozone
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const geozonesUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<GeozonesUpdateEntityData, ThrowOnError>): RequestResult<GeozonesUpdateEntityResponses, GeozonesUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<GeozonesUpdateEntityResponses, GeozonesUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/geozones/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update assigned containers to geozone group
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const geozonesUpdateContainersGroup = <ThrowOnError extends boolean = false>(options: Options<GeozonesUpdateContainersGroupData, ThrowOnError>): RequestResult<GeozonesUpdateContainersGroupResponses, GeozonesUpdateContainersGroupErrors, ThrowOnError> => (options.client ?? client).put<GeozonesUpdateContainersGroupResponses, GeozonesUpdateContainersGroupErrors, ThrowOnError>({
    url: '/api/v1/geozones/{id}/containers/partial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists active containers not assigned to this geozone,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const geozonesListAvailableContainers = <ThrowOnError extends boolean = false>(options: Options<GeozonesListAvailableContainersData, ThrowOnError>): RequestResult<GeozonesListAvailableContainersResponses, GeozonesListAvailableContainersErrors, ThrowOnError> => (options.client ?? client).get<GeozonesListAvailableContainersResponses, GeozonesListAvailableContainersErrors, ThrowOnError>({ url: '/api/v1/geozones/{id}/containers/available', ...options });

/**
 * Lists active containers assigned to this geozone,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const geozonesListContainers = <ThrowOnError extends boolean = false>(options: Options<GeozonesListContainersData, ThrowOnError>): RequestResult<GeozonesListContainersResponses, GeozonesListContainersErrors, ThrowOnError> => (options.client ?? client).get<GeozonesListContainersResponses, GeozonesListContainersErrors, ThrowOnError>({ url: '/api/v1/geozones/{id}/containers', ...options });

/**
 * Lists active containers assigned to this geozone with their last location
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const geozonesListContainersLastLocation = <ThrowOnError extends boolean = false>(options: Options<GeozonesListContainersLastLocationData, ThrowOnError>): RequestResult<GeozonesListContainersLastLocationResponses, GeozonesListContainersLastLocationErrors, ThrowOnError> => (options.client ?? client).get<GeozonesListContainersLastLocationResponses, GeozonesListContainersLastLocationErrors, ThrowOnError>({ url: '/api/v1/geozones/{id}/containers/map', ...options });

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const geozonesIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<GeozonesIsValueUsedData, ThrowOnError>): RequestResult<GeozonesIsValueUsedResponses, GeozonesIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<GeozonesIsValueUsedResponses, GeozonesIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/geozones/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of Hardware Commands
 *
 * Users without EMZ_DEVELOPER role can see only Reset commands<p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const hardwareCommandsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<HardwareCommandsGetEntityPageData, ThrowOnError>): RequestResult<HardwareCommandsGetEntityPageResponses, HardwareCommandsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<HardwareCommandsGetEntityPageResponses, HardwareCommandsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/hardware-commands', ...options });

/**
 * Creates new Hardware Command
 *
 * Users without EMZ_DEVELOPER role create only Reset commands without parameters<p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const hardwareCommandsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<HardwareCommandsCreateEntityData, ThrowOnError>): RequestResult<HardwareCommandsCreateEntityResponses, HardwareCommandsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<HardwareCommandsCreateEntityResponses, HardwareCommandsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/hardware-commands',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets one Hardware Command
 *
 * Users without EMZ_DEVELOPER role can see only Reset commands<p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const hardwareCommandsGetEntity = <ThrowOnError extends boolean = false>(options: Options<HardwareCommandsGetEntityData, ThrowOnError>): RequestResult<HardwareCommandsGetEntityResponses, HardwareCommandsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<HardwareCommandsGetEntityResponses, HardwareCommandsGetEntityErrors, ThrowOnError>({ url: '/api/v1/hardware-commands/{id}', ...options });

/**
 * Get the configuration of hardware unit, which can be used in the endpoint
 * `CheckSnapshot` to check if any changes have occurred
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const hardwareUnitConfigurationChecksGetConfigurationSnapshot = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitConfigurationChecksGetConfigurationSnapshotData, ThrowOnError>): RequestResult<HardwareUnitConfigurationChecksGetConfigurationSnapshotResponses, HardwareUnitConfigurationChecksGetConfigurationSnapshotErrors, ThrowOnError> => (options.client ?? client).get<HardwareUnitConfigurationChecksGetConfigurationSnapshotResponses, HardwareUnitConfigurationChecksGetConfigurationSnapshotErrors, ThrowOnError>({ url: '/api/v1/hardware-unit-configuration-checks/{hardwareUnitId}', ...options });

/**
 * Check the configuration of provided hardware unit.
 * If the configuration of hardware unit is unchanged, it will return 204 No Content,
 * otherwise it will return 200 OK with the list changes of hardware unit configuration
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const hardwareUnitConfigurationChecksCheckSnapshot = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitConfigurationChecksCheckSnapshotData, ThrowOnError>): RequestResult<HardwareUnitConfigurationChecksCheckSnapshotResponses, HardwareUnitConfigurationChecksCheckSnapshotErrors, ThrowOnError> => (options.client ?? client).post<HardwareUnitConfigurationChecksCheckSnapshotResponses, HardwareUnitConfigurationChecksCheckSnapshotErrors, ThrowOnError>({
    url: '/api/v1/hardware-unit-configuration-checks/{hardwareUnitId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets hardware unit log messages
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const hardwareUnitLogMessagesGetMessagesPage = <ThrowOnError extends boolean = false>(options?: Options<HardwareUnitLogMessagesGetMessagesPageData, ThrowOnError>): RequestResult<HardwareUnitLogMessagesGetMessagesPageResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HardwareUnitLogMessagesGetMessagesPageResponses, unknown, ThrowOnError>({ url: '/api/v1/hardware-unit-log-messages', ...options });

/**
 * Get list of available hardware modules
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const hardwareUnitLogMessagesGetListOfModules = <ThrowOnError extends boolean = false>(options?: Options<HardwareUnitLogMessagesGetListOfModulesData, ThrowOnError>): RequestResult<HardwareUnitLogMessagesGetListOfModulesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HardwareUnitLogMessagesGetListOfModulesResponses, unknown, ThrowOnError>({ url: '/api/v1/hardware-unit-log-messages/modules/list', ...options });

/**
 * Imports hardware unit log messages
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const hardwareUnitLogMessagesImportLogMessages = <ThrowOnError extends boolean = false>(options?: Options<HardwareUnitLogMessagesImportLogMessagesData, ThrowOnError>): RequestResult<HardwareUnitLogMessagesImportLogMessagesResponses, HardwareUnitLogMessagesImportLogMessagesErrors, ThrowOnError> => (options?.client ?? client).post<HardwareUnitLogMessagesImportLogMessagesResponses, HardwareUnitLogMessagesImportLogMessagesErrors, ThrowOnError>({
    url: '/api/v1/hardware-unit-log-messages/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Validates import of hardware unit log messages
 *
 * <p><strong>Required Roles</strong>: <code>EMZ_DEVELOPER</code></p>
 */
export const hardwareUnitLogMessagesValidateHardwareUnitLogImport = <ThrowOnError extends boolean = false>(options?: Options<HardwareUnitLogMessagesValidateHardwareUnitLogImportData, ThrowOnError>): RequestResult<HardwareUnitLogMessagesValidateHardwareUnitLogImportResponses, HardwareUnitLogMessagesValidateHardwareUnitLogImportErrors, ThrowOnError> => (options?.client ?? client).post<HardwareUnitLogMessagesValidateHardwareUnitLogImportResponses, HardwareUnitLogMessagesValidateHardwareUnitLogImportErrors, ThrowOnError>({
    url: '/api/v1/hardware-unit-log-messages/import/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of Hardware Units
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_VIEW</code> or <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsGetEntityPage = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsGetEntityPageData, ThrowOnError>): RequestResult<HardwareUnitsGetEntityPageResponses, HardwareUnitsGetEntityPageErrors, ThrowOnError> => (options.client ?? client).get<HardwareUnitsGetEntityPageResponses, HardwareUnitsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/hardware-units', ...options });

/**
 * Gets partial list of hardware units
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_VIEW</code> or <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsListHardwareUnits = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsListHardwareUnitsData, ThrowOnError>): RequestResult<HardwareUnitsListHardwareUnitsResponses, HardwareUnitsListHardwareUnitsErrors, ThrowOnError> => (options.client ?? client).get<HardwareUnitsListHardwareUnitsResponses, HardwareUnitsListHardwareUnitsErrors, ThrowOnError>({ url: '/api/v1/hardware-units/list', ...options });

/**
 * Gets paged list of basic hardware unit information.
 *
 * Main purpose is to get list of hardware units for container transactions multiselect filter<p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>HARDWARE_UNIT_VIEW</code> or <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsListPagedHardwareUnits = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsListPagedHardwareUnitsData, ThrowOnError>): RequestResult<HardwareUnitsListPagedHardwareUnitsResponses, HardwareUnitsListPagedHardwareUnitsErrors, ThrowOnError> => (options.client ?? client).get<HardwareUnitsListPagedHardwareUnitsResponses, HardwareUnitsListPagedHardwareUnitsErrors, ThrowOnError>({ url: '/api/v1/hardware-units/list-paged', ...options });

/**
 * Gets list of hardware unit Ids that given service user can access.
 * If the user does not have the APP_SERVICE_USER, returns empty list.
 * Returns also all unassigned hardware units
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsListHardwareUnitsForServiceUser = <ThrowOnError extends boolean = false>(options?: Options<HardwareUnitsListHardwareUnitsForServiceUserData, ThrowOnError>): RequestResult<HardwareUnitsListHardwareUnitsForServiceUserResponses, HardwareUnitsListHardwareUnitsForServiceUserErrors, ThrowOnError> => (options?.client ?? client).get<HardwareUnitsListHardwareUnitsForServiceUserResponses, HardwareUnitsListHardwareUnitsForServiceUserErrors, ThrowOnError>({ url: '/api/v1/hardware-units/list-for-service-user', ...options });

/**
 * Gets Hardware Unit
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_VIEW</code> or <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsGetEntity = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsGetEntityData, ThrowOnError>): RequestResult<HardwareUnitsGetEntityResponses, HardwareUnitsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<HardwareUnitsGetEntityResponses, HardwareUnitsGetEntityErrors, ThrowOnError>({ url: '/api/v1/hardware-units/{id}', ...options });

/**
 * Updates Hardware Unit
 *
 * <p><strong>Required Roles</strong>: <code>PRODUCT_ADMIN</code> or <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsUpdateEntityData, ThrowOnError>): RequestResult<HardwareUnitsUpdateEntityResponses, HardwareUnitsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<HardwareUnitsUpdateEntityResponses, HardwareUnitsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/hardware-units/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validates bulk update of hardware units
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsValidateBulkUpdate = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsValidateBulkUpdateData, ThrowOnError>): RequestResult<HardwareUnitsValidateBulkUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<HardwareUnitsValidateBulkUpdateResponses, unknown, ThrowOnError>({
    url: '/api/v1/hardware-units/bulk/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates multiple hardware units at once.
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsBulkUpdate = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsBulkUpdateData, ThrowOnError>): RequestResult<HardwareUnitsBulkUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<HardwareUnitsBulkUpdateResponses, unknown, ThrowOnError>({
    url: '/api/v1/hardware-units/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets whether the hardware unit is free to use (is not yet used)
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_VIEW</code> or <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code> or <code>APP_SERVICE_USER</code></p>
 */
export const hardwareUnitsIsAvailable = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsIsAvailableData, ThrowOnError>): RequestResult<HardwareUnitsIsAvailableResponses, HardwareUnitsIsAvailableErrors, ThrowOnError> => (options.client ?? client).get<HardwareUnitsIsAvailableResponses, HardwareUnitsIsAvailableErrors, ThrowOnError>({ url: '/api/v1/hardware-units/{id}/available', ...options });

/**
 * Gets id of assigned container for given hardware unit
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>HARDWARE_UNIT_VIEW</code> or <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsGetContainerId = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsGetContainerIdData, ThrowOnError>): RequestResult<HardwareUnitsGetContainerIdResponses, HardwareUnitsGetContainerIdErrors, ThrowOnError> => (options.client ?? client).get<HardwareUnitsGetContainerIdResponses, HardwareUnitsGetContainerIdErrors, ThrowOnError>({ url: '/api/v1/hardware-units/{id}/container', ...options });

/**
 * Gets list of hardware modules for given hardware unit
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>HARDWARE_UNIT_VIEW</code> or <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsListHardwareModules = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsListHardwareModulesData, ThrowOnError>): RequestResult<HardwareUnitsListHardwareModulesResponses, HardwareUnitsListHardwareModulesErrors, ThrowOnError> => (options.client ?? client).get<HardwareUnitsListHardwareModulesResponses, HardwareUnitsListHardwareModulesErrors, ThrowOnError>({ url: '/api/v1/hardware-units/{id}/modules', ...options });

/**
 * Gets page of hardware units end-test results
 *
 * <p><strong>Required Roles</strong>: <code>ENDTEST_VIEW</code> or <code>ENDTEST_RUN</code></p>
 */
export const hardwareUnitsGetEndTestResults = <ThrowOnError extends boolean = false>(options?: Options<HardwareUnitsGetEndTestResultsData, ThrowOnError>): RequestResult<HardwareUnitsGetEndTestResultsResponses, HardwareUnitsGetEndTestResultsErrors, ThrowOnError> => (options?.client ?? client).get<HardwareUnitsGetEndTestResultsResponses, HardwareUnitsGetEndTestResultsErrors, ThrowOnError>({ url: '/api/v1/hardware-units/end-tests', ...options });

/**
 * Gets hardware configuration of given hardware unit
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_VIEW</code> or <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsGetHardwareConfiguration = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsGetHardwareConfigurationData, ThrowOnError>): RequestResult<HardwareUnitsGetHardwareConfigurationResponses, HardwareUnitsGetHardwareConfigurationErrors, ThrowOnError> => (options.client ?? client).get<HardwareUnitsGetHardwareConfigurationResponses, HardwareUnitsGetHardwareConfigurationErrors, ThrowOnError>({ url: '/api/v1/hardware-units/{id}/config', ...options });

/**
 * Creates hardware configuration of given hardware unit
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsCreateHardwareConfiguration = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsCreateHardwareConfigurationData, ThrowOnError>): RequestResult<HardwareUnitsCreateHardwareConfigurationResponses, HardwareUnitsCreateHardwareConfigurationErrors, ThrowOnError> => (options.client ?? client).post<HardwareUnitsCreateHardwareConfigurationResponses, HardwareUnitsCreateHardwareConfigurationErrors, ThrowOnError>({
    url: '/api/v1/hardware-units/{id}/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets page of hardware unit telemetry history
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_VIEW</code> or <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsGetTelemetryHistory = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsGetTelemetryHistoryData, ThrowOnError>): RequestResult<HardwareUnitsGetTelemetryHistoryResponses, HardwareUnitsGetTelemetryHistoryErrors, ThrowOnError> => (options.client ?? client).get<HardwareUnitsGetTelemetryHistoryResponses, HardwareUnitsGetTelemetryHistoryErrors, ThrowOnError>({ url: '/api/v1/hardware-units/{id}/telemetry', ...options });

/**
 * Gets page of hardware unit firmware history
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_VIEW</code> or <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsGetFirmwareHistory = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsGetFirmwareHistoryData, ThrowOnError>): RequestResult<HardwareUnitsGetFirmwareHistoryResponses, HardwareUnitsGetFirmwareHistoryErrors, ThrowOnError> => (options.client ?? client).get<HardwareUnitsGetFirmwareHistoryResponses, HardwareUnitsGetFirmwareHistoryErrors, ThrowOnError>({ url: '/api/v1/hardware-units/{id}/firmware-history', ...options });

/**
 * Exports hardware unit data
 *
 * Note when filter is not specified or eGateDigi.Api.HardwareUnitFilter.Assignment is null,
 * returns all units<p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_VIEW</code> or <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsExport = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsExportData, ThrowOnError>): RequestResult<HardwareUnitsExportResponses, unknown, ThrowOnError> => (options.client ?? client).get<HardwareUnitsExportResponses, unknown, ThrowOnError>({ url: '/api/v1/hardware-units/export.{format}', ...options });

/**
 * Exports hardware units
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_VIEW</code> or <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsExportTelemetryHistory = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsExportTelemetryHistoryData, ThrowOnError>): RequestResult<HardwareUnitsExportTelemetryHistoryResponses, unknown, ThrowOnError> => (options.client ?? client).get<HardwareUnitsExportTelemetryHistoryResponses, unknown, ThrowOnError>({ url: '/api/v1/hardware-units/{id}/telemetry/export.{format}', ...options });

/**
 * Exports hardware unit telemetry
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_VIEW</code> or <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsExportMultiTelemetryHistory = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsExportMultiTelemetryHistoryData, ThrowOnError>): RequestResult<HardwareUnitsExportMultiTelemetryHistoryResponses, unknown, ThrowOnError> => (options.client ?? client).get<HardwareUnitsExportMultiTelemetryHistoryResponses, unknown, ThrowOnError>({ url: '/api/v1/hardware-units/telemetry/export.{format}', ...options });

/**
 * Gets logs for the hardware unit
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_VIEW</code> or <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const hardwareUnitsGetLog = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsGetLogData, ThrowOnError>): RequestResult<HardwareUnitsGetLogResponses, unknown, ThrowOnError> => (options.client ?? client).get<HardwareUnitsGetLogResponses, unknown, ThrowOnError>({ url: '/api/v1/hardware-units/{id}/log', ...options });

/**
 * Gets information about assigned firmware update for given HW ACU unit.
 * This is used by ACU Proxy
 *
 * <p><strong>Required Roles</strong>: <code>FIRMWARE_VIEW</code> or <code>FIRMWARE_ADMIN</code></p>
 */
export const hardwareUnitsGetFirmwareInfo = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsGetFirmwareInfoData, ThrowOnError>): RequestResult<HardwareUnitsGetFirmwareInfoResponses, HardwareUnitsGetFirmwareInfoErrors, ThrowOnError> => (options.client ?? client).get<HardwareUnitsGetFirmwareInfoResponses, HardwareUnitsGetFirmwareInfoErrors, ThrowOnError>({ url: '/api/v1/hardware-units/{id}/firmware', ...options });

/**
 * Adds entries to the large list associated with this hardware unit.
 * If the hardware unit does not have any assigned list, a new one will be created automatically.
 *
 * If there is preexisting list associated with the hardware unit
 * and that list is associated with other hardware units too,
 * it will be replaced by new clean list.
 * If container is associated with the hardware unit,
 * the list will be also associated with the container.<p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const hardwareUnitsAddEntries = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsAddEntriesData, ThrowOnError>): RequestResult<HardwareUnitsAddEntriesResponses, HardwareUnitsAddEntriesErrors, ThrowOnError> => (options.client ?? client).post<HardwareUnitsAddEntriesResponses, HardwareUnitsAddEntriesErrors, ThrowOnError>({
    url: '/api/v1/hardware-units/{id}/large-list/entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets large list associated with this hardware unit
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_VIEW</code> or <code>LARGE_LIST_ADMIN</code></p>
 */
export const hardwareUnitsGetLargeList = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsGetLargeListData, ThrowOnError>): RequestResult<HardwareUnitsGetLargeListResponses, unknown, ThrowOnError> => (options.client ?? client).get<HardwareUnitsGetLargeListResponses, unknown, ThrowOnError>({ url: '/api/v1/hardware-units/{id}/large-list', ...options });

/**
 * Adds entries to the legacy access list of the hardware unit.
 *
 * The access list is used for `eGate` type hardware units.
 * For the newer generation `AcUpgrade`, the Large List is used instead.<p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const hardwareUnitsAddLegacyAccessListEntries = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsAddLegacyAccessListEntriesData, ThrowOnError>): RequestResult<HardwareUnitsAddLegacyAccessListEntriesResponses, HardwareUnitsAddLegacyAccessListEntriesErrors, ThrowOnError> => (options.client ?? client).post<HardwareUnitsAddLegacyAccessListEntriesResponses, HardwareUnitsAddLegacyAccessListEntriesErrors, ThrowOnError>({
    url: '/api/v1/hardware-units/{id}/legacy-access-list/entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets the legacy access list of the container associated with this hardware unit
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_VIEW</code> or <code>LARGE_LIST_ADMIN</code></p>
 */
export const hardwareUnitsGetLegacyAccessList = <ThrowOnError extends boolean = false>(options: Options<HardwareUnitsGetLegacyAccessListData, ThrowOnError>): RequestResult<HardwareUnitsGetLegacyAccessListResponses, HardwareUnitsGetLegacyAccessListErrors, ThrowOnError> => (options.client ?? client).get<HardwareUnitsGetLegacyAccessListResponses, HardwareUnitsGetLegacyAccessListErrors, ThrowOnError>({ url: '/api/v1/hardware-units/{id}/legacy-access-list', ...options });

/**
 * Gets image
 */
export const imagesShowImage = <ThrowOnError extends boolean = false>(options: Options<ImagesShowImageData, ThrowOnError>): RequestResult<ImagesShowImageResponses, ImagesShowImageErrors, ThrowOnError> => (options.client ?? client).get<ImagesShowImageResponses, ImagesShowImageErrors, ThrowOnError>({ url: '/api/v1/images/{id}', ...options });

/**
 * Uploads JPEG or PNG image.
 * Expects image binary data in the body of the request
 */
export const imagesUploadImage = <ThrowOnError extends boolean = false>(options: Options<ImagesUploadImageData, ThrowOnError>): RequestResult<ImagesUploadImageResponses, ImagesUploadImageErrors, ThrowOnError> => (options.client ?? client).post<ImagesUploadImageResponses, ImagesUploadImageErrors, ThrowOnError>({
    bodySerializer: null,
    url: '/api/v1/images',
    ...options,
    headers: {
        'Content-Type': 'image/jpeg',
        ...options.headers
    }
});

/**
 * Gets page of IntervalConfigurationGroups
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const intervalConfigurationGroupsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<IntervalConfigurationGroupsGetEntityPageData, ThrowOnError>): RequestResult<IntervalConfigurationGroupsGetEntityPageResponses, IntervalConfigurationGroupsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<IntervalConfigurationGroupsGetEntityPageResponses, IntervalConfigurationGroupsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/interval-configuration-groups', ...options });

/**
 * Creates new IntervalConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const intervalConfigurationGroupsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<IntervalConfigurationGroupsCreateEntityData, ThrowOnError>): RequestResult<IntervalConfigurationGroupsCreateEntityResponses, IntervalConfigurationGroupsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<IntervalConfigurationGroupsCreateEntityResponses, IntervalConfigurationGroupsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/interval-configuration-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of IntervalConfigurationGroups
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const intervalConfigurationGroupsListEntities = <ThrowOnError extends boolean = false>(options?: Options<IntervalConfigurationGroupsListEntitiesData, ThrowOnError>): RequestResult<IntervalConfigurationGroupsListEntitiesResponses, IntervalConfigurationGroupsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<IntervalConfigurationGroupsListEntitiesResponses, IntervalConfigurationGroupsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/interval-configuration-groups/list', ...options });

/**
 * Delete IntervalConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const intervalConfigurationGroupsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<IntervalConfigurationGroupsDeleteEntityData, ThrowOnError>): RequestResult<IntervalConfigurationGroupsDeleteEntityResponses, IntervalConfigurationGroupsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<IntervalConfigurationGroupsDeleteEntityResponses, IntervalConfigurationGroupsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/interval-configuration-groups/{id}', ...options });

/**
 * Gets IntervalConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const intervalConfigurationGroupsGetEntity = <ThrowOnError extends boolean = false>(options: Options<IntervalConfigurationGroupsGetEntityData, ThrowOnError>): RequestResult<IntervalConfigurationGroupsGetEntityResponses, IntervalConfigurationGroupsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<IntervalConfigurationGroupsGetEntityResponses, IntervalConfigurationGroupsGetEntityErrors, ThrowOnError>({ url: '/api/v1/interval-configuration-groups/{id}', ...options });

/**
 * Updates IntervalConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const intervalConfigurationGroupsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<IntervalConfigurationGroupsUpdateEntityData, ThrowOnError>): RequestResult<IntervalConfigurationGroupsUpdateEntityResponses, IntervalConfigurationGroupsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<IntervalConfigurationGroupsUpdateEntityResponses, IntervalConfigurationGroupsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/interval-configuration-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update assigned containers to Interval Configuration Group
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const intervalConfigurationGroupsUpdateContainersGroup = <ThrowOnError extends boolean = false>(options: Options<IntervalConfigurationGroupsUpdateContainersGroupData, ThrowOnError>): RequestResult<IntervalConfigurationGroupsUpdateContainersGroupResponses, IntervalConfigurationGroupsUpdateContainersGroupErrors, ThrowOnError> => (options.client ?? client).put<IntervalConfigurationGroupsUpdateContainersGroupResponses, IntervalConfigurationGroupsUpdateContainersGroupErrors, ThrowOnError>({
    url: '/api/v1/interval-configuration-groups/{id}/containers/partial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists active containers not assigned to this Interval Configuration,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const intervalConfigurationGroupsListAvailableContainers = <ThrowOnError extends boolean = false>(options: Options<IntervalConfigurationGroupsListAvailableContainersData, ThrowOnError>): RequestResult<IntervalConfigurationGroupsListAvailableContainersResponses, IntervalConfigurationGroupsListAvailableContainersErrors, ThrowOnError> => (options.client ?? client).get<IntervalConfigurationGroupsListAvailableContainersResponses, IntervalConfigurationGroupsListAvailableContainersErrors, ThrowOnError>({ url: '/api/v1/interval-configuration-groups/{id}/containers/available', ...options });

/**
 * Lists active containers assigned to this Interval Configuration Group,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const intervalConfigurationGroupsListContainers = <ThrowOnError extends boolean = false>(options: Options<IntervalConfigurationGroupsListContainersData, ThrowOnError>): RequestResult<IntervalConfigurationGroupsListContainersResponses, IntervalConfigurationGroupsListContainersErrors, ThrowOnError> => (options.client ?? client).get<IntervalConfigurationGroupsListContainersResponses, IntervalConfigurationGroupsListContainersErrors, ThrowOnError>({ url: '/api/v1/interval-configuration-groups/{id}/containers', ...options });

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const intervalConfigurationGroupsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<IntervalConfigurationGroupsIsValueUsedData, ThrowOnError>): RequestResult<IntervalConfigurationGroupsIsValueUsedResponses, IntervalConfigurationGroupsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<IntervalConfigurationGroupsIsValueUsedResponses, IntervalConfigurationGroupsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/interval-configuration-groups/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of all known issue types
 */
export const issuesListIssueTypes = <ThrowOnError extends boolean = false>(options?: Options<IssuesListIssueTypesData, ThrowOnError>): RequestResult<IssuesListIssueTypesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<IssuesListIssueTypesResponses, unknown, ThrowOnError>({ url: '/api/v1/issues/types', ...options });

/**
 * Gets page of reported issues
 *
 * <p><strong>Required Roles</strong>: <code>ISSUE_VIEW</code> or <code>ISSUE_ADMIN</code></p>
 */
export const issuesGetIssuesPage = <ThrowOnError extends boolean = false>(options?: Options<IssuesGetIssuesPageData, ThrowOnError>): RequestResult<IssuesGetIssuesPageResponses, IssuesGetIssuesPageErrors, ThrowOnError> => (options?.client ?? client).get<IssuesGetIssuesPageResponses, IssuesGetIssuesPageErrors, ThrowOnError>({ url: '/api/v1/issues', ...options });

/**
 * Creates new issue report.
 *
 * For the report to be useful, please provide at least one of the following:
 * * Container
 * * Location
 * * Nearby containers
 *
 * To specify container or nearby container, either use it's Id or BLE name (but only one of those)<p><strong>Required Roles</strong>: <code>ISSUE_VIEW</code> or <code>ISSUE_ADMIN</code> or <code>APP_USER</code></p>
 */
export const issuesCreateIssue = <ThrowOnError extends boolean = false>(options?: Options<IssuesCreateIssueData, ThrowOnError>): RequestResult<IssuesCreateIssueResponses, IssuesCreateIssueErrors, ThrowOnError> => (options?.client ?? client).post<IssuesCreateIssueResponses, IssuesCreateIssueErrors, ThrowOnError>({
    url: '/api/v1/issues',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets specific issue report
 *
 * <p><strong>Required Roles</strong>: <code>ISSUE_VIEW</code> or <code>ISSUE_ADMIN</code></p>
 */
export const issuesGetIssue = <ThrowOnError extends boolean = false>(options: Options<IssuesGetIssueData, ThrowOnError>): RequestResult<IssuesGetIssueResponses, IssuesGetIssueErrors, ThrowOnError> => (options.client ?? client).get<IssuesGetIssueResponses, IssuesGetIssueErrors, ThrowOnError>({ url: '/api/v1/issues/{id}', ...options });

/**
 * Exports issues.
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>ISSUE_VIEW</code> or <code>ISSUE_ADMIN</code></p>
 */
export const issuesExportList = <ThrowOnError extends boolean = false>(options: Options<IssuesExportListData, ThrowOnError>): RequestResult<IssuesExportListResponses, IssuesExportListErrors, ThrowOnError> => (options.client ?? client).get<IssuesExportListResponses, IssuesExportListErrors, ThrowOnError>({ url: '/api/v1/issues/export.{format}', ...options });

/**
 * Sets the issue to state "In Progress"
 *
 * <p><strong>Required Roles</strong>: <code>ISSUE_ADMIN</code></p>
 */
export const issuesStartIssue = <ThrowOnError extends boolean = false>(options: Options<IssuesStartIssueData, ThrowOnError>): RequestResult<IssuesStartIssueResponses, IssuesStartIssueErrors, ThrowOnError> => (options.client ?? client).put<IssuesStartIssueResponses, IssuesStartIssueErrors, ThrowOnError>({ url: '/api/v1/issues/{id}/start', ...options });

/**
 * Sets the issue to state "Fixed"
 *
 * <p><strong>Required Roles</strong>: <code>ISSUE_ADMIN</code></p>
 */
export const issuesFixIssue = <ThrowOnError extends boolean = false>(options: Options<IssuesFixIssueData, ThrowOnError>): RequestResult<IssuesFixIssueResponses, IssuesFixIssueErrors, ThrowOnError> => (options.client ?? client).put<IssuesFixIssueResponses, IssuesFixIssueErrors, ThrowOnError>({ url: '/api/v1/issues/{id}/fix', ...options });

/**
 * Sets the issue to state "Rejected"
 *
 * <p><strong>Required Roles</strong>: <code>ISSUE_ADMIN</code></p>
 */
export const issuesRejectIssue = <ThrowOnError extends boolean = false>(options: Options<IssuesRejectIssueData, ThrowOnError>): RequestResult<IssuesRejectIssueResponses, IssuesRejectIssueErrors, ThrowOnError> => (options.client ?? client).put<IssuesRejectIssueResponses, IssuesRejectIssueErrors, ThrowOnError>({ url: '/api/v1/issues/{id}/reject', ...options });

/**
 * Sets the issue to state "Open"
 *
 * <p><strong>Required Roles</strong>: <code>ISSUE_ADMIN</code></p>
 */
export const issuesReopenIssue = <ThrowOnError extends boolean = false>(options: Options<IssuesReopenIssueData, ThrowOnError>): RequestResult<IssuesReopenIssueResponses, IssuesReopenIssueErrors, ThrowOnError> => (options.client ?? client).put<IssuesReopenIssueResponses, IssuesReopenIssueErrors, ThrowOnError>({ url: '/api/v1/issues/{id}/reopen', ...options });

/**
 * Gets list of all supported languages
 */
export const languagesListLanguages = <ThrowOnError extends boolean = false>(options?: Options<LanguagesListLanguagesData, ThrowOnError>): RequestResult<LanguagesListLanguagesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<LanguagesListLanguagesResponses, unknown, ThrowOnError>({ url: '/api/v1/languages', ...options });

/**
 * Gets page of NFC card large lists
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_VIEW</code> or <code>LARGE_LIST_ADMIN</code></p>
 */
export const largeListsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<LargeListsGetEntityPageData, ThrowOnError>): RequestResult<LargeListsGetEntityPageResponses, LargeListsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<LargeListsGetEntityPageResponses, LargeListsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/large-lists', ...options });

/**
 * Creates new NFC card large list
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const largeListsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<LargeListsCreateEntityData, ThrowOnError>): RequestResult<LargeListsCreateEntityResponses, LargeListsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<LargeListsCreateEntityResponses, LargeListsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/large-lists',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of Large Lists
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_VIEW</code> or <code>LARGE_LIST_ADMIN</code></p>
 */
export const largeListsListEntities = <ThrowOnError extends boolean = false>(options?: Options<LargeListsListEntitiesData, ThrowOnError>): RequestResult<LargeListsListEntitiesResponses, LargeListsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<LargeListsListEntitiesResponses, LargeListsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/large-lists/list', ...options });

/**
 * Deletes large list
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const largeListsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<LargeListsDeleteEntityData, ThrowOnError>): RequestResult<LargeListsDeleteEntityResponses, LargeListsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<LargeListsDeleteEntityResponses, LargeListsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/large-lists/{id}', ...options });

/**
 * Gets NFC card large list
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_VIEW</code> or <code>LARGE_LIST_ADMIN</code></p>
 */
export const largeListsGetEntity = <ThrowOnError extends boolean = false>(options: Options<LargeListsGetEntityData, ThrowOnError>): RequestResult<LargeListsGetEntityResponses, LargeListsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<LargeListsGetEntityResponses, LargeListsGetEntityErrors, ThrowOnError>({ url: '/api/v1/large-lists/{id}', ...options });

/**
 * Updates Large List
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const largeListsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<LargeListsUpdateEntityData, ThrowOnError>): RequestResult<LargeListsUpdateEntityResponses, LargeListsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<LargeListsUpdateEntityResponses, LargeListsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/large-lists/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets page of NFC card large list entries
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_VIEW</code> or <code>LARGE_LIST_ADMIN</code></p>
 */
export const largeListsGetEntriesPage = <ThrowOnError extends boolean = false>(options: Options<LargeListsGetEntriesPageData, ThrowOnError>): RequestResult<LargeListsGetEntriesPageResponses, unknown, ThrowOnError> => (options.client ?? client).get<LargeListsGetEntriesPageResponses, unknown, ThrowOnError>({ url: '/api/v1/large-lists/{id}/entries', ...options });

/**
 * Adds entries to the large list
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const largeListsAddEntries = <ThrowOnError extends boolean = false>(options: Options<LargeListsAddEntriesData, ThrowOnError>): RequestResult<LargeListsAddEntriesResponses, LargeListsAddEntriesErrors, ThrowOnError> => (options.client ?? client).post<LargeListsAddEntriesResponses, LargeListsAddEntriesErrors, ThrowOnError>({
    url: '/api/v1/large-lists/{id}/entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists active containers assigned to this large list,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_VIEW</code> or <code>LARGE_LIST_ADMIN</code></p>
 */
export const largeListsListContainers = <ThrowOnError extends boolean = false>(options: Options<LargeListsListContainersData, ThrowOnError>): RequestResult<LargeListsListContainersResponses, LargeListsListContainersErrors, ThrowOnError> => (options.client ?? client).get<LargeListsListContainersResponses, LargeListsListContainersErrors, ThrowOnError>({ url: '/api/v1/large-lists/{id}/containers', ...options });

/**
 * Bulk assign large list to multiple containers
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const largeListsBulkAssignLargeList = <ThrowOnError extends boolean = false>(options: Options<LargeListsBulkAssignLargeListData, ThrowOnError>): RequestResult<LargeListsBulkAssignLargeListResponses, LargeListsBulkAssignLargeListErrors, ThrowOnError> => (options.client ?? client).put<LargeListsBulkAssignLargeListResponses, LargeListsBulkAssignLargeListErrors, ThrowOnError>({
    url: '/api/v1/large-lists/{id}/containers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists active containers not assigned to this large list,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const largeListsListAvailableContainers = <ThrowOnError extends boolean = false>(options: Options<LargeListsListAvailableContainersData, ThrowOnError>): RequestResult<LargeListsListAvailableContainersResponses, LargeListsListAvailableContainersErrors, ThrowOnError> => (options.client ?? client).get<LargeListsListAvailableContainersResponses, LargeListsListAvailableContainersErrors, ThrowOnError>({ url: '/api/v1/large-lists/{id}/containers/available', ...options });

/**
 * Updates given containers for given large list
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const largeListsUpdateContainers = <ThrowOnError extends boolean = false>(options: Options<LargeListsUpdateContainersData, ThrowOnError>): RequestResult<LargeListsUpdateContainersResponses, LargeListsUpdateContainersErrors, ThrowOnError> => (options.client ?? client).put<LargeListsUpdateContainersResponses, LargeListsUpdateContainersErrors, ThrowOnError>({
    url: '/api/v1/large-lists/{id}/containers/partial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activates Large List
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const largeListsActivateEntity = <ThrowOnError extends boolean = false>(options: Options<LargeListsActivateEntityData, ThrowOnError>): RequestResult<LargeListsActivateEntityResponses, LargeListsActivateEntityErrors, ThrowOnError> => (options.client ?? client).put<LargeListsActivateEntityResponses, LargeListsActivateEntityErrors, ThrowOnError>({ url: '/api/v1/large-lists/{id}/activate', ...options });

/**
 * Check if value for given field is already used.
 * Only "Name" is supported, with scope of "CustomerId"
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_ADMIN</code></p>
 */
export const largeListsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<LargeListsIsValueUsedData, ThrowOnError>): RequestResult<LargeListsIsValueUsedResponses, LargeListsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<LargeListsIsValueUsedResponses, LargeListsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/large-lists/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Provides template CSV for large list CSV import
 *
 * <p><strong>Required Roles</strong>: <code>LARGE_LIST_VIEW</code> or <code>LARGE_LIST_ADMIN</code></p>
 */
export const largeListsGetImportTemplateContractContainers = <ThrowOnError extends boolean = false>(options?: Options<LargeListsGetImportTemplateContractContainersData, ThrowOnError>): RequestResult<LargeListsGetImportTemplateContractContainersResponses, LargeListsGetImportTemplateContractContainersErrors, ThrowOnError> => (options?.client ?? client).get<LargeListsGetImportTemplateContractContainersResponses, LargeListsGetImportTemplateContractContainersErrors, ThrowOnError>({ url: '/api/v1/large-lists/template/large-list.csv', ...options });

/**
 * Gets legal document of given type in given language
 */
export const legalGetLegalDocument = <ThrowOnError extends boolean = false>(options: Options<LegalGetLegalDocumentData, ThrowOnError>): RequestResult<LegalGetLegalDocumentResponses, LegalGetLegalDocumentErrors, ThrowOnError> => (options.client ?? client).get<LegalGetLegalDocumentResponses, LegalGetLegalDocumentErrors, ThrowOnError>({ url: '/legal/{type}', ...options });

/**
 * Gets legal document of given type in given language
 */
export const legalGetLegalDocumentWithCulture = <ThrowOnError extends boolean = false>(options: Options<LegalGetLegalDocumentWithCultureData, ThrowOnError>): RequestResult<LegalGetLegalDocumentWithCultureResponses, LegalGetLegalDocumentWithCultureErrors, ThrowOnError> => (options.client ?? client).get<LegalGetLegalDocumentWithCultureResponses, LegalGetLegalDocumentWithCultureErrors, ThrowOnError>({ url: '/legal/{culture}/{type}', ...options });

/**
 * Gets page of lifting systems
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_VIEW</code> or <code>TRUCK_ADMIN</code></p>
 */
export const liftingSystemsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<LiftingSystemsGetEntityPageData, ThrowOnError>): RequestResult<LiftingSystemsGetEntityPageResponses, LiftingSystemsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<LiftingSystemsGetEntityPageResponses, LiftingSystemsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/lifting-systems', ...options });

/**
 * Creates new lifting system
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_ADMIN</code></p>
 */
export const liftingSystemsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<LiftingSystemsCreateEntityData, ThrowOnError>): RequestResult<LiftingSystemsCreateEntityResponses, LiftingSystemsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<LiftingSystemsCreateEntityResponses, LiftingSystemsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/lifting-systems',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of lifting systems
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_VIEW</code> or <code>TRUCK_ADMIN</code></p>
 */
export const liftingSystemsListEntities = <ThrowOnError extends boolean = false>(options?: Options<LiftingSystemsListEntitiesData, ThrowOnError>): RequestResult<LiftingSystemsListEntitiesResponses, LiftingSystemsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<LiftingSystemsListEntitiesResponses, LiftingSystemsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/lifting-systems/list', ...options });

/**
 * Deletes lifting system
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_ADMIN</code></p>
 */
export const liftingSystemsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<LiftingSystemsDeleteEntityData, ThrowOnError>): RequestResult<LiftingSystemsDeleteEntityResponses, LiftingSystemsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<LiftingSystemsDeleteEntityResponses, LiftingSystemsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/lifting-systems/{id}', ...options });

/**
 * Gets lifting system
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_VIEW</code> or <code>TRUCK_ADMIN</code></p>
 */
export const liftingSystemsGetEntity = <ThrowOnError extends boolean = false>(options: Options<LiftingSystemsGetEntityData, ThrowOnError>): RequestResult<LiftingSystemsGetEntityResponses, LiftingSystemsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<LiftingSystemsGetEntityResponses, LiftingSystemsGetEntityErrors, ThrowOnError>({ url: '/api/v1/lifting-systems/{id}', ...options });

/**
 * Updates lifting system
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_ADMIN</code></p>
 */
export const liftingSystemsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<LiftingSystemsUpdateEntityData, ThrowOnError>): RequestResult<LiftingSystemsUpdateEntityResponses, LiftingSystemsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<LiftingSystemsUpdateEntityResponses, LiftingSystemsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/lifting-systems/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets paged list of location trackers
 *
 * <p><strong>Required Roles</strong>: <code>LOC_TRACK_VIEW</code> or <code>LOC_TRACK_ADMIN</code></p>
 */
export const locationTrackersGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<LocationTrackersGetEntityPageData, ThrowOnError>): RequestResult<LocationTrackersGetEntityPageResponses, unknown, ThrowOnError> => (options?.client ?? client).get<LocationTrackersGetEntityPageResponses, unknown, ThrowOnError>({ url: '/api/v1/location-trackers', ...options });

/**
 * Creates new location tracker
 *
 * <p><strong>Required Roles</strong>: <code>LOC_TRACK_ADMIN</code></p>
 */
export const locationTrackersCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<LocationTrackersCreateEntityData, ThrowOnError>): RequestResult<LocationTrackersCreateEntityResponses, LocationTrackersCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<LocationTrackersCreateEntityResponses, LocationTrackersCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/location-trackers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of location trackers
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>LOC_TRACK_VIEW</code> or <code>LOC_TRACK_ADMIN</code></p>
 */
export const locationTrackersListEntities = <ThrowOnError extends boolean = false>(options?: Options<LocationTrackersListEntitiesData, ThrowOnError>): RequestResult<LocationTrackersListEntitiesResponses, LocationTrackersListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<LocationTrackersListEntitiesResponses, LocationTrackersListEntitiesErrors, ThrowOnError>({ url: '/api/v1/location-trackers/list', ...options });

/**
 * Soft-deletes location tracker
 *
 * Soft-deleted location tracker stops receiving new telemetry data<p><strong>Required Roles</strong>: <code>LOC_TRACK_ADMIN</code></p>
 */
export const locationTrackersDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<LocationTrackersDeleteEntityData, ThrowOnError>): RequestResult<LocationTrackersDeleteEntityResponses, LocationTrackersDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<LocationTrackersDeleteEntityResponses, LocationTrackersDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/location-trackers/{id}', ...options });

/**
 * Gets location tracker by id
 *
 * <p><strong>Required Roles</strong>: <code>LOC_TRACK_VIEW</code> or <code>LOC_TRACK_ADMIN</code></p>
 */
export const locationTrackersGetEntity = <ThrowOnError extends boolean = false>(options: Options<LocationTrackersGetEntityData, ThrowOnError>): RequestResult<LocationTrackersGetEntityResponses, LocationTrackersGetEntityErrors, ThrowOnError> => (options.client ?? client).get<LocationTrackersGetEntityResponses, LocationTrackersGetEntityErrors, ThrowOnError>({ url: '/api/v1/location-trackers/{id}', ...options });

/**
 * Updates Location tracker
 *
 * <p><strong>Required Roles</strong>: <code>LOC_TRACK_ADMIN</code></p>
 */
export const locationTrackersUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<LocationTrackersUpdateEntityData, ThrowOnError>): RequestResult<LocationTrackersUpdateEntityResponses, LocationTrackersUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<LocationTrackersUpdateEntityResponses, LocationTrackersUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/location-trackers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Checks whether given value is already used by another location tracker
 *
 * <p><strong>Required Roles</strong>: <code>LOC_TRACK_ADMIN</code></p>
 */
export const locationTrackersIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<LocationTrackersIsValueUsedData, ThrowOnError>): RequestResult<LocationTrackersIsValueUsedResponses, LocationTrackersIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<LocationTrackersIsValueUsedResponses, LocationTrackersIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/location-trackers/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Activates soft-deleted location tracker
 *
 * <p><strong>Required Roles</strong>: <code>LOC_TRACK_ADMIN</code></p>
 */
export const locationTrackersActivateEntity = <ThrowOnError extends boolean = false>(options: Options<LocationTrackersActivateEntityData, ThrowOnError>): RequestResult<LocationTrackersActivateEntityResponses, LocationTrackersActivateEntityErrors, ThrowOnError> => (options.client ?? client).put<LocationTrackersActivateEntityResponses, LocationTrackersActivateEntityErrors, ThrowOnError>({ url: '/api/v1/location-trackers/{id}/activate', ...options });

/**
 * Gets list of location tracker types
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>LOC_TRACK_VIEW</code> or <code>LOC_TRACK_ADMIN</code></p>
 */
export const locationTrackerTypesListLocationTrackerTypes = <ThrowOnError extends boolean = false>(options?: Options<LocationTrackerTypesListLocationTrackerTypesData, ThrowOnError>): RequestResult<LocationTrackerTypesListLocationTrackerTypesResponses, LocationTrackerTypesListLocationTrackerTypesErrors, ThrowOnError> => (options?.client ?? client).get<LocationTrackerTypesListLocationTrackerTypesResponses, LocationTrackerTypesListLocationTrackerTypesErrors, ThrowOnError>({ url: '/api/v1/location-tracker-types/list', ...options });

/**
 * Gets page of all materials
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const materialsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<MaterialsGetEntityPageData, ThrowOnError>): RequestResult<MaterialsGetEntityPageResponses, MaterialsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<MaterialsGetEntityPageResponses, MaterialsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/materials', ...options });

/**
 * Creates new material
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const materialsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<MaterialsCreateEntityData, ThrowOnError>): RequestResult<MaterialsCreateEntityResponses, MaterialsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<MaterialsCreateEntityResponses, MaterialsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/materials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of service task Materials
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const materialsListMaterials = <ThrowOnError extends boolean = false>(options?: Options<MaterialsListMaterialsData, ThrowOnError>): RequestResult<MaterialsListMaterialsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MaterialsListMaterialsResponses, unknown, ThrowOnError>({ url: '/api/v1/materials/list', ...options });

/**
 * Deletes material
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const materialsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<MaterialsDeleteEntityData, ThrowOnError>): RequestResult<MaterialsDeleteEntityResponses, MaterialsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<MaterialsDeleteEntityResponses, MaterialsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/materials/{id}', ...options });

/**
 * Gets material by id
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const materialsGetEntity = <ThrowOnError extends boolean = false>(options: Options<MaterialsGetEntityData, ThrowOnError>): RequestResult<MaterialsGetEntityResponses, MaterialsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<MaterialsGetEntityResponses, MaterialsGetEntityErrors, ThrowOnError>({ url: '/api/v1/materials/{id}', ...options });

/**
 * Updates material
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const materialsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<MaterialsUpdateEntityData, ThrowOnError>): RequestResult<MaterialsUpdateEntityResponses, MaterialsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<MaterialsUpdateEntityResponses, MaterialsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/materials/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const materialsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<MaterialsIsValueUsedData, ThrowOnError>): RequestResult<MaterialsIsValueUsedResponses, MaterialsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<MaterialsIsValueUsedResponses, MaterialsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/materials/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets user's profile, including devices and contracts
 */
export const meGetUserProfile = <ThrowOnError extends boolean = false>(options?: Options<MeGetUserProfileData, ThrowOnError>): RequestResult<MeGetUserProfileResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MeGetUserProfileResponses, unknown, ThrowOnError>({ url: '/api/v1/me', ...options });

/**
 * Gets user's containers
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const meGetContainers = <ThrowOnError extends boolean = false>(options?: Options<MeGetContainersData, ThrowOnError>): RequestResult<MeGetContainersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MeGetContainersResponses, unknown, ThrowOnError>({ url: '/api/v1/me/containers', ...options });

/**
 * Shows known container locations
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const meGetContainerMap = <ThrowOnError extends boolean = false>(options?: Options<MeGetContainerMapData, ThrowOnError>): RequestResult<MeGetContainerMapResponses, MeGetContainerMapErrors, ThrowOnError> => (options?.client ?? client).get<MeGetContainerMapResponses, MeGetContainerMapErrors, ThrowOnError>({ url: '/api/v1/me/map', ...options });

/**
 * Gets blocking intervals for the container
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const meGetContainerBlockingIntervals = <ThrowOnError extends boolean = false>(options: Options<MeGetContainerBlockingIntervalsData, ThrowOnError>): RequestResult<MeGetContainerBlockingIntervalsResponses, MeGetContainerBlockingIntervalsErrors, ThrowOnError> => (options.client ?? client).get<MeGetContainerBlockingIntervalsResponses, MeGetContainerBlockingIntervalsErrors, ThrowOnError>({ url: '/api/v1/me/containers/{containerId}/blocking-intervals', ...options });

/**
 * Gets messages for the user
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const meGetMessages = <ThrowOnError extends boolean = false>(options?: Options<MeGetMessagesData, ThrowOnError>): RequestResult<MeGetMessagesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MeGetMessagesResponses, unknown, ThrowOnError>({ url: '/api/v1/me/messages', ...options });

/**
 * Gets features for all customers the current user has access to
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const meGetFeatures = <ThrowOnError extends boolean = false>(options?: Options<MeGetFeaturesData, ThrowOnError>): RequestResult<MeGetFeaturesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MeGetFeaturesResponses, unknown, ThrowOnError>({ url: '/api/v1/me/features', ...options });

/**
 * Gets data for Transactions Daily Count Report
 */
export const meGetTransactionsDailyCountReport = <ThrowOnError extends boolean = false>(options: Options<MeGetTransactionsDailyCountReportData, ThrowOnError>): RequestResult<MeGetTransactionsDailyCountReportResponses, MeGetTransactionsDailyCountReportErrors, ThrowOnError> => (options.client ?? client).get<MeGetTransactionsDailyCountReportResponses, MeGetTransactionsDailyCountReportErrors, ThrowOnError>({ url: '/api/v1/me/reports/transactions-daily-count', ...options });

/**
 * Gets data for user's Transaction Totals
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code></p>
 */
export const meGetUserTransactionTotals = <ThrowOnError extends boolean = false>(options?: Options<MeGetUserTransactionTotalsData, ThrowOnError>): RequestResult<MeGetUserTransactionTotalsResponses, MeGetUserTransactionTotalsErrors, ThrowOnError> => (options?.client ?? client).get<MeGetUserTransactionTotalsResponses, MeGetUserTransactionTotalsErrors, ThrowOnError>({ url: '/api/v1/me/reports/transaction-totals', ...options });

/**
 * Gets data for user's Transaction Totals by Fraction
 *
 * <b>Deprecated</b>: Please use the `GET /api/v1/reports/transaction-totals` endpoint instead with fraction filter
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code></p>
 *
 * @deprecated
 */
export const meGetUserTransactionTotalsByFraction = <ThrowOnError extends boolean = false>(options?: Options<MeGetUserTransactionTotalsByFractionData, ThrowOnError>): RequestResult<MeGetUserTransactionTotalsByFractionResponses, MeGetUserTransactionTotalsByFractionErrors, ThrowOnError> => (options?.client ?? client).get<MeGetUserTransactionTotalsByFractionResponses, MeGetUserTransactionTotalsByFractionErrors, ThrowOnError>({ url: '/api/v1/me/reports/transaction-fraction-totals', ...options });

/**
 * Gets data for user's which fraction was used over period
 */
export const meGetUserTransactionFraction = <ThrowOnError extends boolean = false>(options?: Options<MeGetUserTransactionFractionData, ThrowOnError>): RequestResult<MeGetUserTransactionFractionResponses, MeGetUserTransactionFractionErrors, ThrowOnError> => (options?.client ?? client).get<MeGetUserTransactionFractionResponses, MeGetUserTransactionFractionErrors, ThrowOnError>({ url: '/api/v1/me/reports/transaction-fractions', ...options });

/**
 * Gets data for user's Transaction Totals broke down by smaller time interval
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code></p>
 */
export const meGetUserTransactionTotalsDetailed = <ThrowOnError extends boolean = false>(options?: Options<MeGetUserTransactionTotalsDetailedData, ThrowOnError>): RequestResult<MeGetUserTransactionTotalsDetailedResponses, MeGetUserTransactionTotalsDetailedErrors, ThrowOnError> => (options?.client ?? client).get<MeGetUserTransactionTotalsDetailedResponses, MeGetUserTransactionTotalsDetailedErrors, ThrowOnError>({ url: '/api/v1/me/reports/transaction-totals/detailed', ...options });

/**
 * Gets data for user's Transaction Totals broke down by fractions and then by smaller time interval
 *
 * <b>Deprecated</b>: Please use the `GET /api/v1/reports/transaction-totals/detailed` endpoint instead with fraction filter
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code></p>
 *
 * @deprecated
 */
export const meGetUserTransactionTotalsByFractionDetailed = <ThrowOnError extends boolean = false>(options?: Options<MeGetUserTransactionTotalsByFractionDetailedData, ThrowOnError>): RequestResult<MeGetUserTransactionTotalsByFractionDetailedResponses, MeGetUserTransactionTotalsByFractionDetailedErrors, ThrowOnError> => (options?.client ?? client).get<MeGetUserTransactionTotalsByFractionDetailedResponses, MeGetUserTransactionTotalsByFractionDetailedErrors, ThrowOnError>({ url: '/api/v1/me/reports/transaction-fraction-totals/detailed', ...options });

/**
 * Gets data for user's Transaction Totals by source
 *
 * <b>Deprecated</b>: Please use the `GET /api/v1/reports/transaction-totals` endpoint instead with source filter
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code></p>
 *
 * @deprecated
 */
export const meGetUserTransactionTotalsBySource = <ThrowOnError extends boolean = false>(options?: Options<MeGetUserTransactionTotalsBySourceData, ThrowOnError>): RequestResult<MeGetUserTransactionTotalsBySourceResponses, MeGetUserTransactionTotalsBySourceErrors, ThrowOnError> => (options?.client ?? client).get<MeGetUserTransactionTotalsBySourceResponses, MeGetUserTransactionTotalsBySourceErrors, ThrowOnError>({ url: '/api/v1/me/reports/transaction-source-totals', ...options });

/**
 * Gets paged list of calling user's container transactions.
 *
 * Note the userId query parameter is meaningless in this call.<p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code></p>
 */
export const meGetTransactions = <ThrowOnError extends boolean = false>(options: Options<MeGetTransactionsData, ThrowOnError>): RequestResult<MeGetTransactionsResponses, MeGetTransactionsErrors, ThrowOnError> => (options.client ?? client).get<MeGetTransactionsResponses, MeGetTransactionsErrors, ThrowOnError>({ url: '/api/v1/me/transactions', ...options });

/**
 * Gets user's profile, including devices and contracts
 */
export const meGetUserProfileV2 = <ThrowOnError extends boolean = false>(options?: Options<MeGetUserProfileV2Data, ThrowOnError>): RequestResult<MeGetUserProfileV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<MeGetUserProfileV2Responses, unknown, ThrowOnError>({ url: '/api/v2/me', ...options });

/**
 * Adds contract to current user and device
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const meAddContractV2 = <ThrowOnError extends boolean = false>(options?: Options<MeAddContractV2Data, ThrowOnError>): RequestResult<MeAddContractV2Responses, unknown, ThrowOnError> => (options?.client ?? client).post<MeAddContractV2Responses, unknown, ThrowOnError>({
    url: '/api/v2/me/contracts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Updates user contract.
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const meUpdateUserContractV2 = <ThrowOnError extends boolean = false>(options: Options<MeUpdateUserContractV2Data, ThrowOnError>): RequestResult<MeUpdateUserContractV2Responses, unknown, ThrowOnError> => (options.client ?? client).put<MeUpdateUserContractV2Responses, unknown, ThrowOnError>({
    url: '/api/v2/me/contracts/{contractId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates user device.
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const meUpdateUserDeviceV2 = <ThrowOnError extends boolean = false>(options: Options<MeUpdateUserDeviceV2Data, ThrowOnError>): RequestResult<MeUpdateUserDeviceV2Responses, unknown, ThrowOnError> => (options.client ?? client).put<MeUpdateUserDeviceV2Responses, unknown, ThrowOnError>({
    url: '/api/v2/me/devices/{deviceId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets user's containers
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const meGetContainersV2 = <ThrowOnError extends boolean = false>(options?: Options<MeGetContainersV2Data, ThrowOnError>): RequestResult<MeGetContainersV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<MeGetContainersV2Responses, unknown, ThrowOnError>({ url: '/api/v2/me/containers', ...options });

/**
 * Shows known container locations
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const meGetContainerMapV2 = <ThrowOnError extends boolean = false>(options?: Options<MeGetContainerMapV2Data, ThrowOnError>): RequestResult<MeGetContainerMapV2Responses, MeGetContainerMapV2Errors, ThrowOnError> => (options?.client ?? client).get<MeGetContainerMapV2Responses, MeGetContainerMapV2Errors, ThrowOnError>({ url: '/api/v2/me/map', ...options });

/**
 * Gets blocking intervals for the container
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const meGetContainerBlockingIntervalsV2 = <ThrowOnError extends boolean = false>(options: Options<MeGetContainerBlockingIntervalsV2Data, ThrowOnError>): RequestResult<MeGetContainerBlockingIntervalsV2Responses, MeGetContainerBlockingIntervalsV2Errors, ThrowOnError> => (options.client ?? client).get<MeGetContainerBlockingIntervalsV2Responses, MeGetContainerBlockingIntervalsV2Errors, ThrowOnError>({ url: '/api/v2/me/containers/{containerId}/blocking-intervals', ...options });

/**
 * Gets messages for the user
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const meGetMessagesV2 = <ThrowOnError extends boolean = false>(options?: Options<MeGetMessagesV2Data, ThrowOnError>): RequestResult<MeGetMessagesV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<MeGetMessagesV2Responses, unknown, ThrowOnError>({ url: '/api/v2/me/messages', ...options });

/**
 * Gets features for all customers the current user has access to
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const meGetFeaturesV2 = <ThrowOnError extends boolean = false>(options?: Options<MeGetFeaturesV2Data, ThrowOnError>): RequestResult<MeGetFeaturesV2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<MeGetFeaturesV2Responses, unknown, ThrowOnError>({ url: '/api/v2/me/features', ...options });

/**
 * Gets data for Transactions Daily Count Report
 */
export const meGetTransactionsDailyCountReportV2 = <ThrowOnError extends boolean = false>(options: Options<MeGetTransactionsDailyCountReportV2Data, ThrowOnError>): RequestResult<MeGetTransactionsDailyCountReportV2Responses, MeGetTransactionsDailyCountReportV2Errors, ThrowOnError> => (options.client ?? client).get<MeGetTransactionsDailyCountReportV2Responses, MeGetTransactionsDailyCountReportV2Errors, ThrowOnError>({ url: '/api/v2/me/reports/transactions-daily-count', ...options });

/**
 * Gets data for user's Transaction Totals
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code></p>
 */
export const meGetUserTransactionTotalsV2 = <ThrowOnError extends boolean = false>(options?: Options<MeGetUserTransactionTotalsV2Data, ThrowOnError>): RequestResult<MeGetUserTransactionTotalsV2Responses, MeGetUserTransactionTotalsV2Errors, ThrowOnError> => (options?.client ?? client).get<MeGetUserTransactionTotalsV2Responses, MeGetUserTransactionTotalsV2Errors, ThrowOnError>({ url: '/api/v2/me/reports/transaction-totals', ...options });

/**
 * Gets data for user's Transaction Totals by Fraction
 *
 * <b>Deprecated</b>: Please use the `GET /api/v1/reports/transaction-totals` endpoint instead with fraction filter
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code></p>
 *
 * @deprecated
 */
export const meGetUserTransactionTotalsByFractionV2 = <ThrowOnError extends boolean = false>(options?: Options<MeGetUserTransactionTotalsByFractionV2Data, ThrowOnError>): RequestResult<MeGetUserTransactionTotalsByFractionV2Responses, MeGetUserTransactionTotalsByFractionV2Errors, ThrowOnError> => (options?.client ?? client).get<MeGetUserTransactionTotalsByFractionV2Responses, MeGetUserTransactionTotalsByFractionV2Errors, ThrowOnError>({ url: '/api/v2/me/reports/transaction-fraction-totals', ...options });

/**
 * Gets data for user's which fraction was used over period
 */
export const meGetUserTransactionFractionV2 = <ThrowOnError extends boolean = false>(options?: Options<MeGetUserTransactionFractionV2Data, ThrowOnError>): RequestResult<MeGetUserTransactionFractionV2Responses, MeGetUserTransactionFractionV2Errors, ThrowOnError> => (options?.client ?? client).get<MeGetUserTransactionFractionV2Responses, MeGetUserTransactionFractionV2Errors, ThrowOnError>({ url: '/api/v2/me/reports/transaction-fractions', ...options });

/**
 * Gets data for user's Transaction Totals broke down by smaller time interval
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code></p>
 */
export const meGetUserTransactionTotalsDetailedV2 = <ThrowOnError extends boolean = false>(options?: Options<MeGetUserTransactionTotalsDetailedV2Data, ThrowOnError>): RequestResult<MeGetUserTransactionTotalsDetailedV2Responses, MeGetUserTransactionTotalsDetailedV2Errors, ThrowOnError> => (options?.client ?? client).get<MeGetUserTransactionTotalsDetailedV2Responses, MeGetUserTransactionTotalsDetailedV2Errors, ThrowOnError>({ url: '/api/v2/me/reports/transaction-totals/detailed', ...options });

/**
 * Gets data for user's Transaction Totals broke down by fractions and then by smaller time interval
 *
 * <b>Deprecated</b>: Please use the `GET /api/v1/reports/transaction-totals/detailed` endpoint instead with fraction filter
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code></p>
 *
 * @deprecated
 */
export const meGetUserTransactionTotalsByFractionDetailedV2 = <ThrowOnError extends boolean = false>(options?: Options<MeGetUserTransactionTotalsByFractionDetailedV2Data, ThrowOnError>): RequestResult<MeGetUserTransactionTotalsByFractionDetailedV2Responses, MeGetUserTransactionTotalsByFractionDetailedV2Errors, ThrowOnError> => (options?.client ?? client).get<MeGetUserTransactionTotalsByFractionDetailedV2Responses, MeGetUserTransactionTotalsByFractionDetailedV2Errors, ThrowOnError>({ url: '/api/v2/me/reports/transaction-fraction-totals/detailed', ...options });

/**
 * Gets data for user's Transaction Totals by source
 *
 * <b>Deprecated</b>: Please use the `GET /api/v1/reports/transaction-totals` endpoint instead with source filter
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code></p>
 *
 * @deprecated
 */
export const meGetUserTransactionTotalsBySourceV2 = <ThrowOnError extends boolean = false>(options?: Options<MeGetUserTransactionTotalsBySourceV2Data, ThrowOnError>): RequestResult<MeGetUserTransactionTotalsBySourceV2Responses, MeGetUserTransactionTotalsBySourceV2Errors, ThrowOnError> => (options?.client ?? client).get<MeGetUserTransactionTotalsBySourceV2Responses, MeGetUserTransactionTotalsBySourceV2Errors, ThrowOnError>({ url: '/api/v2/me/reports/transaction-source-totals', ...options });

/**
 * Gets paged list of calling user's container transactions.
 *
 * Note the userId query parameter is meaningless in this call.<p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code></p>
 */
export const meGetTransactionsV2 = <ThrowOnError extends boolean = false>(options: Options<MeGetTransactionsV2Data, ThrowOnError>): RequestResult<MeGetTransactionsV2Responses, MeGetTransactionsV2Errors, ThrowOnError> => (options.client ?? client).get<MeGetTransactionsV2Responses, MeGetTransactionsV2Errors, ThrowOnError>({ url: '/api/v2/me/transactions', ...options });

/**
 * Gets protobuf messages for all containers accessible by user
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const meGetAllContainersDataV2V2 = <ThrowOnError extends boolean = false>(options?: Options<MeGetAllContainersDataV2V2Data, ThrowOnError>): RequestResult<MeGetAllContainersDataV2V2Responses, unknown, ThrowOnError> => (options?.client ?? client).get<MeGetAllContainersDataV2V2Responses, unknown, ThrowOnError>({ url: '/api/v2/me/containers/proto', ...options });

/**
 * Gets all protobuf messages for given container
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code> or <code>APP_SERVICE_USER</code> or <code>APP_SERVICE_RUNNER</code></p>
 */
export const meGetContainerDataV2V2 = <ThrowOnError extends boolean = false>(options: Options<MeGetContainerDataV2V2Data, ThrowOnError>): RequestResult<MeGetContainerDataV2V2Responses, MeGetContainerDataV2V2Errors, ThrowOnError> => (options.client ?? client).get<MeGetContainerDataV2V2Responses, MeGetContainerDataV2V2Errors, ThrowOnError>({ url: '/api/v2/me/containers/{containerId}/proto', ...options });

/**
 * Gets page of MIFARE Data Read Frames
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const mifareDataReadFrameGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<MifareDataReadFrameGetEntityPageData, ThrowOnError>): RequestResult<MifareDataReadFrameGetEntityPageResponses, MifareDataReadFrameGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<MifareDataReadFrameGetEntityPageResponses, MifareDataReadFrameGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/mifare-data-read-frame', ...options });

/**
 * Creates new MIFARE Data Read Frame
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const mifareDataReadFrameCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<MifareDataReadFrameCreateEntityData, ThrowOnError>): RequestResult<MifareDataReadFrameCreateEntityResponses, MifareDataReadFrameCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<MifareDataReadFrameCreateEntityResponses, MifareDataReadFrameCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/mifare-data-read-frame',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of MIFARE Data Read Frames
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const mifareDataReadFrameListEntities = <ThrowOnError extends boolean = false>(options?: Options<MifareDataReadFrameListEntitiesData, ThrowOnError>): RequestResult<MifareDataReadFrameListEntitiesResponses, MifareDataReadFrameListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<MifareDataReadFrameListEntitiesResponses, MifareDataReadFrameListEntitiesErrors, ThrowOnError>({ url: '/api/v1/mifare-data-read-frame/list', ...options });

/**
 * Deletes MIFARE Data Read Frame
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const mifareDataReadFrameDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<MifareDataReadFrameDeleteEntityData, ThrowOnError>): RequestResult<MifareDataReadFrameDeleteEntityResponses, MifareDataReadFrameDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<MifareDataReadFrameDeleteEntityResponses, MifareDataReadFrameDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/mifare-data-read-frame/{id}', ...options });

/**
 * Gets MIFARE Data Read Frame
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const mifareDataReadFrameGetEntity = <ThrowOnError extends boolean = false>(options: Options<MifareDataReadFrameGetEntityData, ThrowOnError>): RequestResult<MifareDataReadFrameGetEntityResponses, MifareDataReadFrameGetEntityErrors, ThrowOnError> => (options.client ?? client).get<MifareDataReadFrameGetEntityResponses, MifareDataReadFrameGetEntityErrors, ThrowOnError>({ url: '/api/v1/mifare-data-read-frame/{id}', ...options });

/**
 * Updates MIFARE Data Read Frame
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const mifareDataReadFrameUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<MifareDataReadFrameUpdateEntityData, ThrowOnError>): RequestResult<MifareDataReadFrameUpdateEntityResponses, MifareDataReadFrameUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<MifareDataReadFrameUpdateEntityResponses, MifareDataReadFrameUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/mifare-data-read-frame/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const mifareDataReadFrameIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<MifareDataReadFrameIsValueUsedData, ThrowOnError>): RequestResult<MifareDataReadFrameIsValueUsedResponses, MifareDataReadFrameIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<MifareDataReadFrameIsValueUsedResponses, MifareDataReadFrameIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/mifare-data-read-frame/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of NFC card blacklists
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_VIEW</code> or <code>REGION_CODE_ADMIN</code></p>
 */
export const nfcCardBlacklistsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<NfcCardBlacklistsGetEntityPageData, ThrowOnError>): RequestResult<NfcCardBlacklistsGetEntityPageResponses, NfcCardBlacklistsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<NfcCardBlacklistsGetEntityPageResponses, NfcCardBlacklistsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/nfc-card-blacklists', ...options });

/**
 * Creates new NFC card Blacklist
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const nfcCardBlacklistsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<NfcCardBlacklistsCreateEntityData, ThrowOnError>): RequestResult<NfcCardBlacklistsCreateEntityResponses, NfcCardBlacklistsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<NfcCardBlacklistsCreateEntityResponses, NfcCardBlacklistsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/nfc-card-blacklists',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of NFC card Blacklists
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_VIEW</code> or <code>REGION_CODE_ADMIN</code></p>
 */
export const nfcCardBlacklistsListEntities = <ThrowOnError extends boolean = false>(options?: Options<NfcCardBlacklistsListEntitiesData, ThrowOnError>): RequestResult<NfcCardBlacklistsListEntitiesResponses, NfcCardBlacklistsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<NfcCardBlacklistsListEntitiesResponses, NfcCardBlacklistsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/nfc-card-blacklists/list', ...options });

/**
 * Clears all cards from NFC card Blacklist
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const nfcCardBlacklistsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<NfcCardBlacklistsDeleteEntityData, ThrowOnError>): RequestResult<NfcCardBlacklistsDeleteEntityResponses, NfcCardBlacklistsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<NfcCardBlacklistsDeleteEntityResponses, NfcCardBlacklistsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/nfc-card-blacklists/{id}', ...options });

/**
 * Gets NFC card Blacklist
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_VIEW</code> or <code>REGION_CODE_ADMIN</code></p>
 */
export const nfcCardBlacklistsGetEntity = <ThrowOnError extends boolean = false>(options: Options<NfcCardBlacklistsGetEntityData, ThrowOnError>): RequestResult<NfcCardBlacklistsGetEntityResponses, NfcCardBlacklistsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<NfcCardBlacklistsGetEntityResponses, NfcCardBlacklistsGetEntityErrors, ThrowOnError>({ url: '/api/v1/nfc-card-blacklists/{id}', ...options });

/**
 * Updates NFC card Blacklist
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const nfcCardBlacklistsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<NfcCardBlacklistsUpdateEntityData, ThrowOnError>): RequestResult<NfcCardBlacklistsUpdateEntityResponses, NfcCardBlacklistsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<NfcCardBlacklistsUpdateEntityResponses, NfcCardBlacklistsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/nfc-card-blacklists/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const nfcCardBlacklistsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<NfcCardBlacklistsIsValueUsedData, ThrowOnError>): RequestResult<NfcCardBlacklistsIsValueUsedResponses, NfcCardBlacklistsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<NfcCardBlacklistsIsValueUsedResponses, NfcCardBlacklistsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/nfc-card-blacklists/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Adds card to blacklist, all large lists and all legacy blacklists for given customer.
 *
 * Request NoDestroy works only when customer has only ACU devices.
 * Digis a legacy controllers always destroy the card.<p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const nfcCardBlacklistsAddCard = <ThrowOnError extends boolean = false>(options: Options<NfcCardBlacklistsAddCardData, ThrowOnError>): RequestResult<NfcCardBlacklistsAddCardResponses, NfcCardBlacklistsAddCardErrors, ThrowOnError> => (options.client ?? client).post<NfcCardBlacklistsAddCardResponses, NfcCardBlacklistsAddCardErrors, ThrowOnError>({
    url: '/api/v1/nfc-card-blacklists/{customerId}/add',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Removes card from blacklist
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const nfcCardBlacklistsRemoveCard = <ThrowOnError extends boolean = false>(options: Options<NfcCardBlacklistsRemoveCardData, ThrowOnError>): RequestResult<NfcCardBlacklistsRemoveCardResponses, NfcCardBlacklistsRemoveCardErrors, ThrowOnError> => (options.client ?? client).post<NfcCardBlacklistsRemoveCardResponses, NfcCardBlacklistsRemoveCardErrors, ThrowOnError>({
    url: '/api/v1/nfc-card-blacklists/{customerId}/remove',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets page of NfcCardConfigurationGroups
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const nfcCardConfigurationGroupsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<NfcCardConfigurationGroupsGetEntityPageData, ThrowOnError>): RequestResult<NfcCardConfigurationGroupsGetEntityPageResponses, NfcCardConfigurationGroupsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<NfcCardConfigurationGroupsGetEntityPageResponses, NfcCardConfigurationGroupsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/nfc-card-configuration-groups', ...options });

/**
 * Creates new NfcCardConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const nfcCardConfigurationGroupsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<NfcCardConfigurationGroupsCreateEntityData, ThrowOnError>): RequestResult<NfcCardConfigurationGroupsCreateEntityResponses, NfcCardConfigurationGroupsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<NfcCardConfigurationGroupsCreateEntityResponses, NfcCardConfigurationGroupsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/nfc-card-configuration-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of NfcCardConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const nfcCardConfigurationGroupsListEntities = <ThrowOnError extends boolean = false>(options?: Options<NfcCardConfigurationGroupsListEntitiesData, ThrowOnError>): RequestResult<NfcCardConfigurationGroupsListEntitiesResponses, NfcCardConfigurationGroupsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<NfcCardConfigurationGroupsListEntitiesResponses, NfcCardConfigurationGroupsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/nfc-card-configuration-groups/list', ...options });

/**
 * Delete NfcCardConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const nfcCardConfigurationGroupsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<NfcCardConfigurationGroupsDeleteEntityData, ThrowOnError>): RequestResult<NfcCardConfigurationGroupsDeleteEntityResponses, NfcCardConfigurationGroupsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<NfcCardConfigurationGroupsDeleteEntityResponses, NfcCardConfigurationGroupsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/nfc-card-configuration-groups/{id}', ...options });

/**
 * Gets NfcCardConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const nfcCardConfigurationGroupsGetEntity = <ThrowOnError extends boolean = false>(options: Options<NfcCardConfigurationGroupsGetEntityData, ThrowOnError>): RequestResult<NfcCardConfigurationGroupsGetEntityResponses, NfcCardConfigurationGroupsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<NfcCardConfigurationGroupsGetEntityResponses, NfcCardConfigurationGroupsGetEntityErrors, ThrowOnError>({ url: '/api/v1/nfc-card-configuration-groups/{id}', ...options });

/**
 * Updates NfcCardConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const nfcCardConfigurationGroupsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<NfcCardConfigurationGroupsUpdateEntityData, ThrowOnError>): RequestResult<NfcCardConfigurationGroupsUpdateEntityResponses, NfcCardConfigurationGroupsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<NfcCardConfigurationGroupsUpdateEntityResponses, NfcCardConfigurationGroupsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/nfc-card-configuration-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update nfc card group
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const nfcCardConfigurationGroupsUpdateContainersGroup = <ThrowOnError extends boolean = false>(options: Options<NfcCardConfigurationGroupsUpdateContainersGroupData, ThrowOnError>): RequestResult<NfcCardConfigurationGroupsUpdateContainersGroupResponses, NfcCardConfigurationGroupsUpdateContainersGroupErrors, ThrowOnError> => (options.client ?? client).put<NfcCardConfigurationGroupsUpdateContainersGroupResponses, NfcCardConfigurationGroupsUpdateContainersGroupErrors, ThrowOnError>({
    url: '/api/v1/nfc-card-configuration-groups/{id}/containers/partial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const nfcCardConfigurationGroupsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<NfcCardConfigurationGroupsIsValueUsedData, ThrowOnError>): RequestResult<NfcCardConfigurationGroupsIsValueUsedResponses, NfcCardConfigurationGroupsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<NfcCardConfigurationGroupsIsValueUsedResponses, NfcCardConfigurationGroupsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/nfc-card-configuration-groups/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Lists active containers not assigned to this nfc card,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const nfcCardConfigurationGroupsListAvailableContainers = <ThrowOnError extends boolean = false>(options: Options<NfcCardConfigurationGroupsListAvailableContainersData, ThrowOnError>): RequestResult<NfcCardConfigurationGroupsListAvailableContainersResponses, NfcCardConfigurationGroupsListAvailableContainersErrors, ThrowOnError> => (options.client ?? client).get<NfcCardConfigurationGroupsListAvailableContainersResponses, NfcCardConfigurationGroupsListAvailableContainersErrors, ThrowOnError>({ url: '/api/v1/nfc-card-configuration-groups/{id}/containers/available', ...options });

/**
 * Lists active containers assigned to this nfc card,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const nfcCardConfigurationGroupsListContainers = <ThrowOnError extends boolean = false>(options: Options<NfcCardConfigurationGroupsListContainersData, ThrowOnError>): RequestResult<NfcCardConfigurationGroupsListContainersResponses, NfcCardConfigurationGroupsListContainersErrors, ThrowOnError> => (options.client ?? client).get<NfcCardConfigurationGroupsListContainersResponses, NfcCardConfigurationGroupsListContainersErrors, ThrowOnError>({ url: '/api/v1/nfc-card-configuration-groups/{id}/containers', ...options });

/**
 * Gets paged list of containers eligible for Nfc Card Group
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const nfcCardConfigurationGroupsListEligible = <ThrowOnError extends boolean = false>(options: Options<NfcCardConfigurationGroupsListEligibleData, ThrowOnError>): RequestResult<NfcCardConfigurationGroupsListEligibleResponses, unknown, ThrowOnError> => (options.client ?? client).get<NfcCardConfigurationGroupsListEligibleResponses, unknown, ThrowOnError>({ url: '/api/v1/nfc-card-configuration-groups/eligible-containers', ...options });

/**
 * Gets page of NFC cards
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_VIEW</code> or <code>CONTRACT_ADMIN</code></p>
 */
export const nfcCardsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<NfcCardsGetEntityPageData, ThrowOnError>): RequestResult<NfcCardsGetEntityPageResponses, NfcCardsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<NfcCardsGetEntityPageResponses, NfcCardsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/nfc-cards', ...options });

/**
 * Creates new NFC card
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const nfcCardsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<NfcCardsCreateEntityData, ThrowOnError>): RequestResult<NfcCardsCreateEntityResponses, NfcCardsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<NfcCardsCreateEntityResponses, NfcCardsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/nfc-cards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of NFC cards
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_VIEW</code> or <code>CONTRACT_ADMIN</code></p>
 */
export const nfcCardsListEntities = <ThrowOnError extends boolean = false>(options?: Options<NfcCardsListEntitiesData, ThrowOnError>): RequestResult<NfcCardsListEntitiesResponses, NfcCardsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<NfcCardsListEntitiesResponses, NfcCardsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/nfc-cards/list', ...options });

/**
 * Gets NFC card
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_VIEW</code> or <code>CONTRACT_ADMIN</code></p>
 */
export const nfcCardsGetEntity = <ThrowOnError extends boolean = false>(options: Options<NfcCardsGetEntityData, ThrowOnError>): RequestResult<NfcCardsGetEntityResponses, NfcCardsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<NfcCardsGetEntityResponses, NfcCardsGetEntityErrors, ThrowOnError>({ url: '/api/v1/nfc-cards/{id}', ...options });

/**
 * Updates NFC card code
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const nfcCardsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<NfcCardsUpdateEntityData, ThrowOnError>): RequestResult<NfcCardsUpdateEntityResponses, NfcCardsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<NfcCardsUpdateEntityResponses, NfcCardsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/nfc-cards/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activates NFC card.
 *
 * Only deleted cards can be activated.
 * Blacklisted cards must be removed from the blacklist.<p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const nfcCardsActivateEntity = <ThrowOnError extends boolean = false>(options: Options<NfcCardsActivateEntityData, ThrowOnError>): RequestResult<NfcCardsActivateEntityResponses, NfcCardsActivateEntityErrors, ThrowOnError> => (options.client ?? client).put<NfcCardsActivateEntityResponses, NfcCardsActivateEntityErrors, ThrowOnError>({ url: '/api/v1/nfc-cards/{id}/activate', ...options });

/**
 * Gets blacklist options for the card
 *
 * Only deleted cards can be activated.
 * Blacklisted cards must be removed from the blacklist.<p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code> or <code>REGION_CODE_ADMIN</code></p>
 */
export const nfcCardsGetBlacklistOptions = <ThrowOnError extends boolean = false>(options: Options<NfcCardsGetBlacklistOptionsData, ThrowOnError>): RequestResult<NfcCardsGetBlacklistOptionsResponses, NfcCardsGetBlacklistOptionsErrors, ThrowOnError> => (options.client ?? client).get<NfcCardsGetBlacklistOptionsResponses, NfcCardsGetBlacklistOptionsErrors, ThrowOnError>({ url: '/api/v1/nfc-cards/{id}/blacklist-options', ...options });

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>CONTRACT_ADMIN</code></p>
 */
export const nfcCardsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<NfcCardsIsValueUsedData, ThrowOnError>): RequestResult<NfcCardsIsValueUsedResponses, NfcCardsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<NfcCardsIsValueUsedResponses, NfcCardsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/nfc-cards/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Exports NFC cards.
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>CONTRACT_VIEW</code> or <code>CONTRACT_ADMIN</code></p>
 */
export const nfcCardsExportList = <ThrowOnError extends boolean = false>(options: Options<NfcCardsExportListData, ThrowOnError>): RequestResult<NfcCardsExportListResponses, NfcCardsExportListErrors, ThrowOnError> => (options.client ?? client).get<NfcCardsExportListResponses, NfcCardsExportListErrors, ThrowOnError>({ url: '/api/v1/nfc-cards/export.{format}', ...options });

/**
 * Gets list of all known card reader types
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const nfcCardsListCardTypes = <ThrowOnError extends boolean = false>(options?: Options<NfcCardsListCardTypesData, ThrowOnError>): RequestResult<NfcCardsListCardTypesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<NfcCardsListCardTypesResponses, unknown, ThrowOnError>({ url: '/api/v1/nfc-cards/types', ...options });

/**
 * Gets list of all known card reader types
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const nfcCardsListCardReaderTypes = <ThrowOnError extends boolean = false>(options?: Options<NfcCardsListCardReaderTypesData, ThrowOnError>): RequestResult<NfcCardsListCardReaderTypesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<NfcCardsListCardReaderTypesResponses, unknown, ThrowOnError>({ url: '/api/v1/nfc-cards/reader-types', ...options });

/**
 * Gets list of all known card reader types
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const nfcCardsListCardAuthenticationTypes = <ThrowOnError extends boolean = false>(options?: Options<NfcCardsListCardAuthenticationTypesData, ThrowOnError>): RequestResult<NfcCardsListCardAuthenticationTypesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<NfcCardsListCardAuthenticationTypesResponses, unknown, ThrowOnError>({ url: '/api/v1/nfc-cards/authentication-types', ...options });

/**
 * Generates new BLE keys for given customer
 *
 * <p><strong>Required Roles</strong>: <code>BLE_KEY_GENERATOR</code></p>
 */
export const nfcCardsGenerateBleKeys = <ThrowOnError extends boolean = false>(options?: Options<NfcCardsGenerateBleKeysData, ThrowOnError>): RequestResult<NfcCardsGenerateBleKeysResponses, NfcCardsGenerateBleKeysErrors, ThrowOnError> => (options?.client ?? client).post<NfcCardsGenerateBleKeysResponses, NfcCardsGenerateBleKeysErrors, ThrowOnError>({
    url: '/api/v1/nfc-cards/generate-ble-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Deletes notification setting
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const notificationSettingsDeleteNotificationSetting = <ThrowOnError extends boolean = false>(options: Options<NotificationSettingsDeleteNotificationSettingData, ThrowOnError>): RequestResult<NotificationSettingsDeleteNotificationSettingResponses, NotificationSettingsDeleteNotificationSettingErrors, ThrowOnError> => (options.client ?? client).delete<NotificationSettingsDeleteNotificationSettingResponses, NotificationSettingsDeleteNotificationSettingErrors, ThrowOnError>({ url: '/api/v1/notification-settings/{id}', ...options });

/**
 * Gets specific notification setting
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const notificationSettingsGetNotificationSetting = <ThrowOnError extends boolean = false>(options: Options<NotificationSettingsGetNotificationSettingData, ThrowOnError>): RequestResult<NotificationSettingsGetNotificationSettingResponses, NotificationSettingsGetNotificationSettingErrors, ThrowOnError> => (options.client ?? client).get<NotificationSettingsGetNotificationSettingResponses, NotificationSettingsGetNotificationSettingErrors, ThrowOnError>({ url: '/api/v1/notification-settings/{id}', ...options });

/**
 * Update notification setting
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const notificationSettingsUpdateNotificationSetting = <ThrowOnError extends boolean = false>(options: Options<NotificationSettingsUpdateNotificationSettingData, ThrowOnError>): RequestResult<NotificationSettingsUpdateNotificationSettingResponses, NotificationSettingsUpdateNotificationSettingErrors, ThrowOnError> => (options.client ?? client).put<NotificationSettingsUpdateNotificationSettingResponses, NotificationSettingsUpdateNotificationSettingErrors, ThrowOnError>({
    url: '/api/v1/notification-settings/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creates new notification setting
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const notificationSettingsCreateNotificationSetting = <ThrowOnError extends boolean = false>(options?: Options<NotificationSettingsCreateNotificationSettingData, ThrowOnError>): RequestResult<NotificationSettingsCreateNotificationSettingResponses, NotificationSettingsCreateNotificationSettingErrors, ThrowOnError> => (options?.client ?? client).post<NotificationSettingsCreateNotificationSettingResponses, NotificationSettingsCreateNotificationSettingErrors, ThrowOnError>({
    url: '/api/v1/notification-settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get list of permission groups
 *
 * <p><strong>Required Roles</strong>: <code>PERMISSION_GROUP_VIEW</code> or <code>PERMISSION_GROUP_ADMIN</code></p>
 */
export const permissionGroupsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<PermissionGroupsGetEntityPageData, ThrowOnError>): RequestResult<PermissionGroupsGetEntityPageResponses, PermissionGroupsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<PermissionGroupsGetEntityPageResponses, PermissionGroupsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/permission-groups', ...options });

/**
 * Creates new security role
 *
 * <p><strong>Required Roles</strong>: <code>PERMISSION_GROUP_ADMIN</code></p>
 */
export const permissionGroupsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<PermissionGroupsCreateEntityData, ThrowOnError>): RequestResult<PermissionGroupsCreateEntityResponses, PermissionGroupsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<PermissionGroupsCreateEntityResponses, PermissionGroupsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/permission-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of permission groups
 *
 * <p><strong>Required Roles</strong>: <code>PERMISSION_GROUP_VIEW</code> or <code>PERMISSION_GROUP_ADMIN</code></p>
 */
export const permissionGroupsListEntities = <ThrowOnError extends boolean = false>(options?: Options<PermissionGroupsListEntitiesData, ThrowOnError>): RequestResult<PermissionGroupsListEntitiesResponses, PermissionGroupsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<PermissionGroupsListEntitiesResponses, PermissionGroupsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/permission-groups/list', ...options });

/**
 * Deletes permission group
 *
 * <p><strong>Required Roles</strong>: <code>PERMISSION_GROUP_ADMIN</code></p>
 */
export const permissionGroupsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<PermissionGroupsDeleteEntityData, ThrowOnError>): RequestResult<PermissionGroupsDeleteEntityResponses, PermissionGroupsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<PermissionGroupsDeleteEntityResponses, PermissionGroupsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/permission-groups/{id}', ...options });

/**
 * Gets permission group with given Id
 *
 * <p><strong>Required Roles</strong>: <code>PERMISSION_GROUP_VIEW</code> or <code>PERMISSION_GROUP_ADMIN</code></p>
 */
export const permissionGroupsGetEntity = <ThrowOnError extends boolean = false>(options: Options<PermissionGroupsGetEntityData, ThrowOnError>): RequestResult<PermissionGroupsGetEntityResponses, PermissionGroupsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<PermissionGroupsGetEntityResponses, PermissionGroupsGetEntityErrors, ThrowOnError>({ url: '/api/v1/permission-groups/{id}', ...options });

/**
 * Updates permission group given by Id
 *
 * <p><strong>Required Roles</strong>: <code>PERMISSION_GROUP_ADMIN</code></p>
 */
export const permissionGroupsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<PermissionGroupsUpdateEntityData, ThrowOnError>): RequestResult<PermissionGroupsUpdateEntityResponses, PermissionGroupsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<PermissionGroupsUpdateEntityResponses, PermissionGroupsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/permission-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>PERMISSION_GROUP_ADMIN</code></p>
 */
export const permissionGroupsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<PermissionGroupsIsValueUsedData, ThrowOnError>): RequestResult<PermissionGroupsIsValueUsedResponses, PermissionGroupsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<PermissionGroupsIsValueUsedResponses, PermissionGroupsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/permission-groups/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets extended list of permission groups by IDS
 *
 * <p><strong>Required Roles</strong>: <code>USER_VIEW</code> or <code>USER_ADMIN</code></p>
 */
export const permissionGroupsGetEffectiveRolesByGroupIds = <ThrowOnError extends boolean = false>(options: Options<PermissionGroupsGetEffectiveRolesByGroupIdsData, ThrowOnError>): RequestResult<PermissionGroupsGetEffectiveRolesByGroupIdsResponses, unknown, ThrowOnError> => (options.client ?? client).get<PermissionGroupsGetEffectiveRolesByGroupIdsResponses, unknown, ThrowOnError>({ url: '/api/v1/permission-groups/effective-roles', ...options });

/**
 * Gets page of Products
 *
 * <p><strong>Required Roles</strong>: <code>PRODUCT_VIEW</code> or <code>PRODUCT_ADMIN</code></p>
 */
export const productsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<ProductsGetEntityPageData, ThrowOnError>): RequestResult<ProductsGetEntityPageResponses, ProductsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<ProductsGetEntityPageResponses, ProductsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/products', ...options });

/**
 * Creates new Product
 *
 * <p><strong>Required Roles</strong>: <code>PRODUCT_ADMIN</code></p>
 */
export const productsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<ProductsCreateEntityData, ThrowOnError>): RequestResult<ProductsCreateEntityResponses, ProductsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<ProductsCreateEntityResponses, ProductsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of Products
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>PRODUCT_VIEW</code> or <code>PRODUCT_ADMIN</code></p>
 */
export const productsListEntities = <ThrowOnError extends boolean = false>(options?: Options<ProductsListEntitiesData, ThrowOnError>): RequestResult<ProductsListEntitiesResponses, ProductsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<ProductsListEntitiesResponses, ProductsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/products/list', ...options });

/**
 * Deletes product
 *
 * <p><strong>Required Roles</strong>: <code>PRODUCT_ADMIN</code></p>
 */
export const productsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<ProductsDeleteEntityData, ThrowOnError>): RequestResult<ProductsDeleteEntityResponses, ProductsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<ProductsDeleteEntityResponses, ProductsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/products/{id}', ...options });

/**
 * Gets Product
 *
 * <p><strong>Required Roles</strong>: <code>PRODUCT_VIEW</code> or <code>PRODUCT_ADMIN</code></p>
 */
export const productsGetEntity = <ThrowOnError extends boolean = false>(options: Options<ProductsGetEntityData, ThrowOnError>): RequestResult<ProductsGetEntityResponses, ProductsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<ProductsGetEntityResponses, ProductsGetEntityErrors, ThrowOnError>({ url: '/api/v1/products/{id}', ...options });

/**
 * Updates product
 *
 * <p><strong>Required Roles</strong>: <code>PRODUCT_ADMIN</code></p>
 */
export const productsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<ProductsUpdateEntityData, ThrowOnError>): RequestResult<ProductsUpdateEntityResponses, ProductsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<ProductsUpdateEntityResponses, ProductsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/products/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets Product by part number
 *
 * <p><strong>Required Roles</strong>: <code>PRODUCT_VIEW</code> or <code>PRODUCT_ADMIN</code></p>
 */
export const productsGetByPartNumber = <ThrowOnError extends boolean = false>(options: Options<ProductsGetByPartNumberData, ThrowOnError>): RequestResult<ProductsGetByPartNumberResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProductsGetByPartNumberResponses, unknown, ThrowOnError>({ url: '/api/v1/products/by-part/{partNumber}', ...options });

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>PRODUCT_ADMIN</code></p>
 */
export const productsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<ProductsIsValueUsedData, ThrowOnError>): RequestResult<ProductsIsValueUsedResponses, ProductsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<ProductsIsValueUsedResponses, ProductsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/products/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of region codes
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>REGION_CODE_VIEW</code> or <code>REGION_CODE_ADMIN</code></p>
 */
export const regionCodesGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<RegionCodesGetEntityPageData, ThrowOnError>): RequestResult<RegionCodesGetEntityPageResponses, RegionCodesGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<RegionCodesGetEntityPageResponses, RegionCodesGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/region-codes', ...options });

/**
 * Creates new region code
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const regionCodesCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<RegionCodesCreateEntityData, ThrowOnError>): RequestResult<RegionCodesCreateEntityResponses, RegionCodesCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<RegionCodesCreateEntityResponses, RegionCodesCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/region-codes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of region codes
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>REGION_CODE_VIEW</code> or <code>REGION_CODE_ADMIN</code></p>
 */
export const regionCodesListEntities = <ThrowOnError extends boolean = false>(options?: Options<RegionCodesListEntitiesData, ThrowOnError>): RequestResult<RegionCodesListEntitiesResponses, RegionCodesListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<RegionCodesListEntitiesResponses, RegionCodesListEntitiesErrors, ThrowOnError>({ url: '/api/v1/region-codes/list', ...options });

/**
 * Deletes region code
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const regionCodesDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<RegionCodesDeleteEntityData, ThrowOnError>): RequestResult<RegionCodesDeleteEntityResponses, RegionCodesDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<RegionCodesDeleteEntityResponses, RegionCodesDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/region-codes/{id}', ...options });

/**
 * Gets region code
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>REGION_CODE_VIEW</code> or <code>REGION_CODE_ADMIN</code></p>
 */
export const regionCodesGetEntity = <ThrowOnError extends boolean = false>(options: Options<RegionCodesGetEntityData, ThrowOnError>): RequestResult<RegionCodesGetEntityResponses, RegionCodesGetEntityErrors, ThrowOnError> => (options.client ?? client).get<RegionCodesGetEntityResponses, RegionCodesGetEntityErrors, ThrowOnError>({ url: '/api/v1/region-codes/{id}', ...options });

/**
 * Updates region code
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const regionCodesUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<RegionCodesUpdateEntityData, ThrowOnError>): RequestResult<RegionCodesUpdateEntityResponses, RegionCodesUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<RegionCodesUpdateEntityResponses, RegionCodesUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/region-codes/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const regionCodesIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<RegionCodesIsValueUsedData, ThrowOnError>): RequestResult<RegionCodesIsValueUsedResponses, RegionCodesIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<RegionCodesIsValueUsedResponses, RegionCodesIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/region-codes/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Exports Region Codes.
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>REGION_CODE_VIEW</code> or <code>REGION_CODE_ADMIN</code></p>
 */
export const regionCodesExportList = <ThrowOnError extends boolean = false>(options: Options<RegionCodesExportListData, ThrowOnError>): RequestResult<RegionCodesExportListResponses, RegionCodesExportListErrors, ThrowOnError> => (options.client ?? client).get<RegionCodesExportListResponses, RegionCodesExportListErrors, ThrowOnError>({ url: '/api/v1/region-codes/export.{format}', ...options });

/**
 * Gets page of RegionCodesConfigurationGroups
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const regionCodesConfigurationGroupsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<RegionCodesConfigurationGroupsGetEntityPageData, ThrowOnError>): RequestResult<RegionCodesConfigurationGroupsGetEntityPageResponses, RegionCodesConfigurationGroupsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<RegionCodesConfigurationGroupsGetEntityPageResponses, RegionCodesConfigurationGroupsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/region-codes-configuration-groups', ...options });

/**
 * Creates new RegionCodesConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const regionCodesConfigurationGroupsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<RegionCodesConfigurationGroupsCreateEntityData, ThrowOnError>): RequestResult<RegionCodesConfigurationGroupsCreateEntityResponses, RegionCodesConfigurationGroupsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<RegionCodesConfigurationGroupsCreateEntityResponses, RegionCodesConfigurationGroupsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/region-codes-configuration-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of RegionCodesConfigurationGroups
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const regionCodesConfigurationGroupsListEntities = <ThrowOnError extends boolean = false>(options?: Options<RegionCodesConfigurationGroupsListEntitiesData, ThrowOnError>): RequestResult<RegionCodesConfigurationGroupsListEntitiesResponses, RegionCodesConfigurationGroupsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<RegionCodesConfigurationGroupsListEntitiesResponses, RegionCodesConfigurationGroupsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/region-codes-configuration-groups/list', ...options });

/**
 * Delete RegionCodesConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const regionCodesConfigurationGroupsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<RegionCodesConfigurationGroupsDeleteEntityData, ThrowOnError>): RequestResult<RegionCodesConfigurationGroupsDeleteEntityResponses, RegionCodesConfigurationGroupsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<RegionCodesConfigurationGroupsDeleteEntityResponses, RegionCodesConfigurationGroupsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/region-codes-configuration-groups/{id}', ...options });

/**
 * Gets RegionCodesConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const regionCodesConfigurationGroupsGetEntity = <ThrowOnError extends boolean = false>(options: Options<RegionCodesConfigurationGroupsGetEntityData, ThrowOnError>): RequestResult<RegionCodesConfigurationGroupsGetEntityResponses, RegionCodesConfigurationGroupsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<RegionCodesConfigurationGroupsGetEntityResponses, RegionCodesConfigurationGroupsGetEntityErrors, ThrowOnError>({ url: '/api/v1/region-codes-configuration-groups/{id}', ...options });

/**
 * Updates RegionCodesConfigurationGroup
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const regionCodesConfigurationGroupsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<RegionCodesConfigurationGroupsUpdateEntityData, ThrowOnError>): RequestResult<RegionCodesConfigurationGroupsUpdateEntityResponses, RegionCodesConfigurationGroupsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<RegionCodesConfigurationGroupsUpdateEntityResponses, RegionCodesConfigurationGroupsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/region-codes-configuration-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update assigned containers to region code group
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const regionCodesConfigurationGroupsUpdateContainersGroup = <ThrowOnError extends boolean = false>(options: Options<RegionCodesConfigurationGroupsUpdateContainersGroupData, ThrowOnError>): RequestResult<RegionCodesConfigurationGroupsUpdateContainersGroupResponses, RegionCodesConfigurationGroupsUpdateContainersGroupErrors, ThrowOnError> => (options.client ?? client).put<RegionCodesConfigurationGroupsUpdateContainersGroupResponses, RegionCodesConfigurationGroupsUpdateContainersGroupErrors, ThrowOnError>({
    url: '/api/v1/region-codes-configuration-groups/{id}/containers/partial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists active containers not assigned to this region code,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const regionCodesConfigurationGroupsListAvailableContainers = <ThrowOnError extends boolean = false>(options: Options<RegionCodesConfigurationGroupsListAvailableContainersData, ThrowOnError>): RequestResult<RegionCodesConfigurationGroupsListAvailableContainersResponses, RegionCodesConfigurationGroupsListAvailableContainersErrors, ThrowOnError> => (options.client ?? client).get<RegionCodesConfigurationGroupsListAvailableContainersResponses, RegionCodesConfigurationGroupsListAvailableContainersErrors, ThrowOnError>({ url: '/api/v1/region-codes-configuration-groups/{id}/containers/available', ...options });

/**
 * Lists active containers assigned to this region code,
 * ordered by name
 *
 * <p><strong>Required Roles</strong>: <code>REGION_CODE_ADMIN</code></p>
 */
export const regionCodesConfigurationGroupsListContainers = <ThrowOnError extends boolean = false>(options: Options<RegionCodesConfigurationGroupsListContainersData, ThrowOnError>): RequestResult<RegionCodesConfigurationGroupsListContainersResponses, RegionCodesConfigurationGroupsListContainersErrors, ThrowOnError> => (options.client ?? client).get<RegionCodesConfigurationGroupsListContainersResponses, RegionCodesConfigurationGroupsListContainersErrors, ThrowOnError>({ url: '/api/v1/region-codes-configuration-groups/{id}/containers', ...options });

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const regionCodesConfigurationGroupsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<RegionCodesConfigurationGroupsIsValueUsedData, ThrowOnError>): RequestResult<RegionCodesConfigurationGroupsIsValueUsedResponses, RegionCodesConfigurationGroupsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<RegionCodesConfigurationGroupsIsValueUsedResponses, RegionCodesConfigurationGroupsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/region-codes-configuration-groups/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of reports
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const reportsGetReportsPage = <ThrowOnError extends boolean = false>(options?: Options<ReportsGetReportsPageData, ThrowOnError>): RequestResult<ReportsGetReportsPageResponses, ReportsGetReportsPageErrors, ThrowOnError> => (options?.client ?? client).get<ReportsGetReportsPageResponses, ReportsGetReportsPageErrors, ThrowOnError>({ url: '/api/v1/reports', ...options });

/**
 * Deletes Report
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const reportsDeleteReport = <ThrowOnError extends boolean = false>(options: Options<ReportsDeleteReportData, ThrowOnError>): RequestResult<ReportsDeleteReportResponses, ReportsDeleteReportErrors, ThrowOnError> => (options.client ?? client).delete<ReportsDeleteReportResponses, ReportsDeleteReportErrors, ThrowOnError>({ url: '/api/v1/reports/{id}', ...options });

/**
 * Gets single report
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const reportsGetReportConfiguration = <ThrowOnError extends boolean = false>(options: Options<ReportsGetReportConfigurationData, ThrowOnError>): RequestResult<ReportsGetReportConfigurationResponses, unknown, ThrowOnError> => (options.client ?? client).get<ReportsGetReportConfigurationResponses, unknown, ThrowOnError>({ url: '/api/v1/reports/{id}', ...options });

/**
 * Creates new emptying tasks list report configuration
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const reportsCreateTaskListReport = <ThrowOnError extends boolean = false>(options: Options<ReportsCreateTaskListReportData, ThrowOnError>): RequestResult<ReportsCreateTaskListReportResponses, ReportsCreateTaskListReportErrors, ThrowOnError> => (options.client ?? client).post<ReportsCreateTaskListReportResponses, ReportsCreateTaskListReportErrors, ThrowOnError>({
    url: '/api/v1/reports/emptying-task-list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates existing emptying tasks list report configuration
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const reportsUpdateTaskListReport = <ThrowOnError extends boolean = false>(options: Options<ReportsUpdateTaskListReportData, ThrowOnError>): RequestResult<ReportsUpdateTaskListReportResponses, ReportsUpdateTaskListReportErrors, ThrowOnError> => (options.client ?? client).put<ReportsUpdateTaskListReportResponses, ReportsUpdateTaskListReportErrors, ThrowOnError>({
    url: '/api/v1/reports/emptying-task-list/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Runs report immediately
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const reportsRunTaskListReport = <ThrowOnError extends boolean = false>(options: Options<ReportsRunTaskListReportData, ThrowOnError>): RequestResult<ReportsRunTaskListReportResponses, ReportsRunTaskListReportErrors, ThrowOnError> => (options.client ?? client).get<ReportsRunTaskListReportResponses, ReportsRunTaskListReportErrors, ThrowOnError>({ url: '/api/v1/reports/run/{id}', ...options });

/**
 * Gets data for Transactions Daily Count Report
 *
 * <p><strong>Required Roles</strong>: <code>TRANSACTION_VIEW</code></p>
 */
export const reportsGetTransactionsDailyCountReport = <ThrowOnError extends boolean = false>(options: Options<ReportsGetTransactionsDailyCountReportData, ThrowOnError>): RequestResult<ReportsGetTransactionsDailyCountReportResponses, ReportsGetTransactionsDailyCountReportErrors, ThrowOnError> => (options.client ?? client).get<ReportsGetTransactionsDailyCountReportResponses, ReportsGetTransactionsDailyCountReportErrors, ThrowOnError>({ url: '/api/v1/reports/transactions-daily-count', ...options });

/**
 * Gets data for Issue Reports Daily Count Report
 *
 * <p><strong>Required Roles</strong>: <code>ISSUE_VIEW</code> or <code>ISSUE_ADMIN</code></p>
 */
export const reportsGetIssueReportsDailyCountReport = <ThrowOnError extends boolean = false>(options: Options<ReportsGetIssueReportsDailyCountReportData, ThrowOnError>): RequestResult<ReportsGetIssueReportsDailyCountReportResponses, ReportsGetIssueReportsDailyCountReportErrors, ThrowOnError> => (options.client ?? client).get<ReportsGetIssueReportsDailyCountReportResponses, ReportsGetIssueReportsDailyCountReportErrors, ThrowOnError>({ url: '/api/v1/reports/issue-reports-daily-count', ...options });

/**
 * Gets data about battery life
 *
 * <b>Deprecated</b>: Please use the `GET /api/v1/reports/battery-life-paged` endpoint instead
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>APP_SERVICE_USER</code></p>
 *
 * @deprecated
 */
export const reportsGetBatteryLifeReport = <ThrowOnError extends boolean = false>(options?: Options<ReportsGetBatteryLifeReportData, ThrowOnError>): RequestResult<ReportsGetBatteryLifeReportResponses, ReportsGetBatteryLifeReportErrors, ThrowOnError> => (options?.client ?? client).get<ReportsGetBatteryLifeReportResponses, ReportsGetBatteryLifeReportErrors, ThrowOnError>({ url: '/api/v1/reports/battery-life', ...options });

/**
 * Gets data about battery life, paged
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>APP_SERVICE_USER</code></p>
 */
export const reportsGetPagedBatteryLifeReport = <ThrowOnError extends boolean = false>(options?: Options<ReportsGetPagedBatteryLifeReportData, ThrowOnError>): RequestResult<ReportsGetPagedBatteryLifeReportResponses, ReportsGetPagedBatteryLifeReportErrors, ThrowOnError> => (options?.client ?? client).get<ReportsGetPagedBatteryLifeReportResponses, ReportsGetPagedBatteryLifeReportErrors, ThrowOnError>({ url: '/api/v1/reports/battery-life-paged', ...options });

/**
 * Exports container for battery life report
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const reportsExportList = <ThrowOnError extends boolean = false>(options: Options<ReportsExportListData, ThrowOnError>): RequestResult<ReportsExportListResponses, ReportsExportListErrors, ThrowOnError> => (options.client ?? client).get<ReportsExportListResponses, ReportsExportListErrors, ThrowOnError>({ url: '/api/v1/reports/battery-life/export.{format}', ...options });

/**
 * Gets data about last connections to/from devices
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>APP_SERVICE_USER</code></p>
 */
export const reportsGetLastCommunicationReport = <ThrowOnError extends boolean = false>(options?: Options<ReportsGetLastCommunicationReportData, ThrowOnError>): RequestResult<ReportsGetLastCommunicationReportResponses, ReportsGetLastCommunicationReportErrors, ThrowOnError> => (options?.client ?? client).get<ReportsGetLastCommunicationReportResponses, ReportsGetLastCommunicationReportErrors, ThrowOnError>({ url: '/api/v1/reports/last-communication', ...options });

/**
 * Exports data about last connections to/from devices.
 * Exports max 100,000 records
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>APP_SERVICE_USER</code></p>
 */
export const reportsExportLastCommunicationReport = <ThrowOnError extends boolean = false>(options: Options<ReportsExportLastCommunicationReportData, ThrowOnError>): RequestResult<ReportsExportLastCommunicationReportResponses, ReportsExportLastCommunicationReportErrors, ThrowOnError> => (options.client ?? client).get<ReportsExportLastCommunicationReportResponses, ReportsExportLastCommunicationReportErrors, ThrowOnError>({ url: '/api/v1/reports/last-communication.{format}', ...options });

/**
 * Gets data about last connections to/from fill level sensors
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>APP_SERVICE_USER</code></p>
 */
export const reportsGetLastCommunicationFlsReport = <ThrowOnError extends boolean = false>(options?: Options<ReportsGetLastCommunicationFlsReportData, ThrowOnError>): RequestResult<ReportsGetLastCommunicationFlsReportResponses, ReportsGetLastCommunicationFlsReportErrors, ThrowOnError> => (options?.client ?? client).get<ReportsGetLastCommunicationFlsReportResponses, ReportsGetLastCommunicationFlsReportErrors, ThrowOnError>({ url: '/api/v1/reports/last-communication-fls', ...options });

/**
 * Exports data about last fls connections from devices.
 * Exports max 500,000 records
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>APP_SERVICE_USER</code></p>
 */
export const reportsExportLastCommunicationFlsReport = <ThrowOnError extends boolean = false>(options: Options<ReportsExportLastCommunicationFlsReportData, ThrowOnError>): RequestResult<ReportsExportLastCommunicationFlsReportResponses, ReportsExportLastCommunicationFlsReportErrors, ThrowOnError> => (options.client ?? client).get<ReportsExportLastCommunicationFlsReportResponses, ReportsExportLastCommunicationFlsReportErrors, ThrowOnError>({ url: '/api/v1/reports/last-communication-fls.{format}', ...options });

/**
 * Gets data about last connections to/from location tracker
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>APP_SERVICE_USER</code></p>
 */
export const reportsGetLastCommunicationLocationTracker = <ThrowOnError extends boolean = false>(options?: Options<ReportsGetLastCommunicationLocationTrackerData, ThrowOnError>): RequestResult<ReportsGetLastCommunicationLocationTrackerResponses, ReportsGetLastCommunicationLocationTrackerErrors, ThrowOnError> => (options?.client ?? client).get<ReportsGetLastCommunicationLocationTrackerResponses, ReportsGetLastCommunicationLocationTrackerErrors, ThrowOnError>({ url: '/api/v1/reports/last-communication-lt', ...options });

/**
 * Exports data about last location tracker connections from devices.
 * Exports max 500,000 records
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>APP_SERVICE_USER</code></p>
 */
export const reportsExportLastCommunicationLocationTrackerReport = <ThrowOnError extends boolean = false>(options: Options<ReportsExportLastCommunicationLocationTrackerReportData, ThrowOnError>): RequestResult<ReportsExportLastCommunicationLocationTrackerReportResponses, ReportsExportLastCommunicationLocationTrackerReportErrors, ThrowOnError> => (options.client ?? client).get<ReportsExportLastCommunicationLocationTrackerReportResponses, ReportsExportLastCommunicationLocationTrackerReportErrors, ThrowOnError>({ url: '/api/v1/reports/last-communication-lt.{format}', ...options });

/**
 * Gets list of security roles
 *
 * <p><strong>Required Roles</strong>: <code>USER_VIEW</code> or <code>USER_ADMIN</code> or <code>PERMISSION_GROUP_VIEW</code> or <code>PERMISSION_GROUP_ADMIN</code></p>
 */
export const rolesGetAll = <ThrowOnError extends boolean = false>(options?: Options<RolesGetAllData, ThrowOnError>): RequestResult<RolesGetAllResponses, unknown, ThrowOnError> => (options?.client ?? client).get<RolesGetAllResponses, unknown, ThrowOnError>({ url: '/api/v1/roles', ...options });

/**
 * Gets server information
 */
export const serverInfoGetConfig = <ThrowOnError extends boolean = false>(options?: Options<ServerInfoGetConfigData, ThrowOnError>): RequestResult<ServerInfoGetConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServerInfoGetConfigResponses, unknown, ThrowOnError>({ url: '/api/v1/server-info', ...options });

/**
 * Gets export settings
 */
export const serverInfoGetExportSettings = <ThrowOnError extends boolean = false>(options?: Options<ServerInfoGetExportSettingsData, ThrowOnError>): RequestResult<ServerInfoGetExportSettingsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServerInfoGetExportSettingsResponses, unknown, ThrowOnError>({ url: '/api/v1/server-info/export-settings', ...options });

/**
 * Gets page of all service task categories
 *
 * <p><strong>Required Roles</strong>: <code>SC_APP_EVENT_VIEW</code> or <code>SC_APP_EVENT_ADMIN</code></p>
 */
export const serviceAppEventsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<ServiceAppEventsGetEntityPageData, ThrowOnError>): RequestResult<ServiceAppEventsGetEntityPageResponses, ServiceAppEventsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<ServiceAppEventsGetEntityPageResponses, ServiceAppEventsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/service-app-events', ...options });

/**
 * Receives new service app event
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code> or <code>SC_APP_EVENT_ADMIN</code></p>
 */
export const serviceAppEventsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<ServiceAppEventsCreateEntityData, ThrowOnError>): RequestResult<ServiceAppEventsCreateEntityResponses, ServiceAppEventsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<ServiceAppEventsCreateEntityResponses, ServiceAppEventsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/service-app-events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets service app event
 *
 * <p><strong>Required Roles</strong>: <code>SC_APP_EVENT_VIEW</code> or <code>SC_APP_EVENT_ADMIN</code></p>
 */
export const serviceAppEventsGetEntity = <ThrowOnError extends boolean = false>(options: Options<ServiceAppEventsGetEntityData, ThrowOnError>): RequestResult<ServiceAppEventsGetEntityResponses, ServiceAppEventsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<ServiceAppEventsGetEntityResponses, ServiceAppEventsGetEntityErrors, ThrowOnError>({ url: '/api/v1/service-app-events/{id}', ...options });

/**
 * Exports service app events
 *
 * <p><strong>Required Roles</strong>: <code>SC_APP_EVENT_VIEW</code> or <code>SC_APP_EVENT_ADMIN</code></p>
 */
export const serviceAppEventsExportServiceAppEvents = <ThrowOnError extends boolean = false>(options: Options<ServiceAppEventsExportServiceAppEventsData, ThrowOnError>): RequestResult<ServiceAppEventsExportServiceAppEventsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServiceAppEventsExportServiceAppEventsResponses, unknown, ThrowOnError>({ url: '/api/v1/service-app-events/export.{format}', ...options });

/**
 * Gets page of service calls
 *
 * <p><strong>Required Roles</strong>: <code>SC_VIEW</code> or <code>SC_ADMIN</code> or <code>SC_BULK</code></p>
 */
export const serviceCallsGetServiceCallsPage = <ThrowOnError extends boolean = false>(options?: Options<ServiceCallsGetServiceCallsPageData, ThrowOnError>): RequestResult<ServiceCallsGetServiceCallsPageResponses, ServiceCallsGetServiceCallsPageErrors, ThrowOnError> => (options?.client ?? client).get<ServiceCallsGetServiceCallsPageResponses, ServiceCallsGetServiceCallsPageErrors, ThrowOnError>({ url: '/api/v1/service-calls', ...options });

/**
 * Gets list of service calls
 *
 * <p><strong>Required Roles</strong>: <code>SC_VIEW</code> or <code>SC_ADMIN</code> or <code>SC_BULK</code></p>
 */
export const serviceCallsListServiceCalls = <ThrowOnError extends boolean = false>(options?: Options<ServiceCallsListServiceCallsData, ThrowOnError>): RequestResult<ServiceCallsListServiceCallsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServiceCallsListServiceCallsResponses, unknown, ThrowOnError>({ url: '/api/v1/service-calls/list', ...options });

/**
 * Confirms the service call
 *
 * <p><strong>Required Roles</strong>: <code>SC_ADMIN</code> or <code>SC_BULK</code></p>
 */
export const serviceCallsConfirmServiceCall = <ThrowOnError extends boolean = false>(options: Options<ServiceCallsConfirmServiceCallData, ThrowOnError>): RequestResult<ServiceCallsConfirmServiceCallResponses, ServiceCallsConfirmServiceCallErrors, ThrowOnError> => (options.client ?? client).put<ServiceCallsConfirmServiceCallResponses, ServiceCallsConfirmServiceCallErrors, ThrowOnError>({ url: '/api/v1/service-calls/{id}/confirm', ...options });

/**
 * Validates bulk confirmation of service calls
 *
 * <p><strong>Required Roles</strong>: <code>SC_BULK</code></p>
 */
export const serviceCallsValidateBulkServiceCallConfirmation = <ThrowOnError extends boolean = false>(options: Options<ServiceCallsValidateBulkServiceCallConfirmationData, ThrowOnError>): RequestResult<ServiceCallsValidateBulkServiceCallConfirmationResponses, ServiceCallsValidateBulkServiceCallConfirmationErrors, ThrowOnError> => (options.client ?? client).patch<ServiceCallsValidateBulkServiceCallConfirmationResponses, ServiceCallsValidateBulkServiceCallConfirmationErrors, ThrowOnError>({
    url: '/api/v1/service-calls/bulk/confirm/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Starts bulk confirmation of service calls
 *
 * <p><strong>Required Roles</strong>: <code>SC_BULK</code></p>
 */
export const serviceCallsBulkServiceCallConfirmation = <ThrowOnError extends boolean = false>(options: Options<ServiceCallsBulkServiceCallConfirmationData, ThrowOnError>): RequestResult<ServiceCallsBulkServiceCallConfirmationResponses, ServiceCallsBulkServiceCallConfirmationErrors, ThrowOnError> => (options.client ?? client).patch<ServiceCallsBulkServiceCallConfirmationResponses, ServiceCallsBulkServiceCallConfirmationErrors, ThrowOnError>({
    url: '/api/v1/service-calls/bulk/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exports service calls.
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>SC_VIEW</code> or <code>SC_ADMIN</code> or <code>SC_BULK</code></p>
 */
export const serviceCallsExportServiceCalls = <ThrowOnError extends boolean = false>(options: Options<ServiceCallsExportServiceCallsData, ThrowOnError>): RequestResult<ServiceCallsExportServiceCallsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ServiceCallsExportServiceCallsResponses, unknown, ThrowOnError>({ url: '/api/v1/service-calls/export.{format}', ...options });

/**
 * Gets data for Dashboard
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>APP_SERVICE_USER</code> or <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const serviceDashboardGetDashboardData = <ThrowOnError extends boolean = false>(options?: Options<ServiceDashboardGetDashboardDataData, ThrowOnError>): RequestResult<ServiceDashboardGetDashboardDataResponses, ServiceDashboardGetDashboardDataErrors, ThrowOnError> => (options?.client ?? client).get<ServiceDashboardGetDashboardDataResponses, ServiceDashboardGetDashboardDataErrors, ThrowOnError>({ url: '/api/v1/service-dashboard', ...options });

/**
 * Get page of reported service tasks
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_VIEW</code> or <code>SC_TASK_ADMIN</code></p>
 */
export const serviceTaskGetServiceTaskPage = <ThrowOnError extends boolean = false>(options?: Options<ServiceTaskGetServiceTaskPageData, ThrowOnError>): RequestResult<ServiceTaskGetServiceTaskPageResponses, ServiceTaskGetServiceTaskPageErrors, ThrowOnError> => (options?.client ?? client).get<ServiceTaskGetServiceTaskPageResponses, ServiceTaskGetServiceTaskPageErrors, ThrowOnError>({ url: '/api/v1/service-task', ...options });

/**
 * Creates new service task.
 *
 * If you want to successfully create a service task, fill in at least the following
 * * Container
 * * ServiceCall
 * * Category<p><strong>Required Roles</strong>: <code>SC_TASK_ADMIN</code></p>
 */
export const serviceTaskCreateServiceTask = <ThrowOnError extends boolean = false>(options?: Options<ServiceTaskCreateServiceTaskData, ThrowOnError>): RequestResult<ServiceTaskCreateServiceTaskResponses, ServiceTaskCreateServiceTaskErrors, ThrowOnError> => (options?.client ?? client).post<ServiceTaskCreateServiceTaskResponses, ServiceTaskCreateServiceTaskErrors, ThrowOnError>({
    url: '/api/v1/service-task',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of service tasks
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_VIEW</code> or <code>SC_TASK_ADMIN</code></p>
 */
export const serviceTaskGetServiceTaskList = <ThrowOnError extends boolean = false>(options?: Options<ServiceTaskGetServiceTaskListData, ThrowOnError>): RequestResult<ServiceTaskGetServiceTaskListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServiceTaskGetServiceTaskListResponses, unknown, ThrowOnError>({ url: '/api/v1/service-task/list', ...options });

/**
 * Get specific service task
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_VIEW</code> or <code>SC_TASK_ADMIN</code></p>
 */
export const serviceTaskGetServiceTask = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskGetServiceTaskData, ThrowOnError>): RequestResult<ServiceTaskGetServiceTaskResponses, ServiceTaskGetServiceTaskErrors, ThrowOnError> => (options.client ?? client).get<ServiceTaskGetServiceTaskResponses, ServiceTaskGetServiceTaskErrors, ThrowOnError>({ url: '/api/v1/service-task/{id}', ...options });

/**
 * Update service task
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_ADMIN</code></p>
 */
export const serviceTaskUpdateServiceTask = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskUpdateServiceTaskData, ThrowOnError>): RequestResult<ServiceTaskUpdateServiceTaskResponses, ServiceTaskUpdateServiceTaskErrors, ThrowOnError> => (options.client ?? client).put<ServiceTaskUpdateServiceTaskResponses, ServiceTaskUpdateServiceTaskErrors, ThrowOnError>({
    url: '/api/v1/service-task/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Uploads JPEG or PNG image to the task.
 * Expects image binary data in the body of the request
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_ADMIN</code></p>
 */
export const serviceTaskUploadImage = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskUploadImageData, ThrowOnError>): RequestResult<ServiceTaskUploadImageResponses, ServiceTaskUploadImageErrors, ThrowOnError> => (options.client ?? client).put<ServiceTaskUploadImageResponses, ServiceTaskUploadImageErrors, ThrowOnError>({
    bodySerializer: null,
    url: '/api/v1/service-task/{id}/image',
    ...options,
    headers: {
        'Content-Type': 'image/jpeg',
        ...options.headers
    }
});

/**
 * Export service task list
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>SC_TASK_VIEW</code> or <code>SC_TASK_ADMIN</code></p>
 */
export const serviceTaskExportList = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskExportListData, ThrowOnError>): RequestResult<ServiceTaskExportListResponses, ServiceTaskExportListErrors, ThrowOnError> => (options.client ?? client).get<ServiceTaskExportListResponses, ServiceTaskExportListErrors, ThrowOnError>({ url: '/api/v1/service-task/export.{format}', ...options });

/**
 * Checks if a container has any active service task (in state Open or In Progress)
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_VIEW</code> or <code>SC_TASK_ADMIN</code></p>
 */
export const serviceTaskHasActiveServiceTask = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskHasActiveServiceTaskData, ThrowOnError>): RequestResult<ServiceTaskHasActiveServiceTaskResponses, ServiceTaskHasActiveServiceTaskErrors, ThrowOnError> => (options.client ?? client).get<ServiceTaskHasActiveServiceTaskResponses, ServiceTaskHasActiveServiceTaskErrors, ThrowOnError>({ url: '/api/v1/service-task/{containerId}/has-active-task', ...options });

/**
 * Sets the service task to state "In Progress"
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_ADMIN</code></p>
 */
export const serviceTaskStartServiceTask = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskStartServiceTaskData, ThrowOnError>): RequestResult<ServiceTaskStartServiceTaskResponses, ServiceTaskStartServiceTaskErrors, ThrowOnError> => (options.client ?? client).put<ServiceTaskStartServiceTaskResponses, ServiceTaskStartServiceTaskErrors, ThrowOnError>({
    url: '/api/v1/service-task/{id}/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sets the service task to state "Fixed"
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_ADMIN</code></p>
 */
export const serviceTaskFixServiceTask = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskFixServiceTaskData, ThrowOnError>): RequestResult<ServiceTaskFixServiceTaskResponses, ServiceTaskFixServiceTaskErrors, ThrowOnError> => (options.client ?? client).put<ServiceTaskFixServiceTaskResponses, ServiceTaskFixServiceTaskErrors, ThrowOnError>({
    url: '/api/v1/service-task/{id}/fix',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sets the service task to state "Open"
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_ADMIN</code></p>
 */
export const serviceTaskReopenServiceTask = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskReopenServiceTaskData, ThrowOnError>): RequestResult<ServiceTaskReopenServiceTaskResponses, ServiceTaskReopenServiceTaskErrors, ThrowOnError> => (options.client ?? client).put<ServiceTaskReopenServiceTaskResponses, ServiceTaskReopenServiceTaskErrors, ThrowOnError>({
    url: '/api/v1/service-task/{id}/reopen',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sets the service task to state "Rejected"
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_ADMIN</code></p>
 */
export const serviceTaskRejectServiceTask = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskRejectServiceTaskData, ThrowOnError>): RequestResult<ServiceTaskRejectServiceTaskResponses, ServiceTaskRejectServiceTaskErrors, ThrowOnError> => (options.client ?? client).put<ServiceTaskRejectServiceTaskResponses, ServiceTaskRejectServiceTaskErrors, ThrowOnError>({
    url: '/api/v1/service-task/{id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sets the service task to state "Canceled"
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_ADMIN</code></p>
 */
export const serviceTaskCancelServiceTask = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskCancelServiceTaskData, ThrowOnError>): RequestResult<ServiceTaskCancelServiceTaskResponses, ServiceTaskCancelServiceTaskErrors, ThrowOnError> => (options.client ?? client).put<ServiceTaskCancelServiceTaskResponses, ServiceTaskCancelServiceTaskErrors, ThrowOnError>({ url: '/api/v1/service-task/{id}/cancel', ...options });

/**
 * Get page of logs for a service task
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_VIEW</code> or <code>SC_TASK_ADMIN</code></p>
 */
export const serviceTaskGetServiceTaskLogsPage = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskGetServiceTaskLogsPageData, ThrowOnError>): RequestResult<ServiceTaskGetServiceTaskLogsPageResponses, ServiceTaskGetServiceTaskLogsPageErrors, ThrowOnError> => (options.client ?? client).get<ServiceTaskGetServiceTaskLogsPageResponses, ServiceTaskGetServiceTaskLogsPageErrors, ThrowOnError>({ url: '/api/v1/service-task/{id}/logs', ...options });

/**
 * Gets page of all service task categories
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskCategoriesGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<ServiceTaskCategoriesGetEntityPageData, ThrowOnError>): RequestResult<ServiceTaskCategoriesGetEntityPageResponses, ServiceTaskCategoriesGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<ServiceTaskCategoriesGetEntityPageResponses, ServiceTaskCategoriesGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/service-task-categories', ...options });

/**
 * Creates new service task category
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskCategoriesCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<ServiceTaskCategoriesCreateEntityData, ThrowOnError>): RequestResult<ServiceTaskCategoriesCreateEntityResponses, ServiceTaskCategoriesCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<ServiceTaskCategoriesCreateEntityResponses, ServiceTaskCategoriesCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/service-task-categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of service task categories
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskCategoriesListCategories = <ThrowOnError extends boolean = false>(options?: Options<ServiceTaskCategoriesListCategoriesData, ThrowOnError>): RequestResult<ServiceTaskCategoriesListCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServiceTaskCategoriesListCategoriesResponses, unknown, ThrowOnError>({ url: '/api/v1/service-task-categories/list', ...options });

/**
 * Deletes service task category
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskCategoriesDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskCategoriesDeleteEntityData, ThrowOnError>): RequestResult<ServiceTaskCategoriesDeleteEntityResponses, ServiceTaskCategoriesDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<ServiceTaskCategoriesDeleteEntityResponses, ServiceTaskCategoriesDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/service-task-categories/{id}', ...options });

/**
 * Gets service task category
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskCategoriesGetEntity = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskCategoriesGetEntityData, ThrowOnError>): RequestResult<ServiceTaskCategoriesGetEntityResponses, ServiceTaskCategoriesGetEntityErrors, ThrowOnError> => (options.client ?? client).get<ServiceTaskCategoriesGetEntityResponses, ServiceTaskCategoriesGetEntityErrors, ThrowOnError>({ url: '/api/v1/service-task-categories/{id}', ...options });

/**
 * Updates service task category
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskCategoriesUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskCategoriesUpdateEntityData, ThrowOnError>): RequestResult<ServiceTaskCategoriesUpdateEntityResponses, ServiceTaskCategoriesUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<ServiceTaskCategoriesUpdateEntityResponses, ServiceTaskCategoriesUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/service-task-categories/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskCategoriesIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<ServiceTaskCategoriesIsValueUsedData, ThrowOnError>): RequestResult<ServiceTaskCategoriesIsValueUsedResponses, ServiceTaskCategoriesIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<ServiceTaskCategoriesIsValueUsedResponses, ServiceTaskCategoriesIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/service-task-categories/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of all service task Causes
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskCausesGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<ServiceTaskCausesGetEntityPageData, ThrowOnError>): RequestResult<ServiceTaskCausesGetEntityPageResponses, ServiceTaskCausesGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<ServiceTaskCausesGetEntityPageResponses, ServiceTaskCausesGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/service-task-causes', ...options });

/**
 * Creates new service task Cause
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskCausesCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<ServiceTaskCausesCreateEntityData, ThrowOnError>): RequestResult<ServiceTaskCausesCreateEntityResponses, ServiceTaskCausesCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<ServiceTaskCausesCreateEntityResponses, ServiceTaskCausesCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/service-task-causes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of service task Causes
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskCausesListCauses = <ThrowOnError extends boolean = false>(options?: Options<ServiceTaskCausesListCausesData, ThrowOnError>): RequestResult<ServiceTaskCausesListCausesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServiceTaskCausesListCausesResponses, unknown, ThrowOnError>({ url: '/api/v1/service-task-causes/list', ...options });

/**
 * Deletes service task Cause
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskCausesDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskCausesDeleteEntityData, ThrowOnError>): RequestResult<ServiceTaskCausesDeleteEntityResponses, ServiceTaskCausesDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<ServiceTaskCausesDeleteEntityResponses, ServiceTaskCausesDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/service-task-causes/{id}', ...options });

/**
 * Gets service task Cause
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskCausesGetEntity = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskCausesGetEntityData, ThrowOnError>): RequestResult<ServiceTaskCausesGetEntityResponses, ServiceTaskCausesGetEntityErrors, ThrowOnError> => (options.client ?? client).get<ServiceTaskCausesGetEntityResponses, ServiceTaskCausesGetEntityErrors, ThrowOnError>({ url: '/api/v1/service-task-causes/{id}', ...options });

/**
 * Updates service task Cause
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskCausesUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskCausesUpdateEntityData, ThrowOnError>): RequestResult<ServiceTaskCausesUpdateEntityResponses, ServiceTaskCausesUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<ServiceTaskCausesUpdateEntityResponses, ServiceTaskCausesUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/service-task-causes/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskCausesIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<ServiceTaskCausesIsValueUsedData, ThrowOnError>): RequestResult<ServiceTaskCausesIsValueUsedResponses, ServiceTaskCausesIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<ServiceTaskCausesIsValueUsedResponses, ServiceTaskCausesIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/service-task-causes/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets page of all service task solutions
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskSolutionsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<ServiceTaskSolutionsGetEntityPageData, ThrowOnError>): RequestResult<ServiceTaskSolutionsGetEntityPageResponses, ServiceTaskSolutionsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<ServiceTaskSolutionsGetEntityPageResponses, ServiceTaskSolutionsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/service-task-solutions', ...options });

/**
 * Creates new service task solution
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskSolutionsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<ServiceTaskSolutionsCreateEntityData, ThrowOnError>): RequestResult<ServiceTaskSolutionsCreateEntityResponses, ServiceTaskSolutionsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<ServiceTaskSolutionsCreateEntityResponses, ServiceTaskSolutionsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/service-task-solutions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of service task solutions
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskSolutionsListSolutions = <ThrowOnError extends boolean = false>(options?: Options<ServiceTaskSolutionsListSolutionsData, ThrowOnError>): RequestResult<ServiceTaskSolutionsListSolutionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ServiceTaskSolutionsListSolutionsResponses, unknown, ThrowOnError>({ url: '/api/v1/service-task-solutions/list', ...options });

/**
 * Deletes service task solution
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskSolutionsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskSolutionsDeleteEntityData, ThrowOnError>): RequestResult<ServiceTaskSolutionsDeleteEntityResponses, ServiceTaskSolutionsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<ServiceTaskSolutionsDeleteEntityResponses, ServiceTaskSolutionsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/service-task-solutions/{id}', ...options });

/**
 * Gets service task solution
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskSolutionsGetEntity = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskSolutionsGetEntityData, ThrowOnError>): RequestResult<ServiceTaskSolutionsGetEntityResponses, ServiceTaskSolutionsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<ServiceTaskSolutionsGetEntityResponses, ServiceTaskSolutionsGetEntityErrors, ThrowOnError>({ url: '/api/v1/service-task-solutions/{id}', ...options });

/**
 * Updates service task solution
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskSolutionsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<ServiceTaskSolutionsUpdateEntityData, ThrowOnError>): RequestResult<ServiceTaskSolutionsUpdateEntityResponses, ServiceTaskSolutionsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<ServiceTaskSolutionsUpdateEntityResponses, ServiceTaskSolutionsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/service-task-solutions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const serviceTaskSolutionsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<ServiceTaskSolutionsIsValueUsedData, ThrowOnError>): RequestResult<ServiceTaskSolutionsIsValueUsedResponses, ServiceTaskSolutionsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<ServiceTaskSolutionsIsValueUsedResponses, ServiceTaskSolutionsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/service-task-solutions/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Terminates all SIM cards identified by the IMSI
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const simCardsValidatSimCardsForTermination = <ThrowOnError extends boolean = false>(options?: Options<SimCardsValidatSimCardsForTerminationData, ThrowOnError>): RequestResult<SimCardsValidatSimCardsForTerminationResponses, SimCardsValidatSimCardsForTerminationErrors, ThrowOnError> => (options?.client ?? client).post<SimCardsValidatSimCardsForTerminationResponses, SimCardsValidatSimCardsForTerminationErrors, ThrowOnError>({
    url: '/api/v1/sim-cards/terminate/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Terminates all SIM cards identified by the IMSI
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const simCardsTerminateSimCards = <ThrowOnError extends boolean = false>(options?: Options<SimCardsTerminateSimCardsData, ThrowOnError>): RequestResult<SimCardsTerminateSimCardsResponses, SimCardsTerminateSimCardsErrors, ThrowOnError> => (options?.client ?? client).post<SimCardsTerminateSimCardsResponses, SimCardsTerminateSimCardsErrors, ThrowOnError>({
    url: '/api/v1/sim-cards/terminate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Provides template CSV for container addresses import
 *
 * <p><strong>Required Roles</strong>: <code>HARDWARE_UNIT_ADMIN</code> or <code>HARDWARE_UNIT_BULK</code></p>
 */
export const simCardsGetTerminateTemplate = <ThrowOnError extends boolean = false>(options?: Options<SimCardsGetTerminateTemplateData, ThrowOnError>): RequestResult<SimCardsGetTerminateTemplateResponses, SimCardsGetTerminateTemplateErrors, ThrowOnError> => (options?.client ?? client).get<SimCardsGetTerminateTemplateResponses, SimCardsGetTerminateTemplateErrors, ThrowOnError>({ url: '/api/v1/sim-cards/terminate/terminate-sim-template.csv', ...options });

/**
 * Gets the SLOC profiles
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code> or <code>EMZ_DEVELOPER</code> or <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const slocGetSlocProfiles = <ThrowOnError extends boolean = false>(options: Options<SlocGetSlocProfilesData, ThrowOnError>): RequestResult<SlocGetSlocProfilesResponses, SlocGetSlocProfilesErrors, ThrowOnError> => (options.client ?? client).get<SlocGetSlocProfilesResponses, SlocGetSlocProfilesErrors, ThrowOnError>({ url: '/api/v1/sloc/profiles/{customerId}', ...options });

/**
 * Gets the SLOC emptying options
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code> or <code>EMZ_DEVELOPER</code> or <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const slocGetSlocEmptyingOptions = <ThrowOnError extends boolean = false>(options: Options<SlocGetSlocEmptyingOptionsData, ThrowOnError>): RequestResult<SlocGetSlocEmptyingOptionsResponses, SlocGetSlocEmptyingOptionsErrors, ThrowOnError> => (options.client ?? client).get<SlocGetSlocEmptyingOptionsResponses, SlocGetSlocEmptyingOptionsErrors, ThrowOnError>({ url: '/api/v1/sloc/emptying-options/{customerId}', ...options });

/**
 * Gets the SLOC groups
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const slocGetSlocGroups = <ThrowOnError extends boolean = false>(options: Options<SlocGetSlocGroupsData, ThrowOnError>): RequestResult<SlocGetSlocGroupsResponses, SlocGetSlocGroupsErrors, ThrowOnError> => (options.client ?? client).get<SlocGetSlocGroupsResponses, SlocGetSlocGroupsErrors, ThrowOnError>({ url: '/api/v1/sloc/groups/{customerId}', ...options });

/**
 * Checks if the customer has a valid SLOC API key
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const slocHasValidSlocApiKey = <ThrowOnError extends boolean = false>(options: Options<SlocHasValidSlocApiKeyData, ThrowOnError>): RequestResult<SlocHasValidSlocApiKeyResponses, unknown, ThrowOnError> => (options.client ?? client).get<SlocHasValidSlocApiKeyResponses, unknown, ThrowOnError>({ url: '/api/v1/sloc/has-valid-key/{customerId}', ...options });

/**
 * Gets the SLOC organization (customer) name for the customer's configured SLOC API key
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code> or <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const slocGetSlocCustomerName = <ThrowOnError extends boolean = false>(options: Options<SlocGetSlocCustomerNameData, ThrowOnError>): RequestResult<SlocGetSlocCustomerNameResponses, SlocGetSlocCustomerNameErrors, ThrowOnError> => (options.client ?? client).get<SlocGetSlocCustomerNameResponses, SlocGetSlocCustomerNameErrors, ThrowOnError>({ url: '/api/v1/sloc/customer-name/{customerId}', ...options });

/**
 * Gets the SLOC groups by SLOC API key
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const slocGetSlocGroupsByApiKey = <ThrowOnError extends boolean = false>(options: Options<SlocGetSlocGroupsByApiKeyData, ThrowOnError>): RequestResult<SlocGetSlocGroupsByApiKeyResponses, SlocGetSlocGroupsByApiKeyErrors, ThrowOnError> => (options.client ?? client).post<SlocGetSlocGroupsByApiKeyResponses, SlocGetSlocGroupsByApiKeyErrors, ThrowOnError>({
    url: '/api/v1/sloc/groups/api-key',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sets SLOC configuration for container
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code> or <code>EMZ_DEVELOPER</code> or <code>CRON</code></p>
 */
export const slocSetSlocConfiguration = <ThrowOnError extends boolean = false>(options?: Options<SlocSetSlocConfigurationData, ThrowOnError>): RequestResult<SlocSetSlocConfigurationResponses, SlocSetSlocConfigurationErrors, ThrowOnError> => (options?.client ?? client).put<SlocSetSlocConfigurationResponses, SlocSetSlocConfigurationErrors, ThrowOnError>({
    url: '/api/v1/sloc/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets the telemetry data from SLOC sdm.sloc.one portal.
 *
 * This endpoint is used to receive telemetry data from SLOC portal.
 * Sloc portal sends data to this endpoint every 5 minutes.<p><strong>Required Roles</strong>: <code>SLOC_API_KEY</code></p>
 */
export const slocReceiveSlocData = <ThrowOnError extends boolean = false>(options?: Options<SlocReceiveSlocDataData, ThrowOnError>): RequestResult<SlocReceiveSlocDataResponses, unknown, ThrowOnError> => (options?.client ?? client).post<SlocReceiveSlocDataResponses, unknown, ThrowOnError>({
    url: '/api/v1/sloc/receive-data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Updates fill level sensor configuration
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const slocGetSlocConfigurationState = <ThrowOnError extends boolean = false>(options: Options<SlocGetSlocConfigurationStateData, ThrowOnError>): RequestResult<SlocGetSlocConfigurationStateResponses, SlocGetSlocConfigurationStateErrors, ThrowOnError> => (options.client ?? client).get<SlocGetSlocConfigurationStateResponses, SlocGetSlocConfigurationStateErrors, ThrowOnError>({ url: '/api/v1/sloc/{macAddress}/config-state', ...options });

/**
 * User marks himself as a runner
 * Use this endpoint to mark the current user as a runner.
 */
export const socialServiceActivateRunnerPrivileges = <ThrowOnError extends boolean = false>(options?: Options<SocialServiceActivateRunnerPrivilegesData, ThrowOnError>): RequestResult<SocialServiceActivateRunnerPrivilegesResponses, SocialServiceActivateRunnerPrivilegesErrors, ThrowOnError> => (options?.client ?? client).put<SocialServiceActivateRunnerPrivilegesResponses, SocialServiceActivateRunnerPrivilegesErrors, ThrowOnError>({ url: '/api/v1/social-service/activate', ...options });

/**
 * User deactivates himself as a runner
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceDeactivateRunnerPrivileges = <ThrowOnError extends boolean = false>(options?: Options<SocialServiceDeactivateRunnerPrivilegesData, ThrowOnError>): RequestResult<SocialServiceDeactivateRunnerPrivilegesResponses, SocialServiceDeactivateRunnerPrivilegesErrors, ThrowOnError> => (options?.client ?? client).delete<SocialServiceDeactivateRunnerPrivilegesResponses, SocialServiceDeactivateRunnerPrivilegesErrors, ThrowOnError>({ url: '/api/v1/social-service/deactivate', ...options });

/**
 * Runner reports his location
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceReportsRunnerLocation = <ThrowOnError extends boolean = false>(options: Options<SocialServiceReportsRunnerLocationData, ThrowOnError>): RequestResult<SocialServiceReportsRunnerLocationResponses, SocialServiceReportsRunnerLocationErrors, ThrowOnError> => (options.client ?? client).put<SocialServiceReportsRunnerLocationResponses, SocialServiceReportsRunnerLocationErrors, ThrowOnError>({
    url: '/api/v1/social-service/location',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get social service notifications settings of calling runner.
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceGetRunnerNotificationSettings = <ThrowOnError extends boolean = false>(options?: Options<SocialServiceGetRunnerNotificationSettingsData, ThrowOnError>): RequestResult<SocialServiceGetRunnerNotificationSettingsResponses, SocialServiceGetRunnerNotificationSettingsErrors, ThrowOnError> => (options?.client ?? client).get<SocialServiceGetRunnerNotificationSettingsResponses, SocialServiceGetRunnerNotificationSettingsErrors, ThrowOnError>({ url: '/api/v1/social-service/notification-settings', ...options });

/**
 * Runner updates his notification settings
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceUpdateRunnerNotificationSettings = <ThrowOnError extends boolean = false>(options: Options<SocialServiceUpdateRunnerNotificationSettingsData, ThrowOnError>): RequestResult<SocialServiceUpdateRunnerNotificationSettingsResponses, SocialServiceUpdateRunnerNotificationSettingsErrors, ThrowOnError> => (options.client ?? client).put<SocialServiceUpdateRunnerNotificationSettingsResponses, SocialServiceUpdateRunnerNotificationSettingsErrors, ThrowOnError>({
    url: '/api/v1/social-service/notification-settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets list of social service transactions for the calling runner.
 */
export const socialServiceGetTransactions = <ThrowOnError extends boolean = false>(options?: Options<SocialServiceGetTransactionsData, ThrowOnError>): RequestResult<SocialServiceGetTransactionsResponses, SocialServiceGetTransactionsErrors, ThrowOnError> => (options?.client ?? client).get<SocialServiceGetTransactionsResponses, SocialServiceGetTransactionsErrors, ThrowOnError>({ url: '/api/v1/social-service/transactions', ...options });

/**
 * Gets page of all social service actions
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const socialServiceActionsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<SocialServiceActionsGetEntityPageData, ThrowOnError>): RequestResult<SocialServiceActionsGetEntityPageResponses, SocialServiceActionsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<SocialServiceActionsGetEntityPageResponses, SocialServiceActionsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/social-service-actions', ...options });

/**
 * Gets a list of social service actions
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const socialServiceActionsListCategories = <ThrowOnError extends boolean = false>(options?: Options<SocialServiceActionsListCategoriesData, ThrowOnError>): RequestResult<SocialServiceActionsListCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SocialServiceActionsListCategoriesResponses, unknown, ThrowOnError>({ url: '/api/v1/social-service-actions/list', ...options });

/**
 * Gets social service action by id
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_VIEW</code> or <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const socialServiceActionsGetEntity = <ThrowOnError extends boolean = false>(options: Options<SocialServiceActionsGetEntityData, ThrowOnError>): RequestResult<SocialServiceActionsGetEntityResponses, SocialServiceActionsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<SocialServiceActionsGetEntityResponses, SocialServiceActionsGetEntityErrors, ThrowOnError>({ url: '/api/v1/social-service-actions/{id}', ...options });

/**
 * Updates social service action
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_CATEGORY_ADMIN</code></p>
 */
export const socialServiceActionsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<SocialServiceActionsUpdateEntityData, ThrowOnError>): RequestResult<SocialServiceActionsUpdateEntityResponses, SocialServiceActionsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<SocialServiceActionsUpdateEntityResponses, SocialServiceActionsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/social-service-actions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Posts message to all devices belonging to runners of given social service task
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_ADMIN</code></p>
 */
export const socialServiceNotificationsNotifyRunners = <ThrowOnError extends boolean = false>(options?: Options<SocialServiceNotificationsNotifyRunnersData, ThrowOnError>): RequestResult<SocialServiceNotificationsNotifyRunnersResponses, SocialServiceNotificationsNotifyRunnersErrors, ThrowOnError> => (options?.client ?? client).post<SocialServiceNotificationsNotifyRunnersResponses, SocialServiceNotificationsNotifyRunnersErrors, ThrowOnError>({
    url: '/api/v1/social-service-notifications/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of all users
 *
 * <p><strong>Required Roles</strong>: <code>USER_VIEW</code> or <code>USER_ADMIN</code></p>
 */
export const socialServiceRunnersGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<SocialServiceRunnersGetEntityPageData, ThrowOnError>): RequestResult<SocialServiceRunnersGetEntityPageResponses, SocialServiceRunnersGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<SocialServiceRunnersGetEntityPageResponses, SocialServiceRunnersGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/social-service-runners', ...options });

/**
 * Gets list of runners
 *
 * <p><strong>Required Roles</strong>: <code>USER_VIEW</code> or <code>USER_ADMIN</code></p>
 */
export const socialServiceRunnersListUsers = <ThrowOnError extends boolean = false>(options: Options<SocialServiceRunnersListUsersData, ThrowOnError>): RequestResult<SocialServiceRunnersListUsersResponses, unknown, ThrowOnError> => (options.client ?? client).get<SocialServiceRunnersListUsersResponses, unknown, ThrowOnError>({ url: '/api/v1/social-service-runners/list', ...options });

/**
 * Service task admin deactivates runner privileges from a user
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_ADMIN</code></p>
 */
export const socialServiceRunnersBanRunner = <ThrowOnError extends boolean = false>(options: Options<SocialServiceRunnersBanRunnerData, ThrowOnError>): RequestResult<SocialServiceRunnersBanRunnerResponses, SocialServiceRunnersBanRunnerErrors, ThrowOnError> => (options.client ?? client).delete<SocialServiceRunnersBanRunnerResponses, SocialServiceRunnersBanRunnerErrors, ThrowOnError>({
    url: '/api/v1/social-service-runners/{userId}/ban',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Service task admin deactivates runner privileges from a user
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_ADMIN</code></p>
 */
export const socialServiceRunnersUnbanBanRunner = <ThrowOnError extends boolean = false>(options: Options<SocialServiceRunnersUnbanBanRunnerData, ThrowOnError>): RequestResult<SocialServiceRunnersUnbanBanRunnerResponses, SocialServiceRunnersUnbanBanRunnerErrors, ThrowOnError> => (options.client ?? client).put<SocialServiceRunnersUnbanBanRunnerResponses, SocialServiceRunnersUnbanBanRunnerErrors, ThrowOnError>({ url: '/api/v1/social-service-runners/{userId}/unban', ...options });

/**
 * Gets list of social service transactions for the social service admin
 *
 * <p><strong>Required Roles</strong>: <code>SC_TASK_VIEW</code> or <code>SC_TASK_ADMIN</code></p>
 */
export const socialServiceRunnersGetRunnerTransactions = <ThrowOnError extends boolean = false>(options: Options<SocialServiceRunnersGetRunnerTransactionsData, ThrowOnError>): RequestResult<SocialServiceRunnersGetRunnerTransactionsResponses, SocialServiceRunnersGetRunnerTransactionsErrors, ThrowOnError> => (options.client ?? client).get<SocialServiceRunnersGetRunnerTransactionsResponses, SocialServiceRunnersGetRunnerTransactionsErrors, ThrowOnError>({ url: '/api/v1/social-service-runners/{userId}/transactions', ...options });

/**
 * Deducts the specified number of credits from the runner's account
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceRunnersRedeemRunnerCredits = <ThrowOnError extends boolean = false>(options: Options<SocialServiceRunnersRedeemRunnerCreditsData, ThrowOnError>): RequestResult<SocialServiceRunnersRedeemRunnerCreditsResponses, SocialServiceRunnersRedeemRunnerCreditsErrors, ThrowOnError> => (options.client ?? client).put<SocialServiceRunnersRedeemRunnerCreditsResponses, SocialServiceRunnersRedeemRunnerCreditsErrors, ThrowOnError>({
    url: '/api/v1/social-service-runners/redeem-credits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets a page of available social service tasks
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceTaskGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<SocialServiceTaskGetEntityPageData, ThrowOnError>): RequestResult<SocialServiceTaskGetEntityPageResponses, SocialServiceTaskGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<SocialServiceTaskGetEntityPageResponses, SocialServiceTaskGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/social-service-task', ...options });

/**
 * Gets the social service task by id
 *
 * Returns only social service tasks that are open or assigned to the runner who calls this endpoint.<p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceTaskGetSocialServiceTask = <ThrowOnError extends boolean = false>(options: Options<SocialServiceTaskGetSocialServiceTaskData, ThrowOnError>): RequestResult<SocialServiceTaskGetSocialServiceTaskResponses, SocialServiceTaskGetSocialServiceTaskErrors, ThrowOnError> => (options.client ?? client).get<SocialServiceTaskGetSocialServiceTaskResponses, SocialServiceTaskGetSocialServiceTaskErrors, ThrowOnError>({ url: '/api/v1/social-service-task/{id}', ...options });

/**
 * Lists available social service tasks in the given area
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceTaskSocialServiceTasksMap = <ThrowOnError extends boolean = false>(options: Options<SocialServiceTaskSocialServiceTasksMapData, ThrowOnError>): RequestResult<SocialServiceTaskSocialServiceTasksMapResponses, SocialServiceTaskSocialServiceTasksMapErrors, ThrowOnError> => (options.client ?? client).get<SocialServiceTaskSocialServiceTasksMapResponses, SocialServiceTaskSocialServiceTasksMapErrors, ThrowOnError>({ url: '/api/v1/social-service-task/map', ...options });

/**
 * Lists social service tasks assigned to the current user
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceTaskListOfAssignedSocialServiceTasksToCurrentUser = <ThrowOnError extends boolean = false>(options?: Options<SocialServiceTaskListOfAssignedSocialServiceTasksToCurrentUserData, ThrowOnError>): RequestResult<SocialServiceTaskListOfAssignedSocialServiceTasksToCurrentUserResponses, SocialServiceTaskListOfAssignedSocialServiceTasksToCurrentUserErrors, ThrowOnError> => (options?.client ?? client).get<SocialServiceTaskListOfAssignedSocialServiceTasksToCurrentUserResponses, SocialServiceTaskListOfAssignedSocialServiceTasksToCurrentUserErrors, ThrowOnError>({ url: '/api/v1/social-service-task/list/my', ...options });

/**
 * Assign a social service task to the runner. Removes the task from the pool of available tasks.
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceTaskAssignSocialServiceTask = <ThrowOnError extends boolean = false>(options: Options<SocialServiceTaskAssignSocialServiceTaskData, ThrowOnError>): RequestResult<SocialServiceTaskAssignSocialServiceTaskResponses, SocialServiceTaskAssignSocialServiceTaskErrors, ThrowOnError> => (options.client ?? client).put<SocialServiceTaskAssignSocialServiceTaskResponses, SocialServiceTaskAssignSocialServiceTaskErrors, ThrowOnError>({ url: '/api/v1/social-service-task/{id}/assign', ...options });

/**
 * Start a social service task. Runner starts performing the action on the container.
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceTaskStartSocialServiceTask = <ThrowOnError extends boolean = false>(options: Options<SocialServiceTaskStartSocialServiceTaskData, ThrowOnError>): RequestResult<SocialServiceTaskStartSocialServiceTaskResponses, SocialServiceTaskStartSocialServiceTaskErrors, ThrowOnError> => (options.client ?? client).put<SocialServiceTaskStartSocialServiceTaskResponses, SocialServiceTaskStartSocialServiceTaskErrors, ThrowOnError>({ url: '/api/v1/social-service-task/{id}/start', ...options });

/**
 * Service app runner cancels the social service task. Task is returned to the pool of available tasks.
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceTaskRejectSocialServiceTask = <ThrowOnError extends boolean = false>(options: Options<SocialServiceTaskRejectSocialServiceTaskData, ThrowOnError>): RequestResult<SocialServiceTaskRejectSocialServiceTaskResponses, SocialServiceTaskRejectSocialServiceTaskErrors, ThrowOnError> => (options.client ?? client).put<SocialServiceTaskRejectSocialServiceTaskResponses, SocialServiceTaskRejectSocialServiceTaskErrors, ThrowOnError>({ url: '/api/v1/social-service-task/{id}/reject', ...options });

/**
 * Finish a social service task.
 * Runner finishes the action on the container.
 * Task is marked as completed. Runner gets the reward.
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceTaskFinishSocialServiceTask = <ThrowOnError extends boolean = false>(options: Options<SocialServiceTaskFinishSocialServiceTaskData, ThrowOnError>): RequestResult<SocialServiceTaskFinishSocialServiceTaskResponses, SocialServiceTaskFinishSocialServiceTaskErrors, ThrowOnError> => (options.client ?? client).put<SocialServiceTaskFinishSocialServiceTaskResponses, SocialServiceTaskFinishSocialServiceTaskErrors, ThrowOnError>({ url: '/api/v1/social-service-task/{id}/finish', ...options });

/**
 * Runner requests extra time for the social service task
 *
 * Add an extra 30 minutes to the social service task<p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceTaskAddExtraTimeToSocialServiceTask = <ThrowOnError extends boolean = false>(options: Options<SocialServiceTaskAddExtraTimeToSocialServiceTaskData, ThrowOnError>): RequestResult<SocialServiceTaskAddExtraTimeToSocialServiceTaskResponses, SocialServiceTaskAddExtraTimeToSocialServiceTaskErrors, ThrowOnError> => (options.client ?? client).put<SocialServiceTaskAddExtraTimeToSocialServiceTaskResponses, SocialServiceTaskAddExtraTimeToSocialServiceTaskErrors, ThrowOnError>({ url: '/api/v1/social-service-task/{id}/extra-time', ...options });

/**
 * Runner reports an issue with the social service task
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceTaskReportIssueSocialServiceTask = <ThrowOnError extends boolean = false>(options: Options<SocialServiceTaskReportIssueSocialServiceTaskData, ThrowOnError>): RequestResult<SocialServiceTaskReportIssueSocialServiceTaskResponses, SocialServiceTaskReportIssueSocialServiceTaskErrors, ThrowOnError> => (options.client ?? client).put<SocialServiceTaskReportIssueSocialServiceTaskResponses, SocialServiceTaskReportIssueSocialServiceTaskErrors, ThrowOnError>({
    url: '/api/v1/social-service-task/{id}/report-issue',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Runners service app reports that the social service task has failed.
 *
 * The evaluation of whether a task will be marked as failed (depends on the client),
 * which can send a flag to force the failure or the server can decide that the task should be marked as failed.<p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceTaskFailSocialServiceTask = <ThrowOnError extends boolean = false>(options: Options<SocialServiceTaskFailSocialServiceTaskData, ThrowOnError>): RequestResult<SocialServiceTaskFailSocialServiceTaskResponses, SocialServiceTaskFailSocialServiceTaskErrors, ThrowOnError> => (options.client ?? client).put<SocialServiceTaskFailSocialServiceTaskResponses, SocialServiceTaskFailSocialServiceTaskErrors, ThrowOnError>({
    url: '/api/v1/social-service-task/{id}/fail',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Runner adds images to the social service task
 *
 * First upload images via eGateDigi.Web.Controllers.ImagesController API and
 * then add their ids to the task by calling this endpoint.<p><strong>Required Roles</strong>: <code>APP_SERVICE_RUNNER</code></p>
 */
export const socialServiceTaskAddImages = <ThrowOnError extends boolean = false>(options: Options<SocialServiceTaskAddImagesData, ThrowOnError>): RequestResult<SocialServiceTaskAddImagesResponses, SocialServiceTaskAddImagesErrors, ThrowOnError> => (options.client ?? client).post<SocialServiceTaskAddImagesResponses, SocialServiceTaskAddImagesErrors, ThrowOnError>({
    url: '/api/v1/social-service-task/{id}/images',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets page of Superset Dashboards
 *
 * <p><strong>Required Roles</strong>: <code>BI_DASHBOARD_VIEW</code> or <code>BI_DASHBOARD_ADMIN</code></p>
 */
export const supersetDashboardsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<SupersetDashboardsGetEntityPageData, ThrowOnError>): RequestResult<SupersetDashboardsGetEntityPageResponses, SupersetDashboardsGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<SupersetDashboardsGetEntityPageResponses, SupersetDashboardsGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/superset-dashboards', ...options });

/**
 * Creates new Superset dashboard
 *
 * <p><strong>Required Roles</strong>: <code>BI_DASHBOARD_ADMIN</code></p>
 */
export const supersetDashboardsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<SupersetDashboardsCreateEntityData, ThrowOnError>): RequestResult<SupersetDashboardsCreateEntityResponses, SupersetDashboardsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<SupersetDashboardsCreateEntityResponses, SupersetDashboardsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/superset-dashboards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of Superset Dashboards
 *
 * <p><strong>Required Roles</strong>: <code>BI_DASHBOARD_RUN</code> or <code>BI_DASHBOARD_VIEW</code> or <code>BI_DASHBOARD_ADMIN</code></p>
 */
export const supersetDashboardsListEntities = <ThrowOnError extends boolean = false>(options?: Options<SupersetDashboardsListEntitiesData, ThrowOnError>): RequestResult<SupersetDashboardsListEntitiesResponses, SupersetDashboardsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<SupersetDashboardsListEntitiesResponses, SupersetDashboardsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/superset-dashboards/list', ...options });

/**
 * Deletes Superset dashboard
 *
 * <p><strong>Required Roles</strong>: <code>BI_DASHBOARD_ADMIN</code></p>
 */
export const supersetDashboardsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<SupersetDashboardsDeleteEntityData, ThrowOnError>): RequestResult<SupersetDashboardsDeleteEntityResponses, SupersetDashboardsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<SupersetDashboardsDeleteEntityResponses, SupersetDashboardsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/superset-dashboards/{id}', ...options });

/**
 * Gets details of Superset Dashboard
 *
 * <p><strong>Required Roles</strong>: <code>BI_DASHBOARD_VIEW</code> or <code>BI_DASHBOARD_ADMIN</code></p>
 */
export const supersetDashboardsGetEntity = <ThrowOnError extends boolean = false>(options: Options<SupersetDashboardsGetEntityData, ThrowOnError>): RequestResult<SupersetDashboardsGetEntityResponses, SupersetDashboardsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<SupersetDashboardsGetEntityResponses, SupersetDashboardsGetEntityErrors, ThrowOnError>({ url: '/api/v1/superset-dashboards/{id}', ...options });

/**
 * Updates existing Superset dashboard
 *
 * <p><strong>Required Roles</strong>: <code>BI_DASHBOARD_ADMIN</code></p>
 */
export const supersetDashboardsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<SupersetDashboardsUpdateEntityData, ThrowOnError>): RequestResult<SupersetDashboardsUpdateEntityResponses, SupersetDashboardsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<SupersetDashboardsUpdateEntityResponses, SupersetDashboardsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/superset-dashboards/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>BI_DASHBOARD_ADMIN</code></p>
 */
export const supersetDashboardsIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<SupersetDashboardsIsValueUsedData, ThrowOnError>): RequestResult<SupersetDashboardsIsValueUsedResponses, SupersetDashboardsIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<SupersetDashboardsIsValueUsedResponses, SupersetDashboardsIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/superset-dashboards/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets Guest token for embedding the Superset Dashboard
 *
 * <p><strong>Required Roles</strong>: <code>BI_DASHBOARD_RUN</code> or <code>BI_DASHBOARD_VIEW</code> or <code>BI_DASHBOARD_ADMIN</code></p>
 */
export const supersetDashboardsGetGuestToken = <ThrowOnError extends boolean = false>(options: Options<SupersetDashboardsGetGuestTokenData, ThrowOnError>): RequestResult<SupersetDashboardsGetGuestTokenResponses, SupersetDashboardsGetGuestTokenErrors, ThrowOnError> => (options.client ?? client).get<SupersetDashboardsGetGuestTokenResponses, SupersetDashboardsGetGuestTokenErrors, ThrowOnError>({ url: '/api/v1/superset-dashboards/{id}/token', ...options });

/**
 * Gets page of System operation logs
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const systemOperationsLogGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<SystemOperationsLogGetEntityPageData, ThrowOnError>): RequestResult<SystemOperationsLogGetEntityPageResponses, SystemOperationsLogGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<SystemOperationsLogGetEntityPageResponses, SystemOperationsLogGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/system-operations-log', ...options });

/**
 * Gets specific System operations log
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const systemOperationsLogGetIssue = <ThrowOnError extends boolean = false>(options: Options<SystemOperationsLogGetIssueData, ThrowOnError>): RequestResult<SystemOperationsLogGetIssueResponses, SystemOperationsLogGetIssueErrors, ThrowOnError> => (options.client ?? client).get<SystemOperationsLogGetIssueResponses, SystemOperationsLogGetIssueErrors, ThrowOnError>({ url: '/api/v1/system-operations-log/{id}', ...options });

/**
 * Exports System operations log
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code> or <code>EMZ_DEVELOPER</code></p>
 */
export const systemOperationsLogExportList = <ThrowOnError extends boolean = false>(options: Options<SystemOperationsLogExportListData, ThrowOnError>): RequestResult<SystemOperationsLogExportListResponses, SystemOperationsLogExportListErrors, ThrowOnError> => (options.client ?? client).get<SystemOperationsLogExportListResponses, SystemOperationsLogExportListErrors, ThrowOnError>({ url: '/api/v1/system-operations-log/export.{format}', ...options });

/**
 * Gets list of all users
 *
 * <p><strong>Required Roles</strong>: <code>USER_VIEW</code> or <code>USER_ADMIN</code></p>
 */
export const techniciansGetEntityPage = <ThrowOnError extends boolean = false>(options: Options<TechniciansGetEntityPageData, ThrowOnError>): RequestResult<TechniciansGetEntityPageResponses, TechniciansGetEntityPageErrors, ThrowOnError> => (options.client ?? client).get<TechniciansGetEntityPageResponses, TechniciansGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/technicians', ...options });

/**
 * Gets list of users
 *
 * <p><strong>Required Roles</strong>: <code>USER_VIEW</code> or <code>USER_ADMIN</code></p>
 */
export const techniciansListUsers = <ThrowOnError extends boolean = false>(options: Options<TechniciansListUsersData, ThrowOnError>): RequestResult<TechniciansListUsersResponses, unknown, ThrowOnError> => (options.client ?? client).get<TechniciansListUsersResponses, unknown, ThrowOnError>({ url: '/api/v1/technicians/list', ...options });

/**
 * Gets page of truck bodies
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_VIEW</code> or <code>TRUCK_ADMIN</code></p>
 */
export const truckBodiesGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<TruckBodiesGetEntityPageData, ThrowOnError>): RequestResult<TruckBodiesGetEntityPageResponses, TruckBodiesGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<TruckBodiesGetEntityPageResponses, TruckBodiesGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/truck-bodies', ...options });

/**
 * Creates new truck body
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_ADMIN</code></p>
 */
export const truckBodiesCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<TruckBodiesCreateEntityData, ThrowOnError>): RequestResult<TruckBodiesCreateEntityResponses, TruckBodiesCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<TruckBodiesCreateEntityResponses, TruckBodiesCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/truck-bodies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of truck bodies
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_VIEW</code> or <code>TRUCK_ADMIN</code></p>
 */
export const truckBodiesListEntities = <ThrowOnError extends boolean = false>(options?: Options<TruckBodiesListEntitiesData, ThrowOnError>): RequestResult<TruckBodiesListEntitiesResponses, TruckBodiesListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<TruckBodiesListEntitiesResponses, TruckBodiesListEntitiesErrors, ThrowOnError>({ url: '/api/v1/truck-bodies/list', ...options });

/**
 * Deletes truck body
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_ADMIN</code></p>
 */
export const truckBodiesDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<TruckBodiesDeleteEntityData, ThrowOnError>): RequestResult<TruckBodiesDeleteEntityResponses, TruckBodiesDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<TruckBodiesDeleteEntityResponses, TruckBodiesDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/truck-bodies/{id}', ...options });

/**
 * Gets truck body
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_VIEW</code> or <code>TRUCK_ADMIN</code></p>
 */
export const truckBodiesGetEntity = <ThrowOnError extends boolean = false>(options: Options<TruckBodiesGetEntityData, ThrowOnError>): RequestResult<TruckBodiesGetEntityResponses, TruckBodiesGetEntityErrors, ThrowOnError> => (options.client ?? client).get<TruckBodiesGetEntityResponses, TruckBodiesGetEntityErrors, ThrowOnError>({ url: '/api/v1/truck-bodies/{id}', ...options });

/**
 * Updates truck body
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_ADMIN</code></p>
 */
export const truckBodiesUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<TruckBodiesUpdateEntityData, ThrowOnError>): RequestResult<TruckBodiesUpdateEntityResponses, TruckBodiesUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<TruckBodiesUpdateEntityResponses, TruckBodiesUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/truck-bodies/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets page of truck depots
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const truckDepotsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<TruckDepotsGetEntityPageData, ThrowOnError>): RequestResult<TruckDepotsGetEntityPageResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TruckDepotsGetEntityPageResponses, unknown, ThrowOnError>({ url: '/api/v1/truck-depots', ...options });

/**
 * Creates new truck depot
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const truckDepotsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<TruckDepotsCreateEntityData, ThrowOnError>): RequestResult<TruckDepotsCreateEntityResponses, TruckDepotsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<TruckDepotsCreateEntityResponses, TruckDepotsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/truck-depots',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of truck depots
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const truckDepotsListEntities = <ThrowOnError extends boolean = false>(options?: Options<TruckDepotsListEntitiesData, ThrowOnError>): RequestResult<TruckDepotsListEntitiesResponses, TruckDepotsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<TruckDepotsListEntitiesResponses, TruckDepotsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/truck-depots/list', ...options });

/**
 * Deletes truck depot
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const truckDepotsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<TruckDepotsDeleteEntityData, ThrowOnError>): RequestResult<TruckDepotsDeleteEntityResponses, TruckDepotsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<TruckDepotsDeleteEntityResponses, TruckDepotsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/truck-depots/{id}', ...options });

/**
 * Gets truck depot
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const truckDepotsGetEntity = <ThrowOnError extends boolean = false>(options: Options<TruckDepotsGetEntityData, ThrowOnError>): RequestResult<TruckDepotsGetEntityResponses, TruckDepotsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<TruckDepotsGetEntityResponses, TruckDepotsGetEntityErrors, ThrowOnError>({ url: '/api/v1/truck-depots/{id}', ...options });

/**
 * Updates truck depot
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const truckDepotsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<TruckDepotsUpdateEntityData, ThrowOnError>): RequestResult<TruckDepotsUpdateEntityResponses, TruckDepotsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<TruckDepotsUpdateEntityResponses, TruckDepotsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/truck-depots/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists trucks not assigned to this or any other depot
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const truckDepotsListAvailableTrucks = <ThrowOnError extends boolean = false>(options: Options<TruckDepotsListAvailableTrucksData, ThrowOnError>): RequestResult<TruckDepotsListAvailableTrucksResponses, TruckDepotsListAvailableTrucksErrors, ThrowOnError> => (options.client ?? client).get<TruckDepotsListAvailableTrucksResponses, TruckDepotsListAvailableTrucksErrors, ThrowOnError>({ url: '/api/v1/truck-depots/{id}/trucks/available', ...options });

/**
 * Lists trucks assigned to this truck depot
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const truckDepotsGetAssignedTrucks = <ThrowOnError extends boolean = false>(options: Options<TruckDepotsGetAssignedTrucksData, ThrowOnError>): RequestResult<TruckDepotsGetAssignedTrucksResponses, TruckDepotsGetAssignedTrucksErrors, ThrowOnError> => (options.client ?? client).get<TruckDepotsGetAssignedTrucksResponses, TruckDepotsGetAssignedTrucksErrors, ThrowOnError>({ url: '/api/v1/truck-depots/{id}/trucks', ...options });

/**
 * Update assigned trucks of truck depot
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const truckDepotsUpdateContainersGroup = <ThrowOnError extends boolean = false>(options: Options<TruckDepotsUpdateContainersGroupData, ThrowOnError>): RequestResult<TruckDepotsUpdateContainersGroupResponses, TruckDepotsUpdateContainersGroupErrors, ThrowOnError> => (options.client ?? client).put<TruckDepotsUpdateContainersGroupResponses, TruckDepotsUpdateContainersGroupErrors, ThrowOnError>({
    url: '/api/v1/truck-depots/{id}/trucks/partial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets page of truck types
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_VIEW</code> or <code>TRUCK_ADMIN</code></p>
 */
export const trucksGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<TrucksGetEntityPageData, ThrowOnError>): RequestResult<TrucksGetEntityPageResponses, TrucksGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<TrucksGetEntityPageResponses, TrucksGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/trucks', ...options });

/**
 * Creates new truck type
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_ADMIN</code></p>
 */
export const trucksCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<TrucksCreateEntityData, ThrowOnError>): RequestResult<TrucksCreateEntityResponses, TrucksCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<TrucksCreateEntityResponses, TrucksCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/trucks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of truck types
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_VIEW</code> or <code>TRUCK_ADMIN</code></p>
 */
export const trucksListEntities = <ThrowOnError extends boolean = false>(options?: Options<TrucksListEntitiesData, ThrowOnError>): RequestResult<TrucksListEntitiesResponses, TrucksListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<TrucksListEntitiesResponses, TrucksListEntitiesErrors, ThrowOnError>({ url: '/api/v1/trucks/list', ...options });

/**
 * Deletes truck type
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_ADMIN</code></p>
 */
export const trucksDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<TrucksDeleteEntityData, ThrowOnError>): RequestResult<TrucksDeleteEntityResponses, TrucksDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<TrucksDeleteEntityResponses, TrucksDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/trucks/{id}', ...options });

/**
 * Gets truck type
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_VIEW</code> or <code>TRUCK_ADMIN</code></p>
 */
export const trucksGetEntity = <ThrowOnError extends boolean = false>(options: Options<TrucksGetEntityData, ThrowOnError>): RequestResult<TrucksGetEntityResponses, TrucksGetEntityErrors, ThrowOnError> => (options.client ?? client).get<TrucksGetEntityResponses, TrucksGetEntityErrors, ThrowOnError>({ url: '/api/v1/trucks/{id}', ...options });

/**
 * Updates truck type
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_ADMIN</code></p>
 */
export const trucksUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<TrucksUpdateEntityData, ThrowOnError>): RequestResult<TrucksUpdateEntityResponses, TrucksUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<TrucksUpdateEntityResponses, TrucksUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/trucks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets page of truck types
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_VIEW</code> or <code>TRUCK_ADMIN</code></p>
 */
export const truckTypesGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<TruckTypesGetEntityPageData, ThrowOnError>): RequestResult<TruckTypesGetEntityPageResponses, TruckTypesGetEntityPageErrors, ThrowOnError> => (options?.client ?? client).get<TruckTypesGetEntityPageResponses, TruckTypesGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/truck-types', ...options });

/**
 * Creates new truck type
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_ADMIN</code></p>
 */
export const truckTypesCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<TruckTypesCreateEntityData, ThrowOnError>): RequestResult<TruckTypesCreateEntityResponses, TruckTypesCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<TruckTypesCreateEntityResponses, TruckTypesCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/truck-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of truck types
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_VIEW</code> or <code>TRUCK_ADMIN</code></p>
 */
export const truckTypesListEntities = <ThrowOnError extends boolean = false>(options?: Options<TruckTypesListEntitiesData, ThrowOnError>): RequestResult<TruckTypesListEntitiesResponses, TruckTypesListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<TruckTypesListEntitiesResponses, TruckTypesListEntitiesErrors, ThrowOnError>({ url: '/api/v1/truck-types/list', ...options });

/**
 * Deletes truck type
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_ADMIN</code></p>
 */
export const truckTypesDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<TruckTypesDeleteEntityData, ThrowOnError>): RequestResult<TruckTypesDeleteEntityResponses, TruckTypesDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<TruckTypesDeleteEntityResponses, TruckTypesDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/truck-types/{id}', ...options });

/**
 * Gets truck type
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_VIEW</code> or <code>TRUCK_ADMIN</code></p>
 */
export const truckTypesGetEntity = <ThrowOnError extends boolean = false>(options: Options<TruckTypesGetEntityData, ThrowOnError>): RequestResult<TruckTypesGetEntityResponses, TruckTypesGetEntityErrors, ThrowOnError> => (options.client ?? client).get<TruckTypesGetEntityResponses, TruckTypesGetEntityErrors, ThrowOnError>({ url: '/api/v1/truck-types/{id}', ...options });

/**
 * Updates truck type
 *
 * <p><strong>Required Roles</strong>: <code>TRUCK_ADMIN</code></p>
 */
export const truckTypesUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<TruckTypesUpdateEntityData, ThrowOnError>): RequestResult<TruckTypesUpdateEntityResponses, TruckTypesUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<TruckTypesUpdateEntityResponses, TruckTypesUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/truck-types/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get page of notification settings for current user
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code></p>
 */
export const userNotificationSettingsGetUserNotificationSettingsPage = <ThrowOnError extends boolean = false>(options: Options<UserNotificationSettingsGetUserNotificationSettingsPageData, ThrowOnError>): RequestResult<UserNotificationSettingsGetUserNotificationSettingsPageResponses, UserNotificationSettingsGetUserNotificationSettingsPageErrors, ThrowOnError> => (options.client ?? client).get<UserNotificationSettingsGetUserNotificationSettingsPageResponses, UserNotificationSettingsGetUserNotificationSettingsPageErrors, ThrowOnError>({ url: '/api/v1/user-notification-settings', ...options });

/**
 * Creates user profile notification setting for current user from DTO
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code></p>
 */
export const userNotificationSettingsCreateProfileNotificationSetting = <ThrowOnError extends boolean = false>(options?: Options<UserNotificationSettingsCreateProfileNotificationSettingData, ThrowOnError>): RequestResult<UserNotificationSettingsCreateProfileNotificationSettingResponses, UserNotificationSettingsCreateProfileNotificationSettingErrors, ThrowOnError> => (options?.client ?? client).post<UserNotificationSettingsCreateProfileNotificationSettingResponses, UserNotificationSettingsCreateProfileNotificationSettingErrors, ThrowOnError>({
    url: '/api/v1/user-notification-settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Deletes user notification setting
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code></p>
 */
export const userNotificationSettingsDeleteNotificationSetting = <ThrowOnError extends boolean = false>(options: Options<UserNotificationSettingsDeleteNotificationSettingData, ThrowOnError>): RequestResult<UserNotificationSettingsDeleteNotificationSettingResponses, UserNotificationSettingsDeleteNotificationSettingErrors, ThrowOnError> => (options.client ?? client).delete<UserNotificationSettingsDeleteNotificationSettingResponses, UserNotificationSettingsDeleteNotificationSettingErrors, ThrowOnError>({ url: '/api/v1/user-notification-settings/{id}', ...options });

/**
 * Gets specific user profile notification setting
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code></p>
 */
export const userNotificationSettingsGetProfileNotificationSetting = <ThrowOnError extends boolean = false>(options: Options<UserNotificationSettingsGetProfileNotificationSettingData, ThrowOnError>): RequestResult<UserNotificationSettingsGetProfileNotificationSettingResponses, UserNotificationSettingsGetProfileNotificationSettingErrors, ThrowOnError> => (options.client ?? client).get<UserNotificationSettingsGetProfileNotificationSettingResponses, UserNotificationSettingsGetProfileNotificationSettingErrors, ThrowOnError>({ url: '/api/v1/user-notification-settings/{id}', ...options });

/**
 * Updates user profile notification setting for current user from DTO
 *
 * <p><strong>Required Roles</strong>: <code>APP_SERVICE_USER</code></p>
 */
export const userNotificationSettingsUpdateProfileNotificationSetting = <ThrowOnError extends boolean = false>(options: Options<UserNotificationSettingsUpdateProfileNotificationSettingData, ThrowOnError>): RequestResult<UserNotificationSettingsUpdateProfileNotificationSettingResponses, UserNotificationSettingsUpdateProfileNotificationSettingErrors, ThrowOnError> => (options.client ?? client).put<UserNotificationSettingsUpdateProfileNotificationSettingResponses, UserNotificationSettingsUpdateProfileNotificationSettingErrors, ThrowOnError>({
    url: '/api/v1/user-notification-settings/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets list of all users
 *
 * <p><strong>Required Roles</strong>: <code>USER_VIEW</code> or <code>USER_ADMIN</code></p>
 */
export const usersGetEntityPage = <ThrowOnError extends boolean = false>(options: Options<UsersGetEntityPageData, ThrowOnError>): RequestResult<UsersGetEntityPageResponses, UsersGetEntityPageErrors, ThrowOnError> => (options.client ?? client).get<UsersGetEntityPageResponses, UsersGetEntityPageErrors, ThrowOnError>({ url: '/api/v1/users', ...options });

/**
 * Creates new User
 *
 * <p><strong>Required Roles</strong>: <code>USER_ADMIN</code></p>
 */
export const usersCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<UsersCreateEntityData, ThrowOnError>): RequestResult<UsersCreateEntityResponses, UsersCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<UsersCreateEntityResponses, UsersCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of users
 *
 * <p><strong>Required Roles</strong>: <code>USER_VIEW</code> or <code>USER_ADMIN</code></p>
 */
export const usersListUsers = <ThrowOnError extends boolean = false>(options: Options<UsersListUsersData, ThrowOnError>): RequestResult<UsersListUsersResponses, unknown, ThrowOnError> => (options.client ?? client).get<UsersListUsersResponses, unknown, ThrowOnError>({ url: '/api/v1/users/list', ...options });

/**
 * Marks user as deleted (i.e. soft-delete)
 *
 * <p><strong>Required Roles</strong>: <code>USER_ADMIN</code></p>
 */
export const usersDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<UsersDeleteEntityData, ThrowOnError>): RequestResult<UsersDeleteEntityResponses, UsersDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<UsersDeleteEntityResponses, UsersDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/users/{id}', ...options });

/**
 * Gets specific user
 *
 * <p><strong>Required Roles</strong>: <code>USER_VIEW</code> or <code>USER_ADMIN</code></p>
 */
export const usersGetEntity = <ThrowOnError extends boolean = false>(options: Options<UsersGetEntityData, ThrowOnError>): RequestResult<UsersGetEntityResponses, UsersGetEntityErrors, ThrowOnError> => (options.client ?? client).get<UsersGetEntityResponses, UsersGetEntityErrors, ThrowOnError>({ url: '/api/v1/users/{id}', ...options });

/**
 * Updates User.
 *
 * <p><strong>Required Roles</strong>: <code>USER_ADMIN</code></p>
 */
export const usersUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<UsersUpdateEntityData, ThrowOnError>): RequestResult<UsersUpdateEntityResponses, UsersUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<UsersUpdateEntityResponses, UsersUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets specific user profile
 * with list of last issuesLimit issues
 * and last transactionLimit transactions
 */
export const usersGetProfile = <ThrowOnError extends boolean = false>(options?: Options<UsersGetProfileData, ThrowOnError>): RequestResult<UsersGetProfileResponses, UsersGetProfileErrors, ThrowOnError> => (options?.client ?? client).get<UsersGetProfileResponses, UsersGetProfileErrors, ThrowOnError>({ url: '/api/v1/users/profile', ...options });

/**
 * Updates user profile from DTO
 *
 * <p><strong>Required Roles</strong>: <code>APP_USER</code></p>
 */
export const usersUpdateProfile = <ThrowOnError extends boolean = false>(options: Options<UsersUpdateProfileData, ThrowOnError>): RequestResult<UsersUpdateProfileResponses, UsersUpdateProfileErrors, ThrowOnError> => (options.client ?? client).put<UsersUpdateProfileResponses, UsersUpdateProfileErrors, ThrowOnError>({
    url: '/api/v1/users/profile/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if value for given field is already used
 *
 * <p><strong>Required Roles</strong>: <code>USER_ADMIN</code></p>
 */
export const usersIsValueUsed = <ThrowOnError extends boolean = false>(options?: Options<UsersIsValueUsedData, ThrowOnError>): RequestResult<UsersIsValueUsedResponses, UsersIsValueUsedErrors, ThrowOnError> => (options?.client ?? client).post<UsersIsValueUsedResponses, UsersIsValueUsedErrors, ThrowOnError>({
    url: '/api/v1/users/value-used',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Marks user as active.
 * Use this to re-activate deleted or disabled user
 *
 * <p><strong>Required Roles</strong>: <code>USER_ADMIN</code></p>
 */
export const usersActivateUser = <ThrowOnError extends boolean = false>(options: Options<UsersActivateUserData, ThrowOnError>): RequestResult<UsersActivateUserResponses, UsersActivateUserErrors, ThrowOnError> => (options.client ?? client).put<UsersActivateUserResponses, UsersActivateUserErrors, ThrowOnError>({ url: '/api/v1/users/{id}/activate', ...options });

/**
 * Exports users.
 *
 * The supported *format*s are either JSON or CSV<p><strong>Required Roles</strong>: <code>CONTRACT_VIEW</code> or <code>CONTRACT_ADMIN</code></p>
 */
export const usersExportList = <ThrowOnError extends boolean = false>(options: Options<UsersExportListData, ThrowOnError>): RequestResult<UsersExportListResponses, UsersExportListErrors, ThrowOnError> => (options.client ?? client).get<UsersExportListResponses, UsersExportListErrors, ThrowOnError>({ url: '/api/v1/users/export.{format}', ...options });

/**
 * Bans user from usage of application for given customer
 *
 * <p><strong>Required Roles</strong>: <code>USER_ADMIN</code></p>
 */
export const usersBanForAppCustomer = <ThrowOnError extends boolean = false>(options: Options<UsersBanForAppCustomerData, ThrowOnError>): RequestResult<UsersBanForAppCustomerResponses, UsersBanForAppCustomerErrors, ThrowOnError> => (options.client ?? client).post<UsersBanForAppCustomerResponses, UsersBanForAppCustomerErrors, ThrowOnError>({ url: '/api/v1/users/{id}/ban', ...options });

/**
 * Unbans user from usage of application for given customer
 *
 * <p><strong>Required Roles</strong>: <code>USER_ADMIN</code></p>
 */
export const usersUnbanForAppCustomer = <ThrowOnError extends boolean = false>(options: Options<UsersUnbanForAppCustomerData, ThrowOnError>): RequestResult<UsersUnbanForAppCustomerResponses, UsersUnbanForAppCustomerErrors, ThrowOnError> => (options.client ?? client).post<UsersUnbanForAppCustomerResponses, UsersUnbanForAppCustomerErrors, ThrowOnError>({ url: '/api/v1/users/{id}/unban', ...options });

/**
 * Changes user's password
 *
 * <p><strong>Required Roles</strong>: <code>USER_ADMIN</code></p>
 */
export const usersChangePassword = <ThrowOnError extends boolean = false>(options: Options<UsersChangePasswordData, ThrowOnError>): RequestResult<UsersChangePasswordResponses, UsersChangePasswordErrors, ThrowOnError> => (options.client ?? client).post<UsersChangePasswordResponses, UsersChangePasswordErrors, ThrowOnError>({
    url: '/api/v1/users/{id}/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Changes user's own password
 */
export const usersChangeOwnPassword = <ThrowOnError extends boolean = false>(options?: Options<UsersChangeOwnPasswordData, ThrowOnError>): RequestResult<UsersChangeOwnPasswordResponses, UsersChangeOwnPasswordErrors, ThrowOnError> => (options?.client ?? client).post<UsersChangeOwnPasswordResponses, UsersChangeOwnPasswordErrors, ThrowOnError>({
    url: '/api/v1/users/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Initializes password reset for given user
 */
export const usersInitPasswordReset = <ThrowOnError extends boolean = false>(options?: Options<UsersInitPasswordResetData, ThrowOnError>): RequestResult<UsersInitPasswordResetResponses, UsersInitPasswordResetErrors, ThrowOnError> => (options?.client ?? client).post<UsersInitPasswordResetResponses, UsersInitPasswordResetErrors, ThrowOnError>({
    url: '/api/v1/users/password-reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Finishes password reset process
 */
export const usersFinishPasswordReset = <ThrowOnError extends boolean = false>(options?: Options<UsersFinishPasswordResetData, ThrowOnError>): RequestResult<UsersFinishPasswordResetResponses, UsersFinishPasswordResetErrors, ThrowOnError> => (options?.client ?? client).put<UsersFinishPasswordResetResponses, UsersFinishPasswordResetErrors, ThrowOnError>({
    url: '/api/v1/users/password-reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Finishes password reset process
 */
export const usersVerifyPasswordReset = <ThrowOnError extends boolean = false>(options: Options<UsersVerifyPasswordResetData, ThrowOnError>): RequestResult<UsersVerifyPasswordResetResponses, UsersVerifyPasswordResetErrors, ThrowOnError> => (options.client ?? client).get<UsersVerifyPasswordResetResponses, UsersVerifyPasswordResetErrors, ThrowOnError>({ url: '/api/v1/users/password-reset/{token}', ...options });

/**
 * Validates new password - for client async validation
 */
export const usersValidatePassword = <ThrowOnError extends boolean = false>(options?: Options<UsersValidatePasswordData, ThrowOnError>): RequestResult<UsersValidatePasswordResponses, UsersValidatePasswordErrors, ThrowOnError> => (options?.client ?? client).put<UsersValidatePasswordResponses, UsersValidatePasswordErrors, ThrowOnError>({
    url: '/api/v1/users/password-reset/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Clears TOTP T2A settings for the current user.
 * Removes the TOTP and all backup codes.
 * User must be loggen in via web (`authorize/login` endpoint)
 */
export const usersResetTotpSettings = <ThrowOnError extends boolean = false>(options?: Options<UsersResetTotpSettingsData, ThrowOnError>): RequestResult<UsersResetTotpSettingsResponses, UsersResetTotpSettingsErrors, ThrowOnError> => (options?.client ?? client).post<UsersResetTotpSettingsResponses, UsersResetTotpSettingsErrors, ThrowOnError>({ url: '/api/v1/users/totp-reset', ...options });

/**
 * Unregisters user's device.
 *
 * Device will be marked as deleted, removed from all contracts
 * and all refresh tokens associated with the device will be invalidated.<p><strong>Required Roles</strong>: <code>USER_ADMIN</code> or <code>APP_USER</code></p>
 */
export const usersUnregisterDevice = <ThrowOnError extends boolean = false>(options: Options<UsersUnregisterDeviceData, ThrowOnError>): RequestResult<UsersUnregisterDeviceResponses, unknown, ThrowOnError> => (options.client ?? client).delete<UsersUnregisterDeviceResponses, unknown, ThrowOnError>({ url: '/api/v1/users/{userId}/devices/{deviceId}', ...options });

/**
 * Unregisters user's own device.
 *
 * Device will be marked as deleted, removed from all contracts
 * and all refresh tokens associated with the device will be invalidated.
 */
export const usersUnregisterOwnDevice = <ThrowOnError extends boolean = false>(options: Options<UsersUnregisterOwnDeviceData, ThrowOnError>): RequestResult<UsersUnregisterOwnDeviceResponses, unknown, ThrowOnError> => (options.client ?? client).delete<UsersUnregisterOwnDeviceResponses, unknown, ThrowOnError>({ url: '/api/v1/users/devices/{deviceId}', ...options });

/**
 * Get my preferences
 *
 * Get layout preferences
 * JSON with any user defined settings<p><strong>Required Roles</strong>: <code>APP_USER</code></p>
 */
export const usersGetMyPreferences = <ThrowOnError extends boolean = false>(options?: Options<UsersGetMyPreferencesData, ThrowOnError>): RequestResult<UsersGetMyPreferencesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetMyPreferencesResponses, unknown, ThrowOnError>({ url: '/api/v1/users/preferences', ...options });

/**
 * Set layout preferences.
 *
 * Set layout preferences form the client
 * JSON with any user defined settings<p><strong>Required Roles</strong>: <code>APP_USER</code></p>
 */
export const usersSetPreferences = <ThrowOnError extends boolean = false>(options?: Options<UsersSetPreferencesData, ThrowOnError>): RequestResult<UsersSetPreferencesResponses, unknown, ThrowOnError> => (options?.client ?? client).put<UsersSetPreferencesResponses, unknown, ThrowOnError>({
    url: '/api/v1/users/preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get my favourites
 *
 * Get layout favourites
 * JSON with any user defined settings
 */
export const usersGetMyFavourites = <ThrowOnError extends boolean = false>(options?: Options<UsersGetMyFavouritesData, ThrowOnError>): RequestResult<UsersGetMyFavouritesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersGetMyFavouritesResponses, unknown, ThrowOnError>({ url: '/api/v1/users/favourites', ...options });

/**
 * Set sidebar favourites.
 *
 * Set sidebar favourites form the client
 * JSON with any user defined settings
 */
export const usersSetFavourites = <ThrowOnError extends boolean = false>(options?: Options<UsersSetFavouritesData, ThrowOnError>): RequestResult<UsersSetFavouritesResponses, unknown, ThrowOnError> => (options?.client ?? client).put<UsersSetFavouritesResponses, unknown, ThrowOnError>({
    url: '/api/v1/users/favourites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get page of user wizards for current user
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const userWizardGetUserWizardPage = <ThrowOnError extends boolean = false>(options?: Options<UserWizardGetUserWizardPageData, ThrowOnError>): RequestResult<UserWizardGetUserWizardPageResponses, UserWizardGetUserWizardPageErrors, ThrowOnError> => (options?.client ?? client).get<UserWizardGetUserWizardPageResponses, UserWizardGetUserWizardPageErrors, ThrowOnError>({ url: '/api/v1/user-wizard', ...options });

/**
 * Creates new user wizard from DTO
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const userWizardCreateUserWizard = <ThrowOnError extends boolean = false>(options?: Options<UserWizardCreateUserWizardData, ThrowOnError>): RequestResult<UserWizardCreateUserWizardResponses, UserWizardCreateUserWizardErrors, ThrowOnError> => (options?.client ?? client).post<UserWizardCreateUserWizardResponses, UserWizardCreateUserWizardErrors, ThrowOnError>({
    url: '/api/v1/user-wizard',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Deletes user wizard
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const userWizardDeleteUserWizard = <ThrowOnError extends boolean = false>(options: Options<UserWizardDeleteUserWizardData, ThrowOnError>): RequestResult<UserWizardDeleteUserWizardResponses, UserWizardDeleteUserWizardErrors, ThrowOnError> => (options.client ?? client).delete<UserWizardDeleteUserWizardResponses, UserWizardDeleteUserWizardErrors, ThrowOnError>({ url: '/api/v1/user-wizard/{id}', ...options });

/**
 * Gets specific user wizard
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const userWizardGetUserWizard = <ThrowOnError extends boolean = false>(options: Options<UserWizardGetUserWizardData, ThrowOnError>): RequestResult<UserWizardGetUserWizardResponses, UserWizardGetUserWizardErrors, ThrowOnError> => (options.client ?? client).get<UserWizardGetUserWizardResponses, UserWizardGetUserWizardErrors, ThrowOnError>({ url: '/api/v1/user-wizard/{id}', ...options });

/**
 * Updates user wizard
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const userWizardUpdateUserWizard = <ThrowOnError extends boolean = false>(options: Options<UserWizardUpdateUserWizardData, ThrowOnError>): RequestResult<UserWizardUpdateUserWizardResponses, UserWizardUpdateUserWizardErrors, ThrowOnError> => (options.client ?? client).put<UserWizardUpdateUserWizardResponses, UserWizardUpdateUserWizardErrors, ThrowOnError>({
    url: '/api/v1/user-wizard/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets list of battery types
 *
 * <p><strong>Required Roles</strong>: <code>CONTAINER_VIEW</code> or <code>CONTAINER_ADMIN</code> or <code>CONTAINER_BULK</code></p>
 */
export const wasteCategoriesListContainerLockTypes = <ThrowOnError extends boolean = false>(options?: Options<WasteCategoriesListContainerLockTypesData, ThrowOnError>): RequestResult<WasteCategoriesListContainerLockTypesResponses, WasteCategoriesListContainerLockTypesErrors, ThrowOnError> => (options?.client ?? client).get<WasteCategoriesListContainerLockTypesResponses, WasteCategoriesListContainerLockTypesErrors, ThrowOnError>({ url: '/api/v1/waste-categories', ...options });

/**
 * Gets page of waste yards
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const wasteYardsGetEntityPage = <ThrowOnError extends boolean = false>(options?: Options<WasteYardsGetEntityPageData, ThrowOnError>): RequestResult<WasteYardsGetEntityPageResponses, unknown, ThrowOnError> => (options?.client ?? client).get<WasteYardsGetEntityPageResponses, unknown, ThrowOnError>({ url: '/api/v1/waste-yards', ...options });

/**
 * Creates new waste yard
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const wasteYardsCreateEntity = <ThrowOnError extends boolean = false>(options?: Options<WasteYardsCreateEntityData, ThrowOnError>): RequestResult<WasteYardsCreateEntityResponses, WasteYardsCreateEntityErrors, ThrowOnError> => (options?.client ?? client).post<WasteYardsCreateEntityResponses, WasteYardsCreateEntityErrors, ThrowOnError>({
    url: '/api/v1/waste-yards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Gets list of waste yards
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const wasteYardsListEntities = <ThrowOnError extends boolean = false>(options?: Options<WasteYardsListEntitiesData, ThrowOnError>): RequestResult<WasteYardsListEntitiesResponses, WasteYardsListEntitiesErrors, ThrowOnError> => (options?.client ?? client).get<WasteYardsListEntitiesResponses, WasteYardsListEntitiesErrors, ThrowOnError>({ url: '/api/v1/waste-yards/list', ...options });

/**
 * Deletes waste yard
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const wasteYardsDeleteEntity = <ThrowOnError extends boolean = false>(options: Options<WasteYardsDeleteEntityData, ThrowOnError>): RequestResult<WasteYardsDeleteEntityResponses, WasteYardsDeleteEntityErrors, ThrowOnError> => (options.client ?? client).delete<WasteYardsDeleteEntityResponses, WasteYardsDeleteEntityErrors, ThrowOnError>({ url: '/api/v1/waste-yards/{id}', ...options });

/**
 * Gets waste yard
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_VIEW</code> or <code>CUSTOMER_ADMIN</code></p>
 */
export const wasteYardsGetEntity = <ThrowOnError extends boolean = false>(options: Options<WasteYardsGetEntityData, ThrowOnError>): RequestResult<WasteYardsGetEntityResponses, WasteYardsGetEntityErrors, ThrowOnError> => (options.client ?? client).get<WasteYardsGetEntityResponses, WasteYardsGetEntityErrors, ThrowOnError>({ url: '/api/v1/waste-yards/{id}', ...options });

/**
 * Updates waste yard
 *
 * <p><strong>Required Roles</strong>: <code>CUSTOMER_ADMIN</code></p>
 */
export const wasteYardsUpdateEntity = <ThrowOnError extends boolean = false>(options: Options<WasteYardsUpdateEntityData, ThrowOnError>): RequestResult<WasteYardsUpdateEntityResponses, WasteYardsUpdateEntityErrors, ThrowOnError> => (options.client ?? client).put<WasteYardsUpdateEntityResponses, WasteYardsUpdateEntityErrors, ThrowOnError>({
    url: '/api/v1/waste-yards/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets well known document
 */
export const wellKnownGetDocument = <ThrowOnError extends boolean = false>(options: Options<WellKnownGetDocumentData, ThrowOnError>): RequestResult<WellKnownGetDocumentResponses, WellKnownGetDocumentErrors, ThrowOnError> => (options.client ?? client).get<WellKnownGetDocumentResponses, WellKnownGetDocumentErrors, ThrowOnError>({ url: '/.well-known/{filename}', ...options });
